var bodyScrollLockOptions = {
  reserveScrollBarGap: true,
  allowTouchMove: function (el) {
    var current = el;
    while (current && current !== document.body) {
      if (
        current.classList &&
        (
          current.classList.contains('swiper') ||
          current.classList.contains('swiper-wrapper') ||
          current.classList.contains('swiper-slide') ||
          current.classList.contains('cart-drawer__recommendations-wrapper')
        )
      ) {
        return true;
      }
      current = current.parentElement;
    }
    return false;
  },
};

// Define a global function to load a script
window.loadScript = function (url) {
  // Check if the script already exists
  var existingScript = document.querySelector(`script[src="${url}"]`);

  if (existingScript) {
    return;
  }

  // Create a new script element
  var script = document.createElement('script');
  script.src = url;
  document.body.appendChild(script);
};

var Shopify = Shopify || {};
// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
Shopify.money_format = '${{amount}}';
Shopify.formatMoney = function (cents, format) {
  if (typeof cents == 'string') {
    cents = cents.replace('.', '');
  }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = format || this.money_format;

  function defaultOption(opt, def) {
    return typeof opt == 'undefined' ? def : opt;
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);

    var parts = number.split('.'),
      dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
      cents = parts[1] ? decimal + parts[1] : '';

    return dollars + cents;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
};

/**
 * DOM event delegator
 *
 * The delegator will listen
 * for events that bubble up
 * to the root node.
 *
 * @constructor
 * @param {Node|string} [root] The root node or a selector string matching the root node
 */
function Delegate(root) {
  /**
   * Maintain a map of listener
   * lists, keyed by event name.
   *
   * @type Object
   */
  this.listenerMap = [{}, {}];
  if (root) {
    this.root(root);
  }

  /** @type function() */
  this.handle = Delegate.prototype.handle.bind(this);

  // Cache of event listeners removed during an event cycle
  this._removedListeners = [];
}

/**
 * Start listening for events
 * on the provided DOM element
 *
 * @param  {Node|string} [root] The root node or a selector string matching the root node
 * @returns {Delegate} This method is chainable
 */
Delegate.prototype.root = function (root) {
  const listenerMap = this.listenerMap;
  let eventType;

  // Remove master event listeners
  if (this.rootElement) {
    for (eventType in listenerMap[1]) {
      if (listenerMap[1].hasOwnProperty(eventType)) {
        this.rootElement.removeEventListener(eventType, this.handle, true);
      }
    }
    for (eventType in listenerMap[0]) {
      if (listenerMap[0].hasOwnProperty(eventType)) {
        this.rootElement.removeEventListener(eventType, this.handle, false);
      }
    }
  }

  // If no root or root is not
  // a dom node, then remove internal
  // root reference and exit here
  if (!root || !root.addEventListener) {
    if (this.rootElement) {
      delete this.rootElement;
    }
    return this;
  }

  /**
   * The root node at which
   * listeners are attached.
   *
   * @type Node
   */
  this.rootElement = root;

  // Set up master event listeners
  for (eventType in listenerMap[1]) {
    if (listenerMap[1].hasOwnProperty(eventType)) {
      // Add the 'passive' option for scroll events
      const isScrollEvent = ['wheel', 'mousewheel'].indexOf(eventType) !== -1;
      this.rootElement.addEventListener(eventType, this.handle, { capture: true, passive: isScrollEvent });
    }
  }
  for (eventType in listenerMap[0]) {
    if (listenerMap[0].hasOwnProperty(eventType)) {
      // Add the 'passive' option for scroll events
      const isScrollEvent = ['wheel', 'mousewheel'].indexOf(eventType) !== -1;
      this.rootElement.addEventListener(eventType, this.handle, { capture: false, passive: isScrollEvent });
    }
  }

  return this;
};

/**
 * @param {string} eventType
 * @returns boolean
 */
Delegate.prototype.captureForType = function (eventType) {
  return ['blur', 'error', 'focus', 'load', 'resize', 'scroll'].indexOf(eventType) !== -1;
};

/**
 * Attach a handler to one
 * event for all elements
 * that match the selector,
 * now or in the future
 *
 * The handler function receives
 * three arguments: the DOM event
 * object, the node that matched
 * the selector while the event
 * was bubbling and a reference
 * to itself. Within the handler,
 * 'this' is equal to the second
 * argument.
 *
 * The node that actually received
 * the event can be accessed via
 * 'event.target'.
 *
 * @param {string} eventType Listen for these events
 * @param {string|undefined} selector Only handle events on elements matching this selector, if undefined match root element
 * @param {function()} handler Handler function - event data passed here will be in event.data
 * @param {boolean} [useCapture] see 'useCapture' in <https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener>
 * @returns {Delegate} This method is chainable
 */
Delegate.prototype.on = function (eventType, selector, handler, useCapture) {
  let root;
  let listenerMap;
  let matcher;
  let matcherParam;

  if (!eventType) {
    throw new TypeError('Invalid event type: ' + eventType);
  }

  // handler can be passed as
  // the second or third argument
  if (typeof selector === 'function') {
    useCapture = handler;
    handler = selector;
    selector = null;
  }

  // Fallback to sensible defaults
  // if useCapture not set
  if (useCapture === undefined) {
    useCapture = this.captureForType(eventType);
  }

  if (typeof handler !== 'function') {
    throw new TypeError('Handler must be a type of Function');
  }

  root = this.rootElement;
  listenerMap = this.listenerMap[useCapture ? 1 : 0];
  const isScrollEvent = ['wheel', 'mousewheel', 'touchstart', 'touchmove'].indexOf(eventType) !== -1;

  // Add master handler for type if not created yet
  if (!listenerMap[eventType]) {
    if (root) {
      root.addEventListener(eventType, this.handle, { capture: useCapture, passive: isScrollEvent });
    }
    listenerMap[eventType] = [];
  }

  if (!selector) {
    matcherParam = null;

    // COMPLEX - matchesRoot needs to have access to
    // this.rootElement, so bind the function to this.
    matcher = matchesRoot.bind(this);

    // Compile a matcher for the given selector
  } else if (/^[a-z]+$/i.test(selector)) {
    matcherParam = selector;
    matcher = matchesTag;
  } else if (/^#[a-z0-9\-_]+$/i.test(selector)) {
    matcherParam = selector.slice(1);
    matcher = matchesId;
  } else {
    matcherParam = selector;
    matcher = Element.prototype.matches;
  }

  // Add to the list of listeners
  listenerMap[eventType].push({
    selector: selector,
    handler: handler,
    matcher: matcher,
    matcherParam: matcherParam,
  });

  return this;
};

/**
 * Remove an event handler
 * for elements that match
 * the selector, forever
 *
 * @param {string} [eventType] Remove handlers for events matching this type, considering the other parameters
 * @param {string} [selector] If this parameter is omitted, only handlers which match the other two will be removed
 * @param {function()} [handler] If this parameter is omitted, only handlers which match the previous two will be removed
 * @returns {Delegate} This method is chainable
 */
Delegate.prototype.off = function (eventType, selector, handler, useCapture) {
  let i;
  let listener;
  let listenerMap;
  let listenerList;
  let singleEventType;

  // Handler can be passed as
  // the second or third argument
  if (typeof selector === 'function') {
    useCapture = handler;
    handler = selector;
    selector = null;
  }

  // If useCapture not set, remove
  // all event listeners
  if (useCapture === undefined) {
    this.off(eventType, selector, handler, true);
    this.off(eventType, selector, handler, false);
    return this;
  }

  listenerMap = this.listenerMap[useCapture ? 1 : 0];
  if (!eventType) {
    for (singleEventType in listenerMap) {
      if (listenerMap.hasOwnProperty(singleEventType)) {
        this.off(singleEventType, selector, handler);
      }
    }

    return this;
  }

  listenerList = listenerMap[eventType];
  if (!listenerList || !listenerList.length) {
    return this;
  }

  // Remove only parameter matches
  // if specified
  for (i = listenerList.length - 1; i >= 0; i--) {
    listener = listenerList[i];

    if ((!selector || selector === listener.selector) && (!handler || handler === listener.handler)) {
      this._removedListeners.push(listener);
      listenerList.splice(i, 1);
    }
  }

  // All listeners removed
  if (!listenerList.length) {
    delete listenerMap[eventType];

    // Remove the main handler
    if (this.rootElement) {
      this.rootElement.removeEventListener(eventType, this.handle, useCapture);
    }
  }

  return this;
};

/**
 * Handle an arbitrary event.
 *
 * @param {Event} event
 */
Delegate.prototype.handle = function (event) {
  let i;
  let l;
  const type = event.type;
  let root;
  let phase;
  let listener;
  let returned;
  let listenerList = [];
  let target;
  const eventIgnore = 'ftLabsDelegateIgnore';

  if (event[eventIgnore] === true) {
    return;
  }

  target = event.target;

  // Hardcode value of Node.TEXT_NODE
  // as not defined in IE8
  if (target.nodeType === 3) {
    target = target.parentNode;
  }

  // Handle SVG <use> elements in IE
  if (target.correspondingUseElement) {
    target = target.correspondingUseElement;
  }

  root = this.rootElement;

  phase = event.eventPhase || (event.target !== event.currentTarget ? 3 : 2);

  // eslint-disable-next-line default-case
  switch (phase) {
    case 1: //Event.CAPTURING_PHASE:
      listenerList = this.listenerMap[1][type];
      break;
    case 2: //Event.AT_TARGET:
      if (this.listenerMap[0] && this.listenerMap[0][type]) {
        listenerList = listenerList.concat(this.listenerMap[0][type]);
      }
      if (this.listenerMap[1] && this.listenerMap[1][type]) {
        listenerList = listenerList.concat(this.listenerMap[1][type]);
      }
      break;
    case 3: //Event.BUBBLING_PHASE:
      listenerList = this.listenerMap[0][type];
      break;
  }

  let toFire = [];

  // Need to continuously check
  // that the specific list is
  // still populated in case one
  // of the callbacks actually
  // causes the list to be destroyed.
  l = listenerList.length;
  while (target && l) {
    for (i = 0; i < l; i++) {
      listener = listenerList[i];

      // Bail from this loop if
      // the length changed and
      // no more listeners are
      // defined between i and l.
      if (!listener) {
        break;
      }

      if (
        target.tagName &&
        ['button', 'input', 'select', 'textarea'].indexOf(target.tagName.toLowerCase()) > -1 &&
        target.hasAttribute('disabled')
      ) {
        // Remove things that have previously fired
        toFire = [];
      }
      // Check for match and fire
      // the event if there's one
      //
      // TODO:MCG:20120117: Need a way
      // to check if event#stopImmediatePropagation
      // was called. If so, break both loops.
      else if (listener.matcher.call(target, listener.matcherParam, target)) {
        toFire.push([event, target, listener]);
      }
    }

    // TODO:MCG:20120117: Need a way to
    // check if event#stopPropagation
    // was called. If so, break looping
    // through the DOM. Stop if the
    // delegation root has been reached
    if (target === root) {
      break;
    }

    l = listenerList.length;

    // Fall back to parentNode since SVG children have no parentElement in IE
    target = target.parentElement || target.parentNode;

    // Do not traverse up to document root when using parentNode, though
    if (target instanceof HTMLDocument) {
      break;
    }
  }

  let ret;

  for (i = 0; i < toFire.length; i++) {
    // Has it been removed during while the event function was fired
    if (this._removedListeners.indexOf(toFire[i][2]) > -1) {
      continue;
    }
    returned = this.fire.apply(this, toFire[i]);

    // Stop propagation to subsequent
    // callbacks if the callback returned
    // false
    if (returned === false) {
      toFire[i][0][eventIgnore] = true;
      toFire[i][0].preventDefault();
      ret = false;
      break;
    }
  }

  return ret;
};

/**
 * Fire a listener on a target.
 *
 * @param {Event} event
 * @param {Node} target
 * @param {Object} listener
 * @returns {boolean}
 */
Delegate.prototype.fire = function (event, target, listener) {
  return listener.handler.call(target, event, target);
};

/**
 * Check whether an element
 * matches a tag selector.
 *
 * Tags are NOT case-sensitive,
 * except in XML (and XML-based
 * languages such as XHTML).
 *
 * @param {string} tagName The tag name to test against
 * @param {Element} element The element to test with
 * @returns boolean
 */
function matchesTag(tagName, element) {
  return tagName.toLowerCase() === element.tagName.toLowerCase();
}

/**
 * Check whether an element
 * matches the root.
 *
 * @param {?String} selector In this case this is always passed through as null and not used
 * @param {Element} element The element to test with
 * @returns boolean
 */
function matchesRoot(selector, element) {
  if (this.rootElement === window) {
    return (
      // Match the outer document (dispatched from document)
      element === document ||
      // The <html> element (dispatched from document.body or document.documentElement)
      element === document.documentElement ||
      // Or the window itself (dispatched from window)
      element === window
    );
  }
  return this.rootElement === element;
}

/**
 * Check whether the ID of
 * the element in 'this'
 * matches the given ID.
 *
 * IDs are case-sensitive.
 *
 * @param {string} id The ID to test against
 * @param {Element} element The element to test with
 * @returns boolean
 */
function matchesId(id, element) {
  return id === element.id;
}

/**
 * Short hand for off()
 * and root(), ie both
 * with no parameters
 *
 * @return void
 */
Delegate.prototype.destroy = function () {
  this.off();
  this.root();
};

class IOSScrollLock {
  static _preventScroll = null;
  static _preventGesture = null;
  static _lockCount = 0;

  static lock() {
    if (this._lockCount === 0) {
      this._preventScroll = (e) => {
        if (e.target.closest('.Drawer--wrapper') || e.target.closest('[data-scrollable]')) return;
        e.preventDefault();
      };
      document.addEventListener('touchmove', this._preventScroll, { passive: false, capture: true });

      this._preventGesture = (e) => e.preventDefault();
      document.addEventListener('gesturestart', this._preventGesture);
    }
    this._lockCount++;
  }

  static unlock() {
    if (this._lockCount < 0) return;
    this._lockCount--;

    if (this._lockCount === 0) {
      if (this._preventScroll) {
        document.removeEventListener('touchmove', this._preventScroll, { passive: false, capture: true });
        this._preventScroll = null;
      }

      if (this._preventGesture) {
        document.removeEventListener('gesturestart', this._preventGesture);
        this._preventGesture = null;
      }
    }
  }
}

class GlobalScrollListener {
  constructor() {
    this.callbacks = new Map();
    this.listenerIdCounter = 0;
    this.isListening = false;
    this.boundRunCallbacks = this.runCallbacks.bind(this);
  }

  addScrollListener(classInstance, func) {
    const id = ++this.listenerIdCounter;
    const keyBase = `${classInstance.constructor.name}_${func.name}_${id}`;
    const key = keyBase.replace(/ /g, '_'); // Replace spaces with underscores
    const boundFunction = func.bind(classInstance);

    this.callbacks.set(key, boundFunction);

    if (!this.isListening) {
      window.addEventListener('scroll', this.boundRunCallbacks, { passive: true });
      this.isListening = true;
    }

    return {
      removeScrollListener: () => this.removeScrollListenerFunction(key),
    };
  }

  removeScrollListenerFunction(key) {
    if (this.callbacks.has(key)) {
      this.callbacks.delete(key);
    }

    if (this.callbacks.size === 0 && this.isListening) {
      window.removeEventListener('scroll', this.boundRunCallbacks);
      this.isListening = false;
    }
  }

  runCallbacks() {
    this.callbacks.forEach((callback) => callback());
  }
}

const scrollListener = new GlobalScrollListener();

class Responsive {
  constructor(enableGeneralBreakpointChange, trackWindowHeight) {
    this.settings();

    this.trackWindowHeight = trackWindowHeight;
    this.generalBreakpointChange = enableGeneralBreakpointChange;
    this.currentBreakpoint = this.getCurrentBreakpoint();
    this.breakpointListeners = new Map(); // Stores listeners with their status
    this.resizeCallbacks = new Map();
    this.listenerIdCounter = 0;

    this.setWindowHeight();
    this.initResizeListener();
  }

  initResizeListener() {
    this.boundHandleResize = this.handleResize.bind(this);
    window.addEventListener('resize', this.boundHandleResize);
  }

  settings() {
    this.matchBreakpoints = {
      phone: '(max-width: 640px)',
      tablet: '(min-width: 641px) and (max-width: 1024px)',
      tablet_and_up: '(min-width: 768px)',
      pocket: '(max-width: 1024px)',
      lap_and_up: '(min-width: 1025px)',
      desktop: '(min-width: 1280px)',
      desktop_wide: '(min-width: 1440px)',
    };

    this.currentBreakpoints = {
      phone: '(max-width: 640px)',
      pocket: '(max-width: 1024px)',
      tablet: '(min-width: 641px) and (max-width: 1024px)',
      desktop: '(min-width: 1025px)',
    };
  }

  handleResize() {
    const newBreakpoint = this.getCurrentBreakpoint();

    if (this.generalBreakpointChange) {
      // Check for general breakpoint change
      if (this.currentBreakpoint !== newBreakpoint) {
        document.dispatchEvent(
          new CustomEvent('breakpoint:changed', {
            detail: {
              previousBreakpoint: this.currentBreakpoint,
              currentBreakpoint: newBreakpoint,
            },
          }),
        );
      }
    }

    // Additional check for specific breakpoint
    this.breakpointListeners.forEach((value, key) => {
      const isCurrentlyInBreakpoint = this.matchesBreakpoint(key);
      if (value !== isCurrentlyInBreakpoint) {
        this.breakpointListeners.set(key, isCurrentlyInBreakpoint);
        document.body.dispatchEvent(
          new CustomEvent(`breakpoint:${key}`, {
            detail: {
              matches: isCurrentlyInBreakpoint,
            },
          }),
        );
      }
    });

    this.currentBreakpoint = newBreakpoint;

    this.setWindowHeight();

    // Run additional registered resize callbacks
    this.runCallbacks();
  }

  setWindowHeight() {
    if (this.trackWindowHeight) {
      document.documentElement.style.setProperty('--window-height', `${window.innerHeight}px`);
    }
  }

  matchesBreakpoint(breakpoint) {
    const query = this.matchBreakpoints[breakpoint];
    return window.matchMedia(`screen and ${query}`).matches;
  }

  getCurrentBreakpoint() {
    for (const [key, query] of Object.entries(this.currentBreakpoints)) {
      if (window.matchMedia(`screen and ${query}`).matches) {
        return key;
      }
    }
  }

  addBreakpointListener(breakpoint) {
    if (!this.matchBreakpoints[breakpoint]) {
      console.error('Breakpoint does not exist:', breakpoint);
      return;
    }

    if (this.breakpointListeners.has(breakpoint)) {
      console.warn('Listener already exists for breakpoint:', breakpoint);
      return;
    }

    const isInBreakpoint = this.matchesBreakpoint(breakpoint);
    this.breakpointListeners.set(breakpoint, isInBreakpoint);
  }

  addResizeListener(classInstance, func) {
    const id = ++this.listenerIdCounter;
    const keyBase = `${classInstance.constructor.name}_${func.name}_${id}`;
    const key = keyBase.replace(/ /g, '_'); // Replace spaces with underscores
    const boundFunction = func.bind(classInstance);

    this.resizeCallbacks.set(key, boundFunction);

    return {
      removeResizeListener: () => this.removeResizeListenerFunction(key),
    };
  }

  removeResizeListenerFunction(key) {
    if (this.resizeCallbacks.has(key)) {
      this.resizeCallbacks.delete(key);
    }
  }

  runCallbacks() {
    this.resizeCallbacks.forEach((callback) => callback());
  }
}

const responsive = new Responsive(false, true);

//use this for all popups
class Popup {
  constructor() {
    // Use a delegate for event handling on document.body.
    this.delegateBody = new Delegate(document.body);
    // Maintain a stack of active popups.
    this.activePopups = [];
    this.onPopupOpen = null;
    this.onPopupClose = null;
    this.bindEvents();
  }

  bindEvents() {
    // Bind a listener for clicks on toggle buttons.
    this.delegateBody.on('click', '[data-action="toggle-popup"]', this.handleOpenOptions.bind(this));

    // Listen for the custom "drawer:close-other" event to close all open popups.
    this.delegateBody.on('drawer:close-other', this.handleDrawerCloseOther.bind(this));

    this.delegateBody.on('edit-img:open-popup', this.handleOpenOptions.bind(this));

    // Bind keydown directly on the delegate element so it fires only once.
    this.delegateBody.on('keydown', this.handleEscape.bind(this));

    this.delegateBody.on('ui:close-other', (event) => {
      const source = event?.detail?.source;
      if (source === 'popup') return;
      if (this.activePopups.length) this.closeAllPopups();
    });
  }

  // This method is called when a toggle button is clicked.
  handleOpenOptions(event) {
    event.stopPropagation();
    event.preventDefault();

    const quickSearchBtn = event.target.closest('[data-action="toggle-popup"][aria-controls="quickSearch"]');
    if (quickSearchBtn) {
      const quickSearchEl = document.getElementById('quickSearch');
      const isOpening = quickSearchEl?.getAttribute('aria-hidden') !== 'false';

      // Only debounce the open path — closing must always pass through, otherwise
      // a tap on the X within the 500ms window is silently swallowed.
      if (isOpening) {
        if (document.body.dataset.quicksearchLock === '1') return;
        document.body.dataset.quicksearchLock = '1';

        document.querySelectorAll('[data-action="toggle-popup"][aria-controls="quickSearch"]').forEach((btn) => {
          btn.disabled = true;
        });

        setTimeout(() => {
          document.querySelectorAll('[data-action="toggle-popup"][aria-controls="quickSearch"]').forEach((btn) => {
            btn.disabled = false;
          });
          delete document.body.dataset.quicksearchLock;
        }, 500);
      }
    }

    const localizationBtn = event.target.closest('[data-action="toggle-popup"][aria-controls="modal-country"]');
    if (localizationBtn) {
      if (localizationBtn.disabled) return;
      localizationBtn.disabled = true;
      setTimeout(() => { localizationBtn.disabled = false; }, 500);
    }

    dynamicVars.syncHeight();
    const toggleButton = event.target.closest('[data-action="toggle-popup"]');
    if (toggleButton) {
      this.togglePopup(toggleButton);
      return;
    }

    // If a click occurs on the overlay or outside the top-most popup, close that popup.
    if (this.activePopups.length) {
      const topPopup = this.activePopups[this.activePopups.length - 1];
      const overlay = this.getOverlayElement(topPopup);
      const clickedOnOverlay = overlay && overlay.contains(event.target);
      const clickedOutsidePopup = !topPopup.contains(event.target);
      if (overlay && (clickedOnOverlay || clickedOutsidePopup)) {
        this.closePopup(topPopup);
      }
    }
  }

  // Handle keydown events.
  // Only close the top-most popup when Esc is pressed.
  handleEscape(event) {
    if (event.key === 'Escape' && this.activePopups.length) {
      event.preventDefault();
      event.stopPropagation();
      const topPopup = this.activePopups[this.activePopups.length - 1];
      if (topPopup.querySelector('[data-action="toggle-popup"]')) {
        topPopup.querySelector('[data-action="toggle-popup"]').click();
      } else {
        this.closePopup(topPopup);
      }
    }
  }

  // Toggle the popup associated with the given button.
  togglePopup(button) {
    const popupId = button.getAttribute('aria-controls');
    if (!popupId) return;

    const popupElement = document.getElementById(popupId);
    if (!popupElement) return;

    // Determine if this popup should be treated as a child popup.
    const isChild = button.getAttribute('data-child-popup') === 'true';

    // If the trigger is inside the mobile menu drawer, keep the drawer open.
    const preserveDrawerId = (button.closest('#Drawer') || button.closest('main-menu-dropdown')) ? 'Drawer' : undefined;

    // If the popup is already open, close it; otherwise, open it.
    if (popupElement.getAttribute('aria-hidden') === 'false') {
      this.closePopup(popupElement);
    } else {
      this.openPopup(popupElement, isChild, preserveDrawerId);
    }
  }

  // Open the popup element.
  // If it's not a child popup, close all currently open popups.
  openPopup(popupElement, isChild = false, preserveDrawerId = undefined) {
    const detail = { source: 'popup', id: popupElement?.id || null };
    if (preserveDrawerId) detail.preserveDrawerId = preserveDrawerId;
    document.body.dispatchEvent(new CustomEvent('ui:close-other', {
      bubbles: true,
      detail
    }));

    // Mark the popup element as a child (or not) for later checks.
    popupElement._isChild = isChild;
    popupElement._didQuickSearchCloseEvent = false;

    // Ensure the popup is visible before starting any animations.
    popupElement.style.display = 'block';

    // If this is a parent popup, close any other open popups.
    if (!isChild) {
      while (this.activePopups.length) {
        this._closePopup(this.activePopups.pop());
      }
    }

    popupElement.setAttribute('aria-hidden', 'false');
    popupElement.removeAttribute('inert');
    const overlay = this.getOverlayElement(popupElement);
    if (overlay) overlay.classList.add('is-visible');
    requestAnimationFrame(() => {
      popupElement.setAttribute('aria-expanded', 'true');
      if (typeof this.onPopupOpen === 'function') {
        this.onPopupOpen(popupElement);
      }

      if (popupElement.id === 'quickSearch') {
        document.body.classList.add('scrollLock');
        popupElement.dispatchEvent(new CustomEvent('quicksearch:open', { bubbles: true }));
        document.querySelectorAll('[data-action="toggle-popup"][aria-controls="quickSearch"]').forEach((btn) => {
          btn.classList.add('search-icon-active');
        });
      }
    });

    // Store the scrollable element reference on the popup for later use.
    const focus = popupElement.querySelector('[data-scrollable]');
    popupElement._scrollableElement = focus || popupElement;
    bodyScrollLock.disableBodyScroll(popupElement._scrollableElement, bodyScrollLockOptions);

    var scrollbarGap = window.innerWidth - document.documentElement.clientWidth;
    document.body.style.setProperty('--scrollbar-gap', (scrollbarGap > 0 ? scrollbarGap : 0) + 'px');
    document.body.classList.add('scrollLock');
    IOSScrollLock.lock();

    trapFocus(popupElement);
    if (overlay) {
      const handleOverlayClick = (e) => {
        e.preventDefault();
        this.closePopup(popupElement);
      };
      popupElement._overlayClickHandler = handleOverlayClick;
      overlay.addEventListener('click', handleOverlayClick);
    }

    // Push this popup onto the active stack.
    this.activePopups.push(popupElement);
  }

  // Close the popup element.
  closePopup(popupElement) {
    const index = this.activePopups.indexOf(popupElement);
    if (index !== -1) {
      // Save the scrollable element from the popup being closed.
      const closedScrollEl = popupElement._scrollableElement;
      this._closePopup(popupElement);
      this.activePopups.splice(index, 1);

      // If there is a new top popup, check for its scrollable element.
      if (this.activePopups.length > 0) {
        const topPopup = this.activePopups[this.activePopups.length - 1];
        if (topPopup._scrollableElement) {
          // Reapply the scroll lock to the new top popup's scrollable element.
          bodyScrollLock.disableBodyScroll(topPopup._scrollableElement, bodyScrollLockOptions);
        }
      } else {
        if (closedScrollEl) {
          bodyScrollLock.enableBodyScroll(closedScrollEl);
        }
        const mobileMenuOpen = document.getElementById('Drawer')?.getAttribute('aria-expanded') === 'true';
        if (!mobileMenuOpen) {
          document.body.classList.remove('scrollLock');
          document.body.style.removeProperty('--scrollbar-gap');
          IOSScrollLock.unlock();
        }
      }
    }
  }

  // Internal method to remove open styles and attributes from the popup,
  // then wait for the transition to finish before setting display: none.
  _closePopup(popupElement) {
    const overlay = this.getOverlayElement(popupElement);
    const overlayClass = popupElement.getAttribute('data-overlay');
    const isModalCountryClosing = overlayClass === 'sectionOverlay' && popupElement.id === 'modal-country';

    if (isModalCountryClosing) {
      document.body.classList.add('modal-country-closing');
      if (overlay) {
        if (popupElement._overlayClickHandler) {
          overlay.removeEventListener('click', popupElement._overlayClickHandler);
          delete popupElement._overlayClickHandler;
        }
        overlay.classList.add('is-closing');
      }
      removeTrapFocus(popupElement);
      const removeOverlayVisible = () => {
        const otherUsingOverlay = this.activePopups.some((p) => this.getOverlayElement(p) === overlay);
        if (overlay) {
          if (otherUsingOverlay) overlay.classList.remove('is-closing');
          else overlay.classList.remove('is-visible', 'is-closing');
        }
        document.body.classList.remove('modal-country-closing');
      };
      const dispatchQuickSearchClosedOnce = () => {
        if (popupElement.id !== 'quickSearch') return;
        if (popupElement._didQuickSearchCloseEvent) return;
        popupElement._didQuickSearchCloseEvent = true;
        popupElement.dispatchEvent(new CustomEvent('quicksearch:closed', { bubbles: true }));
        document.querySelectorAll('[data-action="toggle-popup"][aria-controls="quickSearch"]').forEach((btn) => {
          btn.classList.remove('search-icon-active');
        });
      };
      const finishClose = () => {
        popupElement.removeEventListener('transitionend', onModalTransitionEnd);
        clearTimeout(modalCloseFallback);
        popupElement.setAttribute('aria-expanded', 'false');
        popupElement.setAttribute('aria-hidden', 'true');
        popupElement.setAttribute('inert', '');
        popupElement.style.display = 'none';
        removeOverlayVisible();
        if (typeof this.onPopupClose === 'function') this.onPopupClose(popupElement);
        dispatchQuickSearchClosedOnce();
      };
      const onModalTransitionEnd = (e) => {
        if (e.target !== popupElement || e.propertyName !== 'opacity') return;
        finishClose();
      };
      const modalCloseFallback = setTimeout(finishClose, 400);
      popupElement.addEventListener('transitionend', onModalTransitionEnd);
      return;
    }

    popupElement.setAttribute('aria-expanded', 'false');
    if (overlay) {
      if (popupElement._overlayClickHandler) {
        overlay.removeEventListener('click', popupElement._overlayClickHandler);
        delete popupElement._overlayClickHandler;
      }
      if (overlayClass === 'sectionOverlay') {
        if (popupElement.id === 'modal-country') document.body.classList.add('modal-country-closing');
        overlay.classList.add('is-closing');
        const removeOverlayVisible = () => {
          const otherUsingOverlay = this.activePopups.some((p) => this.getOverlayElement(p) === overlay);
          const desktopMenuUsingOverlay = document.querySelector('.desktop-menu__nav-item[aria-expanded="true"]');
          if (otherUsingOverlay) overlay.classList.remove('is-closing');
          else if (desktopMenuUsingOverlay) overlay.classList.remove('is-closing');
          else overlay.classList.remove('is-visible', 'is-closing');
          if (popupElement.id === 'modal-country') document.body.classList.remove('modal-country-closing');
          overlay.removeEventListener('transitionend', onOverlayTransitionEnd);
          clearTimeout(overlayCloseFallback);
        };
        const onOverlayTransitionEnd = (e) => {
          if (e.target === overlay && e.propertyName === 'opacity') removeOverlayVisible();
        };
        overlay.addEventListener('transitionend', onOverlayTransitionEnd);
        const overlayCloseFallback = setTimeout(removeOverlayVisible, 400);
      } else {
        overlay.classList.remove('is-visible');
      }
    }

    removeTrapFocus(popupElement);

    const dispatchQuickSearchClosedOnce = () => {
      if (popupElement.id !== 'quickSearch') return;
      if (popupElement._didQuickSearchCloseEvent) return;
      popupElement._didQuickSearchCloseEvent = true;
      document.body.classList.remove('scrollLock');
      popupElement.dispatchEvent(new CustomEvent('quicksearch:closed', { bubbles: true }));
      document.querySelectorAll('[data-action="toggle-popup"][aria-controls="quickSearch"]').forEach((btn) => {
        btn.classList.remove('search-icon-active');
      });
    };

    const transitionEndHandler = () => {
      popupElement.setAttribute('aria-hidden', 'true');
      popupElement.setAttribute('inert', '');
      popupElement.style.display = 'none';
      popupElement.removeEventListener('transitionend', transitionEndHandler);
      // Trigger the close callback after the transition ends.
      if (typeof this.onPopupClose === 'function') {
        this.onPopupClose(popupElement);
      }
      dispatchQuickSearchClosedOnce();
    };

    setTimeout(() => {
      popupElement.setAttribute('aria-hidden', 'true');
      popupElement.setAttribute('inert', '');
      popupElement.style.display = 'none';
      popupElement.removeEventListener('transitionend', transitionEndHandler);
      dispatchQuickSearchClosedOnce();
    }, 500);

    popupElement.addEventListener('transitionend', transitionEndHandler);
  }

  // Method to handle the custom event "drawer:close-other".
  // It closes all currently open popups.
  handleDrawerCloseOther(event) {
    event.preventDefault();
    this.closeAllPopups();
  }

  // Method to close all open popups.
  closeAllPopups() {
    const n = this.activePopups.length;
    while (this.activePopups.length) {
      const popup = this.activePopups.pop();
      if (popup._scrollableElement) {
        bodyScrollLock.enableBodyScroll(popup._scrollableElement);
      }
      this._closePopup(popup);
    }
    document.body.classList.remove('scrollLock');
    document.body.style.removeProperty('--scrollbar-gap');
    for (let i = 0; i < n; i++) IOSScrollLock.unlock();
  }

  // Retrieve the overlay element based on the popup's data-overlay attribute.
  getOverlayElement(popupElement) {
    const overlayClass = popupElement.getAttribute('data-overlay');
    if (overlayClass) {
      return document.querySelector(`.${overlayClass}`);
    }
    return null;
  }
}

window.globalPopup = new Popup();

class dynamicVariables {
  constructor() {
    document.documentElement.style.setProperty('--viewport_width', `${document.documentElement.clientWidth}px`);

    document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);

    responsive.addResizeListener(this, this.sync.bind(this));
  }

  sync() {
    this.syncWidth();
    this.syncHeight();
  }

  syncWidth() {
    document.documentElement.style.setProperty('--viewport_width', `${document.documentElement.clientWidth}px`);
  }

  syncHeight() {
    document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
  }
}

const dynamicVars = new dynamicVariables();

class RevolutionImageZoom {
  constructor(element, slideshow) {
    this.element = element;
    this.slideshow = slideshow;

    this.delegateElement = new Delegate(this.element);
    this.delegateRoot = new Delegate(document.body);

    loadScript(window.theme.pswpScript);

    this.photoSwipeInstance = null;
    this.pswpThumbEls = null;
    this.pswpBulletEls = null;

    this.syncHeight();
    this.bindEvents();
  }

  isMobile() {
    return window.matchMedia("(max-width: 1024px)").matches;
  }

  syncHeight() {
    document.documentElement.style.setProperty("--window-inner-height", `${window.innerHeight}px`);
  }

  syncPswpColorScheme() {
    const pswp = document.querySelector(".pswp");
    const productRoot = document.querySelector("product-component.main-product");

    if (!pswp || !productRoot) return;

    [...pswp.classList].forEach((c) => {
      if (c.startsWith("colorGroup--")) pswp.classList.remove(c);
    });

    const schemeClass = [...productRoot.classList].find((c) => c.startsWith("colorGroup--"));
    if (schemeClass) pswp.classList.add(schemeClass);
  }

  bindEvents() {
    responsive.addResizeListener(this, this.syncHeight.bind(this));

    this.delegateElement.on(
      "click",
      '[data-action="open-product-zoom"]',
      this.initPhotoSwipe.bind(this)
    );

    this.delegateElement.on("click", ".ProductSliderCell--Zoom", (e) => {
      const slide = e.target.closest(".ProductSliderCell--Zoom");
      if (!slide) return;
      this.initPhotoSwipeFromImageClick(e, slide);
    });

    this.delegateRoot.on("pswpTap", ".pswp__button--close", this.photoswiperClose.bind(this));
  }

  photoswiperClose() {
    if (/iPhone|iPad|iPod/i.test(window.navigator.userAgent)) {
      document.documentElement.classList.remove("pswp-open-in-ios");
    }
  }

  initPhotoSwipe() {
    this.syncPswpColorScheme();

    const images = [];
    let index = 0;

    if (this.slideshow?.swiperElement) {
      this.slideshow.swiperElement.slides.forEach((slide) => {
        if (slide.classList.contains("ProductSliderCell--Zoom")) {
          const img = slide.querySelector("img");
          if (img) images.push(img);
        }
      });

      const current = this.slideshow.swiperElement.realIndex || 0;
      const currentSlide = this.slideshow.swiperElement.slides[current];
      const posAttr = currentSlide
        ?.querySelector(".ProductSlider--Element")
        ?.getAttribute("data-image-position");

      index = parseInt(posAttr, 10) || 0;
    } else {
      const img =
        this.element.querySelector(".ProductSlider--Image") ||
        document.querySelector(".ProductSlider--Image");
      if (img) images.push(img);
    }

    const items = this.createPhotoSwipeItemsFromImages(images);
    this.createPhotoSwipeInstance(items, index);
  }

  initPhotoSwipeFromImageClick(event, targetSlide) {
    this.syncPswpColorScheme();

    const images = [];
    const siblings = Array.from(targetSlide.parentElement?.children || []);

    siblings.forEach((slide) => {
      if (slide.classList.contains("ProductSliderCell--Zoom")) {
        const img = slide.querySelector("img");
        if (img) images.push(img);
      }
    });

    const posAttr = targetSlide
      .querySelector(".ProductSlider--Element")
      ?.getAttribute("data-image-position");

    const index = parseInt(posAttr, 10) || 0;

    const items = this.createPhotoSwipeItemsFromImages(images);
    this.createPhotoSwipeInstance(items, index);
  }

  createPhotoSwipeItemsFromImages(images) {
    const isMobile = this.isMobile();

    const desktopWidth = 625;
    const desktopHeight = 755;

    return images.map((image) => {
      const fullWidth =
        parseInt(image.getAttribute("data-max-width"), 10) || image.naturalWidth || 2000;
      const fullHeight =
        parseInt(image.getAttribute("data-max-height"), 10) || image.naturalHeight || 2000;

      const src = image.dataset.originalSrc || image.currentSrc || image.src;
      const msrc = image.currentSrc || image.src;

      if (isMobile) {
        const vw = window.innerWidth || 360;
        const vh = window.innerHeight || 640;
        const fitZoom = Math.min(vw / fullWidth, vh / fullHeight);

        return {
          msrc,
          src,
          w: fullWidth,
          h: fullHeight,
          initialZoomLevel: fitZoom,
          initZoomLevel: fitZoom
        };
      }

      const initialZoomLevel = desktopWidth / fullWidth;

      return {
        msrc,
        src,
        w: desktopWidth,
        h: desktopHeight,
        initialZoomLevel,
        initZoomLevel: initialZoomLevel
      };
    });
  }

  buildPswpThumbsUI(items) {
    const pswp = document.querySelector(".pswp");
    const list = pswp?.querySelector(".pswp__thumbs-list");
    if (!pswp || !list) return;

    list.innerHTML = "";

    items.forEach((item, i) => {
      const btn = document.createElement("button");
      btn.type = "button";
      btn.className = "pswp__thumb";
      btn.setAttribute("aria-label", `Open image ${i + 1}`);

      const img = document.createElement("img");
      img.src = item.msrc || item.src;
      img.loading = "lazy";
      img.decoding = "async";

      btn.appendChild(img);

      const handler = (ev) => {
        ev.preventDefault();
        ev.stopPropagation();
        ev.stopImmediatePropagation?.();

        if (!this.photoSwipeInstance) return;
        this.photoSwipeInstance.goTo(i);
        this.syncPswpThumbActive();
        this.syncPswpBulletsActive();
      };

      btn.addEventListener("click", handler, true);
      btn.addEventListener("pointerdown", handler, true);

      list.appendChild(btn);
    });

    this.pswpThumbEls = Array.from(list.querySelectorAll(".pswp__thumb"));
  }

  syncPswpThumbActive() {
    if (!this.photoSwipeInstance || !this.pswpThumbEls?.length) return;

    const idx = this.photoSwipeInstance.getCurrentIndex();
    this.pswpThumbEls.forEach((el, i) => el.classList.toggle("is-active", i === idx));

    const active = this.pswpThumbEls[idx];
    if (active) active.scrollIntoView({ block: "nearest" });
  }

  ensureBulletsContainer() {
    const pswp = document.querySelector(".pswp");
    const ui = pswp?.querySelector(".pswp__ui");
    if (!pswp || !ui) return null;

    let wrap = pswp.querySelector(".pswp__bullets");
    if (!wrap) {
      wrap = document.createElement("div");
      wrap.className = "pswp__bullets";
      wrap.setAttribute("aria-hidden", "true");
      ui.appendChild(wrap);
    }
    return wrap;
  }

  buildPswpBulletsUI(items) {
    if (!this.isMobile()) return;
    if (!items || items.length <= 1) return;

    const wrap = this.ensureBulletsContainer();
    if (!wrap) return;

    wrap.innerHTML = "";

    items.forEach((_, i) => {
      const btn = document.createElement("button");
      btn.type = "button";
      btn.className = "pswp__bullet";
      btn.setAttribute("aria-label", `Go to image ${i + 1}`);

      const handler = (ev) => {
        ev.preventDefault();
        ev.stopPropagation();
        ev.stopImmediatePropagation?.();

        if (!this.photoSwipeInstance) return;
        this.photoSwipeInstance.goTo(i);
        this.syncPswpBulletsActive();
        this.syncPswpThumbActive();
      };

      btn.addEventListener("click", handler, true);
      btn.addEventListener("pointerdown", handler, true);

      wrap.appendChild(btn);
    });

    this.pswpBulletEls = Array.from(wrap.querySelectorAll(".pswp__bullet"));
  }

  syncPswpBulletsActive() {
    if (!this.photoSwipeInstance || !this.pswpBulletEls?.length) return;

    const idx = this.photoSwipeInstance.getCurrentIndex();
    this.pswpBulletEls.forEach((el, i) => el.classList.toggle("is-active", i === idx));
  }

  teardownPswpBulletsUI() {
    const pswp = document.querySelector(".pswp");
    const wrap = pswp?.querySelector(".pswp__bullets");
    if (wrap) wrap.innerHTML = "";
    this.pswpBulletEls = null;
  }

  enableThumbsScrolling() {
    const pswp = document.querySelector(".pswp");
    const thumbs = pswp?.querySelector(".pswp__thumbs");
    if (!thumbs) return;

    const stop = (e) => {
      e.stopPropagation();
      e.stopImmediatePropagation?.();
    };

    thumbs.style.touchAction = "pan-y";
    thumbs.style.webkitOverflowScrolling = "touch";

    thumbs.addEventListener("wheel", stop, { capture: true, passive: true });

    thumbs.addEventListener(
      "touchmove",
      (e) => {
        stop(e);
        e.preventDefault();
      },
      { capture: true, passive: false }
    );

    thumbs.addEventListener(
      "pointermove",
      (e) => {
        stop(e);
      },
      { capture: true, passive: true }
    );
  }

  createPhotoSwipeInstance(items, selectedImageIndex) {
    const photoswipeContainer = document.querySelector(".pswp");
    if (!photoswipeContainer) return;

    const isMobile = this.isMobile();

    const thumbsForBounds = Array.from(
      this.element.querySelectorAll(".mainSwiper .ProductSliderCell--Zoom img")
    );

    this.photoSwipeInstance = new PhotoSwipe(photoswipeContainer, false, items, {
      index: selectedImageIndex,
      showHideOpacity: true,
      showAnimationDuration: 450,
      loop: false,
      history: false,

      closeOnVerticalDrag: false,

      allowPanToNext: isMobile ? true : false,

      pinchToClose: false,
      errorMsg: '<p class="pswp__error-msg"></p>',

      scaleMode: isMobile ? "fit" : "orig",

      counterEl: false,
      arrowEl: true,
      preloaderEl: true,

      getDoubleTapZoom: (isMouseClick, item) => {
        if (isMouseClick) return 1.35;
        return item.initialZoomLevel < 0.7 ? 1 : 1.33;
      },

      getThumbBoundsFn: (i) => {
        const thumb = thumbsForBounds[i];
        if (!thumb) return { x: 0, y: 0, w: 0 };
        const pageYScroll = window.pageYOffset || document.documentElement.scrollTop;
        const rect = thumb.getBoundingClientRect();
        return { x: rect.left, y: rect.top + pageYScroll, w: rect.width };
      }
    });

    window.pswp = this.photoSwipeInstance;

    this.photoSwipeInstance.listen("beforeChange", this.onslideChanged.bind(this));
    this.photoSwipeInstance.listen("doubleTap", this.onDoubleTap.bind(this));
    this.photoSwipeInstance.listen("initialZoomIn", this.onInitialZoomIn.bind(this));
    this.photoSwipeInstance.listen("initialZoomOut", this.onInitialZoomOut.bind(this));
    this.photoSwipeInstance.listen("close", this.photoswiperClose.bind(this));

    this.photoSwipeInstance.listen("destroy", () => {
      this.delegateRoot.off("pswpTap");
      this.pswpThumbEls = null;
      this.teardownPswpBulletsUI();
      this.photoSwipeInstance = null;
    });

    this.delegateRoot.on("pswpTap", ".pswp__scroll-wrap", this.onSingleTap.bind(this));

    this.delegateRoot.on("pswpTap", ".pswp__button--close", () => this.photoSwipeInstance?.close());
    this.delegateRoot.on("pswpTap", ".pswp__button--prev", () => this.photoSwipeInstance?.prev());
    this.delegateRoot.on("pswpTap", ".pswp__button--next", () => this.photoSwipeInstance?.next());

    if (/iPhone|iPad|iPod/i.test(window.navigator.userAgent)) {
      document.documentElement.classList.add("pswp-open-in-ios");
    }

    this.buildPswpThumbsUI(items);
    this.buildPswpBulletsUI(items);

    this.photoSwipeInstance.listen("afterChange", () => {
      this.syncPswpThumbActive();
      this.syncPswpBulletsActive();
    });

    this.photoSwipeInstance.listen("initialZoomInEnd", () => {
      if (!this.isMobile()) {
        const item = this.photoSwipeInstance.currItem;
        if (item) {
          const center = { x: window.innerWidth / 2, y: window.innerHeight / 2 };
          this.photoSwipeInstance.zoomTo(item.initialZoomLevel, center, 0);
        }
      }

      this.syncPswpThumbActive();
      this.syncPswpBulletsActive();
    });

    this.photoSwipeInstance.init();
    this.syncPswpThumbActive();
    this.syncPswpBulletsActive();

    this.enableThumbsScrolling();
  }

  onslideChanged() {
    const prevBtn = this.photoSwipeInstance.scrollWrap.querySelector(".pswp__button--prev");
    const nextBtn = this.photoSwipeInstance.scrollWrap.querySelector(".pswp__button--next");

    if (this.photoSwipeInstance.getCurrentIndex() === 0) {
      prevBtn?.setAttribute("disabled", "disabled");
      if (prevBtn) prevBtn.style.display = "none";
    } else {
      prevBtn?.removeAttribute("disabled");
      if (prevBtn) prevBtn.style.display = "flex";
    }

    if (
      this.photoSwipeInstance.getCurrentIndex() + 1 ===
      this.photoSwipeInstance.options.getNumItemsFn()
    ) {
      nextBtn?.setAttribute("disabled", "disabled");
      if (nextBtn) nextBtn.style.display = "none";
    } else {
      nextBtn?.removeAttribute("disabled");
      if (nextBtn) nextBtn.style.display = "flex";
    }
  }

  onSingleTap(event) {
    const inThumbs = event?.target?.closest?.(".pswp__thumbs");
    const inBullets = event?.target?.closest?.(".pswp__bullets");
    if (inThumbs || inBullets) return;

    if (!event.detail || event.detail.pointerType === "mouse") {
      if (event.target.classList.contains("pswp__img")) {
        this.photoSwipeInstance.toggleDesktopZoom(event.detail.releasePoint);
      }
      return;
    }

    if (event.target.classList.contains("pswp__button")) return;

    event.target
      .closest(".pswp")
      .querySelector(".pswp__ui")
      .classList.toggle("pswp__ui--hidden");
  }

  onDoubleTap(point) {
    const initialZoomLevel = this.photoSwipeInstance.currItem.initialZoomLevel;

    if (this.photoSwipeInstance.getZoomLevel() !== initialZoomLevel) {
      this.photoSwipeInstance.zoomTo(initialZoomLevel, point, 333);
    } else {
      this.photoSwipeInstance.zoomTo(initialZoomLevel < 0.7 ? 1 : 1.33, point, 333);
    }
  }

  onInitialZoomIn() {
    document.querySelector(".pswp__ui")?.classList.remove("pswp__ui--hidden");
  }

  onInitialZoomOut() {
    document.querySelector(".pswp__ui")?.classList.add("pswp__ui--hidden");
  }
}

class RevolutionSelectbox {
  constructor(element, popover) {
    this.element = element;
    this.popover = popover;
    this.domDelegate = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);
    this.dropdown = this.element.querySelector('.RevolutionSelectbox');
    this.isOpen = false;
    this.mainDropdown = this.element.querySelector('.RevolutionSelectbox--Content');

    this.mainDropdownContent = this.element.querySelector('.RevolutionSelectbox--InnerContent');
    this.mainButton = this.element.querySelector('.RevolutionSelectbox--Button');
    this.toggleLockTimeout = null;

    this.connectedSelect = this.element.getAttribute('data-select');
    this.selectbox = this.element.querySelector('[name=' + this.connectedSelect + ']');
    if (this.selectbox == null) {
      this.selectbox = this.element.querySelector('[name2=' + this.connectedSelect + ']');
    }
    if (this.popover == true) {
      this.mainDropdown.classList.remove("RevolutionSelectbox--animation");
      this.mainDropdown.classList.add("PopoverContent");
      this.pageOverlayElement = document.querySelector(".pageOverlay");
    }
    this.bindEvents();
    this.initSelectbox();
  }

  bindEvents() {
    this.onClickOutsideListener = this.onClickOutside.bind(this);
    this.domDelegate.on('click', '[data-action=toggle-selectbox]', this.toggleDropdown.bind(this));

    this.domDelegate.on('click', '[data-action=selectbox-submit]', this.selectboxSubmit.bind(this));
    this.domDelegate.on('keypress', '[data-action=selectbox-submit]', this.selectboxSubmit.bind(this));

    this.domDelegate.on('click', '[data-action=selectbox-change]', this.selectboxChange.bind(this));

    this.delegateBody.on('menu:open', this.onClickOutside.bind(this));
    this.domDelegate.on('click', 'body', this.onClickOutside.bind(this));
  }

  selectboxChange() {
    var value = event.target.getAttribute('data-value');
    var selectboxID = event.target.getAttribute('data-selectboxid');
    var innerContent = event.target.innerHTML;
    var selEl = this.element.querySelector('#' + selectboxID);
    if (selEl.nodeName == 'SELECT') {
      selEl.value = value;
      selEl.dispatchEvent(new Event("change"));
    } else if (selEl.nodeName == "INPUT" && ( selEl.id === "country-selector__country-code" || selEl.id === "language-selector__language-code")) {
      return;
    } else {
      selEl.querySelector('[value="' + value + '"]').setAttribute('checked', 'true');
    }
    this.mainButton.querySelector('.RevolutionSelectbox--Title').innerHTML = innerContent;

    if (this.element.classList.contains('dropdownSelector')) {
      this.element.querySelector('.RevolutionSelectbox--Item[disabled="true"]').removeAttribute('disabled');
      event.target.setAttribute('disabled', 'true');
    }
    this.closeDropdown(this.element);
  }

  onClickOutside(event) {
    const withinBoundaries = event.composedPath().includes(this.element);
    if (!withinBoundaries || event.target.classList.contains('FiltersDesktopWrapper')) {
      this.closeDropdown(this.element);
    }
  }

  selectboxSubmit(event) {
    if (event.key != 'Enter' && event.key !== undefined) {
      return;
    }
    var value = event.target.getAttribute('data-value');
    var dataName = event.target.getAttribute('data-name');
    this.selectbox.value = value;
    this.closeDropdown(this.element);
    this.mainButton.querySelector('.RevolutionSelectbox--Title').innerHTML = dataName;
    this.selectbox.parentElement.submit();
  }

  initSelectbox() {
    const selectedItem = this.mainDropdown.querySelector('[selected="selected"]'),
      titleElement = this.element.querySelector('.RevolutionSelectbox--Title');
    if (selectedItem) {
      titleElement.innerHTML = selectedItem.getAttribute('data-name');
    }

    trapFocus(this.element);
    this.element.style.display = 'block';
  }

  toggleDropdown(event, target) {
    event.preventDefault();
    const button = target?.closest('.RevolutionSelectbox--Button') || this.mainButton;
    if (button?.disabled) return;
    button.disabled = true;
    clearTimeout(this.toggleLockTimeout);
    this.toggleLockTimeout = setTimeout(() => {
      button.disabled = false;
    }, 400);

    if (this.isOpen) {
      this.closeDropdown(target);
    } else {
      this.openDropdown(target);
    }
  }

  openDropdown(target) {
    // Dispatch "close:search" and "menu:close" events on the element.
    this.element.dispatchEvent(new CustomEvent('close:search', { bubbles: true }));
    this.element.dispatchEvent(new CustomEvent('menu:close', { bubbles: true }));

    // Find all siblings with class ".RevolutionSelectbox".
    const siblings = Array.from(target.parentElement.parentElement.children).filter((item) =>
      item.classList.contains('RevolutionSelectbox'),
    );

    // Hide the dropdown content for all siblings.
    siblings.forEach((item) => {
      const content = item.querySelector('.RevolutionSelectbox--Content');
      item.querySelector('.RevolutionSelectbox--Button').setAttribute('aria-expanded', false);
      content.setAttribute('aria-hidden', true);
      content.style.display = 'none';
      if (content.closest('#modal-country')) content.style.height = '';
    });

    // If the dropdown is a popover, show the page overlay and disable body scrolling.
    if (this.popover) {
      this.pageOverlayElement.classList.add('is-visible');
      this.pageOverlayElement.addEventListener('click', this.onClickOutsideListener);
      const focus = this.element.querySelector('[data-scrollable]');
      bodyScrollLock.disableBodyScroll(focus || this.mainDropdown, bodyScrollLockOptions);
      document.body.style.setProperty('--scrollbar-gap', (window.innerWidth - document.documentElement.clientWidth > 0 ? window.innerWidth - document.documentElement.clientWidth : 0) + 'px');
      document.body.classList.add('scrollLock');
      IOSScrollLock.lock();
      trapFocus(this.mainDropdown);
      if (document.querySelector('#Drawer').getAttribute('aria-expanded') === 'true') {
        document.querySelector('#Drawer .mobile-menu__wrapper').style.overflow = 'visible';
      }
    }

    // Show the dropdown content for the target element and set its state to "expanded".
    const contentElement = target.parentElement.querySelector('.RevolutionSelectbox--Content');
    target.setAttribute('aria-expanded', 'true');
    contentElement.style.display = 'block';
    if (!contentElement.closest('#modal-country')) {
      contentElement.style.height = `${contentElement.offsetHeight}px`;
    } else {
      contentElement.style.height = '';
    }

    if (this.popover) {
      setTimeout(() => {
        contentElement.setAttribute('aria-hidden', 'false');
      }, 20);
    } else {
      setTimeout(() => {
        contentElement.setAttribute('aria-hidden', 'false');
      }, 20);
    }

    this.isOpen = true;
    window.addEventListener('click', this.onClickOutsideListener);
  }

  closeDropdown(target) {
    var closestDropdown = target.closest('.RevolutionSelectbox');
    if (closestDropdown === null) {
      var closestDropdown = target.querySelector(
        "[aria-expanded='true']"
      ).parentElement;
    }
    closestDropdown
      .querySelector(".RevolutionSelectbox--Button")
      .setAttribute("aria-expanded", false);
    const contentEl = closestDropdown.querySelector(".RevolutionSelectbox--Content");
    contentEl.setAttribute("aria-hidden", true);
    if (contentEl.closest('#modal-country')) contentEl.style.height = '';
    setTimeout(() => {
      contentEl.style.display = "none";
    }, 300);

    if (this.popover == true) {
      this.pageOverlayElement.classList.remove('is-visible');
      this.pageOverlayElement.removeEventListener('click', this.onClickOutsideListener);

      const menuDrawer = document.querySelector('#Drawer');
      if (menuDrawer.getAttribute('aria-expanded') == "true") {
        document.querySelector('#Drawer .mobile-menu__wrapper').style.overflow = "auto";
      } else if (!this.element.closest('#modal-country')) {
        bodyScrollLock.clearAllBodyScrollLocks();
        document.body.classList.remove('scrollLock');
        document.body.style.removeProperty('--scrollbar-gap');
        IOSScrollLock.unlock();
      }
    }
    this.isOpen = false;
    removeTrapFocus(this.mainDropdownContent);
    window.removeEventListener('click', this.onClickOutsideListener);
  }
}
class FormValidator {
  constructor(formElement, options = {}) {
    this.form = formElement;
    this.options = {
      errorClass: 'field--error',
      fieldSelector: '.field',
      buttonSelector: null,
      validateOnBlur: true,
      validateOnInput: false,
      errorOutputSelector: null,
      fieldErrorSelector: null,
      showErrorsOnSubmitOnly: false,
      ...options,
    };

    this.customValidators = new Map();
    this.hasSubmittedOnce = false;
    this.init();
  }

  init() {
    this.setupEventListeners();
    this.setupButtonListener();

    if (this.options.buttonSelector) {
      if (this.options.showErrorsOnSubmitOnly) {
        this.enableButton();
      } else {
        this.updateButtonState();
      }
    }
  }

  enableButton() {
    if (!this.options.buttonSelector) return;

    const button = document.querySelector(this.options.buttonSelector);
    if (!button) return;

    button.removeAttribute('disabled');
    button.classList.remove('disabled');
    button.setAttribute('aria-disabled', 'false');
  }

  setupButtonListener() {
    if (!this.options.buttonSelector) return;

    const button = document.querySelector(this.options.buttonSelector);
    if (!button) return;

    button.addEventListener('click', (e) => {
      this.markSubmitted();
      const isValid = this.showAllErrors();

      if (button.type === 'submit' && !isValid) {
        e.preventDefault();
      }
    });
  }

  outputErrors(errors) {
    if (!this.options.errorOutputSelector) return;

    if (this.options.showErrorsOnSubmitOnly && !this.hasSubmittedOnce) {
      return;
    }

    const container =
      typeof this.options.errorOutputSelector === 'string'
        ? document.querySelector(this.options.errorOutputSelector)
        : this.options.errorOutputSelector;
    if (!container) return;

    container.innerHTML = '';
    if (errors.length > 0) {
      container.innerHTML = errors.join('<br>');
    }
  }

  getFieldErrorContainer(field) {
    if (!this.options.fieldErrorSelector) return null;

    const fieldContainer = field.closest(this.options.fieldSelector);
    if (!fieldContainer) return null;

    let el = fieldContainer.querySelector(this.options.fieldErrorSelector);

    if (!el) {
      const outerContainer = fieldContainer.closest('.field-container');
      if (outerContainer) {
        el = outerContainer.querySelector(this.options.fieldErrorSelector);
      }
    }

    if (!el) {
      const targetContainer =
        fieldContainer.closest('.field-container') || fieldContainer;
      el = document.createElement('div');
      el.className = this.options.fieldErrorSelector.replace(/^\./, '');
      el.setAttribute('aria-live', 'polite');
      targetContainer.appendChild(el);
    }

    return el;
  }

  getFieldErrorMessage(field) {
    if (!field.value.trim()) {
      if (field.hasAttribute('required')) return field.validationMessage || 'This field is required';
      return '';
    }
    if (field.type === 'email' && !this.isValidEmail(field.value)) {
      return 'Please enter a valid email address';
    }
    if (this.customValidators.has(field.id)) {
      const { validatorFn, errorMessage } = this.customValidators.get(field.id);
      const result = validatorFn(field.value, field);
      if (typeof result === 'string') return result;
      if (!result) return errorMessage || 'Invalid';
    }
    if (!this.isFieldValid(field) && field.validationMessage) return field.validationMessage;
    return '';
  }

  setFieldErrorOutput(field, message) {
    const container = this.getFieldErrorContainer(field);
    if (!container) return;
    container.textContent = message || '';
  }

  updateFieldErrorOutputs() {
    if (!this.options.fieldErrorSelector) return;
    if (this.options.showErrorsOnSubmitOnly && !this.hasSubmittedOnce) return;
    this.form.querySelectorAll('input, textarea, select').forEach((field) => {
      const fieldContainer = field.closest(this.options.fieldSelector);
      if (!fieldContainer) return;
      const message = fieldContainer.classList.contains(this.options.errorClass)
        ? this.getFieldErrorMessage(field)
        : '';
      this.setFieldErrorOutput(field, message);
    });
  }

  setupEventListeners() {
    const inputs = this.form.querySelectorAll('input, textarea, select');

    inputs.forEach((input) => {
      input.addEventListener('input', () => this.handleInputForErrorClearing(input));
      if (this.options.validateOnBlur) {
        input.addEventListener('blur', () => this.handleFieldBlur(input));
      }
      input.addEventListener('change', () => this.handleInputChange(input));
    });
  }

  handleInputChange(input) {
    if (this.options.showErrorsOnSubmitOnly && !this.hasSubmittedOnce) {
      return;
    }

    // Always clear errors for empty fields
    if (!input.value.trim()) {
      this.clearFieldError(input);
    } else if (this.options.validateOnInput) {
      this.validateField(input, false);
    } else {
      this.handleInputForErrorClearing(input);
    }

    this.updateErrorOutput();

    if (this.options.buttonSelector) {
      this.updateButtonState();
    }
  }

  updateErrorOutput() {
    if (this.options.showErrorsOnSubmitOnly && !this.hasSubmittedOnce) return;

    if (this.options.errorOutputSelector) {
      const errors = this.getAllErrors();
      this.outputErrors(errors);
    }
    this.updateFieldErrorOutputs();
  }

  // Updated to not include errors for empty fields
  getAllErrors() {
    const errors = [];
    this.form.querySelectorAll('input, textarea, select').forEach((field) => {
      // Skip empty fields - don't show errors for them
      if (!field.value.trim()) {
        return;
      }

      if (!this.isFieldValid(field)) {
        if (this.customValidators.has(field.id)) {
          const { validatorFn } = this.customValidators.get(field.id);
          const result = validatorFn(field.value, field);
          if (typeof result === 'string') {
            errors.push(result);
          }
        } else if (field.validationMessage) {
          errors.push(field.validationMessage);
        } else {
          // Only show validation errors for non-empty fields
          if (field.type === 'email' && field.value && !this.isValidEmail(field.value)) {
            errors.push(`Please enter a valid email address`);
          }
        }
      }
    });
    return errors;
  }

  handleInputForErrorClearing(input) {
    if (this.options.showErrorsOnSubmitOnly && !this.hasSubmittedOnce) return;

    const fieldContainer = input.closest(this.options.fieldSelector);
    if (!fieldContainer) return;

    // Clear error if field is empty or valid
    if (!input.value.trim() || this.isFieldValid(input)) {
      fieldContainer.classList.remove(this.options.errorClass);
      this.updateErrorOutput();
    }

    if (this.options.buttonSelector) {
      this.updateButtonState();
    }
  }

  handleFieldBlur(input) {
    if (this.options.showErrorsOnSubmitOnly && !this.hasSubmittedOnce) return;

    // Only validate non-empty fields on blur
    if (input.value.trim()) {
      this.validateField(input, false);
    }

    this.updateErrorOutput();

    if (this.options.buttonSelector) {
      this.updateButtonState();
    }
  }

  clearFieldError(field) {
    const fieldContainer = field.closest(this.options.fieldSelector);
    if (fieldContainer && fieldContainer.classList.contains(this.options.errorClass)) {
      fieldContainer.classList.remove(this.options.errorClass);
    }
    if (this.options.fieldErrorSelector) {
      this.setFieldErrorOutput(field, '');
    }
  }

  addValidator(fieldId, validatorFn, errorMessage) {
    this.customValidators.set(fieldId, { validatorFn, errorMessage });
  }

  validateField(field, silent = true) {
    const fieldContainer = field.closest(this.options.fieldSelector);
    if (!fieldContainer) return true;

    // Don't show errors for empty fields (but they may still be invalid for form submission)
    if (!field.value.trim()) {
      fieldContainer.classList.remove(this.options.errorClass);
      if (this.options.fieldErrorSelector) this.setFieldErrorOutput(field, '');
      return this.isFieldValid(field); // Return actual validity for button state
    }

    const isValid = this.isFieldValid(field);
    const shouldShowErrors = !silent && (!this.options.showErrorsOnSubmitOnly || this.hasSubmittedOnce);

    if (shouldShowErrors) {
      if (isValid) {
        fieldContainer.classList.remove(this.options.errorClass);
        this.setFieldErrorOutput(field, '');
      } else {
        fieldContainer.classList.add(this.options.errorClass);
        this.setFieldErrorOutput(field, this.getFieldErrorMessage(field));
      }
    } else if (isValid) {
      fieldContainer.classList.remove(this.options.errorClass);
      this.setFieldErrorOutput(field, '');
    }

    return isValid;
  }

  markSubmitted() {
    this.hasSubmittedOnce = true;
    if (this.options.buttonSelector) {
      this.updateButtonState();
    }
  }

  isFieldValid(field) {
    if (field.hasAttribute('required')) {
      const isEmpty = (field.type === 'checkbox' || field.type === 'radio') ? !field.checked : !field.value.trim();
      if (isEmpty) return false;
    }

    // Check email format (only if field has value)
    if (field.type === 'email' && field.value && !this.isValidEmail(field.value)) {
      return false;
    }

    // Check custom validators
    if (this.customValidators.has(field.id)) {
      const { validatorFn } = this.customValidators.get(field.id);
      const result = validatorFn(field.value, field);
      if (typeof result === 'string') {
        return false;
      }
      return !!result;
    }

    return true;
  }

  validateForm(silent = true) {
    const allFields = this.form.querySelectorAll('input, textarea, select');
    let isFormValid = true;

    allFields.forEach((field) => {
      const isFieldValid = this.validateField(field, silent);
      if (!isFieldValid) {
        isFormValid = false;
      }
    });

    if (!silent) {
      this.updateErrorOutput();
    }

    return isFormValid;
  }

  updateButtonState() {
    if (!this.options.buttonSelector) return;

    const button = document.querySelector(this.options.buttonSelector);
    if (!button) return;

    if (this.options.showErrorsOnSubmitOnly && !this.hasSubmittedOnce) {
      button.removeAttribute('disabled');
      button.classList.remove('disabled');
      button.setAttribute('aria-disabled', 'false');
      return;
    }

    const isValid = this.validateForm(true);

    if (isValid) {
      button.removeAttribute('disabled');
      button.classList.remove('disabled');
      button.setAttribute('aria-disabled', 'false');
    } else {
      button.setAttribute('disabled', 'true');
      button.classList.add('disabled');
      button.setAttribute('aria-disabled', 'true');
    }
  }

  clearErrors() {
    const errorFields = this.form.querySelectorAll(`.${this.options.errorClass}`);
    errorFields.forEach((field) => {
      field.classList.remove(this.options.errorClass);
    });

    if (this.options.errorOutputSelector) {
      this.outputErrors([]);
    }
    if (this.options.fieldErrorSelector) {
      this.form.querySelectorAll('input, textarea, select').forEach((input) => {
        this.setFieldErrorOutput(input, '');
      });
    }
  }

  showAllErrors() {
    return this.validateForm(false);
  }

  getFormData() {
    const formData = new FormData(this.form);
    return Object.fromEntries(formData.entries());
  }

  isValidEmail(email) {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  }

  isValidFutureDate(dateString) {
    if (!dateString) return false;
    const selectedDate = new Date(dateString);
    const now = new Date();
    return selectedDate > now;
  }
}
class Form {
  constructor() {}

  serialize(form) {
    function stringKey(key, value) {
      var beginBracket = key.lastIndexOf('[');

      if (beginBracket === -1) {
        var _hash = {};
        _hash[key] = value;
        return _hash;
      }

      var newKey = key.substr(0, beginBracket);
      var newValue = {};

      newValue[key.substring(beginBracket + 1, key.length - 1)] = value;

      return stringKey(newKey, newValue);
    }

    var hash = {};

    for (var i = 0, len = form.elements.length; i < len; i++) {
      var formElement = form.elements[i];

      if (formElement.name === '' || formElement.disabled) {
        continue;
      }

      if (
        formElement.name &&
        !formElement.disabled &&
        (formElement.checked ||
          /select|textarea/i.test(formElement.nodeName) ||
          /hidden|text|search|tel|url|email|password|datetime|date|month|week|time|datetime-local|number|range|color/i.test(
            formElement.type,
          ))
      ) {
        var stringKeys = stringKey(formElement.name, formElement.value);
        hash = this.extend(hash, stringKeys);
      }
    }

    return hash;
  }
  extend() {
    var extended = {},
      i = 0,
      _this = this;

    // Merge the object into the extended object
    var merge = function merge(obj) {
      for (var prop in obj) {
        if (obj.hasOwnProperty(prop)) {
          // If property is an object, merge properties
          if (Object.prototype.toString.call(obj[prop]) === '[object Object]') {
            extended[prop] = _this.extend(extended[prop], obj[prop]);
          } else {
            extended[prop] = obj[prop];
          }
        }
      }
    };

    // Loop through each object and conduct a merge
    for (; i < arguments.length; i++) {
      merge(arguments[i]);
    }

    return extended;
  }
}

class AddToCart {
  constructor(element) {
    this.element = element;
    this.delegateElement = new Delegate(this.element);
    this.pageLoader = document.body.querySelector('.pageLoader');
    this.bindEvents();
  }
  bindEvents() {
    this.delegateElement.on('click', '[data-action=add-to-cart]', this.addToCart.bind(this));
  }

  addToCart() {
    var _this = this;
    event.preventDefault();
    var addToCartButton = event.target;
    this.pageLoader.style.width = 100 + '%';
    addToCartButton.setAttribute('disabled', 'disabled');
    var formElement = event.target.closest('form');
    formElement.querySelector('[name="id"]').removeAttribute('disabled');
    var formHelper = new Form();
    const serialized = formHelper.serialize(formElement);
    fetch(window.routes.localeRootUrl + '/cart/add.js', {
      body: JSON.stringify(serialized),
      credentials: 'same-origin',
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
    }).then(function (response) {
      if (response.ok) {
        var hasCartDrawer = !!document.querySelector('cart-drawer#cart');
        if (window.theme.cartMode === 'page' && !hasCartDrawer) {
          location.href = window.routes.cart_page_url;
        }
        if (window.location.href.indexOf('cart') != -1) {
          location.reload();
          return;
        }
        addToCartButton.removeAttribute('disabled');
        _this.element.dispatchEvent(
          new CustomEvent('product:added', {
            bubbles: true,
            detail: {
              variant: serialized.id,
              quantity: serialized.quantity,
            },
          }),
        );
      } else {
        response.json().then(function (content) {
          if (_this.element.querySelector('.ProductForm--Error')) {
            _this.element.querySelector('.ProductForm--Error').classList.add('visible');
            setTimeout(function () {
              _this.element.querySelector('.ProductForm--Error').classList.remove('visible');
            }, 2500);
            _this.pageLoader.style.left = 'unset';
            _this.pageLoader.style.right = 0 + 'px';
            _this.pageLoader.style.width = 0 + '%';
            setTimeout(() => {
              _this.pageLoader.style.left = 0 + 'px';
              _this.pageLoader.style.right = 'unset';
            }, 550);
          } else {
            var errorMessageElement = document.createElement('span');
            errorMessageElement.className = 'u-p4 accent';
            errorMessageElement.innerHTML = content['description'];
            addToCartButton.removeAttribute('disabled');
            addToCartButton.insertAdjacentElement('afterend', errorMessageElement);
            setTimeout(function () {
              errorMessageElement.remove();
            }, 2500);
            _this.pageLoader.style.left = 'unset';
            _this.pageLoader.style.right = 0 + 'px';
            _this.pageLoader.style.width = 0 + '%';
            setTimeout(() => {
              _this.pageLoader.style.left = 0 + 'px';
              _this.pageLoader.style.right = 'unset';
            }, 550);
          }
        });
      }
    });
  }
}

/*GLOBAL FUNCTIONS */

function handleFirstTab(e) {
  if (e.keyCode === 9) {
    document.body.classList.add('user-is-tabbing');

    window.removeEventListener('keydown', handleFirstTab);
    window.addEventListener('mousedown', handleMouseDownOnce);
  }
}

function handleMouseDownOnce() {
  document.body.classList.remove('user-is-tabbing');

  window.removeEventListener('mousedown', handleMouseDownOnce);
  window.addEventListener('keydown', handleFirstTab);
}

window.addEventListener('keydown', handleFirstTab);

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe, .focusable",
    ),
  );
}

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (event.target !== container && event.target !== last && event.target !== first) return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);
  if (first) {
    first.focus();
  } else {
    elementToFocus.focus();
  }
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

class Dropdown {
  constructor() {
    this.domDelegate = new Delegate(document.body);
    this.breakpoint = responsive.getCurrentBreakpoint();
    this.allDropdowns = document.querySelectorAll('.Dropdown');
    this.pageOverlayElement = document.querySelector('.pageOverlay');
    this.lock = false;
    this.bindEvents();
  }

  bindEvents() {
    // Bind event for general dropdown toggle - ALWAYS bind this regardless of breakpoint
    this.domDelegate.on('click', '[data-action=toggle-dropdown]', this.toggleDropdown.bind(this));

    // ADDITIONAL: Bind specifically for info__dropdown-button class used in PDP
    this.domDelegate.on(
      'click',
      ".info__dropdown-button[data-action='toggle-dropdown']",
      this.toggleDropdown.bind(this),
    );

    let selector;
    switch (this.breakpoint) {
      case 'desktop':
        // For lap-and-up breakpoint, bind event for desktop dropdown toggle
        selector = '[data-action=toggle-desktop-dropdown]';
        break;
      case 'pocket':
        // For pocket breakpoint, bind event for mobile dropdown toggle
        selector = '[data-action=toggle-mobile-dropdown]';
        break;
      default:
        // If no specific breakpoint, set selector as false to skip binding
        selector = false;
        break;
    }

    if (selector) {
      // Bind event for specific breakpoint dropdown toggle
      this.domDelegate.on('click', selector, this.toggleDropdown.bind(this));
    }
  }

  updateAllDropdowns() {
    this.allDropdowns = document.querySelectorAll('.Dropdown');
  }

  openDropdown(elem, target) {
    if (this.lock) return;
    this.lock = true;
    // Open the dropdown by setting appropriate attributes and performing animation
    const DropdownButton = elem.querySelector('.Dropdown--Button');
    const DropdownContent = elem.querySelector('.Dropdown--Content');

    const openedDropdown = target.closest(".Dropdown");
    this.allDropdowns.forEach((dropdown) => {
      if (dropdown === openedDropdown) return;
      if (!dropdown.querySelector("[aria-expanded='true']")) return;
      if (dropdown.classList.contains("do-not-close")) return;
      if (openedDropdown?.closest("main-menu-dropdown") && dropdown.contains(openedDropdown)) return;
      this.closeDropdown(dropdown, true);
    });

    let unlockTimeoutId;
    const transitionEndHandler = (event) => {
      if (event.propertyName !== 'height') return;

      clearTimeout(unlockTimeoutId);
      this.lock = false;

      // RevolutionAnimation.slideDown() may skip transitionend when scrollHeight is 0.
      DropdownContent.style.pointerEvents = 'all';
      DropdownContent.style.height = 'auto';
      DropdownContent.setAttribute('aria-hidden', 'false');

      DropdownContent.removeEventListener('transitionend', transitionEndHandler);
    };

    unlockTimeoutId = window.setTimeout(() => {
      this.lock = false;

      DropdownContent.style.pointerEvents = 'all';
      DropdownContent.style.height = 'auto';
      DropdownContent.setAttribute('aria-hidden', 'false');

      DropdownContent.removeEventListener('transitionend', transitionEndHandler);
    }, 600);

    DropdownContent.addEventListener('transitionend', transitionEndHandler);

    DropdownButton.setAttribute('aria-expanded', 'true');
    new RevolutionAnimation(DropdownContent, 'true').slideDown();
  }

  closeAllDropdowns(namespace) {
    namespace.querySelectorAll('.Dropdown').forEach((dropdown) => {
      if (dropdown.querySelector("[aria-expanded='true']") && !dropdown.classList.contains('do-not-close')) {
        this.closeDropdown(dropdown);
      }
    });
  }

  closeDropdown(elem, ignore) {
    if (this.lock && !ignore) return;
    this.lock = true;
    // Close the dropdown by setting appropriate attributes and performing animation
    const DropdownButton = elem.querySelector('.Dropdown--Button');
    const DropdownContent = elem.querySelector('.Dropdown--Content');
    let unlockTimeoutId;
    const transitionEndHandler = (event) => {
      if (event.propertyName !== 'height') return;

      clearTimeout(unlockTimeoutId);

      if (DropdownContent.getAttribute('aria-hidden') !== 'true') {
        DropdownContent.setAttribute('aria-hidden', 'true');
      }

      this.lock = false;
      DropdownContent.removeEventListener('transitionend', transitionEndHandler);
    };

    unlockTimeoutId = window.setTimeout(() => {
      if (DropdownContent.getAttribute('aria-hidden') !== 'true') {
        DropdownContent.setAttribute('aria-hidden', 'true');
      }
      this.lock = false;
      DropdownContent.removeEventListener('transitionend', transitionEndHandler);
    }, 600);

    DropdownContent.addEventListener('transitionend', transitionEndHandler);

    new RevolutionAnimation(DropdownContent, 'true').slideUp();
    DropdownButton.setAttribute('aria-expanded', 'false');
  }

  toggleDropdown(event, target) {
    event.preventDefault();

    const mainDropdown = target.closest('.Dropdown');
    const isOpen = target.getAttribute('aria-expanded') === 'true';

    if (!this.lock) {
      if (isOpen) {
        // If dropdown is open, close it
        this.closeDropdown(mainDropdown, target);

        if (mainDropdown.classList.contains('filter__dropdown')) {
          mainDropdown.dispatchEvent(new CustomEvent('close:filters', { bubbles: true }));
        }
      } else {
        // If dropdown is closed, open it
        this.openDropdown(mainDropdown, target);

        if (mainDropdown.classList.contains('filter__dropdown')) {
          mainDropdown.dispatchEvent(new CustomEvent('open:filters', { bubbles: true }));
        }
      }
    }
  }
}

const allDropdowns = new Dropdown();

class RevolutionSwiper {
  constructor(element, additionalSwiper) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    this.element = element;
    this.thumb = additionalSwiper;
    this.initialConfig = JSON.parse(element.getAttribute('data-swiper-settings'));

    if (additionalSwiper) {
      this.initialConfigThumbs = JSON.parse(additionalSwiper.getAttribute('data-swiper-thumb-settings'));
    }
    this.options = options;
    this.build();
  }

  selectCell(index) {
    this.swiperElement.slideTo(index);
  }

  resize() {
    this.swiperElement.resize();
  }

  build() {
    var _this = this,
      configThumb = this.initialConfigThumbs;
    if (configThumb != null) {
      this.thumbSwiper = new Swiper(this.thumb, configThumb);
      this.initialConfig.thumbs['swiper'] = this.thumbSwiper;
    }

    this.swiperElement = new Swiper(this.element, this.initialConfig);
    this.selectedIndex = this.swiperElement.activeIndex;

    this.swiperElement.on('slideChange', function () {
      _this.element.dispatchEvent(
        new CustomEvent('swiper:slide-changed', {
          bubbles: true,
          detail: {
            currentIndex: _this.swiperElement.activeIndex,
            element: _this.swiperElement.el[0],
          },
        }),
      );
    });
  }
}


class Drawer {
  constructor(element) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    this.element = element;
    this.delegateElement = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);
    this.pageOverlayElement = document.querySelector(
      this.element.getAttribute("id") === "Drawer" ? ".sectionOverlay" : ".pageOverlay"
    );

    if (navigator.platform === 'iPhone')
      document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
    this.onOpen = options['onOpen'] || function () {};
    this.onClose = options['onClose'] || function () {};
    this.isOpen = false;
    this._drawerToggleEnableTimeout = null;

    if (!this.element.style.display) {
      this.element.style.display = 'none';
    }

    this.bindEvents();
  }

  bindEvents() {
    this.delegateBody.on(
      'click',
      '[data-action="open-drawer"][data-toggle-id="' + this.element.id + '"]',
      this.openDrawer.bind(this),
    );
    this.delegateBody.on(
      'click',
      '[data-action="close-drawer"][data-toggle-id="' + this.element.id + '"]',
      this.closeDrawer.bind(this),
    );
    this.delegateBody.on(
      'click',
      '[data-action="toggle-drawer"][data-toggle-id="' + this.element.id + '"]',
      this.toggleDrawer.bind(this),
    );
    this._openListener = this.openDrawer.bind(this);
    this._closeListener = this.closeDrawer.bind(this);
    this.calculateMaxHeightListener = this.maxHeight.bind(this);
    responsive.addResizeListener(this, this.calculateMaxHeightListener);

    this.delegateBody.on('ui:close-other', (event) => {
      const id = event?.detail?.id;
      if (!this.isOpen) return;
      if (id && id === this.element.id) return;
      if (event?.detail?.preserveDrawerId === this.element.id) return;
      this.closeDrawer(event);
    });
  }

  maxHeight() {
    // Always set outer height to viewport height
    this.element.style.height = window.innerHeight + 'px';

    const id = this.element.getAttribute('id');
    const isCart = id === 'cart';
    const isFavorites = id === 'sidebarFavorites';

    // For empty cart drawer, let CSS + padding control the scrollable height
    if (isCart && this.element.getAttribute('data-empty') === 'true') {
      const wrapper = this.element.querySelector('.cart-drawer__wrapper-inner');
      if (wrapper) {
        wrapper.style.height = '';
      }
      return;
    }

    if (isCart || isFavorites) {
      var footer = this.element.querySelector('.CartDrawer--Footer, .cart-drawer__footer');
      var footerHeight = footer ? footer.offsetHeight : 0;

      var headerEl = this.element.querySelector('.CartHeader, .cart-drawer__header');
      var headerHeight = headerEl ? headerEl.offsetHeight : 0;

      var itemWrapper = this.element.querySelector(
        '.CartItems--Wrapper, .cart-drawer__content[data-scrollable], .cart-drawer__wrapper-inner'
      );
      if (itemWrapper) {
        itemWrapper.style.height = (window.innerHeight - footerHeight - headerHeight) + 'px';
      }
    }
  }

  toggleDrawer(event) {
    event.preventDefault();
    this.isOpen ? this.closeDrawer() : this.openDrawer(event);
  }

  _setDrawerToggleButtonsDisabled(disabled) {
    const id = this.element?.id;
    if (!id) return;
    if (disabled && this._drawerToggleEnableTimeout) {
      clearTimeout(this._drawerToggleEnableTimeout);
      this._drawerToggleEnableTimeout = null;
    }
    document.querySelectorAll('[data-toggle-id="' + id + '"]').forEach((btn) => {
      btn.disabled = disabled;
    });
  }

  _scheduleDrawerToggleEnable() {
    if (this._drawerToggleEnableTimeout) clearTimeout(this._drawerToggleEnableTimeout);
    this._drawerToggleEnableTimeout = setTimeout(() => {
      this._setDrawerToggleButtonsDisabled(false);
      this._drawerToggleEnableTimeout = null;
    }, 500);
  }

  openDrawer(event) {
    const detail = { source: 'drawer', id: this.element?.id || null };
    if (event?.target?.closest?.('main-menu-dropdown')) {
      detail.preserveDrawerId = 'Drawer';
    }
    document.body.dispatchEvent(new CustomEvent('ui:close-other', {
      bubbles: true,
      detail
    }));

    this.element.dispatchEvent(
      new CustomEvent("close:search", { bubbles: true })
    );

    if (this.element.getAttribute('id') == 'cart') {
      this.element.dispatchEvent(new CustomEvent('cart-drawer:open', { bubbles: true }));
    }
    if (this.isOpen) {
      return;
    }

    this._setDrawerToggleButtonsDisabled(true);
    this._scheduleDrawerToggleEnable();

    this.maxHeight();

    if (this.element.getAttribute("id") == "Drawer") {
      this.element.parentElement.classList.remove("mobile-menu--hidden");
      this.element.parentElement.style.display = "";
      document.querySelector(".Drawer--Close").style.display = "block";
    }
    this.element.style.display = "block";

    requestAnimationFrame(() => {
      this.element.setAttribute('aria-expanded', 'true');
      this.element.dispatchEvent(
        new CustomEvent("drawer:open", { bubbles: true })
      );
    });

    if (this.element.getAttribute("id") == "Drawer") {
      const hamburgerBtn = document.getElementById("toggle-mobile-menu-btn");
      if (hamburgerBtn) {
        hamburgerBtn.setAttribute("aria-label", "Close menu");
        hamburgerBtn.setAttribute("aria-expanded", "true");
      }
      this.element.dispatchEvent(
        new CustomEvent('sidebar-drawer:open', {
          bubbles: true,
        }),
      );
    }

    if (this.element.getAttribute("id") !== "Drawer") {
      this.pageOverlayElement.classList.add("is-visible");
      this.pageOverlayElement.addEventListener("click", this._closeListener);
    }
    var focus = this.element.querySelector("[data-scrollable]");
    bodyScrollLock.disableBodyScroll(focus || this.element, bodyScrollLockOptions);
    document.body.style.setProperty('--scrollbar-gap', (window.innerWidth - document.documentElement.clientWidth > 0 ? window.innerWidth - document.documentElement.clientWidth : 0) + 'px');
    document.body.classList.add("scrollLock");
    this.isOpen = true;

    IOSScrollLock.lock();

    setTimeout(() => {
      trapFocus(this.element);
    }, 400);
    this.onOpen();
    return false;
  }

  closeDrawer(event) {
    if (!this.isOpen) {
      return;
    }
    if (event) {
      event.preventDefault();
    }

    const isMobileMenuDrawer = this.element.getAttribute("id") === "Drawer";
    const isHeaderToggleBtnClick = !!event?.target?.closest?.("#toggle-mobile-menu-btn");
    const isForcedMobileMenuClose = isMobileMenuDrawer && (isHeaderToggleBtnClick || !event);

    // If the mobile menu (id="Drawer") is closing via the header toggle (X),
    // close any open popups too (language/market selector lives there as a Popup).
    if (isForcedMobileMenuClose) {
      document.body.dispatchEvent(
        new CustomEvent("drawer:close-other", {
          bubbles: true,
          detail: { source: "mobile-menu-close" },
        }),
      );
    }

    // When Drawer is mobile menu: if a sectionOverlay popup is open, don't close the drawer
    // so the overlay click closes only the popup first. Skip this when closing due to another UI opening (ui:close-other).
    if (isMobileMenuDrawer) {
      const openSectionOverlayPopup = document.querySelector('[data-overlay="sectionOverlay"][aria-hidden="false"]');
      if (openSectionOverlayPopup && event?.type !== 'ui:close-other' && !isForcedMobileMenuClose) return;
    }

    this._setDrawerToggleButtonsDisabled(true);

    if (this.element.getAttribute("id") == "Drawer") {
      const hamburgerBtn = document.getElementById("toggle-mobile-menu-btn");
      if (hamburgerBtn) {
        hamburgerBtn.setAttribute("aria-label", "Open menu");
        hamburgerBtn.setAttribute("aria-expanded", "false");
      }
    }
    document.body.classList.remove("scrollLock");
    document.body.style.removeProperty('--scrollbar-gap');

    if (this._scrollableElement) {
      try {
        bodyScrollLock.enableBodyScroll(this._scrollableElement);
      } catch (e) { }
      this._scrollableElement = null;
    }
    bodyScrollLock.clearAllBodyScrollLocks();
    if (this.element.getAttribute("id") === "modal-address-new") {
      var form = this.element.querySelector("#form-address-new");
      if (form && typeof form.reset === "function") form.reset();
    }
    if (this.element.getAttribute("id") == "cart") {
      var dataSettings = this.element.getAttribute("data-settings");
      if (dataSettings) {
        try {
          var options = JSON.parse(dataSettings);
          if (options["showRecommendations"]) {
            var expendable = this.element.querySelector(".CartDrawer--Expendable, .cart-drawer__recommendations-toggle");
            if (expendable) expendable.setAttribute("aria-expanded", false);
            // Keep existing recommendations markup; CartDrawer manages refresh on open/update.
          }
        } catch (e) { }
      }
    }

    this.element.setAttribute('aria-expanded', 'false');

    const closeDuration = 350;
    const transitionEndHandler = (e) => {
      if (e != null && e.target !== this.element) return;
      this.element.style.display = "none";
      if (this.element.parentElement && this.element.parentElement.tagName.toLowerCase() === "main-menu-dropdown") {
        this.element.parentElement.classList.add("mobile-menu--hidden");
      }
      this._setDrawerToggleButtonsDisabled(false);
      this.element.dispatchEvent(
        new CustomEvent("drawer:closed", { bubbles: true })
      );
    };

    const runAfterTransition = () => {
      const handler = (e) => {
        if (e.target !== this.element) return;
        clearTimeout(this._closeDrawerFallback);
        this._closeDrawerFallback = null;
        this.element.removeEventListener("transitionend", handler);
        transitionEndHandler(e);
      };
      this.element.addEventListener("transitionend", handler, { once: true });
      this._closeDrawerFallback = setTimeout(() => {
        this._closeDrawerFallback = null;
        this.element.removeEventListener("transitionend", handler);
        transitionEndHandler();
      }, 500); /* fallback: transitionend may not fire with prefers-reduced-motion or when transition is 0 */
    };
    if (getComputedStyle(this.element).transitionDuration && parseFloat(getComputedStyle(this.element).transitionDuration) > 0) {
      runAfterTransition();
    } else {
      transitionEndHandler();
    }

    if (this.element.getAttribute("id") !== "Drawer") {
      this.pageOverlayElement.classList.remove("is-visible");
      this.pageOverlayElement.removeEventListener("click", this._closeListener);
    }
    removeTrapFocus(this.element);
    this.isOpen = false;
    this.onClose();

    IOSScrollLock.unlock();
  }

  destroy() {
    if (this.pageOverlayElement) {
      this.pageOverlayElement.removeEventListener("click", this._closeListener);
    }
    if (this._drawerToggleEnableTimeout) {
      clearTimeout(this._drawerToggleEnableTimeout);
      this._drawerToggleEnableTimeout = null;
    }
    this.delegateElement?.off?.();
    this.delegateBody?.off?.();
  }
}

class RevolutionAnimation {
  constructor(element, directAnimation) {
    this.element = element;
    if (!directAnimation) {
      this.intersectionObserver = [];
      this.integer = 0;
      var contentToAnimate = document.querySelectorAll('[data-animation]');
      contentToAnimate.forEach((item, i) => {
        this.animateElement(item, i);
        this.integer = this.integer + 1;
      });

      // Listen for changes to the DOM and animate any new elements
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          mutation.addedNodes.forEach((node) => {
            if (node.nodeType === Node.ELEMENT_NODE) {
              const newContentToAnimate = node.querySelectorAll('[data-animation]');

              newContentToAnimate.forEach((item) => {
                this.animateElement(item, this.integer);
                this.integer = this.integer + 1;
              });
            }
          });
        });
      });

      observer.observe(document.body, { childList: true, subtree: true });
    }
  }

  slideUp() {
    this.element.style.height = this.element.scrollHeight + 'px';
    this.element.offsetHeight;
    this.element.style.height = 0;
  }

  slideDown() {
    if (this.element.style.height === 'auto') {
      return;
    }

    this.element.style.display = 'block';
    this.element.style.height = 0;

    this.element.style.pointerEvents = 'none';
    var _this = this;
    this.element.style.height = this.element.scrollHeight + 'px';
    this.element.setAttribute('aria-hidden', false);
    var transitionEnded = function transitionEnded(event) {
      _this.element.style.pointerEvents = 'all';
      if (event.propertyName === 'height') {
        _this.element.style.height = 'auto';
        _this.element.removeEventListener('transitionend', transitionEnded);
      }
    };

    this.element.addEventListener('transitionend', transitionEnded);
  }

  /**
   * CSS-based reveal: sets stagger delay and data-loaded attribute.
   * Actual animation is handled by CSS transitions in base.css.
   */
  revealElements(elements) {
    const delay = window.theme.animationBetweenElements;
    elements.forEach((element, index) => {
      if (element.hasAttribute('data-loaded')) return;
      element.style.setProperty('--animation-delay', `${delay * index}ms`);
      element.setAttribute('data-loaded', 'true');
    });
  }

  animateElement(animatedItem, index) {
    if (this.intersectionObserver[index]) {
      this.intersectionObserver[index].disconnect();
    }

    this.intersectionObserver[index] = new IntersectionObserver(
      (results) => {
        const elements = [];
        results.forEach((result) => {
          if (result.isIntersecting || result.intersectionRatio > 0) {
            elements.push(result.target);
            this.intersectionObserver[index].unobserve(result.target);
          }
        });
        if (elements.length > 0) {
          this.revealElements(elements);
        }
      },
      { threshold: 0.15 },
    );

    if (animatedItem.classList.contains('animatedContent')) {
      this.intersectionObserver[index].observe(animatedItem);
    }
    animatedItem.querySelectorAll('.animatedContent').forEach((item) => {
      this.intersectionObserver[index].observe(item);
    });
  }
}

if (window.theme.enableAnimations) {
  document.addEventListener('DOMContentLoaded', function () {
    new RevolutionAnimation();
  });
}

/**
 * Custom element: label that follows the cursor when hovering over a visible drawer overlay.
 * Must live outside overlays (e.g. sibling or in body) so it is not affected by overlay opacity.
 */
class OverlayCloseHint extends HTMLElement {
  static OVERLAY_SELECTOR = '.pageOverlay.is-visible, .sectionOverlay.is-visible, .notify-me__overlay.is-visible';
  static CHECK_INTERVAL_MS = 150;

  constructor() {
    super();
    this.element = this;
    this._boundMouseMove = this._handleMouseMove.bind(this);
    this._boundDrawerClosed = this._hideAll.bind(this);
    this._checkInterval = null;
  }

  connectedCallback() {
    this.classList.remove('is-visible');
    document.body.addEventListener('mousemove', this._boundMouseMove, { passive: true });
    document.body.addEventListener('drawer:closed', this._boundDrawerClosed);
    this._checkInterval = setInterval(this._hideIfNoOverlayVisible.bind(this), OverlayCloseHint.CHECK_INTERVAL_MS);
  }

  disconnectedCallback() {
    document.body.removeEventListener('mousemove', this._boundMouseMove);
    document.body.removeEventListener('drawer:closed', this._boundDrawerClosed);
    if (this._checkInterval) clearInterval(this._checkInterval);
    this._checkInterval = null;
  }

  _hideIfNoOverlayVisible() {
    const anyVisible = document.querySelector(OverlayCloseHint.OVERLAY_SELECTOR);
    if (!anyVisible) this._hideAll();
  }

  _hideAll() {
    document.querySelectorAll('overlay-close-hint').forEach((el) => el.classList.remove('is-visible'));
  }

  _handleMouseMove(e) {
    const overlay = e.target.closest(OverlayCloseHint.OVERLAY_SELECTOR);
    if (overlay) {
      const isDesktopMenuOverlay =
        overlay.classList.contains('sectionOverlay') &&
        document.querySelector('.desktop-menu__nav-item[aria-expanded="true"]');
      if (isDesktopMenuOverlay) {
        this.classList.remove('is-visible');
      } else {
        const w = this.offsetWidth || 95;
        const h = this.offsetHeight || 95;
        this.style.left = (e.clientX - w / 2) + 'px';
        this.style.top = (e.clientY - h / 2) + 'px';
        this.classList.add('is-visible');
      }
    } else {
      this.classList.remove('is-visible');
      this._hideIfNoOverlayVisible();
    }
  }
}

customElements.define('overlay-close-hint', OverlayCloseHint);

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.input = this.querySelector('input');
    this.changeEvent = new Event('quantity:changed', { bubbles: true });
    this.options = JSON.parse(this.element.getAttribute('data-settings') || '{}');

    if (this.input?.classList.contains('QuantitySelector__ProductQuantity')) {
      this.input.addEventListener('keydown', (e) => e.preventDefault());
      this.input.addEventListener('focus', () => this.input.blur());
    }

    this.querySelectorAll('button').forEach((button) =>
      button.addEventListener('click', this.onButtonClick.bind(this)),
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);

    if (this.options['noVariants'] == 'true') {
      this.toggleAddButton();
    }
  }

  toggleAddButton() {
    const addButton = document.querySelector('.ProductPage--ATC');
    if (!addButton) return;

    const addButtonInner = addButton.querySelector('.SelfAlign');
    const quantityEl = document.querySelector('.QuantitySelector__ProductQuantity');
    let quantity = quantityEl ? quantityEl.value : 1;
    if (!quantity) quantity = 1;

    if (window.variantInfo?.show_icon) {
      var buySvg =
        '<svg class="Svg Svg--shopping_cart mr-m" width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M25.31 5.19547C25.1687 5.02127 24.9568 4.91946 24.7325 4.91797H9.11751L9.60501 6.41797H23.75L21.7475 15.418H10.4975L7.07001 4.56547C6.99476 4.33174 6.80986 4.14965 6.57501 4.07797L3.50001 3.13297C3.24278 3.05393 2.96292 3.11812 2.76584 3.30137C2.56877 3.48461 2.48443 3.75907 2.54459 4.02137C2.60476 4.28366 2.80028 4.49393 3.05751 4.57297L5.75001 5.39797L9.19251 16.273L7.96251 17.278L7.86501 17.3755C7.2374 18.0987 7.21221 19.1659 7.80501 19.918C8.21952 20.4221 8.84817 20.7002 9.50001 20.668H22.0175C22.4317 20.668 22.7675 20.3322 22.7675 19.918C22.7675 19.5038 22.4317 19.168 22.0175 19.168H9.38001C9.20436 19.162 9.0446 19.0646 8.95873 18.9113C8.87286 18.7579 8.87334 18.5709 8.96001 18.418L10.7675 16.918H22.3475C22.705 16.9267 23.0189 16.6818 23.0975 16.333L25.475 5.83297C25.5212 5.6064 25.4603 5.37117 25.31 5.19547ZM20.75 25.168C21.682 25.168 22.4375 24.4125 22.4375 23.4805C22.4375 22.5485 21.682 21.793 20.75 21.793C19.818 21.793 19.0625 22.5485 19.0625 23.4805C19.0625 24.4125 19.818 25.168 20.75 25.168ZM12.185 23.4805C12.185 24.4125 11.4295 25.168 10.4975 25.168C9.56553 25.168 8.81001 24.4125 8.81001 23.4805C8.81001 22.5485 9.56553 21.793 10.4975 21.793C11.4295 21.793 12.185 22.5485 12.185 23.4805Z" fill="#121212"></path></svg>';
    } else {
      var buySvg = '';
    }

    addButton.removeAttribute('disabled');
    addButton.classList.remove('ProductCard--Sold__Out');
    const price = Number(this.options['price']) * Number(quantity);
    const priceElement = window.variantInfo?.show_price
      ? "<span class='u-p3 ml-s'>" + Shopify.formatMoney(price, window.theme.moneyFormat) + '</span>'
      : '';
    const label = (window.variantStrings && window.variantStrings.addToCart) || '';
    if (addButtonInner) addButtonInner.innerHTML = buySvg + label + priceElement;
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

const serializeForm = (form) => {
  const obj = {};
  const formData = new FormData(form);
  for (const key of formData.keys()) {
    obj[key] = formData.get(key);
  }
  return JSON.stringify(obj);
};

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: `application/${type}`,
    },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement('form');
  form.setAttribute('method', method);
  form.setAttribute('action', path);

  for (var key in params) {
    var hiddenField = document.createElement('input');
    hiddenField.setAttribute('type', 'hidden');
    hiddenField.setAttribute('name', key);
    hiddenField.setAttribute('value', params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = '';
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class ProductForm extends HTMLElement {
  constructor() {
    super();
    new AddToCart(this);
  }
}

customElements.define('product-form', ProductForm);

class Countdown extends HTMLElement {
  constructor() {
    super();
    this.element = this;

    const counterWrapper = this.element.querySelector('.component-countDownWrapper');

    this.options = JSON.parse(this.element.getAttribute('data-settings'));
    let counterString = this.options['countdownString'];
    counterString = counterString.replace('{countdown}', '<span class="u-pb6 component-countDown">00:00:00</span>');
    counterWrapper.innerHTML = counterString;

    const dateNow = new Date();
    const todaysDay = dateNow.getDay();

    const countdownDay = this.options.countdownDays;

    this.dayDifference = countdownDay - todaysDay;

    if (this.dayDifference < 0) {
      // If the countdown day is earlier in the week, add 7 to the difference
      this.dayDifference += 7;
    }

    this.counter = this.element.querySelector('.component-countDown');
    setInterval(this.countDown.bind(this), 1000);
  }

  countDown() {
    const dateNow = new Date();
    const currentHours = dateNow.getHours();
    const currentMinutes = dateNow.getMinutes();
    let countDate = new Date(`March 3, 2099 ${this.options.countdownTime}`);

    if (this.options['countdownType'] == 'to_date') {
      countDate = new Date(this.options.countdownDate);
    }

    const difference = countDate - dateNow;

    const seconds = 1000;
    const minutes = seconds * 60;
    const hours = minutes * 60;
    const days = hours * 24;

    let textDays = Math.floor(difference / (1000 * 60 * 60 * 24));
    let textHours = Math.floor((difference % days) / hours);
    let textMinutes = Math.floor((difference % hours) / minutes);
    let textSeconds = Math.floor((difference % minutes) / seconds);

    const [targetHours, targetMinutes] = this.options.countdownTime.split(':').map(Number);
    if (
      targetHours < currentHours ||
      (targetHours === currentHours && targetMinutes <= currentMinutes && this.options['countdownType'] == 'reccuring')
    ) {
      textDays = this.dayDifference - 1;
    } else if (this.options['countdownType'] == 'reccuring') {
      textDays = this.dayDifference;
    }

    const displayHours = textHours;
    const formatHours = displayHours < 10 ? `0${displayHours}` : displayHours;
    const formatMinutes = textMinutes < 10 ? `0${textMinutes}` : textMinutes;
    const formatSeconds = textSeconds < 10 ? `0${textSeconds}` : textSeconds;

    if (textDays > 0) {
      this.counter.innerText = `${textDays}d ${formatHours}:${formatMinutes}:${formatSeconds}`;
    } else {
      this.counter.innerText = `${formatHours}:${formatMinutes}:${formatSeconds}`;
    }
  }
}


customElements.define("countdown-element", Countdown);
class CartDrawer extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);

    this.focusElement = false;
    this.drawer = new Drawer(this.element, {
      onClose: () => {
        this.isOpen = false;
        this.recommendationsOpen = false;
        this.onClose();
      },
      onOpen: () => {
        this.isOpen = true;
        this.onOpen();
      },
    });

    this.loader = this.element.querySelector(".item-loader") || this.element.querySelector(".itemLoader");

    this.options = JSON.parse(this.element.getAttribute("data-settings"));
    this.pageLoader = document.body.querySelector(".pageLoader");
    this.emptyCartCollection = this.element.querySelector('.cart-drawer__recommendations');
    this.breakpoint = responsive.getCurrentBreakpoint();
    this.cartIds = false;
    this.isOpen = false;
    this.recommendationsOpen = false;
    this.recommendationLoading = false;
    this.breakpoint = responsive.getCurrentBreakpoint();
    this.cachedUsp = this.cacheUspMarkup();

    this.ensureUspPlacement();

    this.addToCart = new AddToCart(this.element);
    this._recommendationsLoaded = false;

    this.bindEvents();
    const closeBtn = this.element.querySelector('.cart-drawer .Drawer--Close');
    if (closeBtn) {
      closeBtn.addEventListener('click', () => {
        closeBtn.classList.add('is-active');
        setTimeout(() => closeBtn.classList.remove('is-active'), 400);
      });
    }
  }

  bindEvents() {
    if (this._listenersBound) return;
    this._listenersBound = true;

    this._onProductAdded = this.onProductAdded.bind(this);
    this._onBreakpointChanged = this.updateCartFooterHeight.bind(this);

    document.addEventListener("product:added", this._onProductAdded);

    this.delegateElement.on(
      "click",
      '[data-action="update-item-quantity"], [data-action="remove-item"]',
      this.updateItemQuantity.bind(this)
    );
    this.delegateElement.on(
      "change",
      '[data-action="update-change-quantity"]',
      this.updateItemQuantity.bind(this)
    );
    this.delegateElement.on(
      "quantity:changed",
      ".cart-item__quantity",
      this.updateItemQuantity.bind(this)
    );

    this.delegateBody.on(
      "click",
      '[data-action="replace-cart-item"]',
      this.handleReplaceCartItem.bind(this)
    );

    document.addEventListener("breakpoint:changed", this._onBreakpointChanged);

  }
  disconnectedCallback() {
    document.removeEventListener("product:added", this._onProductAdded);
    document.removeEventListener("breakpoint:changed", this._onBreakpointChanged);

    this._onProductAdded = null;

    // Destroy the inner Drawer to clean up its listeners and instances
    if (this.drawer) {
      this.drawer.destroy();
      this.drawer = null;
    }

    this.delegateElement?.off?.();
    this.delegateBody?.off?.();

    this._listenersBound = false;
  }

  updateCartFooterHeight() {
    const footer = this.element.querySelector(".cart-drawer__footer");
    if (!footer) return;
    document.documentElement.style.setProperty(
      "--cart-drawer__footer-height",
      footer.offsetHeight + "px"
    );
  }

  cacheUspMarkup() {
    const uspWrapper = this.element.querySelector('.cart-drawer__usp');
    if (uspWrapper) return uspWrapper;
    const usp = this.element.querySelector('cart-drawer-usp-bar');
    if (usp) return usp;
    const temp = this.element.querySelector('.main-cart__usp-bar--temp');
    return temp ? temp.querySelector('cart-drawer-usp-bar') || null : null;
  }

  ensureUspPlacement() {
    if (!this.cachedUsp) return;

    const checkoutBtn = this.element.querySelector('.cart-drawer__checkout');
    if (!checkoutBtn) return;

    if (this.cachedUsp.previousElementSibling !== checkoutBtn) {
      checkoutBtn.after(this.cachedUsp);
    }

    const uspBar = this.cachedUsp.querySelector?.('cart-drawer-usp-bar') || this.cachedUsp;
    if (uspBar?.animationEnabled) {
      requestAnimationFrame(() => {
        if (typeof uspBar.init === 'function') uspBar.init();
        requestAnimationFrame(() => {
          if (typeof uspBar.measure === 'function') uspBar.measure();
        });
      });
    }
  }



  onOpen() {
    if (this.element.getAttribute("aria-expanded") == "false") {
      setTimeout(() => {
        if (this.element.hasAttribute('data-open-drawer')) {
          this.focusElement = this.element.querySelector("[data-scrollable]");
          if (this.focusElement) {
            bodyScrollLock.disableBodyScroll(this.focusElement, bodyScrollLockOptions);
          }
        }

      }, 500);

    }
    const header = this.element.querySelector(".cart-drawer__header");
    const headerHeight = header.offsetHeight;

    document.documentElement.style.setProperty(
      "--cart-drawer__header-height",
      headerHeight + "px"
    );

    if (this.element.querySelector(".cart-drawer__footer")) {
      this.updateCartFooterHeight();
    }

    if (this.element.querySelector(".cart-drawer__shipping")) {
      document.documentElement.style.setProperty(
        "--cart-drawer__shipping-height",
        this.element.querySelector(".cart-drawer__shipping").offsetHeight + "px"
      );
    }

    const usp = this.element.querySelector("cart-drawer-usp-bar");
    if (usp?.animationEnabled) {
      requestAnimationFrame(() => {
        usp.init?.();
        usp.measure?.();
      });
    }

    // Lazy-load recommendations on first open instead of on page load
    if (!this._recommendationsLoaded) {
      this._recommendationsLoaded = true;
      this.loadRecommendations();
    }
  }

  onClose() {
    setTimeout(() => {
      this.resetAllSwipers();
    }, 400);
  }

  resetAllSwipers() {
    const swiperEls = this.element.querySelectorAll("swiper-init");

    swiperEls.forEach((el) => {
      const swiper = el.swiper.swiperElement;

      if (!swiper) return;

      try {
        if (swiper.autoplay) {
          swiper.autoplay.stop();
        }

        swiper.slideTo(0, 0);

        swiper.update();

      } catch (err) {
      }
    });
  }


  async handleReplaceCartItem(e) {
    e.preventDefault();

    // Step 1: Get the current line item ID from localStorage
    const currentLineId = localStorage.getItem("current-line-item");
    if (!currentLineId) {
      return;
    }

    // Step 2: Get the quick-add form
    const form = document.querySelector('.quick-add-product form');
    if (!form) {
      return;
    }

    // Step 3: Extract form data
    const formData = new FormData(form);
    const newVariantId = formData.get('id');
    const newQuantity = parseInt(formData.get('quantity') || 1, 10);

    // Step 4: Collect custom properties
    const newProperties = {};
    for (let [key, value] of formData.entries()) {
      if (key.startsWith('properties[')) {
        const propName = key.match(/properties\[(.*?)\]/)?.[1];
        if (propName) {
          newProperties[propName] = value;
        }
      }
    }

    // Step 5: Call the existing replaceCartItem method
    await this.replaceCartItem(e, currentLineId, newVariantId, newQuantity, newProperties);

    if (window.theme.cartMode === 'page') {
      location.href = window.routes.cart_page_url;
    }
  }

  async replaceCartItem(e, currentLineId, newVariantId, newQuantity = 1, newProperties = {}) {
    e.preventDefault();
    try {
      const addToCartButton = e.target;
      addToCartButton.setAttribute("disabled", "disabled");
      // Show loader for the current item if visible
      const cartItem = document.querySelector(`[data-line-id="${currentLineId}"]`)?.closest('.cart-item');
      if (cartItem) {
        const itemLoader = cartItem.querySelector('.itemLoader');
        if (itemLoader) itemLoader.classList.add('is-visible');
      }

      // Step 1: Remove the current item
      const removeResponse = await fetch(`${window.routes.localeRootUrl}/cart/change.js`, {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
        body: JSON.stringify({ id: currentLineId, quantity: 0 })
      });

      if (!removeResponse.ok) throw new Error('Failed to remove current item');

      // Step 2: Add the new item
      const addResponse = await fetch(`${window.routes.localeRootUrl}/cart/add.js`, {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
        body: JSON.stringify({
          items: [{ id: newVariantId, quantity: newQuantity, properties: newProperties }]
        })
      });

      if (!addResponse.ok) throw new Error('Failed to add new item');
      const addData = await addResponse.json();

      // Step 3: Refresh the cart drawer
      await this.renderCart(false, false);

      // Step 4: Cleanup
      localStorage.removeItem("current-line-item");
      this.currentLineId = null;

      // Step 5: Fire success event
      this.element.dispatchEvent(new CustomEvent('cart:item-replaced', {
        bubbles: true,
        detail: { oldLineId: currentLineId, newVariantId, newQuantity, newProperties, cartData: addData }
      }));

      return addData;
    } catch (error) {
      throw error;
    } finally {
      const cartItem = document.querySelector(`[data-line-id="${currentLineId}"]`)?.closest('.cart-item');
      const itemLoader = cartItem.querySelector('.itemLoader');
      if (itemLoader) itemLoader.classList.remove('is-visible');
    }
  }

  async updateItemQuantity(event, target) {
    event.preventDefault();

    // Block clicks while a quantity update is in progress
    if (this._quantityUpdating) return;

    const cartItem = target.closest(".cart-item");
    const itemLoader = cartItem?.querySelector(".itemLoader");
    if (itemLoader) itemLoader.classList.add("is-visible");

    let quantity;
    if (target.tagName === "INPUT") {
      quantity = Math.max(parseInt(target.value, 10) || 0, 0);
    } else {
      quantity = parseInt(target.getAttribute("data-quantity"), 10);
    }

    const lineId = target.getAttribute("data-line-id");
    const payload = { id: lineId, quantity };

    this._quantityUpdating = true;

    try {
      const response = await fetch(`${window.routes.localeRootUrl}/cart/change.js`, {
        method: "POST",
        credentials: "same-origin",
        headers: {
          "Content-Type": "application/json",
          "X-Requested-With": "XMLHttpRequest",
        },
        body: JSON.stringify(payload),
      });

      // ⚙️ Handle harmless errors gracefully
      if (!response.ok) {
        if (itemLoader) itemLoader.classList.remove("is-visible");
        // Re-render cart to sync
        await this.renderCart(false, false);
        return;
      }

      const data = await response.json();

      if (data.item_count == 0) {
        if (this.loader) this.loader.classList.add("is-visible");
        this.renderCart(false, false).then(() => {
          this.options.itemCount = 0;
          this.options.productId = null;
          if (this.options.showRecommendations) this.loadRecommendations();
        });
      } else if (quantity == 0) {
        const nextItem = cartItem.nextElementSibling;
        this.removeCartItem(cartItem);
        if (nextItem) {
          nextItem.classList.add("repo--top");
          const exitDuration = window.theme?.animationDuration || 700;
          setTimeout(() => nextItem.classList.remove("repo--top"), exitDuration);
        }
        if (data.item_count > 0 && this.options.showRecommendations) {
          this.options["productId"] = data.items[0].product_id;
          this.renderCart(false, false, false, null, true);
        }
        return;
      } else {
        await this.renderCart(target.getAttribute("data-id"), true);
      }
    } catch (error) {
      if (itemLoader) itemLoader.classList.remove("is-visible");
    } finally {
      this._quantityUpdating = false;
    }
  }




  onProductAdded(event) {
    let details = false;
    if (event.detail) {
      details = event.detail;
    }

    if (window.theme.cartCount == 0 && this.isOpen == true && this.loader) {
      this.loader.classList.add("is-visible");
    }

    const quantity = (details && details.quantity) ? parseInt(details.quantity, 10) : 1;
    const headerCountEl = document.querySelector('.header__cart-count') || document.querySelector('.header-cart__item-count');
    if (headerCountEl) {
      const current = parseInt(window.theme.cartCount || 0, 10);
      headerCountEl.textContent = current + quantity;
    }

    if (this.element.hasAttribute('data-open-drawer') && !this.isOpen) {
      this.drawer.openDrawer();
    }

    this._loadingRecosAfterAdd = true;
    this.renderCart(false, false, true, details).then(async () => {
      if (!this.options.showRecommendations) {
        this._loadingRecosAfterAdd = false;
        return;
      }
      try {
        const cartRes = await fetch(window.routes.localeRootUrl + "/cart.js", { credentials: "same-origin" });
        const cartData = await cartRes.json();
        this.options.itemCount = cartData.item_count || 0;
        if (cartData.items && cartData.items.length > 0) {
          this.options.productId = cartData.items[0].product_id;
        } else {
          this.options.productId = null;
        }
        if (window.DEBUG_CART_RECOS) {
          console.log("[cart-drawer] after renderCart (cart.js):", { itemCount: this.options.itemCount, productId: this.options.productId });
        }
      } catch (e) {
        if (window.DEBUG_CART_RECOS) console.warn("[cart-drawer] cart.js fetch failed", e);
      }
      await new Promise(r => setTimeout(r, 50));
      await this.loadRecommendations();
      setTimeout(() => { this._loadingRecosAfterAdd = false; }, 250);
    }).catch(() => {
      this._loadingRecosAfterAdd = false;
    });
  }

  renderCart(lineNumber, quantityChange, productAdd, productAddEvent, updateCount) {
    this.pageLoader.style.width = 90 + "%";
    var _this = this;
    const sectionWrapper = this.element.closest && this.element.closest("[id^=\"shopify-section-\"]");
    const sectionId = sectionWrapper ? sectionWrapper.id.replace("shopify-section-", "") : "main-cart_drawer";
    const basePath = (window.location.pathname && window.location.pathname !== "/") ? window.location.pathname : window.routes.localeRootUrl + "/";
    const sectionUrl = basePath + (basePath.indexOf("?") >= 0 ? "&" : "?") + "section_id=" + encodeURIComponent(sectionId) + "&t=" + Date.now();
    return fetch(
      sectionUrl,
      {
        credentials: "same-origin",
        method: "GET",
        cache: "no-store",
      }
    ).then(function (content) {
      return content.text().then(function (html) {
        _this.replaceContent(
          html,
          lineNumber,
          quantityChange,
          productAdd,
          productAddEvent,
          updateCount
        );

      });
    });
  }

  replaceContent(
    html,
    lineNumber,
    quantityChange,
    productAdd,
    productAddEvent,
    updateCount
  ) {

    // Prepare the page loader animation
    this.pageLoader.style.width = "100%";
    setTimeout(() => {
      this.pageLoader.style.left = "unset";
      this.pageLoader.style.right = "0px";
      this.pageLoader.style.width = "0%";

      setTimeout(() => {
        this.pageLoader.style.left = "0px";
        this.pageLoader.style.right = "unset";
      }, 550);


    }, 100)


    // Create a temporary element to parse the new HTML content
    const tempElement = document.createElement("div");
    tempElement.innerHTML = html;

    // Extract options and update cart count (#cart when not on cart page, #cart-page on cart)
    const cartEl = tempElement.querySelector("#cart") || tempElement.querySelector("#cart-page") || tempElement.querySelector("cart-drawer");
    const settingsJson = cartEl?.getAttribute("data-settings");
    const newOptions = settingsJson ? JSON.parse(settingsJson) : this.options;
    const wasEmptyBeforeUpdate = (this.options.itemCount === 0);
    this.options = newOptions;

    // In your replaceContent method, update this section:

    if (tempElement.querySelector("[data-ids]")) {
      this.cartIds = tempElement
        .querySelector("[data-ids]")
        .dataset.ids.split(",")
        .filter((item) => item !== "");
      if (updateCount) {
        this.cartIds = this.cartIds.filter((item) => item !== this.removeId);
        this.removeid = null;
      }
    } else {
      // Fixed: Initialize as empty array when no items in cart
      this.cartIds = [];
    }

    const itemCount = parseInt(newOptions.itemCount || 0);
    window.theme.cartCount = itemCount;

    if (updateCount) {
      this.updateCartFooter(tempElement);
      this.updateHeaderCartCount();
      this.element.dispatchEvent(
        new CustomEvent("cart:updated", { bubbles: true, detail: { item_count: itemCount } })
      );
      if (this.options.showRecommendations) {
        this.loadRecommendations();
      }
      return;
    }
    if (lineNumber && tempElement.querySelector(`#${lineNumber}`)) {
      this.updateCartItem(lineNumber, tempElement);
    } else if (productAdd && productAddEvent && !wasEmptyBeforeUpdate) {
      const variantId =
        productAddEvent.variant != null ? String(productAddEvent.variant) : "";
      const itemId = variantId ? `cart-item__${variantId}` : "";
      const newLine = itemId && tempElement.querySelector(`#${itemId}`);
      if (!variantId || !newLine) {
        this.replaceCartContent(tempElement, productAdd);
      } else if (this.element.querySelector(`#${itemId}`)) {
        this.updateCartItem(itemId, tempElement);
      } else {
        this.addContent(tempElement, productAddEvent);
      }
    } else {
      this.replaceCartContent(tempElement, productAdd);
    }


    this.updateCartFooter(tempElement);
    this.updateHeaderCartCount();

    this.element.dispatchEvent(
      new CustomEvent("cart:updated", { bubbles: true, detail: { item_count: itemCount } })
    );

    this.cachedUsp = this.cacheUspMarkup();
    this.ensureUspPlacement();

    this.element.dispatchEvent(
      new CustomEvent("cart:render", { bubbles: true })
    );

    const isFullAfterUpdate = itemCount > 0;
    const transitioningToFull = wasEmptyBeforeUpdate && isFullAfterUpdate;

    setTimeout(() => {
      if (this.options.showRecommendations && !this._loadingRecosAfterAdd) {
        this.loadRecommendations();
      }

      if (this.element.hasAttribute('data-open-drawer')) {
        this.focusElement = this.element.querySelector("[data-scrollable]");
        if (this.focusElement) {
          bodyScrollLock.disableBodyScroll(this.focusElement, bodyScrollLockOptions);
        }
      }



    }, 200);
  }

  updateCartItem(lineNumber, tempElement) {
    const cartItemParent = this.element.querySelector(`#${lineNumber}`);
    const newCartItemInfo = tempElement.querySelector(
      `#${lineNumber} .cart-item__info `
    );
    const oldCartItemInfo = cartItemParent.querySelector(`#${lineNumber} .cart-item__info`);



    if (!cartItemParent) {
      this.element
        .querySelector(".itemLoader")
        .classList.remove("is-visible");
    } else {
      cartItemParent
        .querySelector(".itemLoader")
        .classList.remove("is-visible");
    }

    if (newCartItemInfo) {
      cartItemParent.querySelector('.cart-item__inner').replaceChild(
        newCartItemInfo,
        oldCartItemInfo
      );
    } else if (cartItemParent) {
      this.removeCartItem(cartItemParent);
    }
  }

  addContent(tempElement, productAddEvent) {
    if (this.isOpen) {
      this.element.querySelector(".cart-drawer__wrapper").scrollTop = 0;
    }
    const itemToAdd = tempElement.querySelector(
      `#cart-item__${productAddEvent.variant}`
    );
    const cartWrapper = this.element.querySelector(".cart-drawer__items");
    const firstItem = cartWrapper.firstElementChild;
    if (cartWrapper.querySelector(`#cart-item__${productAddEvent.variant}`)) {
      this.updateCartItem(`cart-item__${productAddEvent.variant}`, tempElement);
    } else {
      const height = this.calculateDetachedElement(itemToAdd);
      document.documentElement.style.setProperty(
        "--repositioning_value",
        `${height}px`
      );
      firstItem.classList.add("repo--bottom");
      setTimeout(() => {
        cartWrapper.prepend(itemToAdd);
        itemToAdd.classList.add("repo--adding");
        firstItem.classList.remove("repo--bottom");

        setTimeout(() => {
          itemToAdd.classList.remove("repo--adding");
          if (this.loader) this.loader.classList.remove("is-visible");
        }, 350);
      }, 350);
    }

    this._refreshCartDrawerScrollLock();
  }

  removeCartItem(cartItemParent) {
    if (!cartItemParent) return;
    const duration = window.theme?.animationDuration || 400;
    cartItemParent.style.overflow = "hidden";
    const anim = cartItemParent.animate(
      [
        { transform: "translateX(0px)", opacity: "1" },
        { transform: "translateX(-30px)", opacity: "0" }
      ],
      { duration, fill: "forwards" }
    );
    anim.finished.then(() => cartItemParent.remove());
  }

  calculateDetachedElement(element) {
    // 1. Create a detached container
    const detachedContainer = document.createElement("div");
    detachedContainer.style.position = "absolute";
    detachedContainer.style.visibility = "hidden";
    detachedContainer.style.height = "auto";
    detachedContainer.style.width = "auto";
    detachedContainer.style.top = "-9999px"; // Off-screen positioning

    // 2. Append the new item to the detached container
    detachedContainer.appendChild(element);

    // 3. Append the detached container to the body (but off-screen)
    this.element.appendChild(detachedContainer);

    // 4. Get the offset height of the new item
    const newItemHeight = element.offsetHeight + 16;

    // 5. Remove the detached container from the DOM
    this.element.removeChild(detachedContainer);

    // Now you have the height of the new item without it ever being visible
    return newItemHeight;
  }

  updateCartFooter(tempElement) {
    const itemCount = this.options.itemCount;
    if (itemCount > 0) {

      const footerParent = document.querySelector(".cart-drawer__footer");

      const newFooterTotals = tempElement.querySelector(
        ".cart_drawer__footer-totals"
      );
      const oldFooterTotals = document.querySelector(".cart_drawer__footer-totals");

      if (!footerParent || !newFooterTotals) return;
      if (oldFooterTotals) {

        footerParent.replaceChild(
          newFooterTotals,
          oldFooterTotals
        );
      } else {
        footerParent.prepend(newFooterTotals);
      }

      const newShippingBar = tempElement.querySelector(
        ".cart-drawer__shipping-progress-bar"
      );
      if (newShippingBar) {
        const currentShippingBar = document.querySelector(
          ".cart-drawer__shipping-progress-bar"
        );
        if (currentShippingBar) {
          let percent = parseFloat(newShippingBar.dataset.percent);
          if (percent > 100) {
            percent = 100;
          }
          currentShippingBar.dataset.percent = percent;
          currentShippingBar.style.setProperty('--shipping-progress', percent / 100);
          if (percent >= 100) {
            currentShippingBar.classList.add("done");
            currentShippingBar.classList.remove("active");
          } else {
            currentShippingBar.classList.remove("done");
            currentShippingBar.classList.add("active");
          }
          this.element.querySelector(".cart-drawer__shipping-text").innerHTML =
            tempElement.querySelector(".cart-drawer__shipping-text").innerHTML;
        } else {
          const headerParent = this.element.querySelector(
            ".cart-drawer__header"
          );
          headerParent.appendChild(
            tempElement.querySelector(".cart-drawer__shipping")
          );
        }
      }

    } else {
      this.clearCartFooter(tempElement);
    }

    if (this.element.querySelector(".cart-drawer__footer")) {
      this.updateCartFooterHeight();
    }

    if (this.element.querySelector(".cart-drawer__shipping")) {
      document.documentElement.style.setProperty(
        "--cart-drawer__shipping-height",
        this.element.querySelector(".cart-drawer__shipping").offsetHeight + "px"
      );
    }

    // 🧩 Update total price dynamically
    const newTotal = tempElement.querySelector('.cd__subtotal-final');
    const oldTotal = this.element.querySelector('.cd__subtotal-final');
    if (newTotal && oldTotal) {
      oldTotal.innerHTML = newTotal.innerHTML;
    }
  }

  updateHeaderCartCount() {
    const itemCount = this.options.itemCount;
    const headerCount = document.querySelector('.header__cart-count') || document.querySelector('.header-cart__item-count');
    if (!headerCount) return;
    headerCount.innerHTML = itemCount;
    if (itemCount > 0) headerCount.style.display = '';
    else headerCount.style.display = 'none';
  }

  clearCartFooter(tempElement) {
    if (!tempElement.querySelector(".cart-drawer__wrapper")) return;
    if (document.querySelector(".cart-drawer__footer")) {
      document
        .querySelector(".cart-drawer__footer")
        .classList.add("removing");
    }

    const wrapperParent = this.element.querySelector(".cart-drawer__wrapper");
    if (wrapperParent) {
      wrapperParent.innerHTML = tempElement.querySelector(
        ".cart-drawer__wrapper"
      ).innerHTML;
    }

    this._refreshCartDrawerScrollLock();
  }

  /**
   * @param {boolean} [skipLineAnimations=false] - When true (e.g. just after add-to-cart), avoid
   *   opacity-0 intro on all lines; full DOM replace + staggered animation reads as a flash.
   */
  replaceCartContent(tempElement, skipLineAnimations = false) {

    const cartWrapperParent = this.element.querySelector(
      ".cart-drawer__wrapper"
    ).parentNode;
    const currentScrollPosition = this.element.querySelector(
      ".cart-drawer__wrapper"
    ).scrollTop;

    cartWrapperParent.replaceChild(
      tempElement.querySelector(".cart-drawer__wrapper"),
      this.element.querySelector(".cart-drawer__wrapper")
    );
    setTimeout(() => {
      if (this.loader) this.loader.classList.remove("is-visible");
    }, 200);
    this.element.querySelector(".cart-drawer__wrapper").scrollTop =
      currentScrollPosition;

    if (!skipLineAnimations) {
      this._animateCartItemsOneByOne();
    }

    this._refreshCartDrawerScrollLock();

    setTimeout(() => {
      const header = this.element.querySelector(".cart-drawer__header");
      const headerHeight = header.offsetHeight;

      document.documentElement.style.setProperty(
        "--cart-drawer__header-height",
        headerHeight + "px"
      );
      if (cartWrapperParent.querySelector(".cart-drawer__footer")) {
        this.updateCartFooterHeight();
      }

      if (cartWrapperParent.querySelector(".cart-drawer__shipping")) {
        document.documentElement.style.setProperty(
          "--cart-drawer__shipping-height",
          cartWrapperParent.querySelector(".cart-drawer__shipping").offsetHeight + "px"
        );
      }

    }, 100);
  }

  _refreshCartDrawerScrollLock() {
    if (!this.isOpen) return;
    if (typeof bodyScrollLock === "undefined") return;

    const scrollable = this.element.querySelector("[data-scrollable]");
    if (!scrollable) return;

    try {
      bodyScrollLock.disableBodyScroll(scrollable, bodyScrollLockOptions);
    } catch (e) {}
  }

  _animateCartItemsOneByOne() {
    if (!window.theme?.enableAnimations) return;
    const items = this.element.querySelectorAll(
      ".cart-drawer__items .cart-item.animatedContent[data-animation='elementFromLeft']"
    );
    const duration = window.theme.animationDuration || 400;
    const between = window.theme.animationBetweenElements || 200;
    items.forEach((item, i) => {
      if (item.getAttribute("data-loaded")) return;
      item.setAttribute("data-loaded", true);
      setTimeout(() => {
        item.animate(
          [
            { transform: "translateX(-30px)", opacity: "0" },
            { transform: "translateX(0px)", opacity: "1" }
          ],
          { duration: duration, fill: "forwards" }
        );
      }, between * i);
    });
  }

  _applyRecommendationDragGuards(container) {
    if (!container) return;
    container.querySelectorAll('.swiper-slide img, .swiper-slide a').forEach((node) => {
      node.setAttribute('draggable', 'false');
    });
  }

  async loadRecommendations() {
    const container = this.element.querySelector(".cart-drawer__recommendations");
    if (!container) {
      if (window.DEBUG_CART_RECOS) console.warn("[cart-drawer] loadRecommendations: no .cart-drawer__recommendations container");
      return;
    }

    // Abort any in-flight recommendation fetch to avoid concurrent DOM thrashing
    if (this._recAbortController) {
      this._recAbortController.abort();
    }
    this._recAbortController = new AbortController();
    const signal = this._recAbortController.signal;

    this.recommendationLoading = true;

    const baseUrl = window.routes.localeRootUrl;
    const productId = this.options["productId"];
    const hasItems = this.options["itemCount"] > 0;
    const enabled = container.dataset.enabled === "true";
    const collection = (container.dataset.collection && container.dataset.collection.trim()) ||
      (this.element.dataset.recommendationCollection && this.element.dataset.recommendationCollection.trim()) ||
      "";
    const limit = this.element.getAttribute("product-limit") || 4;
    let url = null;


    const cacheBust = "&t=" + Date.now();

    // 🛒 CART EMPTY
    if (!hasItems) {
      if (enabled && collection && collection !== "blank") {
        url = `${baseUrl}?section_id=helper-recommendations&collection=${encodeURIComponent(collection)}${cacheBust}`;

      } else {
        container.innerHTML = "";
        this.recommendationLoading = false;
        if (window.DEBUG_CART_RECOS) console.warn("[cart-drawer] loadRecommendations: empty cart, no collection or disabled");
        return;
      }
    }

    // 📦 CART HAS ITEMS
    else {
      if (productId) {
        url = `${baseUrl}/recommendations/products?section_id=helper-recommendations&product_id=${productId}&limit=${limit}${cacheBust}`;

      } else {
        this.recommendationLoading = false;
        if (window.DEBUG_CART_RECOS) console.warn("[cart-drawer] loadRecommendations: has items but no productId, skipping");
        return;
      }
    }

    if (window.DEBUG_CART_RECOS) console.log("[cart-drawer] loadRecommendations: fetching", url);

    try {
      const response = await fetch(url, { signal });
      const html = await response.text();

      if (window.DEBUG_CART_RECOS) {
        console.log("[cart-drawer] loadRecommendations: response", response.status, "html length", html.length, "preview:", html.substring(0, 200));
      }

      const temp = document.createElement("div");
      temp.innerHTML = html;

      const upsell = temp.querySelector(".cart-drawer__upsell");
      // 🧠 Intent-aware validation before rendering
      const slides = upsell ? upsell.querySelectorAll('.swiper-slide').length : 0;
      const intent = this.options.intent;

      if (window.DEBUG_CART_RECOS) {
        console.log("[cart-drawer] loadRecommendations: upsell found?", !!upsell, "slides", slides, "intent", intent);
      }

      // 🚫 Hide if no products match for complementary or related (only when showing product recos, not empty-cart collection)
      if (hasItems && (intent === 'complementary' || intent === 'related') && slides === 0) {
        container.innerHTML = '';
        container.style.display = 'none';
        this.recommendationLoading = false;
        if (window.DEBUG_CART_RECOS) console.warn("[cart-drawer] loadRecommendations: intent match, 0 slides, hiding");
        return;
      }

      // ✅ Proceed to render only when valid slides exist
      if (upsell && slides > 0) {
        container.innerHTML = upsell.innerHTML;
        this._applyRecommendationDragGuards(container);
        container.style.display = '';
        container.removeAttribute('data-loaded');
        requestAnimationFrame(() => {
          new RevolutionAnimation(container);
          const swipers = container.querySelectorAll("swiper-init");
          swipers.forEach((swiperEl) => {
            if (typeof swiperEl.connectedCallback === "function") {
              swiperEl.connectedCallback();
            }
          });
          if (window.SwiperInit) {
            window.SwiperInit(container);
          }
        });
        if (window.DEBUG_CART_RECOS) console.log("[cart-drawer] loadRecommendations: rendered", slides, "slides");
      } else {
        container.innerHTML = "";
        container.style.display = 'none';
        if (window.DEBUG_CART_RECOS) console.warn("[cart-drawer] loadRecommendations: no upsell or 0 slides, hiding");
      }


    } catch (err) {
      if (err.name === 'AbortError') return; // Superseded by a newer call
      if (window.DEBUG_CART_RECOS) console.warn("[cart-drawer] loadRecommendations: fetch error", err);
    } finally {
      this.recommendationLoading = false;
    }
  }
}
customElements.define("cart-drawer", CartDrawer);



class MainCart extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this._eventsBound = false;
  }

  connectedCallback() {
    if (!this._eventsBound) {
      this.bindEvents();
      this._eventsBound = true;
    }

    const container = this.querySelector(".cart-drawer__recommendations");
    if (!container) return;

    const productId = this.dataset.productId;
    const collection = container.dataset.collection;
    const limit = this.dataset.limit || 4;
    const baseUrl = window.routes?.localeRootUrl || "";

    this.recommendationsButtonConfig = {
      text: container.dataset.recoButtonText,
      url: container.dataset.recoButtonUrl,
      style: container.dataset.recoButtonStyle
    };

    let url = "";

    if (!productId) {
      url = `${baseUrl}?section_id=helper-recommendations-main-cart&collection=${collection}`;
    } else {
      url = `${baseUrl}/recommendations/products?section_id=helper-recommendations-main-cart&product_id=${productId}&limit=${limit}`;
    }

    fetch(url)
      .then(r => r.text())
      .then(html => {
        const temp = document.createElement("div");
        temp.innerHTML = html;
        const upsell = temp.querySelector(".cart-drawer__upsell");

        if (upsell) {
          container.innerHTML = upsell.outerHTML;
          container.querySelectorAll('.swiper-slide img, .swiper-slide a').forEach((node) => {
            node.setAttribute('draggable', 'false');
          });
          this._updateRecommendationsNavVisibility(container);
          this._injectRecommendationsButton(container);
          new AddToCart(this);
          new RevolutionAnimation(container);

          // ✅ Run Swiper AFTER DOM updates
          // ✅ Force re-upgrade all <swiper-init> elements inside the container
          setTimeout(() => {
            const swipers = container.querySelectorAll("swiper-init");
            swipers.forEach(swiperEl => {
              if (typeof swiperEl.connectedCallback === "function") {
                swiperEl.connectedCallback();
              }
            });

            if (window.SwiperInit) {
              window.SwiperInit(container);
            }
          }, 500);

        } else {
          container.style.display = "none";
        }
      })
      .catch(() => {});
  }

  disconnectedCallback() {
    try {
      this.delegateElement?.off?.();
    } catch (e) {}
    this._eventsBound = false;
  }

  bindEvents() {
    if (!this.delegateElement) return;

    // Show per-item loader overlay on cart page actions (quantity change / remove)
    this.delegateElement.on(
      "click",
      '[data-action="update-item-quantity"], [data-action="remove-item"]',
      (event, target) => {
        const cartItem = target.closest(".cart-item");
        if (!cartItem) return;
        const itemLoader = cartItem.querySelector(".itemLoader");
        if (itemLoader) itemLoader.classList.add("is-visible");
        // Do NOT prevent default – keep existing cart page reload behaviour
      }
    );
  }

  _updateRecommendationsNavVisibility(container) {
    if (!container) return;
    const nav = container.querySelector('.cart-drawer__swiper-nav-buttons');
    if (!nav) return;

    const slidesCount = container.querySelectorAll('.cart-drawer__rec-item').length;
    if (slidesCount <= 4) {
      nav.setAttribute('aria-hidden', 'true');
      nav.style.display = 'none';
    } else {
      nav.setAttribute('aria-hidden', 'false');
      nav.style.display = '';
    }
  }
}

customElements.define("main-cart", MainCart);

MainCart.prototype._injectRecommendationsButton = function (container) {
  const cfg = this.recommendationsButtonConfig || {};
  if (!cfg.text || !cfg.url) return;

  const headerWrapper = container.querySelector(".cart-drawer__title-logo--wrapper");
  if (!headerWrapper) return;

  const button = document.createElement("a");
  const styleSuffix = cfg.style || "Secondary";
  button.className = `Button Button--${styleSuffix} main-cart__recommendations-button`;
  button.href = cfg.url;

  const span = document.createElement("span");
  span.className = "ButtonText u-p1";
  span.textContent = cfg.text;

  button.appendChild(span);
  headerWrapper.appendChild(button);
};


const lerp = (c, t, f) => c * (1 - f) + t * f;
class AnimatedCartUspsBar extends HTMLElement {
  constructor() {
    super();
    // Default settings and state
    this.speed       = 30;       // seconds
    this.fps         = 60;
    this.paused      = false;
    this.lerp        = { current: 0, target: 0 };
    this.factor      = 0.1;
    this.pxPerFrame  = 0;
    this.gutter      = 0;       // in px
    this.animationEnabled = true;

    this._hasStarted = false;
    this._initialized = false;
    this._disconnected = false;

    this.wrapper         = null;
    this.container       = null;
    this.resizeObserver  = null;
    this._boundMouseEnter = null;
    this._boundMouseLeave = null;
    this._boundClick     = null;
  }

  connectedCallback() {
    this._disconnected = false;
    this.wrapper   = this.querySelector('.cart-drawer__usp-bar--duplicate-wrapper');
    this.container = this.querySelector('.cart-drawer__usp-bar--anim-wrapper');

    // Speed override from data-settings
    const speedAttr = parseFloat(this.getAttribute('data-settings'));
    if (!isNaN(speedAttr)) this.speed = speedAttr;

    // Parse JSON for enableAnimation flag
    const json = this.getAttribute('data-block-settings');
    if (json) {
      try {
        const parsed = JSON.parse(json);
        if (parsed.enableAnimation === false) {
          this.animationEnabled = false;
        }
      } catch (e) {
        console.warn('Invalid data-block-settings:', e);
      }
    }

    if (this.animationEnabled) {
      this.init();
    }
  }

  disconnectedCallback() {
    this._disconnected = true;
    if (this.resizeObserver && this.wrapper) {
      this.resizeObserver.disconnect();
      this.resizeObserver = null;
    }
    if (this.container) {
      if (this._boundMouseEnter) this.container.removeEventListener('mouseenter', this._boundMouseEnter);
      if (this._boundMouseLeave) this.container.removeEventListener('mouseleave', this._boundMouseLeave);
      if (this._boundClick) this.container.removeEventListener('click', this._boundClick);
      this._boundMouseEnter = this._boundMouseLeave = this._boundClick = null;
    }
    if (this.wrapper) this.wrapper.style.willChange = '';
    this.wrapper = null;
    this.container = null;
    this._initialized = false;
  }

  init() {
    if (this._initialized) return;
    this._initialized = true;
    this.cloneItems();
    this.measure();
    this.observeResize();
    this.bindInteractions();
  }

  cloneItems() {

    if(this.wrapper.children.length === 1){
      this.wrapper.style.gap = "25rem"
    }
    // Duplicate each child so we can scroll seamlessly
    Array.from(this.wrapper.children).forEach(child =>
      this.wrapper.appendChild(child.cloneNode(true))
    );
  }

  measure() {
    requestAnimationFrame(() => {
      const hostRect = this.getBoundingClientRect();
      if (hostRect.width <= 0) return;

      const contentWidth = this.wrapper.scrollWidth;
      const parentRect = this.parentElement?.getBoundingClientRect();
      this.gutter = parentRect ? Math.max(0, (hostRect.width - parentRect.width) / 2) : 0;

      this.wrapper.style.width = `${contentWidth + this.gutter * 2}px`;
      this.container.style.width = `${hostRect.width}px`;

      const oneRun = contentWidth / 2;
      this.pxPerFrame = oneRun / (this.speed * this.fps);

      this.lerp.current = this.lerp.target = 0;
      this.wrapper.style.transform = `translateX(-${this.gutter}px)`;

      if (!this._hasStarted && oneRun > 0) {
        this._hasStarted = true;
        this.animate();
      }
    });
  }

  observeResize() {
    this.resizeObserver = new ResizeObserver(() => this.measure());
    this.resizeObserver.observe(this.wrapper);
  }

  bindInteractions() {
    this._boundClick = () => {
      if (!window.matchMedia('(hover: hover)').matches) {
        this.paused = !this.paused;
        this._updateWillChange();
      }
    };
    if (this.container) {
      this.container.addEventListener('click', this._boundClick);
    }
  }

  _updateWillChange() {
    if (!this.wrapper) return;
    this.wrapper.style.willChange = this.paused ? '' : 'transform';
  }

  animate() {
    const step = () => {
      if (this._disconnected) return;
      if (!this.paused) {
        if (this.wrapper && this.wrapper.children.length > 0) {
          this.wrapper.style.willChange = 'transform';
          const first = this.wrapper.children[0];
          const gap   = parseFloat(getComputedStyle(this.wrapper).gap) || 0;
          const fw    = first.offsetWidth + gap;

          this.lerp.target += this.pxPerFrame;
          this.lerp.current = this._lerp(this.lerp.current, this.lerp.target, this.factor);

          if (this.lerp.current >= fw) {
            this.wrapper.appendChild(first);
            this.lerp.current -= fw;
            this.lerp.target  -= fw;
          }

          const x = this.lerp.current + this.gutter;
          this.wrapper.style.transform = `translateX(-${x}px)`;
        }
      } else {
        this._updateWillChange();
      }
      requestAnimationFrame(step);
    };

    requestAnimationFrame(step);
  }

  _lerp(c, t, f) {
    return c * (1 - f) + t * f;
  }
}

customElements.define('cart-drawer-usp-bar', AnimatedCartUspsBar);
    
class CarouselTest extends HTMLElement {
  constructor() {
    super();
    const _this = this;
    this.element = this;
    this.domDelegate = new Delegate(this.element);

    this.bindEvents();

    new AddToCart(this.element);
  }

  bindEvents() {}
}
customElements.define('carousel-test', CarouselTest);


class SliderTextSection extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.carouselElement = this.element.querySelector('.swiper');
    this.carousel = new RevolutionSwiper(this.carouselElement);
  }
}
customElements.define('slider-text', SliderTextSection);
class FeaturedCollectionSwitcher extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this._eventsBound = false;
  }

  disconnectedCallback() {
    this.delegateElement.off();
    this._eventsBound = false;
  }

  connectedCallback() {
    const wrapper = this.element.querySelector(".custom-collection-tabs__wrapper");
    const carousels = this.element.querySelector(".pc__carousels");
    const groups = this.element.querySelectorAll(".pc__carousel-group");
    const hasTabs = this.element.querySelector(".pc__header-btn");

    if (!hasTabs && wrapper && carousels && groups.length > 0) {
      this._buildTabsFromCarouselGroups(wrapper, carousels, groups);
    }

    const firstGroup = groups?.[0];
    if (firstGroup) {
      firstGroup.setAttribute("aria-hidden", "false");
      const swiperEl = firstGroup.querySelector("swiper-init");
      const revolutionSwiper = swiperEl?.getSwiper?.();
      if (revolutionSwiper?.swiperElement) {
        requestAnimationFrame(() => {
          revolutionSwiper.swiperElement.update();
        });
      }
    }

    // Move hidden tabs into <template> to remove from DOM tree.
    // Uses appendChild to move live nodes (not innerHTML), preserving
    // custom element state and image loading capability.
    groups.forEach((group, i) => {
      if (i === 0) return;
      const tpl = document.createElement("template");
      while (group.firstChild) {
        tpl.content.appendChild(group.firstChild);
      }
      group.appendChild(tpl);
      group.setAttribute("data-deferred", "");
    });

    const firstBtn = this.element.querySelector(".pc__header-btn");
    if (firstBtn) {
      firstBtn.classList.add("pc__header-btn--active");
      firstBtn.setAttribute("aria-selected", "true");
    }

    if (!this._eventsBound) {
      this.bindEvents();
      this._eventsBound = true;
    }
  }

  /**
   * Build one tab row from carousel groups (data-pc-collection-id + data-collection-title on swiper-init).
   * Inserts the tab row before .pc__carousels so layout is: one row of tabs, one column of swipers.
   */
  _buildTabsFromCarouselGroups(wrapper, carousels, groups) {
    const escapeHtml = (s) =>
      String(s)
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;");

    const items = [];
    groups.forEach((group, index) => {
      const id = group.getAttribute("data-pc-collection-id");
      const swiper = group.querySelector("swiper-init");
      const label =
        swiper?.getAttribute("data-collection-title")?.trim() ||
        this.element.dataset.collectionFallback ||
        (typeof window.languages !== "undefined" && window.languages.collection) ||
        "";
      items.push({ id, label, first: index === 0 });
    });

    const desktopButtons = items
      .map(
        (item) =>
          `<button tabindex="0" data-pc-collection-target="${escapeHtml(item.id)}" role="tab" aria-selected="${item.first ? "true" : "false"}" class="Button Button--${item.first ? "PrimaryOnLight" : "Secondary"} pc__header-btn${item.first ? " pc__header-btn--active" : ""}" style="--adjustment_m: 0px; --adjustment_d: 0px;"><div class="ButtonTextContainer"><span class="ButtonText"><span class="button-txt u-p1">${escapeHtml(item.label)}</span></span></div></button>`
      )
      .join("\n");

    const mobileOptions = items
      .map(
        (item) =>
          `<button type="button" class="Button Button--${item.first ? "PrimaryOnLight" : "Secondary"} pc__header-dropdown-option" data-pc-collection-target="${escapeHtml(item.id)}"><div class="ButtonTextContainer"><span class="ButtonText"><span class="button-txt u-p1">${escapeHtml(item.label)}</span></span></div></button>`
      )
      .join("\n");

    const firstLabel =
      items[0]?.label ??
      this.element.dataset.collectionFallback ??
      (typeof window.languages !== "undefined" && window.languages.collection) ??
      "";
    const tabsHtml = `
      <div class="custom-collection-tabs__tabs">
        <div class="pc__header">
          <div class="pc__header-inner">
            <div class="pc__header-nav pc__header-nav--desktop" role="tablist">${desktopButtons}</div>
            <div class="pc__header-nav pc__header-nav--mobile">
              <button type="button" class="Button Button--PrimaryOnLight pc__header-dropdown-toggle" aria-expanded="false">
                <div class="ButtonTextContainer"><span class="ButtonText"><span class="button-txt u-p1">${escapeHtml(firstLabel)}</span> <span class="pc__header-dropdown-arrow Svg Svg--arrow_down"><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M3.49572 7.0033C3.29076 7.20852 3.27871 7.53687 3.4674 7.7572L9.9674 14.2631L16.4723 7.7572C16.6285 7.59784 16.6744 7.36062 16.5885 7.15466C16.5024 6.94864 16.301 6.81379 16.0778 6.81287C15.9302 6.81209 15.788 6.87007 15.6832 6.974L9.9674 12.6908L4.2506 6.974C4.03018 6.78523 3.70092 6.79809 3.49572 7.0033Z" fill="currentColor"/></svg></span></span></div>
              </button>
              <div class="pc__header-dropdown-list" aria-hidden="true">${mobileOptions}</div>
            </div>
          </div>
        </div>
      </div>`;

    const parse = new DOMParser().parseFromString(tabsHtml, "text/html");
    const tabsEl = parse.body.firstElementChild;
    if (tabsEl) {
      wrapper.insertBefore(tabsEl, carousels);
    }
  }

  bindEvents() {
    this.delegateElement.on(
      "click",
      ".pc__header-btn",
      (event) => {
        const button = event.target.closest(".pc__header-btn");
        if (!button) return;
        const targetId = button.getAttribute("data-pc-collection-target");
        if (!targetId) return;
        const label = button.querySelector(".ButtonText")?.textContent?.trim();
        this.activateCollection(targetId, label);
      }
    );

    this.delegateElement.on(
      "click",
      ".pc__header-dropdown-toggle",
      (event) => {
        const toggle = event.target.closest(".pc__header-dropdown-toggle");
        if (!toggle) return;
        const expanded = toggle.getAttribute("aria-expanded") === "true";
        toggle.setAttribute("aria-expanded", expanded ? "false" : "true");
        const list = this.element.querySelector(".pc__header-dropdown-list");
        if (list) {
          list.setAttribute("aria-hidden", expanded ? "true" : "false");
        }
      }
    );

    this.delegateElement.on(
      "click",
      ".pc__header-dropdown-option",
      (event) => {
        const option = event.target.closest(".pc__header-dropdown-option");
        if (!option) return;
        const targetId = option.getAttribute("data-pc-collection-target");
        if (!targetId) return;
        const label = option.textContent.trim();
        this.activateCollection(targetId, label);
      }
    );
  }

  activateCollection(targetId, label) {
    const groups = this.element.querySelectorAll(".pc__carousel-group");
    groups.forEach((group) => {
      const groupId = group.getAttribute("data-pc-collection-id");
      group.setAttribute("aria-hidden", groupId === targetId ? "false" : "true");
    });

    const activeGroup = this.element.querySelector(
      `.pc__carousel-group[data-pc-collection-id="${CSS.escape(targetId)}"]`
    );
    if (!activeGroup) return;

    // Restore deferred tab: move live nodes back from <template> and trigger animations
    if (activeGroup.hasAttribute("data-deferred")) {
      const tpl = activeGroup.querySelector("template");
      if (tpl) {
        const content = document.importNode(tpl.content, true);
        activeGroup.removeChild(tpl);
        activeGroup.appendChild(content);
        activeGroup.removeAttribute("data-deferred");

        // Trigger animations on hydrated content (same as CTEK approach)
        const animTargets = [];
        if (activeGroup.classList.contains("animatedContent")) animTargets.push(activeGroup);
        activeGroup.querySelectorAll(".animatedContent").forEach((el) => animTargets.push(el));
        animTargets.forEach((el) => {
          el.setAttribute("data-loaded", "true");
          requestAnimationFrame(() => el.classList.add("RevolutionAnimation--in"));
        });
      }
    }

    const swiperEl = activeGroup.querySelector("swiper-init");
    const revolutionSwiper = swiperEl?.getSwiper?.();
    if (revolutionSwiper?.swiperElement) {
      requestAnimationFrame(() => {
        revolutionSwiper.swiperElement.update();
      });
    }

    this.element.querySelectorAll(".pc__carousels--header [data-pc-arrows-for]").forEach((el) => {
      el.setAttribute("aria-hidden", el.getAttribute("data-pc-arrows-for") === targetId ? "false" : "true");
    });

    const buttons = this.element.querySelectorAll(".pc__header-btn");
    buttons.forEach((btn) => {
      const btnId = btn.getAttribute("data-pc-collection-target");
      const isActive = btnId === targetId;
      btn.classList.toggle("pc__header-btn--active", isActive);
      btn.classList.toggle("Button--PrimaryOnLight", isActive);
      btn.classList.toggle("Button--Secondary", !isActive);
      btn.setAttribute("aria-selected", isActive ? "true" : "false");
    });

    const dropdownLabel = this.element.querySelector(
        ".pc__header-dropdown-toggle .button-txt, .pc__header-dropdown-toggle .pc__header-dropdown-label"
      );
    if (dropdownLabel && label) {
      dropdownLabel.textContent = label;
    }

    this.element.querySelectorAll(".pc__header-dropdown-option").forEach((opt) => {
      const optId = opt.getAttribute("data-pc-collection-target");
      const isActive = optId === targetId;
      opt.classList.toggle("Button--PrimaryOnLight", isActive);
      opt.classList.toggle("Button--Secondary", !isActive);
    });

    const dropdownToggle = this.element.querySelector(".pc__header-dropdown-toggle");
    const dropdownList = this.element.querySelector(".pc__header-dropdown-list");
    if (dropdownToggle && dropdownList) {
      dropdownToggle.setAttribute("aria-expanded", "false");
      dropdownList.setAttribute("aria-hidden", "true");
    }
  }

}

customElements.define("featured-collection-switcher", FeaturedCollectionSwitcher);

class Banner extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.previousRealIndex = 0;
    this.options = JSON.parse(this.element.getAttribute('data-section-settings'));
    this.swiperElement = this.querySelector('swiper-init');

    if (this.options.numberOfSlides > 1) {
      this.swiperElement.addEventListener('swiper:initialized', () => {
        this.carousel = this.swiperElement.getSwiper();
        this.fixPagination();
      });

      this.handleResize = debounce(this.onResize.bind(this), 250);
      window.addEventListener('resize', this.handleResize);

      this.onImagesReady = this.createObserver.bind(this);
      this.swiperElement.addEventListener('swiper:slide-changed', this.onImagesReady);

      this.createObserver();
    } else {
      this.createObserver();
    }

    this.bindEvents();
  }

  bindEvents() {
    let hasSlideChanged = false;
    this.swiperElement?.addEventListener('swiper:initialized', () => {
      this.carousel?.swiperElement?.on('slideChange', function () {
        if (!hasSlideChanged) {
          // Add class after first slide change
          const pagination = document.querySelector('.media-slideshow__pagination--autoplay');
          if (pagination) {
            pagination.classList.add('slideshow-started');
          }
          hasSlideChanged = true;
        }
      });
    });
  }

  onResize() {
    const newBreakpoint = responsive.getCurrentBreakpoint();

    if (this.currentBreakpoint !== newBreakpoint) {
      this.currentBreakpoint = newBreakpoint;

      if (this.options.numberOfSlides > 1) {
        this.changeImageQuality();

        setTimeout(() => {
          this.fixPagination();
        }, 100);
      }
    }
  }

  createObserver() {
    this.observer = new IntersectionObserver(this.handleIntersect.bind(this), { threshold: 0.5 });
    this.observer.observe(this.element);
  }

  handleIntersect(entries) {
    var _this = this;
    entries.forEach((entry) => {
      if (entry.intersectionRatio === 1 || entry.isIntersecting == true) {
        if (_this.options['numberOfSlides'] > 1) {
          _this.changeImageQuality();
        } else {
          _this.changeImageQuality(true);
        }
        _this.observer.unobserve(_this);
      }
    });
  }

  changeImageQuality(singleItem) {
    const breakpoint = responsive.getCurrentBreakpoint();

    let imageContainers;
    if (singleItem) {
      imageContainers = Array.from(this.element.querySelectorAll('.image__element')).slice(0, 2);
    } else {
      const currentIndex = this.carousel.swiperElement.activeIndex;
      const cellElement = this.carousel.swiperElement.slides[currentIndex];

      imageContainers = Array.from(cellElement.querySelectorAll('.image__element')).slice(0, 2);
    }

    if (imageContainers.length === 0) {
      return;
    }

    let imageToReveal;
    if (breakpoint === 'pocket' || breakpoint === 'phone' || breakpoint === 'tablet') {
      imageToReveal = imageContainers[0];
    } else {
      if (imageContainers.length == 2) {
        imageToReveal = imageContainers[1];
      } else {
        imageToReveal = imageContainers[0];
      }
    }

    if (!imageToReveal || imageToReveal.dataset.loadedImage === 'true') {
      return;
    }

    if (imageToReveal.dataset.src) {
      const replaceUrl = imageToReveal.dataset.src.replace('{width}x', 'width=2600');
      imageToReveal.src = replaceUrl;
      imageToReveal.dataset.loadedImage = 'true';
    }
  }

  fixPagination() {
    const paginationEl = this.element.querySelector('.media-slideshow__pagination');

    if (!paginationEl) {
      console.warn('Pagination element not found');
      return;
    }

    if (this.carousel && this.carousel.swiperElement) {
      this.carousel.swiperElement.pagination.render();
      this.carousel.swiperElement.pagination.update();
    }

    paginationEl.style.display = 'flex';
    paginationEl.style.opacity = '1';
  }
}
customElements.define('banner-hero', Banner);

class Header extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);
    this.options = JSON.parse(this.getAttribute('data-settings'));
    this.scrollableElement = this.element.querySelector('[data-scrollable]');
    this.announcementElement = document.querySelector('.announcement-bar--sticky');
    this.headerTransparent = false;
    this._isClosing = false;
    this.wasTransparentBeforeDrawer = false;
    this.drawerBlocksTransparency = false;
    this.prevOffset = 0;

    if (this.options.sticky) {
      this.toggleSticky();
    } else if (this.announcementElement) {
      this.adjustToStickyAnn();
    }
    document.documentElement.style.setProperty(
      '--header-height-fixed',
      document.querySelector('#header').offsetHeight + 'px',
    );

    this.updateVisibleHeight();
    window.onload = () => setTimeout(() => this.updateVisibleHeight(), 500);
    this.bindEvents();
    this.initMegaMenuLayoutVars();

    document.querySelectorAll('[data-cart-button]').forEach((btn) => {
      btn.classList.toggle('is-filled', window.theme?.cartCount > 0);
    });
  }

  toggleSticky() {
    if (this.announcementElement) {
      this.element.parentElement.classList.add('header--sticky-with-ann');
    } else {
      this.element.parentElement.classList.add('header--sticky');
    }

    this.element.parentElement.classList.remove('Header--Transparent');
  }

  adjustToStickyAnn() {
    this.element.classList.add('header--not-sticky');
  }

  bindEvents() {
    this.toggleColorListener = this.toggleColor.bind(this);

    if (this.options.transparent || this.options.sticky) {
      this._scrollToggleColor = scrollListener.addScrollListener(this, this.toggleColorListener);
    }
    this.toggleColor();

    this.delegateBody.on('menu:close', (e, target) => {
      if (e.target?.closest?.('#Drawer, #modal-country')) return;
      this.closeMenu.call(this, e, target);
    }, true);

    this.delegateBody.on('mobile-menu:open', this.handleHamburgerMenu.bind(this));
    this.delegateBody.on('mobile-menu:close', this.handleHamburgerMenu.bind(this));

    this.delegateBody.on('drawer:open', this.onDrawerOpened.bind(this), true);
    this.delegateBody.on('drawer:closed', this.onDrawerClosed.bind(this), true);

    this.delegateBody.on('quicksearch:open', this.handleDrawerOpening.bind(this), true);
    this.delegateBody.on('quicksearch:closed', this.handleDrawerClosing.bind(this), true);

    this.delegateElement.on('mouseenter', "[aria-hasMenu='true']", this.openMenu.bind(this), true);
    this.delegateElement.on('focusin', "[aria-hasMenu='true']", this.openMenu.bind(this), true);

    this.delegateElement.on('mouseleave', "[aria-hasMenu='true']", this.closeMenu.bind(this), true);

    this.delegateElement.on(
      'mouseenter',
      '[aria-singleMenu]',
      (e, target) => {
        const openElement =
          this.element.querySelector('.desktop-menu-list [aria-expanded="true"]') ||
          this.element.querySelector('.header-menu-items [aria-expanded="true"]') ||
          this.element.querySelector('[aria-hasMenu="true"][aria-expanded="true"]') ||
          this.element.querySelector('[aria-hasmenu="true"][aria-expanded="true"]');

        if (openElement && openElement !== target) {
          clearTimeout(this._menuCloseTimer);
          this._menuCloseTimer = null;
          this.closeSiblingMenu(openElement, false).then(() => {
            this.hideOverlay();
            if (this.scrollableElement) {
              try { bodyScrollLock.enableBodyScroll(this.scrollableElement); } catch (err) {}
            }
          });
        }
      },
      true,
    );

    this.delegateElement.on(
      'focusin',
      '[aria-singleMenu]',
      (e, target) => {
        const openElement =
          this.element.querySelector('.desktop-menu-list [aria-expanded="true"]') ||
          this.element.querySelector('.header-menu-items [aria-expanded="true"]') ||
          this.element.querySelector('[aria-hasMenu="true"][aria-expanded="true"]') ||
          this.element.querySelector('[aria-hasmenu="true"][aria-expanded="true"]');

        if (openElement && openElement !== target) {
          clearTimeout(this._menuCloseTimer);
          this._menuCloseTimer = null;
          this.closeSiblingMenu(openElement, false).then(() => {
            this.hideOverlay();
            if (this.scrollableElement) {
              try { bodyScrollLock.enableBodyScroll(this.scrollableElement); } catch (err) {}
            }
          });
        }
      },
      true,
    );

    this.delegateElement.on(
      'mouseenter',
      '.desktop-menu__dropdown-wrapper, [aria-submenu], .header-row-desktop',
      () => clearTimeout(this._menuCloseTimer),
      true,
    );

    this.delegateElement.on(
      'mouseleave',
      '.desktop-menu__dropdown-wrapper, [aria-submenu], .header-row-desktop',
      (e, submenuEl) => {
        const to = e.relatedTarget;
        if (to && submenuEl.contains(to)) return;
        const menuTrigger = to?.closest?.('[aria-hasMenu="true"]');
        if (menuTrigger && menuTrigger.querySelector('.desktop-menu__dropdown-wrapper')) return;
        this.closeMenu(e, submenuEl);
      },
      true,
    );

    this._boundUpdateVisibleHeight = this.updateVisibleHeight.bind(this);
    this._scrollUpdateVisibleHeight = scrollListener.addScrollListener(this, this._boundUpdateVisibleHeight);
    this._resizeVisibleHeight =
      typeof responsive !== 'undefined' && responsive.addResizeListener
        ? responsive.addResizeListener(this, this._boundUpdateVisibleHeight)
        : null;
    if (!this._resizeVisibleHeight) {
      window.addEventListener('resize', this._boundUpdateVisibleHeight);
    }

    this.onDocClick = (e) => {
      const toggle = e.target.closest('[data-action="toggle-drawer"]');
      if (toggle) return;
      const logoClick = e.target.closest('.header-logo-wrapper');
      if (logoClick) return;
      const selectorClick = e.target.closest('.language-selector__item, .country-selector__item');
      if (selectorClick) return;

      const drawerEl = document.querySelector('.Drawer--wrapper');
      const overlayEl = document.querySelector('.sectionOverlay');
      const drawerOpen = drawerEl?.getAttribute('aria-expanded') === 'true';
      if (!drawerOpen) return;

      const clickedInsideDrawer = drawerEl.contains(e.target);
      const clickedOverlay = overlayEl?.contains(e.target);
      if ((clickedOverlay || !clickedInsideDrawer) && !e.target.closest('.header--wrapper')) {
        e.preventDefault();
        this.forceCloseMenu();
        this.hideOverlay();
      }
    };

    document.addEventListener('click', this.onDocClick);

    this.onKeyDown = (e) => {
      if (e.key === 'Escape') this.forceCloseMenu();
    };
    document.addEventListener('keydown', this.onKeyDown);

    this.delegateBody.on(
      'click',
      "[data-action='toggle-popup'][aria-controls='modal-country']",
      () => {
        this.handleDrawerOpening();
      },
      true,
    );

    this.delegateBody.on(
      'click',
      '#modal-country .country-selector__close-btn',
      () => {
        this.handleDrawerClosing();
      },
      true,
    );

    this.delegateBody.on(
      "click",
      ".pageOverlay, .sectionOverlay",
      () => {
        const hadTransparent = this.wasTransparentBeforeDrawer;
        this.handleDrawerClosing();
        setTimeout(() => {
          if (
            !this.isOverlayOpen() &&
            hadTransparent &&
            this.options.transparent &&
            (window.pageYOffset <= 25 || !this.options.sticky)
          ) {
            this.element.classList.add("Header--Transparent");
            this.wasTransparentBeforeDrawer = false;
          }
        }, 550);
      },
      true,
    );

    this._overlayObserver = new MutationObserver((mutations) => {
      for (const m of mutations) {
        if (m.attributeName !== "aria-hidden") continue;
        const el = m.target;
        const isOverlay =
          el.id === "quickSearch" ||
          el.classList?.contains("Popup") ||
          el.classList?.contains("Drawer--wrapper");
        if (!isOverlay) continue;
        const open = el.getAttribute("aria-hidden") === "false";
        if (open) {
          this.element.classList.remove("Header--Transparent");
          const shouldRestore =
            this.options.transparent &&
            (window.pageYOffset <= 25 || !this.options.sticky);
          if (shouldRestore) this.wasTransparentBeforeDrawer = true;
          setTimeout(() => this.applyOverlayTransparencyState(), 0);
        } else {
          if (
            !this.isOverlayOpen() &&
            this.wasTransparentBeforeDrawer &&
            this.options.transparent &&
            (window.pageYOffset <= 25 || !this.options.sticky)
          ) {
            this.element.classList.add("Header--Transparent");
            this.wasTransparentBeforeDrawer = false;
          }
        }
      }
    });
    this._overlayObserver.observe(document.body, {
      attributes: true,
      subtree: true,
      attributeFilter: ["aria-hidden"]
    });

    this.delegateBody.on(
      'cart:updated',
      (e) => {
        const count = e.detail?.item_count ?? 0;
        document.querySelectorAll('[data-cart-button]').forEach((btn) => {
          btn.classList.toggle('is-filled', count > 0);
        });
      },
      true,
    );
  }

  updateVisibleHeight() {
    setTimeout(() => {
      const rect = this.element.getBoundingClientRect();
      const windowHeight = window.innerHeight;

      let visibleHeight = Math.min(rect.bottom, windowHeight) - Math.max(rect.top, 0);

      visibleHeight = Math.max(visibleHeight, 0);
      document.documentElement.style.setProperty('--header-dynamic-height', `${visibleHeight}px`);

      document.documentElement.style.setProperty(
        '--header-height-fixed',
        document.querySelector('#header').offsetHeight + 'px',
      );
    }, 550);
  }

  updateMenuPosition() {
    document.documentElement.style.setProperty(
      '--submenu-position',
      `${document.querySelector('#header').offsetHeight}px`,
    );
  }

  showOverlay() {
    const overlay = document.querySelector('.sectionOverlay');
    if (overlay) {
      overlay.classList.remove('is-closing');
      overlay.classList.add('is-visible');
    }
  }

  hideOverlay() {
    const overlay = document.querySelector('.sectionOverlay');
    const drawerEl = document.querySelector('.Drawer--wrapper');
    const drawerOpen = drawerEl?.getAttribute('aria-expanded') === 'true';
    if (drawerOpen) return;
    if (!overlay || !overlay.classList.contains('is-visible')) return;
    if (overlay.classList.contains('is-closing')) {
      overlay.classList.remove('is-visible', 'is-closing');
      return;
    }
    overlay.classList.add('is-closing');
    clearTimeout(this._overlayCloseTimer);
    this._overlayCloseTimer = setTimeout(() => {
      this._overlayCloseTimer = null;
      overlay.classList.remove('is-visible', 'is-closing');
    }, 300);
  }

  async openMenu(event, target) {
    if (this._isClosing || target.getAttribute('aria-expanded') === 'true') {
      return;
    }

    if (window.Drawer && Drawer.active) Drawer.active.closeDrawer();
    if (window.globalPopup) window.globalPopup.closeAllPopups?.();

    clearTimeout(this._menuCloseTimer);
    this._menuCloseTimer = null;

    this.element.dispatchEvent(new CustomEvent('menu:open', { bubbles: true }));
    this.updateMenuPosition(target);

    if (this.element.classList.contains('Header--Transparent')) {
      this.element.classList.remove('Header--Transparent');
      this.headerTransparent = true;
    }

    const siblings = Array.from(target.parentElement.children).filter(
      (child) => child !== target && child.getAttribute('aria-expanded') === 'true',
    );

    this._isClosing = true;
    await Promise.all(siblings.map((s) => this.closeSiblingMenu(s, true)));
    this._isClosing = false;

    if (this._menuCloseTimer) return;

    const wrapper = target.querySelector('.desktop-menu__dropdown-wrapper');
    if (!wrapper) return;
    wrapper.style.display = '';
    wrapper.classList.remove('desktop-menu__dropdown--slide-in', 'fade-in', 'desktop-menu__dropdown--slide-out', 'fade-out');
    target.setAttribute('aria-hidden', 'false');
    target.setAttribute('aria-expanded', 'true');
    this.showOverlay();

    if (siblings.length === 0) {
      wrapper.classList.add('desktop-menu__dropdown--slide-in');
    }

    bodyScrollLock.disableBodyScroll(this.scrollableElement, bodyScrollLockOptions);
  }

  closeMenu(event, target) {
    if (event && event.type === 'mouseleave') {
      const to = event.relatedTarget;
      if (to && target.contains(to)) return;
      if (to && to.closest('.desktop-menu__dropdown-wrapper, [aria-submenu]')) return;
      const menuTrigger = to?.closest?.('[aria-hasMenu="true"]');
      if (to && menuTrigger && menuTrigger.querySelector('.desktop-menu__dropdown-wrapper')) return;
    }

    if (this._menuCloseTimer) {
      clearTimeout(this._menuCloseTimer);
    }

    this._menuCloseTimer = setTimeout(async () => {
      this._menuCloseTimer = null;

      const openElement =
        this.element.querySelector('.desktop-menu-list [aria-expanded="true"]') ||
        this.element.querySelector('.header-menu-items [aria-expanded="true"]') ||
        this.element.querySelector('[aria-hasMenu="true"][aria-expanded="true"]') ||
        this.element.querySelector('[aria-hasmenu="true"][aria-expanded="true"]');

      if (openElement) {
        await this.closeSiblingMenu(openElement, false);
      }

      const stillOpen =
        this.element.querySelector('.desktop-menu-list [aria-expanded="true"]') ||
        this.element.querySelector('[aria-hasMenu="true"][aria-expanded="true"]') ||
        this.element.querySelector('[aria-hasmenu="true"][aria-expanded="true"]') ||
        document.querySelector('.search[aria-expanded="true"]') ||
        document.querySelector('.Drawer--wrapper[aria-expanded="true"]');
      if (!stillOpen && !this.isOverlayOpen()) this.hideOverlay();

      this.toggleColor();
      if (openElement) {
        bodyScrollLock.enableBodyScroll(this.scrollableElement);
      }
    }, 250);
  }

  closeSiblingMenu(element, isSwitch = false) {
    return new Promise((resolve) => {
      if (!element) return resolve();

      const wrapper = element.querySelector('.desktop-menu__dropdown-wrapper');
      if (!wrapper) return resolve();

      wrapper.classList.remove('desktop-menu__dropdown--slide-out', 'fade-out', 'desktop-menu__dropdown--slide-in', 'fade-in');

      if (isSwitch) {
        element.setAttribute('aria-expanded', 'false');
        element.setAttribute('aria-hidden', 'true');
        resolve();
        return;
      }

      wrapper.classList.add('desktop-menu__dropdown--slide-out');
      const overlay = document.querySelector('.sectionOverlay');
      if (overlay?.classList.contains('is-visible')) overlay.classList.add('is-closing');

      const finishClose = () => {
        element.setAttribute('aria-expanded', 'false');
        element.setAttribute('aria-hidden', 'true');
        wrapper.classList.remove('desktop-menu__dropdown--slide-out');
        resolve();
      };

      const handleAnimationEnd = (e) => {
        if (e.target === wrapper && e.animationName === 'slideOut') {
          wrapper.removeEventListener('animationend', handleAnimationEnd);
          finishClose();
        }
      };

      wrapper.addEventListener('animationend', handleAnimationEnd);

      setTimeout(() => {
        wrapper.removeEventListener('animationend', handleAnimationEnd);
        finishClose();
      }, 300);
    });
  }

  forceCloseMenu() {
    if (!this.element) return;

    const openSelectors = '.desktop-menu-list [aria-expanded="true"], [aria-hasMenu="true"][aria-expanded="true"], [aria-hasmenu="true"][aria-expanded="true"]';
    this.element.querySelectorAll(openSelectors).forEach((el) => {
      el.setAttribute('aria-expanded', 'false');
      el.setAttribute('aria-hidden', 'true');
    });

    if (this.scrollableElement) {
      try {
        bodyScrollLock.enableBodyScroll(this.scrollableElement);
      } catch (e) {}
    }

    this.toggleColor();
  }

  isOverlayOpen() {
    const qs = document.querySelector("#quickSearch");
    if (qs && qs.getAttribute("aria-hidden") === "false") return true;
    const drawerOpen = (el) => el?.getAttribute?.("aria-hidden") === "false" || el?.getAttribute?.("aria-expanded") === "true";
    if ([...document.querySelectorAll(".Drawer--wrapper")].some(drawerOpen)) return true;
    const popupOpen = (el) => el?.getAttribute?.("aria-hidden") === "false";
    if ([...document.querySelectorAll(".Popup")].some(popupOpen)) return true;
    return false;
  }

  applyOverlayTransparencyState() {
    if (!this.isOverlayOpen()) return;
    this.element.classList.remove("Header--Transparent");
    const shouldRestore =
      this.options.transparent &&
      (window.pageYOffset <= 25 || !this.options.sticky);
    if (shouldRestore) this.wasTransparentBeforeDrawer = true;
  }

  toggleColor() {
    if (this.options.sticky) {
      if (window.pageYOffset > 25) {
        this.element.classList.add('header--scrolled');
      } else {
        this.element.classList.remove('header--scrolled');
      }
    } else {
      this.element.classList.remove('header--scrolled');
    }

    if (this.isOverlayOpen()) {
      this.element.classList.remove("Header--Transparent");
      return;
    }

    if (this.drawerBlocksTransparency) {
      return;
    }

    if (this.options.transparent) {
      if (window.pageYOffset > 25 && this.options.sticky) {
        this.element.classList.remove('Header--Transparent');
      } else {
        this.element.classList.add('Header--Transparent');
      }
    }
  }

  onDrawerOpened(event) {
    this.handleDrawerOpening();
  }

  onDrawerClosed(event) {
    this.handleDrawerClosing();
  }

  handleDrawerOpening() {
    const shouldBeTransparent = this.options.transparent && (window.pageYOffset <= 25 || !this.options.sticky);

    if (shouldBeTransparent) {
      if (!this.element.classList.contains('Header--Transparent')) {
        this.wasTransparentBeforeDrawer = true;
      } else {
        this.wasTransparentBeforeDrawer = true;
        this.element.classList.remove('Header--Transparent');
      }
    } else {
      this.wasTransparentBeforeDrawer = false;
    }

    this.drawerBlocksTransparency = true;
    setTimeout(() => this.applyOverlayTransparencyState(), 0);
  }

  handleDrawerClosing() {
    this.drawerBlocksTransparency = false;

    if (this.isOverlayOpen()) {
      return;
    }

    if (this.wasTransparentBeforeDrawer && this.options.transparent) {
      if (window.pageYOffset <= 25 || !this.options.sticky) {
        this.element.classList.add('Header--Transparent');
      }
    }

    this.wasTransparentBeforeDrawer = false;
  }

  handleHamburgerMenu(event) {
    const hamburgerButton = document.querySelector('[data-action="toggle-drawer"]');
    if (hamburgerButton) {
      if (event.type === 'mobile-menu:open') {
        hamburgerButton.classList.add('is-active');
        this.handleDrawerOpening();
      } else if (event.type === 'mobile-menu:close') {
        hamburgerButton.classList.remove('is-active');
        this.handleDrawerClosing();
      }
    } else {
      if (event.type === 'mobile-menu:open') {
        this.handleDrawerOpening();
      } else if (event.type === 'mobile-menu:close') {
        this.handleDrawerClosing();
      }
    }
  }

  setMegaMenuLayoutVars({
    upperSelector = '.desktop-menu__upper',
    holderSelector = '.desktop-menu__link-holder',
    collectionSelector = '.desktop-menu__collection',
    promoSelector = '.promo-block',
    menuVar = '--menu-cols',
    collectionVar = '--collection-cols',
    maxMenuCols = 6,
    maxCollectionsWithMenu = 2,
    minCollectionsNoMenu = 4,
    maxCollectionsNoMenu = 6,
    fixedMenuWidthPx = 796,
  } = {}) {
    if (!window.matchMedia('(min-width:1025px)').matches) return;

    const uppers = this.element.querySelectorAll(upperSelector);

    uppers.forEach((upper) => {
      const holder = upper.querySelector(holderSelector);
      const collection = upper.querySelector(collectionSelector);

      let menuCols = 0;

      if (holder) {
        const menuColumns = Array.from(holder.children).filter((el) => {
          if (!(el instanceof HTMLElement)) return false;

          if (
            el.classList.contains('desktop-menu__featured-container') ||
            el.classList.contains('desktop-menu__multiple-items') ||
            el.classList.contains('desktop-menu__image-wrapper')
          ) {
            return true;
          }

          if (el.classList.contains('desktop-menu__custom-button')) return false;
          if (el.classList.contains('desktop-menu__thumb-container')) return false;

          return false;
        });

        menuCols = Math.min(menuColumns.length, maxMenuCols);

        if (!collection) {
          holder.style.setProperty(menuVar, menuCols || 0);
          holder.style.flex = '1 1 auto';
          holder.style.maxWidth = '100%';
          holder.style.width = '100%';
        } else {
          holder.style.setProperty(menuVar, menuCols || 0);

          if (menuCols > 0) {
            holder.style.flex = `0 0 ${fixedMenuWidthPx}px`;
            holder.style.maxWidth = `${fixedMenuWidthPx}px`;
            holder.style.width = `${fixedMenuWidthPx}px`;
          } else {
            holder.style.flex = '';
            holder.style.maxWidth = '';
            holder.style.width = '';
          }
        }
      }

      if (!collection) return;

      const promos = Array.from(collection.querySelectorAll(promoSelector));
      promos.forEach((p) => (p.style.display = ''));

      if (menuCols > 0) {
        const visible = promos.slice(0, maxCollectionsWithMenu);
        const hidden = promos.slice(maxCollectionsWithMenu);

        hidden.forEach((p) => (p.style.display = 'none'));

        upper.style.setProperty(collectionVar, visible.length);
      } else {
        const visibleCount = Math.min(promos.length, maxCollectionsNoMenu);

        promos.slice(visibleCount).forEach((p) => (p.style.display = 'none'));

        const cols =
          visibleCount <= minCollectionsNoMenu ? minCollectionsNoMenu : Math.min(visibleCount, maxCollectionsNoMenu);

        upper.style.setProperty(collectionVar, cols);
      }
    });
  }

  initMegaMenuLayoutVars(options) {
    const run = () => this.setMegaMenuLayoutVars(options);
    this._megaMenuLayoutRun = run;
    run();
    window.addEventListener('resize', run);
    document.addEventListener('shopify:section:load', run);
  }

  disconnectedCallback() {
    clearTimeout(this._overlayCloseTimer);
    this._overlayCloseTimer = null;
    this._overlayObserver?.disconnect();
    this._overlayObserver = null;

    this._scrollToggleColor?.removeScrollListener?.();
    this._scrollUpdateVisibleHeight?.removeScrollListener?.();

    if (this._resizeVisibleHeight?.removeResizeListener) {
      this._resizeVisibleHeight.removeResizeListener();
    } else if (this._boundUpdateVisibleHeight) {
      window.removeEventListener('resize', this._boundUpdateVisibleHeight);
    }

    this._boundUpdateVisibleHeight = null;
    this._scrollToggleColor = null;
    this._scrollUpdateVisibleHeight = null;
    this._resizeVisibleHeight = null;

    if (this._megaMenuLayoutRun) {
      window.removeEventListener("resize", this._megaMenuLayoutRun);
      document.removeEventListener("shopify:section:load", this._megaMenuLayoutRun);
      this._megaMenuLayoutRun = null;
    }
    document.removeEventListener("click", this.onDocClick);
    document.removeEventListener("keydown", this.onKeyDown);
    this.delegateElement?.off?.();
    this.delegateBody?.off?.();
  }
}

customElements.define('header-component', Header);

class MainMenuDropdown extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);
    this.bindEvents();
  }

  connectedCallback() {
    this.drawerPanel = this.element.querySelector(".Drawer--wrapper");
    this.menuDrawerEl = this.element.querySelector(".menu__drawer");
    this.drawer = new Drawer(this.drawerPanel);
    this.footerEl = this.element.querySelector(".mobile-menu__footer");

    this.setFooterHeight();
    this._resizeObserver = new ResizeObserver(() => this.setFooterHeight());
    if (this.footerEl) this._resizeObserver.observe(this.footerEl);
    this._resizeObserver.observe(this.element);
  }

  disconnectedCallback() {
    this._resizeObserver?.disconnect();
  }

  setFooterHeight() {
    const height = this.footerEl ? this.footerEl.offsetHeight : 0;
    this.element.style.setProperty("--mobile-menu-footer-height", `${height}px`);
  }

  bindEvents() {
    this.delegateElement.on("click", (e) => {
      if (!this.drawer?.isOpen || !this.drawerPanel) return;
      if (!this.menuDrawerEl?.contains(e.target)) return;
      if (e.target.closest(".mobile-menu__wrapper") || e.target.closest(".mobile-menu__footer")) return;
      this.drawer.closeDrawer(e);
    });
  }
}

customElements.define("main-menu-dropdown", MainMenuDropdown);

/**
 * Account dialog (mobile drawer). Uses ref="dialog", ref="closeButton", ref="trigger" on child elements.
 */
class AccountDialogComponent extends HTMLElement {
  constructor() {
    super();
    this._refs = {};
    this._previousScrollY = 0;
    this._handleResize = debounce(() => {
      const minW = Number(this.getAttribute('dialog-active-min-width'));
      const maxW = Number(this.getAttribute('dialog-active-max-width'));
      if (minW && window.innerWidth < minW) this.closeDialog();
      if (maxW && window.innerWidth > maxW) this.closeDialog();
    }, 50);
  }

  _updateRefs() {
    this._refs.dialog = this.querySelector('[ref="dialog"]');
    this._refs.closeButton = this.querySelector('[ref="closeButton"]');
    this._refs.trigger = this.querySelector('[ref="trigger"]');
    this._refs.drawerContent = this.querySelector('[ref="drawerContent"]') || this.querySelector('.account-drawer__inner');
  }

  _isClickedOutside(event, element) {
    if (!(event.target instanceof Element)) return true;
    return !element.contains(event.target);
  }

  connectedCallback() {
    this._updateRefs();
    const { dialog, closeButton, trigger } = this._refs;
    if (!dialog) return;

    if (closeButton) closeButton.addEventListener('click', this.closeDialog.bind(this));
    if (trigger) trigger.addEventListener('click', (e) => { e.preventDefault(); this.showDialog(); });

    dialog.addEventListener('cancel', this._handleCancel);
    this.addEventListener('click', this._handleClick);
    this.addEventListener('keydown', this._handleKeyDown);
    if (this.getAttribute('dialog-active-min-width') || this.getAttribute('dialog-active-max-width')) {
      window.addEventListener('resize', this._handleResize);
    }
  }

  _handleCancel = (event) => {
    event.preventDefault();
    this.closeDialog();
  };

  disconnectedCallback() {
    var dialog = this._refs.dialog;
    if (dialog) dialog.removeEventListener('cancel', this._handleCancel);
    window.removeEventListener('resize', this._handleResize);
    this.removeEventListener('click', this._handleClick);
    this.removeEventListener('keydown', this._handleKeyDown);
  }

  _handleClick = (event) => {
    const dialog = this._refs.dialog;
    if (!dialog) return;
    var isBackdropClick = event.target === dialog;
    var isOutsideClick = this._isClickedOutside(event, dialog);
    if (isBackdropClick || isOutsideClick) this.closeDialog();
  };

  _handleKeyDown = (event) => {
    if (event.key === 'Escape') {
      event.preventDefault();
      this.closeDialog();
    }
  };

  showDialog() {
    const dialog = this._refs.dialog;
    if (!dialog || dialog.open) return;

    this._previousScrollY = window.scrollY;
    document.body.style.width = '100%';
    document.body.style.position = 'fixed';
    document.body.style.top = '-' + this._previousScrollY + 'px';
    document.body.style.overflow = 'hidden';
    document.body.classList.add('scrollLock');
    if (typeof bodyScrollLock !== 'undefined') {
      try { bodyScrollLock.disableBodyScroll(dialog, bodyScrollLockOptions); } catch (e) {}
    }
    requestAnimationFrame(function () {
      dialog.showModal();
    });
    this.dispatchEvent(new CustomEvent('dialog:open', { bubbles: true }));
  }

  _finishClose() {
    const dialog = this._refs.dialog;
    const content = this._refs.drawerContent;
    if (content) {
      content.classList.remove('account-drawer__inner--closing');
      content.getAnimations().forEach(function (a) { a.cancel(); });
      content.style.transform = '';
    }
    if (typeof bodyScrollLock !== 'undefined' && dialog) {
      try { bodyScrollLock.enableBodyScroll(dialog); } catch (e) {}
    }
    document.body.classList.remove('scrollLock');
    document.body.style.width = '';
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.overflow = '';
    window.scrollTo({ top: this._previousScrollY, behavior: 'instant' });
    if (dialog) {
      dialog.getAnimations().forEach(function (a) { a.cancel(); });
      dialog.close();
      dialog.classList.remove('dialog-closing');
      dialog.style.willChange = '';
      dialog.style.clipPath = '';
      dialog.style.transform = '';
    }
    this.dispatchEvent(new CustomEvent('dialog:close', { bubbles: true }));
  }

  closeDialog = () => {
    const dialog = this._refs.dialog;
    if (!dialog || !dialog.open) return;
    if (dialog.classList.contains('dialog-closing')) return;

    dialog.classList.add('dialog-closing');

    var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (prefersReducedMotion) {
      this._finishClose();
      return;
    }

    var self = this;
    var duration = 350;
    var closeEasing = 'cubic-bezier(0.4, 0, 1, 1)';

    dialog.getAnimations().forEach(function (a) { a.cancel(); });
    dialog.style.willChange = 'transform';
    var animation = dialog.animate(
      [{ transform: 'translateY(0)' }, { transform: 'translateY(100%)' }],
      { duration: duration, easing: closeEasing, fill: 'forwards' }
    );
    animation.finished.then(function () {
      if (self._closeFallback) clearTimeout(self._closeFallback);
      self._finishClose();
    }).catch(function () {
      self._finishClose();
    });
    self._closeFallback = setTimeout(function () {
      self._closeFallback = null;
      animation.finish();
    }, duration + 50);
  };

  toggleDialog() {
    if (this._refs.dialog && this._refs.dialog.open) this.closeDialog();
    else this.showDialog();
  }
}

if (!customElements.get('dialog-component')) {
  customElements.define('dialog-component', AccountDialogComponent);
}

/**
 * Account anchored popover (desktop). Uses ref="popover", ref="trigger" on child elements.
 */
class AccountAnchoredPopoverComponent extends HTMLElement {
  constructor() {
    super();
    this._refs = {};
    this._resizeListener = debounce(() => {
      var popover = this._refs.popover;
      if (popover && popover.matches && popover.matches(':popover-open')) {
        popover.hidePopover();
      }
    }, 100);
    this._requestIdleCallback = typeof window.requestIdleCallback === 'function'
      ? window.requestIdleCallback.bind(window)
      : function (cb) { setTimeout(cb, 1); };
  }

  _updateRefs() {
    this._refs.popover = this.querySelector('[ref="popover"]');
    this._refs.trigger = this.querySelector('[ref="trigger"]');
    this._refs.closeButton = this.querySelector('[ref="closeButton"]');
  }

  _updatePosition() {
    var popover = this._refs.popover;
    var trigger = this._refs.trigger;
    if (!popover || !trigger) return;
    var rect = trigger.getBoundingClientRect();
    popover.style.setProperty('--anchor-top', rect.top);
    popover.style.setProperty('--anchor-right', window.innerWidth - rect.right);
    popover.style.setProperty('--anchor-bottom', window.innerHeight - rect.bottom);
    popover.style.setProperty('--anchor-left', rect.left);
    popover.style.setProperty('--anchor-height', rect.height);
    popover.style.setProperty('--anchor-width', rect.width);
  }

  _handleDocumentClick = (event) => {
    var popover = this._refs.popover;
    var trigger = this._refs.trigger;
    if (!popover || !trigger || !popover.matches(':popover-open')) return;
    var target = event.target instanceof Node ? event.target : null;
    if (!target || popover.contains(target) || trigger.contains(target)) return;
    this._closePopover();
  };

  _handleTriggerClick = (event) => {
    event.preventDefault();
    var popover = this._refs.popover;
    if (!popover) return;
    if (popover.matches(':popover-open')) {
      this._closePopover();
    } else {
      popover.showPopover();
    }
  };

  _closePopover() {
    var popover = this._refs.popover;
    if (!popover || !popover.matches(':popover-open') || this._popoverClosing) return;
    this._popoverClosing = true;
    var self = this;
    var duration = 250;
    var onDone = function () {
      self._popoverClosing = false;
      if (self._closePopoverFallback) {
        clearTimeout(self._closePopoverFallback);
        self._closePopoverFallback = null;
      }
      popover.getAnimations().forEach(function (a) { a.cancel(); });
      popover.style.transform = '';
      popover.style.opacity = '';
      popover.style.clipPath = '';
      popover.hidePopover();
    };
    popover.getAnimations().forEach(function (a) { a.cancel(); });
    var animation = popover.animate([
      { clipPath: 'inset(0)', opacity: 1, transform: 'translateY(0)' },
      { clipPath: 'inset(0 0 100% 0)', opacity: 0, transform: 'translateY(-8px)' }
    ], { duration: duration, easing: 'ease-in', fill: 'forwards' });
    animation.finished.then(onDone).catch(onDone);
    self._closePopoverFallback = setTimeout(function () {
      self._closePopoverFallback = null;
      animation.finish();
    }, duration + 50);
  }

  connectedCallback() {
    this._updateRefs();
    var popover = this._refs.popover;
    var trigger = this._refs.trigger;
    if (!popover || !trigger) return;

    trigger.addEventListener('click', this._handleTriggerClick);
    var closeBtn = this._refs.closeButton;
    if (closeBtn) closeBtn.addEventListener('click', function (e) { e.preventDefault(); self._closePopover(); });

    var self = this;
    popover.addEventListener('beforetoggle', function (evt) {
      if (evt.newState === 'open') {
        self._popoverClosing = false;
        popover.classList.remove('account-popover__panel--closing');
        popover.getAnimations().forEach(function (a) { a.cancel(); });
        self._updatePosition();
        if (self.dataset.closeOnResize !== undefined) {
          window.addEventListener('resize', self._resizeListener);
        }
        window.addEventListener('scroll', self._scrollListener, true);
        self._documentClickTimer = setTimeout(function () {
          self._documentClickTimer = null;
          document.addEventListener('click', self._handleDocumentClick, true);
        }, 150);
        var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (reducedMotion) {
          popover.style.opacity = '';
          popover.style.transform = '';
          popover.style.clipPath = '';
        } else {
          popover.style.opacity = '0';
          popover.style.transform = 'translateY(-8px)';
          popover.style.clipPath = 'inset(0 0 100% 0)';
          requestAnimationFrame(function () {
            requestAnimationFrame(function () {
              var openAnim = popover.animate([
                { opacity: 0, transform: 'translateY(-8px)', clipPath: 'inset(0 0 100% 0)' },
                { opacity: 1, transform: 'translateY(0)', clipPath: 'inset(0)' }
              ], { duration: 350, easing: 'ease-out', fill: 'forwards' });
              openAnim.finished.then(function () {
                popover.style.opacity = '';
                popover.style.transform = '';
                popover.style.clipPath = '';
              }).catch(function () {
                popover.style.opacity = '';
                popover.style.transform = '';
                popover.style.clipPath = '';
              });
            });
          });
        }
      } else {
        if (self._documentClickTimer) {
          clearTimeout(self._documentClickTimer);
          self._documentClickTimer = null;
        }
        if (self._closePopoverFallback) {
          clearTimeout(self._closePopoverFallback);
          self._closePopoverFallback = null;
        }
        self._popoverClosing = false;
        popover.classList.remove('account-popover__panel--closing');
        document.removeEventListener('click', self._handleDocumentClick, true);
        if (self.dataset.closeOnResize !== undefined) {
          window.removeEventListener('resize', self._resizeListener);
        }
        window.removeEventListener('scroll', self._scrollListener, true);
      }
    });

    if (!CSS.supports || !CSS.supports('position-anchor: --trigger')) {
      this._requestIdleCallback(this._updatePosition.bind(this));
    }
  }

  _scrollListener = () => {
    if (this._scrollRaf) return;
    this._scrollRaf = requestAnimationFrame(() => {
      this._scrollRaf = null;
      if (this._refs.popover && this._refs.popover.matches && this._refs.popover.matches(':popover-open')) {
        this._updatePosition();
      }
    });
  };

  disconnectedCallback() {
    if (this._documentClickTimer) clearTimeout(this._documentClickTimer);
    if (this._closePopoverFallback) clearTimeout(this._closePopoverFallback);
    document.removeEventListener('click', this._handleDocumentClick, true);
    window.removeEventListener('resize', this._resizeListener);
    window.removeEventListener('scroll', this._scrollListener, true);
    var trigger = this._refs.trigger;
    if (trigger) trigger.removeEventListener('click', this._handleTriggerClick);
  }
}

if (!customElements.get('anchored-popover-component')) {
  customElements.define('anchored-popover-component', AccountAnchoredPopoverComponent);
}

/**
 * Account login actions wrapper for shop-login-button.
 */
class AccountLoginActionsElement extends HTMLElement {
  connectedCallback() {
    var shopLoginButton = this.querySelector('shop-login-button');
    if (shopLoginButton) {
      shopLoginButton.setAttribute('full-width', 'true');
      shopLoginButton.setAttribute('persist-after-sign-in', 'true');
      shopLoginButton.setAttribute('analytics-context', 'loginWithShopSelfServe');
      shopLoginButton.setAttribute('flow-version', 'account-actions-popover');
      shopLoginButton.setAttribute('return-uri', window.location.href);
      shopLoginButton.addEventListener('completed', function () {
        window.location.reload();
      });
    }
  }
}

if (!customElements.get('account-login-actions')) {
  customElements.define('account-login-actions', AccountLoginActionsElement);
}

class Transition {
  constructor() {
    // Skip old overlay-based transition if View Transitions API is supported
    this.hasViewTransitions = CSS.supports("view-transition-name", "root");
    this.pageOverlay = document.querySelector('.pageTransition');

    if (!this.isPageLoaded) {
      document.addEventListener('DOMContentLoaded', this.onPageLoaded.bind(this));
    } else {
      this.onPageLoaded();
    }
  }

  onPageLoaded() {
    this.isPageLoaded = true;
    if (this.hasViewTransitions) return;
    if (this.pageOverlay && window.theme.showPageTransition) {
      this.pageOverlay.animate([{ opacity: 1 }, { opacity: 0 }], {
        duration: 100,
        fill: 'forwards',
        easing: 'ease-in-out',
        iterations: 1,
      });
    }
  }

  onPageUnload(event, target) {
    if (this.hasViewTransitions) return;
    if (
      event.defaultPrevented ||
      event.ctrlKey ||
      event.metaKey ||
      !window.theme.showPageTransition ||
      !this.pageOverlay
    ) {
      return;
    }

    event.preventDefault();

    if (this.pageOverlay) {
      this.pageOverlay.animate(
        [{ opacity: 0, visibility: 'visible' }, { opacity: 1, visibility: 'visible' }],
        { duration: 250, fill: 'forwards', easing: 'linear' }
      ).onfinish = () => {
        window.location.href = target.href;
      };
    }
  }
}
new Transition();

class VideoComponent extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.options = JSON.parse(this.element.getAttribute('data-section-settings'));
    this.isTextDisabled = this.element.getAttribute('data-text-disable');
    this.sectionId = this.element.getAttribute('data-section-id');
    this.trueObserver = false;
    this.delegateElement = new Delegate(this.element);
    this.videoPlayer = null; // Initialize videoPlayer property
    this.isInitialized = false; // Track if video has been initialized
    this.isSafari = VideoComponent.isSafariBrowser();

    const isDesktop = !responsive.matchesBreakpoint('phone') || !responsive.matchesBreakpoint('pocket');
    const position = this.element.dataset.position;

    if (this.options['using_fade'] == 'fade') {
      // On desktop with custom scroll, use IntersectionObserver for all videos
      if (isDesktop) {
        this.setupScrollBasedLoading();
      } else {
        this.bindEvents();

        // Only load video if it's the first slide or currently active
        if (
          position == 0 ||
          this.element.closest('.swiper-slide')?.classList.contains('swiper-slide-active') ||
          this.element.closest('.swiper-slide')?.classList.contains('swiper-slide-duplicate-active')
        ) {
          this.checkLoaded();
        }
      }
    } else {
      this.checkLoaded();
    }
  }

  static isSafariBrowser() {
    const ua = navigator.userAgent || '';
    const isSafari = /safari/i.test(ua);
    const isOtherWebKit =
      /chrome|crios|chromium|edg|edgios|opr|opera|fxios|firefox|android/i.test(ua);
    return isSafari && !isOtherWebKit;
  }

  _shouldPrimeFirstFrame() {
    return Boolean(
      this.isSafari &&
        this.options &&
        this.options['controls'] &&
        !this.options['play_in_view'] &&
        !this.options['play_in_view_mob_hover_desk'],
    );
  }

  primeFirstFrame() {
    if (!this.videoPlayer || !this._shouldPrimeFirstFrame()) return;

    const tech = typeof this.videoPlayer.tech === 'function' ? this.videoPlayer.tech(true) : null;
    const videoEl =
      (tech && typeof tech.el === 'function' && tech.el()) || this.videoPlayer.el()?.querySelector('video');
    if (!videoEl || videoEl.nodeName !== 'VIDEO') return;

    // Safari often won't paint the first frame when paused unless we force a small seek after metadata/data is available.
    // Keep it tiny to avoid visibly jumping the first frame.
    const SEEK_TIME = 0.001;

    try {
      videoEl.preload = 'auto';
    } catch (e) {
      // ignore
    }

    const seekAndPause = () => {
      try {
        if (Number.isFinite(videoEl.duration) && videoEl.duration > 0) {
          videoEl.currentTime = Math.min(SEEK_TIME, Math.max(0, videoEl.duration - 0.01));
        } else {
          videoEl.currentTime = SEEK_TIME;
        }
      } catch (e) {
        // ignore
      }
      try {
        videoEl.pause();
      } catch (e) {
        // ignore
      }
    };

    // Run after metadata/data are ready and again on next frame to encourage a paint.
    videoEl.addEventListener('loadedmetadata', seekAndPause, { once: true });
    videoEl.addEventListener('loadeddata', seekAndPause, { once: true });

    try {
      videoEl.load();
    } catch (e) {
      // ignore
    }

    // Video.js events as a fallback (tech order differences).
    if (typeof this.videoPlayer.one === 'function') {
      this.videoPlayer.one('loadeddata', () => {
        try {
          this.videoPlayer.currentTime(SEEK_TIME);
          this.videoPlayer.pause();
        } catch (e) {
          // ignore
        }
      });
    }

    requestAnimationFrame(() => {
      requestAnimationFrame(seekAndPause);
    });
  }

  setupScrollBasedLoading() {
    // Use IntersectionObserver to load videos when they come into view
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && !this.isInitialized) {
            observer.unobserve(this.element); // Stop observing once loaded
            console.log('loaded');
            this.checkLoaded();
          }
        });
      },
      {
        threshold: 0.1, // Load when 10% visible
        rootMargin: '100px', // Start loading 100px before entering viewport
      },
    );

    observer.observe(this.element);
  }

  bindEvents() {
    window.removeEventListener('swiper:slide-changed', this.onSlideChangeListener);
    this.onSlideChangeListener = this.onSlideChange.bind(this);
    window.addEventListener('swiper:slide-changed', this.onSlideChangeListener);
  }

  bindHoverEvents() {
    if (this.options['play_in_view_mob_hover_desk']) {
      this.onMouseEnterListener = this.onMouseEnter.bind(this);
      this.onMouseLeaveListener = this.onMouseLeave.bind(this);

      this.element.addEventListener('mouseenter', this.onMouseEnterListener);
      this.element.addEventListener('mouseleave', this.onMouseLeaveListener);
    }
  }

  onMouseEnter() {
    const isMobile = responsive.matchesBreakpoint('pocket');

    // Only handle hover for play_in_view_mob_hover_desk setting
    if (!isMobile && this.videoPlayer && this.options['play_in_view_mob_hover_desk'] && !this.options['play_in_view']) {
      if (this.options['muted']) {
        this.videoPlayer.muted('true');
      }
      const playPromise = this.videoPlayer.play();
      if (playPromise !== undefined) {
        playPromise.catch(() => {
          // Silently catch autoplay prevention
        });
      }
    }
  }

  onMouseLeave() {
    const isMobile = responsive.matchesBreakpoint('pocket');

    // Only handle hover for play_in_view_mob_hover_desk setting
    if (!isMobile && this.videoPlayer && this.options['play_in_view_mob_hover_desk'] && !this.options['play_in_view']) {
      if (this.videoPlayer.el_.classList.contains('vjs-playing')) {
        this.videoPlayer.pause();
      }
    }
  }

  checkLoaded() {
    var _this = this;
    if (typeof videojs !== 'undefined') {
      this.videoPlayerInitialization();
      // Prevent autoplay if viewport is false
      if (this.videoPlayer && !this.options.viewport) {
        this.videoPlayer.pause();
      }
    } else {
      loadScript(window.theme.videoScript);
      setTimeout(function () {
        _this.checkLoaded();
      }, 100);
    }
  }

  onSlideChange(event) {
    this.elementPosition = parseInt(this.element.getAttribute('data-position'));
    const isMobile = responsive.matchesBreakpoint('pocket');

    if (event.detail.currentIndex == this.elementPosition) {
      // Active slide - initialize or reinitialize video
      if (this.element.getAttribute('loaded')) {
        // Already loaded - on desktop, always reinitialize for fresh controls
        if (!isMobile && this.videoPlayer) {
          this.reinitializeVideoPlayer();
        } else if (!this.videoPlayer) {
          this.checkLoaded();
        }
      } else {
        // First time loading
        var node = document.createElement('div');
        node.appendChild(this.element.querySelector('template').content.firstElementChild.cloneNode(true));
        this.element.appendChild(node.firstElementChild).focus();
        this.element.setAttribute('loaded', true);
        this.checkLoaded();
      }

      // Handle autoplay if enabled
      if (this.options['play_in_view'] || (this.options['play_in_view_mob_hover_desk'] && isMobile)) {
        setTimeout(() => {
          if (this.videoPlayer) {
            const playPromise = this.videoPlayer.play();
            if (playPromise !== undefined) {
              playPromise.catch(() => {
                // Silently catch autoplay prevention
              });
            }
            this.createObserver();
          }
        }, 200);
      }
    } else if (this.videoPlayer && this.videoPlayer.el_.classList.contains('vjs-playing')) {
      // Not active slide - pause if playing
      this.videoPlayer.pause();
    }
  }

  videoPlayerInitialization() {
    if (!this.element.getAttribute('loaded')) {
      const node = document.createElement('div');
      node.appendChild(this.element.querySelector('template').content.firstElementChild.cloneNode(true));
      this.element.appendChild(node.firstElementChild).focus();
      this.element.setAttribute('loaded', true);
    }

    const isMobile = responsive.matchesBreakpoint('pocket');

    let aspect_ratio = '';
    let src = '';
    let host = 'html5';

    if (isMobile) {
      aspect_ratio = this.options['aspect_mob'] || '9:16';

      if (this.options['videoType'] == 'video_inside_media') {
        const sources = this.options['videod']['sources'];
        let topQuality = null;
        sources.forEach((obj) => {
          if (obj.format === 'mp4') {
            if (!topQuality) topQuality = obj;
            if (topQuality.height < obj.height) topQuality = obj;
          }
        });
        const aspectRatioHeight = Math.floor(100 / this.options['videod']['aspect_ratio']);
        if (!this.options['video_ratio']) {
          aspect_ratio = `100:${aspectRatioHeight}`;
        }
        src = topQuality['url'] + '#t=0.001';
      } else if (this.options['videoType'] == 'video_inside_media_external') {
        const aspectRatioHeight = Math.floor(100 / this.options['videom']['aspect_ratio']);
        if (!this.options['video_ratio']) {
          aspect_ratio = `100:${aspectRatioHeight}`;
        }
        host = this.options['videom']['host'];
        if (host == 'youtube') {
          src = 'https://www.youtube.com/watch?v=' + this.options['videom']['external_id'];
        } else {
          src = this.options['videom']['external_id'];
        }
      } else {
        if (this.options['videom'].includes('youtube')) {
          host = 'youtube';
        } else if (this.options['videom'].includes('vimeo')) {
          host = 'vimeo';
        }
        src = this.options['videom'];
      }
    } else {
      aspect_ratio = this.options['aspect_desk'] || '16:9';

      if (this.options['videoType'] == 'video_inside_media') {
        const sources = this.options['videod']['sources'];
        let topQuality = null;
        sources.forEach((obj) => {
          if (obj.format === 'mp4') {
            if (!topQuality) topQuality = obj;
            if (topQuality.height < obj.height) topQuality = obj;
          }
        });
        src = topQuality['url'] + '#t=0.001';
        const aspectRatioHeight = Math.floor(100 / this.options['videod']['aspect_ratio']);

        if (!this.options['video_ratio']) {
          aspect_ratio = `100:${aspectRatioHeight}`;
        }
      } else if (this.options['videoType'] == 'video_inside_media_external') {
        host = this.options['videod']['host'];
        const aspectRatioHeight = Math.floor(100 / this.options['videod']['aspect_ratio']);
        if (!this.options['video_ratio']) {
          aspect_ratio = `100:${aspectRatioHeight}`;
        }
        if (host == 'youtube') {
          src = 'https://www.youtube.com/watch?v=' + this.options['videod']['external_id'];
        } else {
          src = this.options['videod']['external_id'];
        }
      } else {
        if (this.options['videod'].includes('youtube')) {
          host = 'youtube';
        } else if (this.options['videod'].includes('vimeo')) {
          host = 'vimeo';
        }
        src = this.options['videod'];
      }
    }
    if (!src) {
      src = 'https://www.youtube.com/watch?v=_9VUPq3SxOc';
      host = 'youtube';
    }
    const type = host === 'youtube' ? 'video/youtube' : host === 'vimeo' ? 'video/vimeo' : 'video/mp4';

    aspect_ratio = aspect_ratio.replace('/', ':');
    const shouldPrimeFirstFrame = this._shouldPrimeFirstFrame() && host === 'html5';
    const payload = {
      aspectRatio: aspect_ratio,
      autoplay: false,
      muted: this.options['muted'],
      loop: this.options['loop'],
      controls: this.options['controls'],
      poster: false,
      preload: shouldPrimeFirstFrame ? 'auto' : 'metadata',
      playsinline: true,
      responsive: true,
      techOrder: [host],
      disablePictureInPicture: true,
      bigPlayButton: true,
      controlBar: this.options['controls']
        ? {
            children: [
              'playToggle',
              'progressControl',
              'currentTimeDisplay',
              'timeDivider',
              'durationDisplay',
              'CustomControlSpacer',
              'volumePanel',
              'fullscreenToggle',
            ],
          }
        : false,
      sources: [
        {
          type: type,
          src: src,
        },
      ],
    };

    const videoplayerID = this.element.querySelector('video');
    this.videoPlayer = videojs(videoplayerID, payload);

    const _this = this;
    this.videoPlayer.on('ready', function () {
      _this.element.querySelector('.videoHolder').style.display = 'block';

      // Bind hover events for desktop behavior
      _this.bindHoverEvents();

      // When controls are enabled but we are *not* autoplaying, Safari may show a black frame until playback starts.
      // Prime the first frame so the paused state shows actual video.
      _this.primeFirstFrame();

      // Force controls to be interactive on desktop
      const isMobile = responsive.matchesBreakpoint('pocket');
      if (!isMobile) {
        setTimeout(() => {
          _this.ensureDesktopControls();
        }, 100);
      }

      if (
        _this.trueObserver == false &&
        (_this.options['play_in_view_mob_hover_desk'] || _this.options['play_in_view'])
      ) {
        _this.createObserver();
      }
    });

    if (this.options['muted'] && host == 'vimeo') {
      this.videoPlayer.on('play', function () {
        _this.videoPlayer.muted('true');
      });
    }

    if (this.options['controls']) {
      if (host == 'html5') {
        this.videoPlayer.on('touchstart', function () {
          if (event.target.closest('.vjs-control-bar')) {
            return;
          }

          if (_this.videoPlayer.paused()) {
            const playPromise = _this.videoPlayer.play();
            if (playPromise !== undefined) {
              playPromise.catch(() => {
                // Silently catch autoplay prevention
              });
            }
          } else {
            _this.videoPlayer.pause();
          }
        });
      }
      if (host == 'html5') return;
      this.videoPlayer.on('click', function () {
        if (event.target.closest('.vjs-control-bar')) {
          return;
        }

        if (_this.videoPlayer.paused()) {
          const playPromise = _this.videoPlayer.play();
          if (playPromise !== undefined) {
            playPromise.catch((error) => {
              // Autoplay was prevented, video will play when user interacts
              console.log('Video autoplay prevented:', error);
            });
          }
        } else {
          _this.videoPlayer.pause();
        }
      });
    } else {
      // Disable click interactions completely
      this.videoPlayer.off('click');
      this.videoPlayer.off('touchstart');

      // Hide controls completely
      this.videoPlayer.controls(false);

      // Keep hover/mouseover functionality for desktop autoplay but disable manual clicking
      const videoEl = this.element.querySelector('.video-js');
      if (videoEl) {
        // Don't disable pointer events completely - we need hover to work
        // videoEl.style.pointerEvents = 'none';
        videoEl.style.cursor = 'default';

        // Add a custom click handler that does nothing to prevent any manual control
        videoEl.addEventListener(
          'click',
          function (e) {
            e.preventDefault();
            e.stopPropagation();
            return false;
          },
          true,
        );

        videoEl.addEventListener(
          'touchstart',
          function (e) {
            e.preventDefault();
            e.stopPropagation();
            return false;
          },
          true,
        );
      }
    }
  }

  createObserver() {
    const observer = new IntersectionObserver(this.handleIntersect.bind(this), {
      threshold: 0.2,
      rootMargin: '200px 0px 200px 0px',
    });

    const element = this.element;
    observer.observe(element);
    this.trueObserver = true;
  }

  handleIntersect(entries) {
    const isMobile = responsive.matchesBreakpoint('pocket');

    entries.forEach((entry) => {
      if (entry.intersectionRatio === 1 || entry.isIntersecting == true) {
        if (!this.videoPlayer) {
          this.checkLoaded();
          return;
        }

        // Handle play_in_view setting (both devices)
        if (this.options['play_in_view'] && this.videoPlayer) {
          if (this.options['muted']) {
            this.videoPlayer.muted('true');
          }

          const checkIfPlaying = () => {
            if (!this.videoPlayer.el_.classList.contains('vjs-playing')) {
              const playPromise = this.videoPlayer.play();
              if (playPromise !== undefined) {
                playPromise.catch((error) => {
                  // Autoplay was prevented, video will play when user interacts
                  console.log('Video autoplay prevented:', error);
                });
              }
              setTimeout(checkIfPlaying, 100);
            }
          };

          checkIfPlaying();
        }
        // Handle play_in_view_mob_hover_desk setting (mobile only)
        else if (this.options['play_in_view_mob_hover_desk'] && this.videoPlayer && isMobile) {
          if (this.options['muted']) {
            this.videoPlayer.muted('true');
          }

          const checkIfPlaying = () => {
            if (!this.videoPlayer.el_.classList.contains('vjs-playing')) {
              const playPromise = this.videoPlayer.play();
              if (playPromise !== undefined) {
                playPromise.catch((error) => {
                  // Autoplay was prevented, video will play when user interacts
                  console.log('Video autoplay prevented:', error);
                });
              }
              setTimeout(checkIfPlaying, 100);
            }
          };

          checkIfPlaying();
        }
      } else if (entry.intersectionRatio === 0 || entry.isIntersecting == false) {
        // Handle play_in_view setting (both devices)
        if (
          this.options['play_in_view'] &&
          this.videoPlayer &&
          this.videoPlayer.el_.classList.contains('vjs-playing')
        ) {
          this.videoPlayer.pause();
        }
        // Handle play_in_view_mob_hover_desk setting (mobile only)
        else if (
          this.options['play_in_view_mob_hover_desk'] &&
          isMobile &&
          this.videoPlayer &&
          this.videoPlayer.el_.classList.contains('vjs-playing')
        ) {
          this.videoPlayer.pause();
        }
      }
    });
  }

  disposeVideoPlayer() {
    if (this.videoPlayer) {
      try {
        console.log('VideoComponent: Disposing video player');
        this.videoPlayer.dispose();
        this.videoPlayer = null;
        console.log('VideoComponent: Video player disposed successfully');
      } catch (e) {
        console.warn('VideoComponent: Error disposing video player:', e);
        this.videoPlayer = null; // Force null even if dispose fails
      }
    }
  }

  ensureDesktopControls() {
    if (!this.videoPlayer) return;

    // Only enable controls if they are supposed to be enabled
    if (this.options['controls']) {
      // Force controls to be enabled
      this.videoPlayer.controls(true);

      // The main issue was CSS pointer-events, but we can still ensure controls are clickable
      const isMobile = responsive.matchesBreakpoint('pocket');
      if (!isMobile) {
        // Make sure text track display doesn't block clicks
        const textTrackDisplay = this.element.querySelector('.vjs-text-track-display');
        if (textTrackDisplay) {
          textTrackDisplay.style.pointerEvents = 'none';
        }
      }
    } else {
      // Make sure controls stay disabled
      this.videoPlayer.controls(false);

      // Ensure video is non-interactive
      const videoEl = this.element.querySelector('.video-js');
      if (videoEl) {
        videoEl.style.pointerEvents = 'none';
        videoEl.style.cursor = 'default';
      }
    }
  }

  reinitializeVideoPlayer() {
    this.disposeVideoPlayer();

    // Clear the loaded attribute so video can be reinitialized
    this.element.removeAttribute('loaded');
    this.element.removeAttribute('data-loaded');

    // Remove existing video holder completely
    const existingHolder = this.element.querySelector('.videoHolder');
    if (existingHolder) {
      existingHolder.remove();
    }

    // Force a fresh start
    setTimeout(() => {
      this.checkLoaded();
    }, 50);
  }
}
customElements.define('video-component', VideoComponent);

class MainSearch extends HTMLElement {
  constructor() {
    super();
    this.element = this;
  }

  connectedCallback() {
    new AddToCart(this.element);
    this.delegateElement = new Delegate(this.element);

    const url = new URL(window.location.href);
    const totalProducts = this._getSearchCount('totalProducts', 'main-search__total-products-num');
    const totalArticles = this._getSearchCount('totalArticles', 'main-search__total-articles-num');

    if (!url.searchParams.has('type') && (totalProducts > 0 || totalArticles > 0)) {
      const type = totalProducts > 0 ? 'product' : 'article';
      window.location.replace(this.getFilteredSearchUrl(type));
      return;
    }

    this.filterMobileButton = document.querySelector('.collection__filter-bar-button.not_desktop');
    this.filtersEnabledEl = document.querySelector('.collection__nav-filter-bar');
    this.scrollBound = false;

    if (this.filtersEnabledEl) {
      this.filtersEnabled = this.filtersEnabledEl.getAttribute('data-filter-enabled');
      if (this.filtersEnabled === 'true') this.checkGridHeigth();
      else if (this.filterMobileButton) this.filterMobileButton.style.display = 'none';
    }

    this.toggleProductsBtn = this.element.querySelector('[data-action="toggle-products"]') || document.querySelector('#productBtn');
    this.toggleArticlesBtn = this.element.querySelector('[data-action="toggle-articles"]') || document.querySelector('#articleBtn');

    this._applyToggleButtonsDisabledFromData();
    requestAnimationFrame(() => this._applyToggleButtonsDisabledFromData());

    this.bindEvents();
    this.prefetchGrids();
    this.setInitialGridVisibility();
    this.updateSearchTotals();
  }

  /** Apply disabled state to Products/Articles tabs from data-total-products and data-total-articles. Runs on load and can be called again after prefetch. */
  _applyToggleButtonsDisabledFromData() {
    const productBtn = this.toggleProductsBtn || this.element.querySelector('[data-action="toggle-products"]') || document.querySelector('#productBtn');
    const articleBtn = this.toggleArticlesBtn || this.element.querySelector('[data-action="toggle-articles"]') || document.querySelector('#articleBtn');
    const productCount = parseInt(this.element.dataset.totalProducts, 10);
    const articleCount = parseInt(this.element.dataset.totalArticles, 10);
    const productZero = !Number.isNaN(productCount) && productCount === 0;
    const articleZero = !Number.isNaN(articleCount) && articleCount === 0;
    if (productBtn) {
      if (productZero) productBtn.setAttribute('disabled', '');
      else productBtn.removeAttribute('disabled');
    }
    if (articleBtn) {
      if (articleZero) articleBtn.setAttribute('disabled', '');
      else articleBtn.removeAttribute('disabled');
    }
  }

  /**
   * Reads product or article count from data attributes or DOM, for any query.
   * @param {string} dataKey - dataset key (camelCase), e.g. 'totalProducts' or 'totalArticles'
   * @param {string} domClass - fallback class for the count element, e.g. 'main-search__total-products-num'
   * @returns {number}
   */
  _getSearchCount(dataKey, domClass) {
    const fromData = this.element.dataset[dataKey];
    if (fromData !== undefined && fromData !== '') {
      const n = parseInt(fromData, 10);
      if (!Number.isNaN(n)) return n;
    }
    const el = this.element.querySelector(`.${domClass}`);
    if (el) {
      const n = parseInt(el.textContent.trim(), 10);
      if (!Number.isNaN(n)) return n;
    }
    return 0;
  }

  /**
   * Disable Products tab when 0 products, disable Articles tab when 0 articles.
   * Only disables when count is 0 and trusted (from a real source); avoids disabling when count is unknown.
   * @param {number} totalProducts
   * @param {number} totalArticles
   * @param {{ trustProductCount?: boolean, trustArticleCount?: boolean }} [trust] - when true, 0 means disable; when false/undefined, 0 is treated as unknown and button stays enabled
   */
  _updateToggleButtonsState(totalProducts, totalArticles, trust = {}) {
    if (totalProducts === undefined) totalProducts = this._getSearchCount('totalProducts', 'main-search__total-products-num');
    if (totalArticles === undefined) totalArticles = this._getSearchCount('totalArticles', 'main-search__total-articles-num');
    const trustProduct = trust.trustProductCount === true;
    const trustArticle = trust.trustArticleCount === true;
    if (this.toggleProductsBtn) {
      if (totalProducts === 0 && trustProduct) this.toggleProductsBtn.setAttribute('disabled', '');
      else this.toggleProductsBtn.removeAttribute('disabled');
    }
    if (this.toggleArticlesBtn) {
      if (totalArticles === 0 && trustArticle) this.toggleArticlesBtn.setAttribute('disabled', '');
      else this.toggleArticlesBtn.removeAttribute('disabled');
    }
  }

  /** Simplifies building a filtered URL that only includes safe params */
  getFilteredSearchUrl(typeOverride = null) {
    const url = new URL(window.location.href);
    const params = url.searchParams;
    const filtered = new URLSearchParams();

    const keep = ['q', 'type', 'sort_by'];
    keep.forEach((key) => {
      if (params.has(key)) filtered.set(key, params.get(key));
    });

    if (typeOverride) filtered.set('type', typeOverride);
    filtered.set('page', '1');

    url.search = filtered.toString();
    return url.toString();
  }

  bindEvents() {
    this.delegateElement.on('click', '[data-action="toggle-products"]', (e) => {
      const btn = e.target.closest('[data-action="toggle-products"]');
      if (btn && !btn.hasAttribute('disabled')) {
        e.preventDefault();
        this.showProducts(e);
      }
    });
    this.delegateElement.on('click', '[data-action="toggle-articles"]', (e) => {
      const btn = e.target.closest('[data-action="toggle-articles"]');
      if (btn && !btn.hasAttribute('disabled')) {
        e.preventDefault();
        this.showArticles(e);
      }
    });
    this.delegateElement.on('click', '[data-action="toggle-collection"]', this.toggleGrid.bind(this));
    window.addEventListener('popstate', this.toggleGridBasedOnUrl.bind(this));
  }

  async prefetchGrids() {
    const url = new URL(window.location.href);
    const params = url.searchParams;
    const currentType = params.get('type') || 'product';
    const currentPage = params.get('page') || 0;

    let productHtml, articleHtml;

    if (currentType === 'product' || (currentPage > 1 && !document.querySelector('.active-filters__item'))) {
      const articleUrl = this.getFilteredSearchUrl('article');
      articleHtml = await fetch(articleUrl).then((res) => res.text());
      productHtml = document.documentElement.innerHTML;
    }

    if (currentType === 'article' || currentPage > 1) {
      const productUrl = this.getFilteredSearchUrl('product');
      productHtml = await fetch(productUrl).then((res) => res.text());
      if (!articleHtml) articleHtml = document.documentElement.innerHTML;
    }

    const productDoc = new DOMParser().parseFromString(productHtml, 'text/html');
    const articleDoc = new DOMParser().parseFromString(articleHtml, 'text/html');

    const productGrid = productDoc.querySelector('#collection__main-grid-products');
    if (productGrid && currentType === 'article') {
      const target = document.querySelector('#collection__main-grid-products');
      if (target) target.innerHTML = productGrid.innerHTML;
    }

    if (currentType === 'article') {
      const productFilterDrawer = productDoc.querySelector('[id^="collection__filter-drawer-"] .collection__filter-drawer');
      const currentFilterDrawer = document.querySelector('[id^="collection__filter-drawer-"] .collection__filter-drawer');
      if (productFilterDrawer && currentFilterDrawer) {
        currentFilterDrawer.innerHTML = productFilterDrawer.innerHTML;
      }

      const productFiltersDesk = productDoc.querySelector('.collection__filters-desk');
      const currentFiltersDesk = document.querySelector('.collection__filters-desk');
      if (productFiltersDesk && currentFiltersDesk) {
        currentFiltersDesk.innerHTML = productFiltersDesk.innerHTML;
      }
    }

    const productFilters = productDoc.querySelector('.block-filters-bar');
    const targetFilters = document.querySelector('.block-filters-bar');
    if (productFilters && targetFilters && currentType === 'article') {
      targetFilters.innerHTML = productFilters.innerHTML;
    }

    const articleGrid = articleDoc.querySelector('#collection__main-grid-articles');
    if (articleGrid && currentType === 'product') {
      const target = document.querySelector('#collection__main-grid-articles');
      if (target) target.innerHTML = articleGrid.innerHTML;
    }

    const totalProductsTarget = document.querySelector('.main-search__total-products-num');
    let totalProductsEl;

    if (currentPage > 1 && document.querySelector('.active-filters__item')) {
      const url = new URL(window.location.href);
      const params = url.searchParams;
      params.set('page', '1');
      url.search = params.toString();

      const productUrl = url.toString();
      const productHtmlForTotal = await fetch(productUrl).then((res) => res.text());
      const productHtmlForTotalDoc = new DOMParser().parseFromString(productHtmlForTotal, 'text/html');

      totalProductsEl = productHtmlForTotalDoc.querySelector('.main-search__total-products-num');
      if (totalProductsEl && totalProductsTarget) {
        totalProductsTarget.innerHTML = totalProductsEl.innerHTML;
      }
    } else {

      totalProductsEl = productDoc.querySelector('.main-search__total-products-num');
      if (totalProductsEl && totalProductsTarget) {
        totalProductsTarget.innerHTML = totalProductsEl.innerHTML;
      }
    }

    document.querySelector('.main-search__toggle-button.loading')?.classList.remove('loading');

    const totalArticlesEl = articleDoc.querySelector('.main-search__total-articles-num');

    const totalArticlesTarget = document.querySelector('.main-search__total-articles-num');

    if (totalArticlesEl && totalArticlesTarget) {
      totalArticlesTarget.innerHTML = totalArticlesEl.innerHTML;
    }

    const productButton = document.querySelector('.main-search__product-button');
    const articleButton = document.querySelector('.main-search__article-button');
    if (totalProductsTarget && productButton && totalProductsTarget.textContent == 0) productButton.style.display = 'none';
    else if (totalArticlesTarget && articleButton && totalArticlesTarget.textContent == 0) articleButton.style.display = 'none';

    if (currentType === 'article') this.handleSortForArticles();

    this.cachedTotals = {
      product: totalProductsEl ? totalProductsEl.innerHTML : null,
      article: totalArticlesEl ? totalArticlesEl.innerHTML : null,
    };

    let productCount = totalProductsTarget ? (parseInt(totalProductsTarget.textContent.trim(), 10) || 0) : (totalProductsEl ? (parseInt(totalProductsEl.textContent.trim(), 10) || 0) : null);
    let articleCount = totalArticlesTarget ? (parseInt(totalArticlesTarget.textContent.trim(), 10) || 0) : (totalArticlesEl ? (parseInt(totalArticlesEl.textContent.trim(), 10) || 0) : null);

    const fetchedProductSearch = productDoc.querySelector('#main-search') || productDoc.querySelector('search-component');
    const fetchedArticleSearch = articleDoc.querySelector('#main-search') || articleDoc.querySelector('search-component');
    if (productCount !== null) this.element.dataset.totalProducts = String(productCount);
    else if (fetchedProductSearch) {
      const p = fetchedProductSearch.getAttribute('data-total-products');
      if (p !== null && p !== '') this.element.dataset.totalProducts = p;
    }
    if (articleCount !== null) this.element.dataset.totalArticles = String(articleCount);
    else if (fetchedArticleSearch) {
      const a = fetchedArticleSearch.getAttribute('data-total-articles');
      if (a !== null && a !== '') this.element.dataset.totalArticles = a;
    }
    this._applyToggleButtonsDisabledFromData();
  }

  setInitialGridVisibility() {
    const url = new URL(window.location.href);
    const type = url.searchParams.get('type') || 'product';

    const productGrid = this.element.querySelector('#collection__main-grid-products');
    const articleGrid = this.element.querySelector('#collection__main-grid-articles');

    if (type === 'article') {
      if (productGrid) productGrid.setAttribute('aria-hidden', 'true');
      if (articleGrid) articleGrid.setAttribute('aria-hidden', 'false');
    } else {
      if (productGrid) productGrid.setAttribute('aria-hidden', 'false');
      if (articleGrid) articleGrid.setAttribute('aria-hidden', 'true');
    }

    if (this.filterMobileButton) {
      this.filterMobileButton.style.display = type === 'article' ? 'none' : '';
      this.filterMobileButton.setAttribute('aria-hidden', type === 'article');
    }

    const filtersWrapperDesk = this.element.querySelector('.collection__filter-items--desktop');
    const activeFilters = this.element.querySelector('.active-filters');

    if (filtersWrapperDesk) {
      filtersWrapperDesk.style.display = type === 'article' ? 'none' : '';
      filtersWrapperDesk.setAttribute('aria-hidden', type === 'article');
    }

    if (activeFilters) {
      activeFilters.style.display = type === 'article' ? 'none' : '';
      activeFilters.setAttribute('aria-hidden', type === 'article');
    }

  }

  updateSearchTotals() {
    if (!this.cachedTotals) return;
    const { product, article } = this.cachedTotals;

    if (product) {
      const el = document.querySelector('.main-search__total-products-num');
      if (el) el.innerHTML = product;
    }

    if (article) {
      const el = document.querySelector('.main-search__total-articles-num');
      if (el) el.innerHTML = article;
    }
  }

  toggleGridByType(type) {
    const gridWrapper = this.element.querySelector('#collection__grid-wrapper');
    const currentVisible = this.element.querySelector('.collection__grid--inner:not([aria-hidden="true"])');
    const gridToShow = this.element.querySelector(
      type === 'product' ? '#collection__main-grid-products' : '#collection__main-grid-articles'
    );

    // If already showing the correct grid, skip
    if (currentVisible === gridToShow) return;

    const applyFilterVisibility = () => {
      const gridHeader = this.element.querySelector('.collection__grid-header');
      const collectionTop = this.element.querySelector('.collection__top');
      if (type === 'product') {
        if (gridHeader) {
          gridHeader.style.display = '';
          gridHeader.removeAttribute('aria-hidden');
        }
        if (collectionTop) {
          collectionTop.style.display = '';
          collectionTop.removeAttribute('aria-hidden');
        }
      } else {
        if (gridHeader) gridHeader.setAttribute('aria-hidden', 'true');
        if (collectionTop) collectionTop.setAttribute('aria-hidden', 'true');
      }

      if (this.filterMobileButton) {
        this.filterMobileButton.style.display = type === 'article' ? 'none' : '';
        this.filterMobileButton.setAttribute('aria-hidden', type === 'article');
      }

      const filtersWrapperDesk = this.element.querySelector('.collection__filter-items--desktop');
      const filtersDesk = this.element.querySelector('.collection__filters-desk');

      if (filtersWrapperDesk) {
        filtersWrapperDesk.style.display = type === 'article' ? 'none' : '';
        filtersWrapperDesk.setAttribute('aria-hidden', type === 'article');
      }

      if (filtersDesk) {
        filtersDesk.style.display = type === 'article' ? 'none' : '';
        filtersDesk.setAttribute('aria-hidden', type === 'article');
      }

      const collectionFilterBarButtons = this.element.querySelectorAll('.collection__filter-bar-button');

      if (collectionFilterBarButtons.length) {
        collectionFilterBarButtons.forEach((btn) => {
          const isFilterButton = btn.classList.contains('collection__filter-bar-button--filter');
          if (isFilterButton) {
            btn.style.display = type === 'article' ? 'none' : '';
            btn.setAttribute('aria-hidden', type === 'article');
          } else {
            btn.style.display = '';
            btn.removeAttribute('aria-hidden');
          }
        });
      }

      const activeFilters = this.element.querySelector('.block-filters-bar .active-filters');

      if (activeFilters) {
        activeFilters.style.display = type === 'article' ? 'none' : '';
        activeFilters.setAttribute('aria-hidden', type === 'article');
      }
    };

    // Update button states immediately
    if (this.toggleProductsBtn && this.toggleArticlesBtn) {
      if (type === 'product') {
        this.toggleProductsBtn.classList.add('active');
        this.toggleArticlesBtn.classList.remove('active');
      } else {
        this.toggleProductsBtn.classList.remove('active');
        this.toggleArticlesBtn.classList.add('active');
        document.querySelector('filters-custom')?.closeAllDrawers();
      }
    }

    // Fade out current grid, then swap and fade in
    if (currentVisible && gridWrapper) {
      gridWrapper.classList.add('search-toggle-fade-out');
      gridWrapper.addEventListener('animationend', () => {
        gridWrapper.classList.remove('search-toggle-fade-out');

        // Swap grids
        const gridsToHide = this.element.querySelectorAll('.collection__grid--inner');
        gridsToHide.forEach((g) => g.setAttribute('aria-hidden', 'true'));
        if (gridToShow) gridToShow.setAttribute('aria-hidden', 'false');

        applyFilterVisibility();

        // Fade in
        gridWrapper.classList.add('search-toggle-fade-in');
        gridWrapper.addEventListener('animationend', () => {
          gridWrapper.classList.remove('search-toggle-fade-in');
        }, { once: true });
      }, { once: true });
    } else {
      // No current grid visible, just show directly
      const gridsToHide = this.element.querySelectorAll('.collection__grid--inner');
      gridsToHide.forEach((g) => g.setAttribute('aria-hidden', 'true'));
      if (gridToShow) gridToShow.setAttribute('aria-hidden', 'false');
      applyFilterVisibility();
    }

    if (type === 'article') this.handleSortForArticles();
  }

  handleSortForArticles() {
    const url = new URL(window.location.href);
    if (url.searchParams.has('sort_by')) {
      url.searchParams.delete('sort_by');
      history.replaceState({}, '', url.toString());
    }

    const checked = document.querySelector('.collection__sort-element--price input[name="sort_by"]:checked');
    console.log('checked price sort?', checked);
    if (!checked) return;

    const firstOptionTextEl =
      this.element.querySelector('.collection__sort-text');

    const labelText = firstOptionTextEl.textContent.trim();

    document.querySelectorAll('.collection__filter-current-sort-option').forEach(el => {
      el.textContent = labelText;
    });

    document.querySelector('#collection__sort-drawer--desktop [name=sort_by]').checked = true;
    document.querySelector('.collection__sort-items.Drawer--Content [name=sort_by]').checked = true;
  }

  toggleGrid(e) {
    const target = e.target.closest('[data-action="toggle-collection"]');
    const id = target.getAttribute('aria-controls');
    const gridsToHide = this.element.querySelectorAll('.collection__grid[aria-hidden="false"]');
    const gridToShow = this.element.querySelector(`#${id}`);

    gridsToHide.forEach((grid) => grid.setAttribute('aria-hidden', 'true'));
    if (gridToShow) gridToShow.setAttribute('aria-hidden', 'false');

    if (this.filterMobileButton) {
      this.filterMobileButton.style.display = id === 'collection-article' ? 'none' : '';
    }
  }

  toggleGridBasedOnUrl() {
    const url = new URL(window.location.href);
    const type = url.searchParams.get('type') || 'product';
    this.toggleGridByType(type);
  }

  showArticles(e) {
    e.preventDefault();
    this.toggleGridByType('article');
    const url = this.getFilteredSearchUrl('article');
    history.pushState({}, '', url);
  }

  showProducts(e) {
    e.preventDefault();
    this.toggleGridByType('product');
    const url = this.getFilteredSearchUrl('product');
    history.pushState({}, '', url);
  }
  
}

customElements.define('search-component', MainSearch);


class FooterComponent extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.abortController = null;
    this._isSubmitting = false;
    this.bindEvents();
  }

  bindEvents() {
    this.delegateElement.on(
      "click",
      '[data-action="clear-input"]',
      this.clearInput.bind(this)
    );

    this.delegateElement.on("change", "[data-state='required']", this.toggleButton.bind(this));
    this.delegateElement.on("input", "[data-state='required']", this.toggleButton.bind(this));

    // Bind Klaviyo form submit handler
    this.delegateElement.on(
      "submit",
      '#footerForm',
      this.submitFooterNewsletter.bind(this)
    );
    this.delegateElement.on(
      "click",
      '[data-action="show-newsletter-form"]',
      this.showNewsletterForm.bind(this)
    );
  }

  connectedCallback() {
    this.toggleButton();
    this.abortController = new AbortController();
    this._resizeHandler = responsive.addResizeListener(this, this.updateFooterHeight);
    requestAnimationFrame(() => this.updateFooterHeight());
  }

  disconnectedCallback() {
    if (this._resizeHandler && typeof this._resizeHandler.removeResizeListener === "function") {
      this._resizeHandler.removeResizeListener();
      this._resizeHandler = null;
    }
    if (this.abortController) {
      this.abortController.abort();
      this.abortController = null;
    }
    this.delegateElement.off("click", '[data-action="clear-input"]');
    this.delegateElement.off("click", '[data-action="show-newsletter-form"]');
    this.delegateElement.off("change", "[data-state='required']");
    this.delegateElement.off("input", "[data-state='required']");
    this.delegateElement.off("submit", "#footerForm");
    if (this.delegateElement.destroy) this.delegateElement.destroy();
    this.delegateElement = null;
    this.element = null;
  }

  updateFooterHeight = () => {
    const footerHeight = this.offsetHeight + "px";
    document.documentElement.style.setProperty("--footer-dynamic-height", footerHeight);
    document.documentElement.style.setProperty("--footer-height", footerHeight);
  };

  clearInput() {
    const emailInput = this.querySelector(".input-placeholder");
    const errorSpan = this.querySelector("#footer__newsletter-email--error");
    const submitButton = this.querySelector(".footer__newsletter-submit-button");
    const clearButton = this.querySelector(".footer__newsletter-form--clear");
    const emailWrapper = this.querySelector(".footer__newsletter-form-inputs");

    if (emailInput) emailInput.value = "";
    if (emailInput) emailInput.classList.remove("footer__newsletter-input--error");
    if (errorSpan) errorSpan.style.display = "none";
    if (emailWrapper) emailWrapper.classList.remove("alert");

    if (submitButton) submitButton.style.display = "flex";
    if (clearButton) clearButton.style.display = "none";
    this.toggleButton();
  }

  toggleButton() {
    this.buttonState = true;
    const allRequiredFields = this.element.querySelectorAll("[data-state='required']");

    allRequiredFields.forEach((item) => {
      if (item.type === "checkbox") {
        if (!item.checked) this.buttonState = false;
      } else {
        const val = item.value.trim();
        if (val === "") {
          this.buttonState = false;
        } else if (item.type === "email" || (item.getAttribute("name") && item.getAttribute("name").toLowerCase().includes("email"))) {
          if (!this._isValidEmail(val)) this.buttonState = false;
        }
      }
    });

    const submitBtn = this.element.querySelector(".footer__newsletter-submit-button");
    if (submitBtn) {
      if (this.buttonState) {
        submitBtn.removeAttribute("disabled");
        submitBtn.classList.remove("disabled");
        submitBtn.setAttribute("aria-disabled", "false");
      } else {
        submitBtn.setAttribute("disabled", "");
        submitBtn.classList.add("disabled");
        submitBtn.setAttribute("aria-disabled", "true");
      }
    }
  }

  _isValidEmail(val) {
    if (!val || !val.includes("@")) return false;
    const at = val.indexOf("@");
    return at > 0 && at < val.length - 1;
  }

  async submitFooterNewsletter(e) {
    const publicKey = this.element.dataset.klaviyoPublicKey;
    const listId = this.element.dataset.klaviyoListId;
    if (!publicKey || !listId) {
      return;
    }
    e.preventDefault();
    if (this._isSubmitting) return;
    this._isSubmitting = true;

    const emailInput = this.element.querySelector('.input-placeholder');
    const emailTxt = emailInput ? emailInput.value.trim() : "";
    const alertErr = this.element.querySelector('#footer__newsletter-email--error');
    const submitButton = this.element.querySelector(".footer__newsletter-submit-button");
    const checkboxField = this.element.querySelector('[data-state="required"]');

    if (emailTxt === "" || !emailTxt.includes("@")) {
      if (alertErr) {
        alertErr.style.display = "block";
        alertErr.textContent = "Please enter a valid email address.";
        setTimeout(() => {
          if (alertErr) alertErr.style.display = "none";
        }, 3000);
      }
      this._isSubmitting = false;
      return;
    }

    if (checkboxField && checkboxField.type === 'checkbox' && !checkboxField.checked) {
      if (alertErr) {
        alertErr.style.display = "block";
        alertErr.textContent = "Please accept the privacy policy.";
        setTimeout(() => {
          if (alertErr) alertErr.style.display = "none";
        }, 3000);
      }
      this._isSubmitting = false;
      return;
    }

    if (submitButton) {
      submitButton.setAttribute("disabled", "");
      submitButton.classList.add("disabled");
      submitButton.setAttribute("aria-disabled", "true");
    }

    try {
      await this.handleKlaviyoNewsletterAPI(emailTxt);
      this.showSuccessMessage();
    } catch (error) {
      if (error.name === 'AbortError') return;
      console.error('Klaviyo newsletter signup failed:', error);
      this.fallbackToShopifyForm();
    } finally {
      this._isSubmitting = false;
      this.toggleButton();
    }
  }

  async handleKlaviyoNewsletterAPI(email) {
    const listId = this.element.dataset.klaviyoListId;
    const publicKey = this.element.dataset.klaviyoPublicKey;
    if (!publicKey || !listId) throw new Error('Klaviyo config missing');
    const data = {
      type: "subscription",
      attributes: {
        list_id: listId,
        email: email
      }
    };
    const endpoint = `https://a.klaviyo.com/client/subscriptions/?company_id=${publicKey}`;
    const signal = this.abortController ? this.abortController.signal : undefined;
    const response = await fetch(endpoint, {
      signal,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'accept': 'application/json',
        "revision": "2024-06-15"
      },
      body: JSON.stringify({ data }),
    });
    if (!response.ok) {
      throw new Error(`Klaviyo newsletter subscription failed: ${response.statusText}`);
    }
    return response;
  }

  showSuccessMessage() {
    const formWrapper = this.element.querySelector('.footer__newsletter-form-wrapper');
    const successWrapper = this.element.querySelector('.footer__newsletter-form--success-wrapper');
    if (!formWrapper || !successWrapper) return;
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    formWrapper.style.display = 'none';
    successWrapper.classList.remove('is-hidden');
    successWrapper.setAttribute('aria-hidden', 'false');
    if (!prefersReducedMotion) {
      successWrapper.style.transition = 'opacity 300ms ease';
      successWrapper.style.opacity = '0';
      requestAnimationFrame(() => { successWrapper.style.opacity = '1'; });
    }
    this.clearInput();
  }

  showNewsletterForm() {
    const formWrapper = this.element.querySelector('.footer__newsletter-form-wrapper');
    const successWrapper = this.element.querySelector('.footer__newsletter-form--success-wrapper');
    if (!formWrapper || !successWrapper) return;
    successWrapper.classList.add('is-hidden');
    successWrapper.setAttribute('aria-hidden', 'true');
    formWrapper.style.display = '';
    this.toggleButton();
  }

  fallbackToShopifyForm() {
    const form = this.element.querySelector('#footerForm');
    if (form && !this._isSubmitting) {
      form.submit();
    }
  }
}

customElements.define("footer-component", FooterComponent);

class ProductElement extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.domDelegate = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);

    this.options = JSON.parse(this.element.getAttribute('data-section-settings') || '{}');
    this.boundEventHandlers = new Map();

    // qty mirror state
    this._qtyMirrorCleanup = null;
    this._qtySyncing = false;

    // hover preview cleanup
    this._colorHoverUnbinders = [];

    // sticky internal state
    this.hideSticky = false;
    this._desktopStickyBound = false;
    this._mobileBottomScrollBound = false;
    this._atcObserver = null;
    this._klaviyoSortObserver = null;
    this._klaviyoSortDebounceT = null;
    this._klaviyoSortTimeouts = [];
    this._stickyMainAtcObserver = null;
    this._desktopStickyScrollListener = null;
    this._mobileBottomScrollListener = null;
    this._stickyResizeListener = null;
    this._stickyMainAtcVisible = false;
    this._stickyFooterH = 0;
    this._stickyBodyH = 0;

    this.changeImageQuality();
    new AddToCart(this.element);
  }

  /* ---------- QTY BUTTON STATES ---------- */
  updateQtyButtonsState() {
    const wrappers = this.element.querySelectorAll('.Quantity-ATC--wrapper');

    wrappers.forEach((wrap) => {
      const qtyInput = wrap.querySelector('input[name="quantity"]');
      const minusBtn = wrap.querySelector('button[name="minus"]');
      const plusBtn = wrap.querySelector('button[name="plus"]');

      if (!qtyInput || (!minusBtn && !plusBtn)) return;

      const rawQty = parseInt(qtyInput.value, 10);
      const qty = Number.isFinite(rawQty) ? rawQty : 1;

      const minRaw = parseInt(qtyInput.getAttribute('min') || '1', 10);
      const min = Number.isFinite(minRaw) ? minRaw : 1;

      const maxAttr = qtyInput.getAttribute('max');
      const maxRaw = maxAttr ? parseInt(maxAttr, 10) : NaN;
      const max = Number.isFinite(maxRaw) ? maxRaw : null;

      const minusDisabled = qty <= min;
      const plusDisabled = max ? qty >= max : false;

      if (minusBtn) {
        minusBtn.disabled = minusDisabled;
        minusBtn.setAttribute('aria-disabled', minusDisabled ? 'true' : 'false');
      }

      if (plusBtn) {
        plusBtn.disabled = plusDisabled;
        plusBtn.setAttribute('aria-disabled', plusDisabled ? 'true' : 'false');
      }
    });
  }

  connectedCallback() {
    // DOM refs
    this.carouselElement = this.element.querySelector('.mainSwiper');
    this.carouselElementThumbs = this.element.querySelector('.main-product__thumbs');
    this.uspSwiperElement = this.element.querySelector('.product-usp__swiper.swiper');
    this.mainAtc = this.element.querySelector('.product-info__actions');

    // sticky wrapper (✅ ALWAYS same selector everywhere)
    this.stickyAtcWrapper = this.element.querySelector('.pdp-sticky-product-atc, .product-module__sticky-atc');

    // Ensure sticky is hidden by default until logic decides to show it
    if (this.stickyAtcWrapper && !this.stickyAtcWrapper.hasAttribute('aria-hidden')) {
      this.stickyAtcWrapper.setAttribute('aria-hidden', 'true');
    }
    // Don't force has-sticky at load. Let toggleStickyAtc control it.
    document.body.classList.remove('has-sticky');

    // sticky sentinel (some themes)
    if (this.mainAtc) {
      const existing = this.element.querySelector('.sticky-atc-sentinel');
      this._stickySentinel = existing || null;

      if (!this._stickySentinel) {
        const sentinel = document.createElement('div');
        sentinel.className = 'sticky-atc-sentinel';
        sentinel.setAttribute('aria-hidden', 'true');
        this.mainAtc.insertAdjacentElement('afterend', sentinel);
        this._stickySentinel = sentinel;
      }
    }

    // swiper init
    const slides = this.carouselElement?.querySelectorAll('.swiper-slide') || [];
    if (slides.length > 1) {
      this.carousel = new RevolutionSwiper(this.carouselElement, this.carouselElementThumbs);
    } else {
      this.element.querySelectorAll('.pdp_swiperButton').forEach((btn) => (btn.style.display = 'none'));
    }

    if (slides.length <= 1) this.element.classList.add('has-single-image');
    else this.element.classList.remove('has-single-image');

    // zoom
    if (this.options['enable_zoom']) {
      setTimeout(() => {
        try {
          const zoom = new RevolutionImageZoom(this.element, this.carousel);
          zoom.syncHeight = zoom.syncHeight.bind(zoom);
          responsive.addResizeListener(zoom, zoom.syncHeight);
        } catch (err) {
          console.warn('⚠️ RevolutionImageZoom failed', err);
        }
      }, 200);
    }

    // usp swiper
    if (this.uspSwiperElement) this.uspSwiper = new RevolutionSwiper(this.uspSwiperElement);

    this.bindEvents();
    this.setupQuantityMirror();
    this.bindColorHoverPreview();

    // initial totals
    this.updatePriceButtonATC();
    this.updateQtyButtonsState();

    // keep availability + totals in sync with VariantSelects
    this._onVariantPriceUpdated = () => {
      const v = this.getCurrentVariantFromSection();
      if (v) this.applyVariantAvailabilityUI(!!v.available);

      this.updatePriceButtonATC();
    };
    document.addEventListener('variant:price-updated', this._onVariantPriceUpdated);

    this._onVariantIdChanged = () => {
      const v = this.getCurrentVariantFromSection();
      if (v) this.applyVariantAvailabilityUI(!!v.available);
    };
    document.addEventListener('variant:id-changed', this._onVariantIdChanged);

    // set correct initial availability
    const initialVariant = this.getCurrentVariantFromSection();
    if (initialVariant) this.applyVariantAvailabilityUI(!!initialVariant.available);

    // init sticky after paint so measurements/observer behave
    if (this.options['sticky_atc']) {
      setTimeout(() => this.showStickyAtc(), 120);
    }

    this.initReloadWithoutRefresh?.();
    this.updateNotifyButtonState?.();
    this.runPDPAnimations?.();

    this.sliderWrapperEl = this.element.querySelector('.main-product__slider-wrapper');
    this.uspBlockWrapperEl = this.element.querySelector('.pdp_group-buy-usp__block-wrapper');

    this.updateSliderWrapperHeightVar = this.updateSliderWrapperHeightVar.bind(this);
    this.updateUspBlockHeightVar = this.updateUspBlockHeightVar.bind(this);

    this.updateSliderWrapperHeightVar();
    this.updateUspBlockHeightVar();

    if ('ResizeObserver' in window) {
      if (this.sliderWrapperEl) {
        this._sliderWrapperRO = new ResizeObserver(this.updateSliderWrapperHeightVar);
        this._sliderWrapperRO.observe(this.sliderWrapperEl);
      }

      if (this.uspBlockWrapperEl) {
        this._uspBlockWrapperRO = new ResizeObserver(this.updateUspBlockHeightVar);
        this._uspBlockWrapperRO.observe(this.uspBlockWrapperEl);
      }
    }

    this._onViewportWidthChange = () => {
      clearTimeout(this._viewportWidthResizeT);
      this._viewportWidthResizeT = setTimeout(() => {
        this.updateSliderWrapperHeightVar();
        this.updateUspBlockHeightVar();
      }, 80);
    };
    window.addEventListener('resize', this._onViewportWidthChange, { passive: true });
    window.addEventListener('orientationchange', this._onViewportWidthChange);

    if (window.theme?.klaviyoForceHighestSort) {
      this.initKlaviyoHighestSort();
    }
  }

  disconnectedCallback() {
    this.cleanupEvents();
  }

  cleanupEvents() {
    try {
      this.domDelegate?.off?.();
    } catch (e) {}
    try {
      this.delegateBody?.off?.();
    } catch (e) {}

    if (this.carousel?.destroy) {
      this.carousel.destroy(true, true);
      this.carousel = null;
    }
    if (this.uspSwiper?.destroy) {
      this.uspSwiper.destroy(true, true);
      this.uspSwiper = null;
    }

    if (this.boundEventHandlers?.has?.('popstate')) {
      window.removeEventListener('popstate', this.boundEventHandlers.get('popstate'));
    }

    if (this._atcObserver) {
      try {
        this._atcObserver.disconnect();
      } catch (e) {}
      this._atcObserver = null;
    }

    if (this._klaviyoSortObserver) {
      try {
        this._klaviyoSortObserver.disconnect();
      } catch (e) {}
      this._klaviyoSortObserver = null;
    }

    if (this._klaviyoSortDebounceT) {
      clearTimeout(this._klaviyoSortDebounceT);
      this._klaviyoSortDebounceT = null;
    }

    if (this._klaviyoSortTimeouts?.length) {
      this._klaviyoSortTimeouts.forEach((id) => clearTimeout(id));
      this._klaviyoSortTimeouts = [];
    }

    if (this._stickyMainAtcObserver) {
      try {
        this._stickyMainAtcObserver.disconnect();
      } catch (e) {}
      this._stickyMainAtcObserver = null;
    }

    if (this._desktopStickyScrollListener?.removeScrollListener) {
      this._desktopStickyScrollListener.removeScrollListener();
    }
    this._desktopStickyScrollListener = null;
    this._desktopStickyBound = false;

    if (this._mobileBottomScrollListener?.removeScrollListener) {
      this._mobileBottomScrollListener.removeScrollListener();
    }
    this._mobileBottomScrollListener = null;
    this._mobileBottomScrollBound = false;

    if (this._stickyResizeListener?.removeResizeListener) {
      this._stickyResizeListener.removeResizeListener();
    }
    this._stickyResizeListener = null;

    if (typeof responsive !== 'undefined' && typeof responsive.removeResizeListener === 'function') {
      try {
        responsive.removeResizeListener(this);
      } catch (e) {}
    }

    if (this._onVariantPriceUpdated) {
      document.removeEventListener('variant:price-updated', this._onVariantPriceUpdated);
      this._onVariantPriceUpdated = null;
    }
    if (this._onVariantIdChanged) {
      document.removeEventListener('variant:id-changed', this._onVariantIdChanged);
      this._onVariantIdChanged = null;
    }

    if (this._colorHoverUnbinders?.length) {
      this._colorHoverUnbinders.forEach((off) => {
        try {
          off();
        } catch (e) {}
      });
      this._colorHoverUnbinders = [];
    }

    this._qtyMirrorCleanup?.();
    this._qtyMirrorCleanup = null;

    this.boundEventHandlers?.clear?.();

    if (this._sliderWrapperRO) {
      try { this._sliderWrapperRO.disconnect(); } catch (e) {}
      this._sliderWrapperRO = null;
    }

    if (this._uspBlockWrapperRO) {
      try { this._uspBlockWrapperRO.disconnect(); } catch (e) {}
      this._uspBlockWrapperRO = null;
    }

    if (this._onViewportWidthChange) {
      window.removeEventListener('resize', this._onViewportWidthChange);
      window.removeEventListener('orientationchange', this._onViewportWidthChange);
      this._onViewportWidthChange = null;
    }

    if (this._viewportWidthResizeT) {
      clearTimeout(this._viewportWidthResizeT);
      this._viewportWidthResizeT = null;
    }
  }

  updateUspBlockHeightVar() {
    if (!this.uspBlockWrapperEl) {
      this.uspBlockWrapperEl = this.element.querySelector('.pdp_group-buy-usp__block-wrapper');
      if (!this.uspBlockWrapperEl) return;
    }

    const height = Math.round(
      this.uspBlockWrapperEl.getBoundingClientRect().height
    );

    // JS memorija
    this.uspBlockHeight = height;

    // CSS var (za layout usage)
    this.element.style.setProperty('--usp-block-height', `${height}px`);

    // data-attr (debug / future use)
    this.element.dataset.uspBlockHeight = String(height);
  }

  updateSliderWrapperHeightVar() {
    if (!this.sliderWrapperEl) {
      this.sliderWrapperEl = this.element.querySelector('.main-product__slider-wrapper');
      if (!this.sliderWrapperEl) return;
    }

    const h = Math.round(this.sliderWrapperEl.getBoundingClientRect().height);

    // 1) CSS var (koristiš u CSS-u kao var(--slider-wrapper-h))
    this.element.style.setProperty('--slider-wrapper-h', `${h}px`);

    // 2) data atribut (ako želiš debuggati ili čitati kasnije)
    this.element.dataset.sliderWrapperH = String(h);
  }

  /* =========================
     AVAILABILITY UI
     ========================= */
  applyVariantAvailabilityUI(available) {
    const wrappers = this.element.querySelectorAll('.Quantity-ATC--wrapper');

    wrappers.forEach((wrap) => {
      const qtyHandler = wrap.querySelector('.QuantityHandler');
      const qtyEl = wrap.querySelector('quantity-input.Quantity, quantity-input');
      const qtyInput = wrap.querySelector('input[name="quantity"]');
      const minusBtn = wrap.querySelector('button[name="minus"]');
      const plusBtn = wrap.querySelector('button[name="plus"]');

      const atc = wrap.querySelector('.add-to-cart__wrapper');
      const notify = wrap.querySelector('.notify-wrapper');
      const notifyButton = notify?.querySelector("button, [role='button']");

      if (qtyHandler) qtyHandler.classList.toggle('hideBtn', !available);
      if (atc) atc.classList.toggle('hideBtn', !available);
      if (notify) notify.classList.toggle('hideBtn', available);

      if (qtyEl) qtyEl.style.display = available ? '' : 'none';

      if (qtyInput) qtyInput.disabled = !available;
      if (minusBtn) minusBtn.disabled = !available;
      if (plusBtn) plusBtn.disabled = !available;

      if (qtyHandler) qtyHandler.setAttribute('aria-hidden', (!available).toString());
      if (atc) atc.setAttribute('aria-hidden', (!available).toString());
      if (notify) notify.setAttribute('aria-hidden', available.toString());

      if (notifyButton) {
        const isSoldOutMode = notifyButton.dataset.oosMode === 'sold_out';
        const shouldDisableNotify = !available && isSoldOutMode;

        if (shouldDisableNotify) {
          notifyButton.setAttribute('disabled', 'disabled');
          notifyButton.setAttribute('aria-disabled', 'true');
          notifyButton.setAttribute('tabindex', '-1');
          notifyButton.removeAttribute('data-action');
          notifyButton.removeAttribute('aria-controls');
        } else {
          notifyButton.removeAttribute('disabled');
          notifyButton.setAttribute('aria-disabled', 'false');
          notifyButton.removeAttribute('tabindex');
          notifyButton.setAttribute('data-action', 'toggle-popup');
          notifyButton.setAttribute('aria-controls', 'notify-me-popup');
        }
      }
    });
  }

  _toggleVideoStateAriaLabel(e) {
    const btn = e.target.closest('[data-action="toggle-state"]');
    if (!btn) return;
    const play = btn.getAttribute('data-aria-label-play');
    const pause = btn.getAttribute('data-aria-label-pause');
    if (play && pause) btn.setAttribute('aria-label', btn.getAttribute('aria-label') === play ? pause : play);
  }

  _toggleVideoSoundAriaLabel(e) {
    const btn = e.target.closest('[data-action="toggle-sound"]');
    if (!btn) return;
    const whenMuted = btn.getAttribute('data-aria-label-when-muted');
    const whenUnmuted = btn.getAttribute('data-aria-label-when-unmuted');
    if (whenMuted && whenUnmuted) btn.setAttribute('aria-label', btn.getAttribute('aria-label') === whenMuted ? whenUnmuted : whenMuted);
  }

  bindEvents() {
    this.domDelegate.on('input', 'input[name="quantity"]', () => {
      this.updatePriceButtonATC();
      this.updateQtyButtonsState();
    });

    this.domDelegate.on('change', 'input[name="quantity"]', () => {
      this.updatePriceButtonATC();
      this.updateQtyButtonsState();
    });

    this.domDelegate.on('click', 'button[name="plus"], button[name="minus"]', () => {
      setTimeout(() => {
        this.updatePriceButtonATC();
        this.updateQtyButtonsState();
      }, 0);
    });

    // keep totals responsive while VariantSelects does its work
    this.domDelegate.on('change', 'input[name^="options["], select[name^="options["]', () => {
      this.updateVariantAvailability();
      this.updatePriceButtonATC();
    });

    // sticky show/hide hooks
    if (this.options['sticky_atc']) {
      // if add-to-cart feedback hides sticky temporarily
      this.delegateBody.on('product:added', this.hideStickyTimeout.bind(this));
      this.delegateBody.on('product:error', this.hideStickyTimeout.bind(this));

      if (document.readyState === 'loading') {
        window.addEventListener('DOMContentLoaded', () => this.showStickyAtc());
      } else {
        setTimeout(() => this.showStickyAtc(), 100);
      }
    }

    this.domDelegate.on('click', '[data-action="scroll-to-top"]', (e) => {
      e.preventDefault();
      e.stopPropagation();

      window.scrollTo({ top: 0, behavior: 'smooth' });
    });

    this.domDelegate.on('click', '[data-action="scroll-to-reviews"]', this.scrollToFirstReviewTarget.bind(this));

    this.delegateBody.on('click', '[data-action="toggle-state"]', this._toggleVideoStateAriaLabel.bind(this));
    this.delegateBody.on('click', '[data-action="toggle-sound"]', this._toggleVideoSoundAriaLabel.bind(this));

    const reloadPageHandler = this.reloadPage.bind(this);
    this.boundEventHandlers.set('popstate', reloadPageHandler);
    window.addEventListener('popstate', reloadPageHandler);
  }

  /* ---------- VARIANT HELPERS ---------- */

  getCurrentVariantPriceCents() {
    // 1) Preferred: VariantSelects.currentVariant (available as soon as it runs)
    const vs = this.element.querySelector('variant-selects');
    if (vs && vs.currentVariant && Number.isFinite(vs.currentVariant.price)) {
      return vs.currentVariant.price;
    }

    // 2) Fallback: variants JSON + hidden id input
    const variantJson = this.element.querySelector("variant-selects script[type='application/json']");
    if (!variantJson) return NaN;

    let variants;
    try {
      variants = JSON.parse(variantJson.textContent);
    } catch {
      return NaN;
    }

    const idInput = this.element.querySelector('form[data-product-form] input[name="id"]');
    const currentId = idInput?.value;
    if (!currentId) return NaN;

    const v = variants.find((x) => String(x.id) === String(currentId));
    return v?.price ?? NaN;
  }

  getCurrentVariantFromSection() {
    const variantJson = this.element.querySelector("variant-selects script[type='application/json']");
    if (!variantJson) return null;

    let variants;
    try {
      variants = JSON.parse(variantJson.textContent);
    } catch {
      return null;
    }

    const idInput = this.element.querySelector('form[data-product-form] input[name="id"]');
    const byId = idInput ? variants.find((v) => String(v.id) === String(idInput.value)) : null;
    if (byId) return byId;

    const opts = Array.from(
      this.element.querySelectorAll('input[name^="options["]:checked, select[name^="options["]'),
    ).map((el) => el.value);

    return (
      variants.find((v) => {
        if (Array.isArray(v.options)) {
          return v.options.every((val, idx) => (opts[idx] ? opts[idx] === val : true));
        }
        return (
          (!v.option1 || v.option1 === opts[0]) &&
          (!v.option2 || v.option2 === opts[1]) &&
          (!v.option3 || v.option3 === opts[2])
        );
      }) || null
    );
  }

  updateVariantAvailability() {
    const variantDataEl = this.element.querySelector("variant-selects script[type='application/json']");
    if (!variantDataEl) return;

    let variants;
    try {
      variants = JSON.parse(variantDataEl.textContent);
    } catch {
      return;
    }

    const currentOptions = Array.from(this.element.querySelectorAll('input[name^="options["]:checked')).map(
      (el) => el.value,
    );

    this.element.querySelectorAll('.inputSelectboxCheckbox').forEach((input) => {
      const optionPos = parseInt(input.name.match(/\d+/)?.[0] || '0', 10);
      if (!optionPos) return;

      const testOptions = [...currentOptions];
      testOptions[optionPos - 1] = input.value;

      const match = variants.find(
        (v) =>
          (!v.option1 || v.option1 === testOptions[0]) &&
          (!v.option2 || v.option2 === testOptions[1]) &&
          (!v.option3 || v.option3 === testOptions[2]),
      );

      const available = !!(match && match.available);
      const label = input.nextElementSibling;
      input.classList.toggle('variant-disabled', !available);
      label?.classList.toggle?.('opacity-50', !available);
    });
  }

  /* ---------- TOTAL PRICE ---------- */

  calculateTotalPrice() {
    let total = 0;

    const baseCents = this.getCurrentVariantPriceCents();
    if (Number.isFinite(baseCents)) total += baseCents;

    const checkedAddons = this.element.querySelectorAll('.pdp-addon-product-card__checkbox:checked[data-price]');
    checkedAddons.forEach((input) => {
      const price = parseFloat(input.getAttribute('data-price')) || 0;
      total += price;
    });

    const checkedAccessories = this.element.querySelectorAll(
      '.pdp-accessory-product-card__checkbox:checked[data-price]',
    );
    checkedAccessories.forEach((input) => {
      const price = parseFloat(input.getAttribute('data-price')) || 0;
      const productId = input.getAttribute('data-productid');
      const qtyInput = this.element.querySelector(`.quantity-input[data-productid="${productId}"]`);
      const qty = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;
      total += price * qty;
    });

    return total;
  }

  updatePriceButtonATC() {
    const total = this.calculateTotalPrice();
    const formatted = Shopify.formatMoney(total, window.theme.moneyFormat);

    this.element.querySelectorAll('.product__atc-button .button-total-price').forEach((span) => {
      const button = span.closest('.product__atc-button');
      if (button && button.hasAttribute('disabled')) return;
      span.textContent = ` - ${formatted}`;
    });
  }

  /* ---------- STICKY ATC ---------- */

  // ✅ Make sure we always have the sticky wrapper (important after DOM swaps)
  ensureStickyRefs() {
    if (!this.stickyAtcWrapper) {
      this.stickyAtcWrapper = this.element.querySelector('.pdp-sticky-product-atc, .product-module__sticky-atc');
    }
    if (!this.mainAtc) {
      this.mainAtc = this.element.querySelector('.product-info__actions');
    }
  }

  hideStickyTimeout() {
    this.ensureStickyRefs();
    if (!this.stickyAtcWrapper) return;

    this.stickyAtcWrapper.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('has-sticky');

    this.hideSticky = true;
    setTimeout(() => {
      this.hideSticky = false;
      this.showStickyAtc();
    }, 3000);
  }

  _measureStickyLayout() {
    const footer = document.querySelector('footer');
    this._stickyFooterH = footer ? footer.offsetHeight : 0;
    this._stickyBodyH = document.body.offsetHeight;
  }

  showStickyAtc() {
    this.ensureStickyRefs();
    if (!this.options['sticky_atc']) return;
    if (!this.stickyAtcWrapper || this.hideSticky) return;

    const footer = document.querySelector('footer');

    this._measureStickyLayout();
    if (!this._stickyResizeListener) {
      this._stickyResizeListener = responsive.addResizeListener(this, this._measureStickyLayout);
    }

    // Desktop
    if (window.matchMedia('(min-width: 1025px)').matches) {
      if (this._desktopStickyBound) return;
      this._desktopStickyBound = true;

      // Replace per-scroll getBoundingClientRect with IO flag
      if (this.mainAtc && !this._stickyMainAtcObserver) {
        this._stickyMainAtcObserver = new IntersectionObserver(
          (entries) => {
            this._stickyMainAtcVisible = entries[0]?.isIntersecting ?? false;
            this._evaluateDesktopSticky();
          },
          { root: null, threshold: 0 },
        );
        this._stickyMainAtcObserver.observe(this.mainAtc);
      }

      this._evaluateDesktopSticky = () => {
        if (this.hideSticky) return;
        const shouldShow = window.scrollY > 150;
        const bottomOffset = footer ? this._stickyFooterH - 60 : 100;
        const atTheBottom = window.innerHeight + window.scrollY >= this._stickyBodyH - bottomOffset;
        this.toggleStickyAtc(shouldShow && !atTheBottom && !this._stickyMainAtcVisible);
      };

      this._desktopStickyScrollListener = scrollListener.addScrollListener(this, this._evaluateDesktopSticky);
      this._evaluateDesktopSticky();
      return;
    }

    // Mobile: observer on main ATC visibility
    if (!this.mainAtc) return;

    if (this._atcObserver) {
      try {
        this._atcObserver.disconnect();
      } catch (e) {}
      this._atcObserver = null;
    }

    this._atcObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const isVisible = entry.isIntersecting;
          const bottomOffset = footer ? this._stickyFooterH - 60 : 100;
          const atTheBottom = window.innerHeight + window.scrollY >= this._stickyBodyH - bottomOffset;
          if (atTheBottom) this.toggleStickyAtc(false);
          else this.toggleStickyAtc(!isVisible);
        });
      },
      { root: null, threshold: 0 },
    );

    this._atcObserver.observe(this.mainAtc);

    // bottom check (bind once)
    if (!this._mobileBottomScrollBound) {
      this._mobileBottomScrollBound = true;
      const onMobileBottomScroll = () => {
        const bottomOffset = footer ? this._stickyFooterH : 100;
        const atTheBottom = window.innerHeight + window.scrollY >= this._stickyBodyH - bottomOffset;
        if (atTheBottom) this.toggleStickyAtc(false);
      };
      this._mobileBottomScrollListener = scrollListener.addScrollListener(this, onMobileBottomScroll);
    }
  }

  toggleStickyAtc(show) {
    this.ensureStickyRefs();
    if (!this.stickyAtcWrapper) return;
    if (this.hideSticky) return;

    this.stickyAtcWrapper.setAttribute('aria-hidden', show ? 'false' : 'true');
    document.body.classList.toggle('has-sticky', !!show);
  }

  /* ---------- QTY MIRROR ---------- */

  setupQuantityMirror() {
    this.teardownQuantityMirror();
    this._qtyMirrorCleanup = () => this.teardownQuantityMirror();

    const getForms = () => {
      const mainForm = this.element.querySelector('.product-info__actions form[data-product-form]');
      const stickyForm =
        this.element.querySelector('.pdp-sticky-product-atc form[data-product-form]') ||
        this.element.querySelector('.product-module__sticky-atc form[data-product-form]');
      return { mainForm, stickyForm };
    };

    const getInputs = () => {
      const { mainForm, stickyForm } = getForms();

      let mainQty = mainForm?.querySelector('input[name="quantity"]') || null;
      if (!mainQty && mainForm?.id) {
        mainQty = this.element.querySelector(`input[name="quantity"][form="${CSS.escape(mainForm.id)}"]`);
      }

      const stickyQty = stickyForm?.querySelector('input[name="quantity"]') || null;
      return { mainQty, stickyQty };
    };

    const clampQty = (targetInput, raw) => {
      let v = parseInt(raw, 10);
      if (Number.isNaN(v)) v = 1;

      const min = targetInput?.min ? parseInt(targetInput.min, 10) : 1;
      const max = targetInput?.max ? parseInt(targetInput.max, 10) : null;

      if (!Number.isNaN(min)) v = Math.max(v, min);
      if (max && !Number.isNaN(max)) v = Math.min(v, max);

      return v;
    };

    const sync = (fromInput, toInput) => {
      if (!fromInput || !toInput) return;
      if (this._qtySyncing) return;

      this._qtySyncing = true;
      try {
        const v = clampQty(toInput, fromInput.value);
        if (String(toInput.value) !== String(v)) {
          toInput.value = v;
          toInput.dispatchEvent(new Event('input', { bubbles: true }));
          toInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
      } finally {
        this._qtySyncing = false;
      }
    };

    const bind = () => {
      const { mainQty, stickyQty } = getInputs();
      if (!mainQty || !stickyQty) return;

      this._mainQty = mainQty;
      this._stickyQty = stickyQty;

      sync(mainQty, stickyQty);

      this._onMainQtyInput = () => sync(mainQty, stickyQty);
      this._onStickyQtyInput = () => sync(stickyQty, mainQty);

      mainQty.addEventListener('input', this._onMainQtyInput);
      mainQty.addEventListener('change', this._onMainQtyInput);

      stickyQty.addEventListener('input', this._onStickyQtyInput);
      stickyQty.addEventListener('change', this._onStickyQtyInput);

      this._onQtyButtonClick = (e) => {
        const btn = e.target.closest('button[name="plus"], button[name="minus"]');
        if (!btn) return;

        setTimeout(() => {
          const { mainQty: m, stickyQty: s } = getInputs();
          if (!m || !s) return;

          if (btn.closest('.pdp-sticky-product-atc, .product-module__sticky-atc')) sync(s, m);
          else sync(m, s);
        }, 0);
      };

      this.element.addEventListener('click', this._onQtyButtonClick, true);
    };

    bind();
    this._qtyMirrorRebindTimer = setTimeout(bind, 50);
  }

  teardownQuantityMirror() {
    if (this._qtyMirrorRebindTimer) {
      clearTimeout(this._qtyMirrorRebindTimer);
      this._qtyMirrorRebindTimer = null;
    }

    if (this._mainQty && this._onMainQtyInput) {
      this._mainQty.removeEventListener('input', this._onMainQtyInput);
      this._mainQty.removeEventListener('change', this._onMainQtyInput);
    }

    if (this._stickyQty && this._onStickyQtyInput) {
      this._stickyQty.removeEventListener('input', this._onStickyQtyInput);
      this._stickyQty.removeEventListener('change', this._onStickyQtyInput);
    }

    if (this._onQtyButtonClick) {
      this.element.removeEventListener('click', this._onQtyButtonClick, true);
    }

    this._mainQty = null;
    this._stickyQty = null;
    this._onMainQtyInput = null;
    this._onStickyQtyInput = null;
    this._onQtyButtonClick = null;
  }

  /* ---------- MISC / YOUR EXISTING METHODS ---------- */

  reloadPage() {
    window.location.reload();
  }

  changeImageQuality() {
    const imageToReveal = this.element.querySelector('.ProductSlider--ImageFirst');
    if (imageToReveal !== null) {
      const replaceUrl = this.element.querySelector('.ProductSlider--ImageFirst')?.getAttribute('data-src')?.replace('{width}x', '2600x');
      if (replaceUrl) imageToReveal.src = replaceUrl;
    }
  }

  bindColorHoverPreview() {
    const currentLabelEl = this.element.querySelector('.connected-products-option-info--current');
    if (!currentLabelEl) return;

    if (!currentLabelEl.dataset.originalText) {
      currentLabelEl.dataset.originalText = (currentLabelEl.textContent || '').trim();
    }

    this._colorHoverUnbinders.forEach((off) => {
      try {
        off();
      } catch (e) {}
    });
    this._colorHoverUnbinders = [];

    const links = this.element.querySelectorAll('.filterColor--item a[data-action="handle-reload"]');

    links.forEach((link) => {
      const item = link.closest('.filterColor--item');
      if (!item) return;

      const input = item.querySelector('input[id^="Color-"]');
      const prettyName = (input?.id?.slice(6) || '').replace(/-/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase());

      const enter = () => {
        if (prettyName) currentLabelEl.textContent = prettyName;
      };
      const leave = () => {
        currentLabelEl.textContent = currentLabelEl.dataset.originalText || '';
      };

      link.addEventListener('mouseenter', enter);
      link.addEventListener('mouseleave', leave);

      this._colorHoverUnbinders.push(() => {
        link.removeEventListener('mouseenter', enter);
        link.removeEventListener('mouseleave', leave);
      });
    });
  }

  initReloadWithoutRefresh() {
    sessionStorage.setItem('elementaryLoad', 'true');

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => {
        this.preloadConnectedProducts?.();
        this.preloadVariants?.();
      });
    } else {
      this.preloadConnectedProducts?.();
      this.preloadVariants?.();
    }
  }

  // keep your existing preloadConnectedProducts/preloadVariants/updateContentWithoutReload/fetchAndNavigate
  // (not included here because you asked specifically for ProductElement;
  //  paste your existing ones below this class if they’re outside)

  reinitializeAfterContentUpdate() {
    // Re-grab refs after innerHTML swap
    this.carousel = null;
    this.uspSwiper = null;

    this.carouselElement = this.element.querySelector('.mainSwiper');
    this.carouselElementThumbs = this.element.querySelector('.main-product__thumbs');
    this.uspSwiperElement = this.element.querySelector('.product-usp__swiper.swiper');
    this.mainAtc = this.element.querySelector('.product-info__actions');
    this.stickyAtcWrapper = this.element.querySelector('.pdp-sticky-product-atc, .product-module__sticky-atc');

    this.options = JSON.parse(this.element.getAttribute('data-section-settings') || '{}');

    const slides = this.carouselElement?.querySelectorAll('.swiper-slide') || [];
    if (slides.length > 1) {
      this.carousel = new RevolutionSwiper(this.carouselElement, this.carouselElementThumbs);
    } else {
      this.element.querySelectorAll('.pdp_swiperButton').forEach((btn) => (btn.style.display = 'none'));
    }

    if (slides.length <= 1) this.element.classList.add('has-single-image');
    else this.element.classList.remove('has-single-image');

    if (this.options['enable_zoom']) {
      setTimeout(() => {
        try {
          const zoom = new RevolutionImageZoom(this.element, this.carousel);
          zoom.syncHeight = zoom.syncHeight.bind(zoom);
          responsive.addResizeListener(zoom, zoom.syncHeight);
        } catch (err) {
          console.warn('⚠️ Zoom failed', err);
        }
      }, 200);
    }

    if (this.uspSwiperElement) this.uspSwiper = new RevolutionSwiper(this.uspSwiperElement);

    new AddToCart(this.element);

    // Rebind events + behaviors
    this.bindEvents();
    this.setupQuantityMirror();
    this.bindColorHoverPreview();
    this.updateNotifyButtonState();

    if (this.options['sticky_atc']) {
      document.body.classList.add('has-sticky');
      setTimeout(() => this.showStickyAtc?.(), 200);
    } else {
      document.body.classList.remove('has-sticky');
    }

    this.updatePriceButtonATC();
    this.changeImageQuality();

    // ✅ force correct availability after DOM swap
    const v = this.getCurrentVariantFromSection();
    if (v) this.applyVariantAvailabilityUI(!!v.available);

    setTimeout(() => {
      const swiperEl = this.element.querySelector('#productSwiperElement') || document.querySelector('#productSwiperElement');
      const awardsEl = document.querySelector('.product-awards_wrapper');
      if (swiperEl && awardsEl && swiperEl.swiper) {
        const swiper = swiperEl.swiper;
        const toggleAwards = () => {
          awardsEl.style.display = swiper.activeIndex === 0 ? 'flex' : 'none';
        };
        toggleAwards();
        swiper.on('slideChange', toggleAwards);
      }
    }, 100);

    const forms = this.element.querySelectorAll('form[data-product-form]');
    forms.forEach((form) => {
      const atcWrapper = form.querySelector('.add-to-cart__wrapper');
      const notifyWrapper = form.querySelector('.notify-wrapper');
      const idInput = form.querySelector('input[name="id"]');
      const variantId = idInput?.value;
      if (!variantId) return;
      const variantData = this.element.querySelector('variant-selects script[type="application/json"]');
      if (!variantData) return;
      try {
        const variants = JSON.parse(variantData.textContent);
        const currentVariant = variants.find((v) => v.id == variantId);
        if (!currentVariant) return;
        if (currentVariant.available) {
          atcWrapper?.classList.remove('hideBtn');
          notifyWrapper?.classList.add('hideBtn');
        } else {
          atcWrapper?.classList.add('hideBtn');
          notifyWrapper?.classList.remove('hideBtn');
        }
      } catch (err) {}
    });
  }

  updateNotifyButtonState() {
    const translationsEl = document.querySelector('#notify-translations');
    if (!translationsEl) return;

    const soldOutText = translationsEl.dataset.soldOut || '';
    const outOfStockText = translationsEl.dataset.outOfStock || '';

    const hasPopup = !!document.querySelector('notify-me-popup');

    this.element.querySelectorAll(".notify-wrapper button, .notify-wrapper [role='button']").forEach((notifyBtn) => {
      const txtEl = notifyBtn.querySelector('.button-txt');
      if (!txtEl) return;
      const isSoldOutMode = notifyBtn.dataset.oosMode === 'sold_out';

      if (hasPopup) {
        txtEl.textContent = soldOutText;
        if (isSoldOutMode) {
          notifyBtn.setAttribute('disabled', 'disabled');
          notifyBtn.setAttribute('aria-disabled', 'true');
          notifyBtn.setAttribute('tabindex', '-1');
          notifyBtn.removeAttribute('data-action');
          notifyBtn.removeAttribute('aria-controls');
        } else {
          notifyBtn.removeAttribute('disabled');
          notifyBtn.setAttribute('aria-disabled', 'false');
          notifyBtn.removeAttribute('tabindex');
          notifyBtn.setAttribute('data-action', 'toggle-popup');
          notifyBtn.setAttribute('aria-controls', 'notify-me-popup');
        }
      } else {
        txtEl.textContent = outOfStockText;
        notifyBtn.setAttribute('disabled', 'disabled');
        notifyBtn.setAttribute('aria-disabled', 'true');
        notifyBtn.setAttribute('tabindex', '-1');
        notifyBtn.removeAttribute('data-action');
        notifyBtn.removeAttribute('aria-controls');
      }
    });
  }

  async fetchAndNavigate(url) {
    const currentProductComponent = document.querySelector('product-component');
    if (currentProductComponent) {
      currentProductComponent.style.opacity = '0.5';
      currentProductComponent.style.pointerEvents = 'none';
    }

    try {
      const response = await fetch(url);
      if (response.ok) {
        const htmlContent = await response.text();
        const parser = new DOMParser();
        const doc = parser.parseFromString(htmlContent, 'text/html');

        contentCache[url] = doc;

        if (currentProductComponent) {
          currentProductComponent.style.opacity = '';
          currentProductComponent.style.pointerEvents = '';
        }

        this.updateContentWithoutReload({
          preventDefault: () => {},
          target: { closest: () => ({ href: url }) },
        });
      } else {
        window.location.href = url;
      }
    } catch (error) {
      window.location.href = url;
    }
  }

  runPDPAnimations() {
    const items = this.element.querySelectorAll('[data-animation]:not([data-loaded])');
    const delay = window.theme.animationBetweenElements || 50;

    items.forEach((item, i) => {
      if (!item.classList.contains('animatedContent')) {
        item.classList.add('animatedContent');
      }
      item.style.setProperty('--animation-delay', `${delay * i}ms`);
    });

    requestAnimationFrame(() => {
      items.forEach((item) => {
        item.setAttribute('data-loaded', 'true');
      });
    });
  }

  scrollToFirstReviewTarget(e) {
    e?.preventDefault?.();
    e?.stopPropagation?.();

    const reviewSelectors = [
      '#klaviyo-reviews-summary',
      '#klaviyo-reviews-list',
      '#fulfilled-reviews-all',
    ];

    const nodes = reviewSelectors
      .map((sel) => document.querySelector(sel))
      .filter(Boolean);

    if (!nodes.length) return;

    nodes.sort((a, b) => {
      if (a === b) return 0;
      const pos = a.compareDocumentPosition(b);
      if (pos & Node.DOCUMENT_POSITION_FOLLOWING) return -1;
      if (pos & Node.DOCUMENT_POSITION_PRECEDING) return 1;
      return 0;
    });

    const targetNow = nodes[0];
    if (!targetNow) return;

    targetNow.scrollIntoView({
      behavior: 'smooth',
      block: 'start',
    });
  }

  /**
   * Force Klaviyo review list sort to highest (one-shot).
   * Prefers an option whose label contains "highest"; falls back to value "1".
   * Observes document only until all matching selects are applied, then disconnects.
   * Requires Sorting enabled on the Klaviyo Review list widget.
   */
  initKlaviyoHighestSort() {
    const SORT_SELECTOR = '[id="kl_reviews__sort_by_reviews"]';
    const FALLBACK_VALUE = '1';
    const DEBOUNCE_MS = 100;
    const APPLY_DELAY_MS = 50;

    this._klaviyoSortTimeouts = this._klaviyoSortTimeouts || [];

    const findHighestOption = (select) => {
      const options = Array.from(select.options || []);
      const byLabel = options.find((opt) =>
        (opt.textContent || '').toLowerCase().includes('highest'),
      );
      if (byLabel) return byLabel;
      return options.find((opt) => opt.value === FALLBACK_VALUE) || null;
    };

    const applyToSelect = (select) => {
      if (!(select instanceof HTMLSelectElement)) return;
      if (!select.isConnected) return;

      const option = findHighestOption(select);
      if (!option) return;

      select.focus();

      const nativeSetter = Object.getOwnPropertyDescriptor(
        HTMLSelectElement.prototype,
        'value',
      )?.set;
      if (nativeSetter) {
        nativeSetter.call(select, option.value);
      } else {
        select.value = option.value;
      }

      option.selected = true;
      select.selectedIndex = option.index;
      select.dispatchEvent(new Event('input', { bubbles: true }));
      select.dispatchEvent(new Event('change', { bubbles: true }));

      option.click();
      select.click();
    };

    const stopWatching = () => {
      if (this._klaviyoSortObserver) {
        try {
          this._klaviyoSortObserver.disconnect();
        } catch (e) {}
        this._klaviyoSortObserver = null;
      }
      if (this._klaviyoSortDebounceT) {
        clearTimeout(this._klaviyoSortDebounceT);
        this._klaviyoSortDebounceT = null;
      }
    };

    const tryApply = () => {
      const selects = Array.from(document.querySelectorAll(SORT_SELECTOR)).filter(
        (el) => el instanceof HTMLSelectElement,
      );
      if (!selects.length) return;

      selects.forEach((select) => {
        if (select.dataset.highestSortApplied === 'true') return;
        if (!findHighestOption(select)) return;

        // Mark immediately so debounced retries don't queue duplicates.
        select.dataset.highestSortApplied = 'true';

        const timeoutId = setTimeout(() => applyToSelect(select), APPLY_DELAY_MS);
        this._klaviyoSortTimeouts.push(timeoutId);
      });

      // All found selects ready + applied — stop observing (no quick-load remount).
      const allApplied = selects.every((select) => select.dataset.highestSortApplied === 'true');
      if (allApplied) stopWatching();
    };

    const scheduleTryApply = () => {
      if (this._klaviyoSortDebounceT) clearTimeout(this._klaviyoSortDebounceT);
      this._klaviyoSortDebounceT = setTimeout(() => {
        this._klaviyoSortDebounceT = null;
        tryApply();
      }, DEBOUNCE_MS);
    };

    tryApply();

    if (this._klaviyoSortObserver) {
      try {
        this._klaviyoSortObserver.disconnect();
      } catch (e) {}
    }

    // Temporary document watch until widget mounts; disconnects after successful apply.
    this._klaviyoSortObserver = new MutationObserver(scheduleTryApply);
    this._klaviyoSortObserver.observe(document.documentElement, {
      childList: true,
      subtree: true,
    });
  }
}

customElements.define('product-component', ProductElement);

class VariantSelectBox extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this._resizeHandler = null;
  }

  connectedCallback() {
    this.selectBoxWrapper =
      this.selectBoxWrapper ||
      this.querySelector('.variant-selectbox__items') ||
      this.querySelector('.RevolutionSelectbox') ||
      this;

    this.variants =
      this.variants ||
      Array.from(
        this.querySelectorAll('[data-variant-item], .variant-item, .Selectbox, .RevolutionSelectbox--Item'),
      ).filter(Boolean);

    this.plusButton = this.plusButton || this.querySelector('[data-action="show-more"]');
    this.minusButton = this.minusButton || this.querySelector('[data-action="show-less"]');
    this.totalVariants = this.variants?.length || 0;

    this.observeResize();
    this.bindEvents();
    this.calculateLayout();
  }

  disconnectedCallback() {
    try {
      this.delegateElement?.off?.();
    } catch (e) {}
    this.delegateElement = null;

    if (typeof responsive !== 'undefined' && responsive.removeResizeListener) {
      try {
        responsive.removeResizeListener(this, this.handleResize);
      } catch (e) {}
    } else if (this._resizeHandler) {
      window.removeEventListener('resize', this._resizeHandler);
    }
    this._resizeHandler = null;
  }

  observeResize() {
    this.handleResize = this.handleResize.bind(this);

    if (typeof responsive !== 'undefined' && responsive.addResizeListener) {
      responsive.addResizeListener(this, this.handleResize);
    } else {
      this._resizeHandler = this.handleResize;
      window.addEventListener('resize', this._resizeHandler);
    }
  }

  bindEvents() {
    if (!this.selectBoxWrapper) return;

    try {
      this.delegateElement?.off?.();
    } catch (e) {}

    this.delegateElement = new Delegate(this.selectBoxWrapper);
    this.delegateElement.on('click', '[data-action="show-more"]', this.showAllVariants.bind(this));
    this.delegateElement.on('click', '[data-action="show-less"]', this.showLessVariants.bind(this));
  }

  calculateLayout() {
    if (!this.selectBoxWrapper || !this.variants || !this.variants.length) {
      if (this.plusButton) this.plusButton.style.display = 'none';
      if (this.minusButton) this.minusButton.style.display = 'none';
      return;
    }

    this.variants.forEach((variant) => {
      variant.style.display = '';
    });
    if (this.plusButton) this.plusButton.style.display = '';
    if (this.minusButton) this.minusButton.style.display = 'none';

    const availableWidth = this.selectBoxWrapper.offsetWidth;
    if (!availableWidth) return;

    this.totalVariants = this.variants.length;

    const singleVariantWidth = this.variants[0].offsetWidth || 0;
    const variantGap = 8;
    const plusButtonWidth = this.plusButton ? this.plusButton.offsetWidth : 0;

    let itemsInFirstRow = 0;
    let totalWidthSoFar = 0;

    for (let i = 0; i < this.variants.length; i++) {
      const widthNeeded = variantGap + singleVariantWidth;
      const stillMoreVariantsRemain = i < this.variants.length - 1;
      const spaceNeededForPlus = stillMoreVariantsRemain ? plusButtonWidth : 0;

      if (totalWidthSoFar + widthNeeded + spaceNeededForPlus <= availableWidth) {
        itemsInFirstRow++;
        totalWidthSoFar += widthNeeded;
      } else {
        break;
      }
    }

    if (itemsInFirstRow >= this.totalVariants) {
      if (this.plusButton) this.plusButton.style.display = 'none';
      if (this.minusButton) this.minusButton.style.display = 'none';
    } else {
      this.variants.forEach((variant, idx) => {
        variant.style.display = idx < itemsInFirstRow ? '' : 'none';
      });

      if (this.plusButton) {
        this.remaining = this.totalVariants - itemsInFirstRow;
        this.plusButton.style.display = '';
        this.plusButton.innerText = `+ ${this.remaining} more`;
      }
      if (this.minusButton) this.minusButton.style.display = 'none';
    }
  }

  handleResize() {
    this.calculateLayout();
  }

  showAllVariants(event) {
    event?.preventDefault?.();
    (this.variants || []).forEach((variant) => {
      variant.style.display = '';
    });
    if (this.plusButton) this.plusButton.style.display = 'none';
    if (this.minusButton) {
      const remaining = this.remaining ?? Math.max(0, (this.totalVariants || 0) - 1);
      this.minusButton.innerText = `- ${remaining} less`;
      this.minusButton.style.display = '';
    }
  }

  showLessVariants(event) {
    event?.preventDefault?.();
    this.calculateLayout();
  }
}

customElements.define('variant-selectbox', VariantSelectBox);

/* =========================
   variant-selects (THIS is the main fix)
   - supports options[...] inputs
   - scopes everything to the current product-component
   - after renderProductInfo swap: re-applies JS price attributes
   - dispatches variant:price-updated reliably
   ========================= */
class VariantSelects extends HTMLElement {
  constructor() {
    super();

    this.element = this;
    this.type = this.element.getAttribute('data-type');
    this.productID = this.element.getAttribute('data-product-id');

    this.isUpsell =
      this.element.classList.contains('upsell-variants') ||
      !!this.closest('.upsell-product') ||
      !!this.closest('form.upsell-form');

    this.delegateElement = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);

    this._availabilitySyncing = false;

    this._onChange = this.onVariantChange.bind(this);
    this._onClickAtc = this.clickAtc.bind(this);
    this._onQtyBtnClick = () => this.initAccessoryStateSync?.();

    this.metafieldsCache = null;

    // bind only listeners here (no logic that depends on DOM state)
    this.bindEvents();
  }

  connectedCallback() {
    if (!this.isUpsell) this.preselectFromUrlOrInput();

    // cache metafields map once (instant updates, no fetch delay)
    this.hydrateMetafieldsCache();

    queueMicrotask(() => {
      this.onVariantChange();
      document.dispatchEvent(new CustomEvent('variant:price-updated'));
    });
  }

  disconnectedCallback() {
    try {
      this.delegateElement?.off?.();
    } catch (e) {}
    try {
      this.delegateBody?.off?.();
    } catch (e) {}
    this.delegateElement = null;
    this.delegateBody = null;
  }

  getRoot() {
    return this.closest('product-component') || document;
  }

  refreshUIRefs() {
    const root = this.getRoot();
    this.atcButtons = root.querySelectorAll('.product__atc-button');
    this.notifyButtons = root.querySelectorAll('.product-module__product-atc-notify');
    this.stickyAtcWrapper = root.querySelector('.product-module__sticky-atc, .pdp-sticky-product-atc');
    this.notifyStickyAddButton = root.querySelector('.product-module__product-atc');
    this.pricesWrapper = root.querySelector('.product-info__price');

    this.shortDescriptionEl = root.querySelector('.product-info__short-description');
    this.lowestPriceStockEl = root.querySelector('.product-info__price-stock');
    this.lowestPriceEl = root.querySelector('.product-info__price--lowest');
    this.lowestPriceValueEl = root.querySelector('.product-info__price--lowest span');
  }

  bindEvents() {
    // ✅ listen to both options[...] and any legacy inputs
    this.delegateElement.on(
      'change',
      'select, input, input[name^="options["], select[name^="options["]',
      this._onChange,
    );

    if (!this.isUpsell) {
      this.delegateBody.on('click', '[data-action="click-atc"]', this._onClickAtc);
      this.delegateElement.on('click', '.quantity-btn.increase, .quantity-btn.decrease', this._onQtyBtnClick);
    }
  }

  clickAtc(event) {
    event.preventDefault();
    const root = this.getRoot();
    const btn = root.querySelector('.product-info__actions .product__atc-button');
    if (btn) btn.click();
  }

  setNoVariantsFlag() {
    const root = this.closest('product-component');
    if (!root) return;

    const data = this.getVariantData();
    const noVariants = !Array.isArray(data) || data.length <= 1;
    root.dataset.noVariants = noVariants ? 'true' : 'false';
  }

  hydrateMetafieldsCache() {
    const root = this.getRoot();
    const node = root.querySelector('[data-variant-metafields-cache]');
    if (!node) return;

    try {
      this.metafieldsCache = JSON.parse(node.textContent || '{}');
    } catch (e) {
      this.metafieldsCache = null;
    }
  }

  updateMetafieldsFromCache() {
    if (!this.currentVariant) return;
    if (!this.metafieldsCache?.variants) return;

    const root = this.getRoot();
    const entry = this.metafieldsCache.variants[String(this.currentVariant.id)];
    if (!entry) return;

    // short description (already HTML-safe from Liquid json)
    if (this.metafieldsCache.short_enabled) {
      const html = entry.short || '';
      const existing = root.querySelector('.product-info__short-description');

      if (html) {
        if (existing) existing.innerHTML = html;
        else {
          const anchor =
            root.querySelector('.title-price__wrapper .pdp-rating') ||
            root.querySelector('.title-price__wrapper .product-title_price-header') ||
            root.querySelector('.title-price__wrapper');
          if (anchor?.classList.contains('title-price__wrapper')) {
            anchor.insertAdjacentHTML('beforeend', `<div class="product-info__short-description u-p3">${html}</div>`);
          } else if (anchor) {
            anchor.insertAdjacentHTML('afterend', `<div class="product-info__short-description u-p3">${html}</div>`);
          }
        }
      } else if (existing) {
        existing.remove();
      }
    }

    // lowest price cents (already cents from Liquid)
    if (this.metafieldsCache.lowest_enabled) {
      const cents = Number(entry.lowest_cents || 0);
      const stockWrap = root.querySelector('.product-info__price-stock');
      const lowestWrap = root.querySelector('.product-info__price--lowest');
      const valueEl = root.querySelector('.product-info__price--lowest span');

      if (cents > 0) {
        if (valueEl) {
          const moneyFormat = window.theme?.moneyFormatWithCurrency || window.theme?.moneyFormat || '{{amount}}';
          const code = window.Shopify?.currency?.active;
          const base = Shopify.formatMoney(cents, moneyFormat);
          valueEl.textContent = base;
        }
        if (stockWrap) stockWrap.style.display = '';
        if (lowestWrap) lowestWrap.style.display = '';
      } else {
        if (lowestWrap) lowestWrap.style.display = 'none';
      }
    }
  }

  preselectFromUrlOrInput() {
    const data = this.getVariantData();
    if (!Array.isArray(data) || !data.length) return;

    const root = this.getRoot();

    // 1) respect ?variant=
    const urlVariantId = new URL(window.location.href).searchParams.get('variant');
    let targetVariant = urlVariantId ? data.find((v) => String(v.id) === String(urlVariantId)) : null;

    // 2) fallback to current hidden input (if theme set something)
    if (!targetVariant) {
      const input = root.querySelector(`#product-form-${this.productID} input[name="id"]`);
      const currentId = input?.value;
      targetVariant = currentId ? data.find((v) => String(v.id) === String(currentId)) : null;
    }

    // 3) if none OR sold out -> first available, else first
    if (!targetVariant || !targetVariant.available) {
      targetVariant = data.find((v) => v.available) || data[0];
    }

    if (!targetVariant) return;

    // Apply options to selectors (options[...] radios/selects)
    const optionInputs = root.querySelectorAll('input[name^="options["], select[name^="options["]');
    if (optionInputs.length) {
      (targetVariant.options || []).forEach((optValue, idx) => {
        const radios = root.querySelectorAll(`input[name="options[${idx}]"][type="radio"]`);
        if (radios.length) {
          const match = Array.from(radios).find((r) => r.value === optValue);
          if (match) match.checked = true;
        } else {
          const select = root.querySelector(`select[name="options[${idx}]"]`);
          if (select) select.value = optValue;
        }
      });
    } else {
      // legacy fallback
      (targetVariant.options || []).forEach((optValue, idx) => {
        const position = idx + 1;
        const radios = this.querySelectorAll(`input[type="radio"][name="option-${this.productID}-${position}"]`);
        if (radios?.length) {
          const match = Array.from(radios).find((r) => r.value === optValue);
          if (match) match.checked = true;
        } else {
          const selects = this.querySelectorAll('select');
          if (selects && selects[idx]) selects[idx].value = optValue;
        }
      });
    }

    // Set variant id on main product forms only (exclude upsell forms)
    root.querySelectorAll('form[data-product-form]:not(.upsell-form) input[name="id"]').forEach((inp) => {
      inp.value = targetVariant.id;
      inp.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  onVariantChange() {
    if (!this.isUpsell) this.refreshUIRefs();

    this.updateOptions();
    this.updateOptionAvailability();
    this.updateMasterId();
    if (!this.currentVariant) return;

    this.updateSelectedTexts();
    this.updateVariantInput();

    if (this.isUpsell) {
      this.updateUpsellAvailabilityUI();
      return;
    }

    this.toggleAddButton();
    this.updateAvailability();
    this.updatePdpPricesUI();
    this.updateStickyAtcUI();
    this.updateStockUI();

    // instant (no fetch) metafields update
    this.updateMetafieldsFromCache();

    this.updateLowestPrice();
    this.updateMedia();
    this.updateURL();

    this.renderProductInfo();

    document.dispatchEvent(new CustomEvent('variant:price-updated'));
  }

  updateOptions() {
    const root = this.getRoot();

    const radios = Array.from(root.querySelectorAll('input[name^="options["]:checked')).map((el) => el.value);
    const selects = Array.from(root.querySelectorAll('select[name^="options["]')).map((el) => el.value);

    if (radios.length || selects.length) {
      this.options = radios.length ? radios : selects;
      return;
    }

    this.options = Array.from(this.querySelectorAll('select, input:checked'), (el) => el.value);
  }

  updateMasterId() {
    const data = this.getVariantData();
    if (!Array.isArray(data) || !data.length) {
      this.currentVariant = null;
      return null;
    }

    const opts = Array.isArray(this.options) ? this.options : [];
    if (!opts.length) {
      this.currentVariant = null;
      return null;
    }

    this.currentVariant =
      data.find((v) => {
        if (!v) return false;
        if (Array.isArray(v.options) && v.options.length) {
          return v.options.every((val, idx) => (opts[idx] ? opts[idx] === val : true));
        }
        return (
          (!v.option1 || v.option1 === opts[0]) &&
          (!v.option2 || v.option2 === opts[1]) &&
          (!v.option3 || v.option3 === opts[2])
        );
      }) || null;

    return this.currentVariant;
  }

  updateOptionAvailability() {
    if (this._availabilitySyncing) return;

    const data = this.getVariantData();
    if (!Array.isArray(data) || !data.length) return;

    const optionCount = data[0]?.options?.length || 0;
    if (!optionCount) return;

    const selections = Array.isArray(this.options) ? [...this.options] : [];

    const isOptionValueAvailable = (positionIndex, value) => {
      for (let i = 0; i < data.length; i++) {
        const v = data[i];
        if (!v || !v.available) continue;
        if (v.options[positionIndex] !== value) continue;

        let ok = true;
        for (let p = 0; p < optionCount; p++) {
          if (p === positionIndex) continue;
          const sel = selections[p];
          if (sel && v.options[p] !== sel) {
            ok = false;
            break;
          }
        }
        if (ok) return true;
      }
      return false;
    };

    for (let pos = 0; pos < optionCount; pos++) {
      const root = this.getRoot();
      const radios = root.querySelectorAll(`input[type="radio"][name="options[${pos}]"]`).length
        ? root.querySelectorAll(`input[type="radio"][name="options[${pos}]"]`)
        : this.querySelectorAll(`input[type="radio"][name="option-${this.productID}-${pos + 1}"]`);

      if (radios && radios.length) {
        radios.forEach((input) => {
          const available = isOptionValueAvailable(pos, input.value);
          input.disabled = false;

          const wrapper = input.closest('.Selectbox');
          if (wrapper) wrapper.classList.toggle('is-disabled', !available);

          const label =
            root.querySelector(`label[for="${input.id}"]`) || this.querySelector(`label[for="${input.id}"]`);
          if (label) label.setAttribute('aria-disabled', (!available).toString());
        });

        continue;
      }

      const selects = root.querySelectorAll(`select[name="options[${pos}]"]`).length
        ? root.querySelectorAll(`select[name="options[${pos}]"]`)
        : this.querySelectorAll('select');

      const select = selects && selects[pos] ? selects[pos] : null;
      if (select) {
        Array.from(select.options).forEach((opt) => {
          const available = isOptionValueAvailable(pos, opt.value);
          opt.disabled = false;

          const wrapper = select.closest('.Selectbox');
          if (wrapper) wrapper.classList.toggle('is-disabled', !available);
        });
      }
    }
  }

  updateVariantInput() {
    if (!this.currentVariant) return;

    const root = this.getRoot();
    const inputs = root.querySelectorAll('form[data-product-form]:not(.upsell-form) input[name="id"]');
    inputs.forEach((inp) => {
      inp.value = this.currentVariant.id;
      inp.dispatchEvent(new Event('change', { bubbles: true }));
    });

    document.dispatchEvent(
      new CustomEvent('variant:id-changed', {
        detail: { productId: this.productID, variantId: this.currentVariant.id },
      }),
    );
  }

  updateUpsellAvailabilityUI() {
    const wrapper = this.closest('.upsell-product');
    const form = wrapper?.querySelector('form.upsell-form') || this.closest('form.upsell-form') || this.closest('form');
    if (!form) return;

    const submit = form.querySelector('button[type="submit"], [type="submit"]');
    if (!submit) return;

    submit.disabled = !this.currentVariant.available;
  }

  updatePdpPricesUI() {
    if (!this.currentVariant) return;

    const root = this.getRoot();
    const priceValueEls = root.querySelectorAll('.product-info__price--value');
    const compareEls = root.querySelectorAll('.product-info__price--compare');
    if (!priceValueEls.length) return;

    const moneyFormat = window.theme?.moneyFormatWithCurrency || window.theme?.moneyFormat || '{{amount}}';
    const code = window.Shopify?.currency?.active;

    const fmt = (cents) => {
      const base = Shopify.formatMoney(cents, moneyFormat);
      return base;
    };

    priceValueEls.forEach((el) => {
      el.setAttribute('data-price', String(this.currentVariant.price));
      el.textContent = fmt(this.currentVariant.price);
    });

    const compare = this.currentVariant.compare_at_price;
    compareEls.forEach((el) => {
      if (compare && compare > this.currentVariant.price) {
        el.style.display = '';
        el.textContent = fmt(compare);
        el.setAttribute('data-price', String(compare));
      } else {
        el.textContent = '';
        el.removeAttribute('data-price');
        el.style.display = 'none';
      }
    });
  }

  updateStickyAtcUI() {
    if (!this.currentVariant) return;

    const root = this.getRoot();
    const stickyRoot = root.querySelector('.product-module__sticky-atc, .pdp-sticky-product-atc');
    if (!stickyRoot) return;

    const moneyFormat = window.theme?.moneyFormatWithCurrency || window.theme?.moneyFormat || '{{amount}}';
    const code = window.Shopify?.currency?.active;

    const fmt = (cents) => {
      const base = Shopify.formatMoney(cents, moneyFormat);
      return base;
    };

    stickyRoot
      .querySelectorAll('.product-module__price--current')
      .forEach((el) => (el.textContent = fmt(this.currentVariant.price)));

    const compare = this.currentVariant.compare_at_price;
    stickyRoot.querySelectorAll('.product-module__price--compare').forEach((el) => {
      if (compare && compare > this.currentVariant.price) {
        el.style.display = '';
        el.textContent = fmt(compare);
      } else {
        el.style.display = 'none';
        el.textContent = '';
      }
    });

    const variantTitle =
      this.currentVariant.public_title && this.currentVariant.public_title !== 'Default Title'
        ? this.currentVariant.public_title
        : this.currentVariant.title !== 'Default Title'
          ? this.currentVariant.title
          : '';

    stickyRoot.querySelectorAll('[data-sticky-variant-title]').forEach((el) => {
      el.textContent = variantTitle;
      el.style.display = variantTitle ? '' : 'none';
    });
  }

  updateStockUI() {
    if (!this.currentVariant) return;

    const root = this.getRoot();
    const stockEls = root.querySelectorAll('.product-info__stock');
    if (!stockEls.length) return;

    const inStockText = window.theme?.strings?.inStock || 'In stock';
    const outOfStockText = window.theme?.strings?.outOfStock || 'Out of stock';

    stockEls.forEach((el) => {
      if (this.currentVariant.available) {
        el.classList.remove('out-of-stock');
        el.classList.add('in-stock');
        el.innerHTML = `${inStockText}`;
      } else {
        el.classList.remove('in-stock');
        el.classList.add('out-of-stock');
        el.innerHTML = `${outOfStockText}`;
      }
    });
  }

  updateAvailability() {
    const availableSuccessDiv = document.querySelector('.availability-success__wrapper');
    const availableErrorDiv = document.querySelector('.availability-error__wrapper');

    if (!this.currentVariant) return;

    if (this.currentVariant.available) {
      if (availableSuccessDiv) availableSuccessDiv.setAttribute('aria-hidden', 'false');
      if (availableErrorDiv) availableErrorDiv.setAttribute('aria-hidden', 'true');
    } else {
      if (availableSuccessDiv) availableSuccessDiv.setAttribute('aria-hidden', 'true');
      if (availableErrorDiv) availableErrorDiv.setAttribute('aria-hidden', 'false');
    }
  }

  updateMedia() {
    if (this.isUpsell) return;
    if (!this.currentVariant?.featured_media) return;

    const newMedia = this.currentVariant.featured_media.id;
    if (!newMedia) return;

    this.element.dispatchEvent(new CustomEvent('variant:changed', { bubbles: true, detail: { new_image: newMedia } }));
  }

  updateURL() {
    if (this.isUpsell) return;
    if (!this.currentVariant) return;
    window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateLowestPrice() {
    const allMetaVariants = document.querySelectorAll('.lowest-price-meta');
    const lowestPriceInput = document.querySelectorAll('.product-info__price--lowest span');
    const lowestPriceDiv = document.querySelectorAll('.product-info__price--lowest');

    allMetaVariants.forEach((meta) => {
      if (meta.getAttribute('data-variant_id') == this.currentVariant.id) {
        const lowestPrice = meta.getAttribute('meta-data');

        lowestPriceInput.forEach((input) => {
          input.innerHTML = Shopify.formatMoney(lowestPrice * 100, window.theme.moneyFormat);
        });

        lowestPriceDiv.forEach((item) => {
          item.style.display = 'flex';
        });

        if (Number(lowestPrice) === 0) {
          lowestPriceDiv.forEach((item) => {
            item.style.display = 'none';
          });
        }
      }
    });
  }

  renderProductInfo() {
    if (this.isUpsell) return;
    if (!this.currentVariant?.id) return;

    const baseUrl = new URL(this.dataset.url, window.location.origin);
    baseUrl.searchParams.set('variant', String(this.currentVariant.id));
    baseUrl.searchParams.set('section_id', String(this.dataset.section));

    fetch(baseUrl.toString(), { credentials: 'same-origin' })
      .then((r) => r.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const selector = '.ProductInfo--Prices';

        const root = this.getRoot();
        const destinations = root.querySelectorAll(selector);
        const source = html.querySelector(selector);

        if (source && destinations.length) {
          destinations.forEach((destination) => {
            destination.innerHTML = source.innerHTML;
          });
        }

        this.updatePdpPricesUI();
        this.toggleAddButton();
        this.updateStickyAtcUI();

        document.dispatchEvent(new CustomEvent('variant:price-updated'));
      })
      .catch(() => {
        this.updatePdpPricesUI();
        document.dispatchEvent(new CustomEvent('variant:price-updated'));
      });
  }

  toggleAddButton() {
    if (!this.currentVariant || this.isUpsell) return;

    const root = this.getRoot();
    const available = !!this.currentVariant.available;
    
    const actions = root.querySelector('.product-info__actions');
    const sticky = root.querySelector('.product-module__sticky-atc, .pdp-sticky-product-atc');

    if (actions) {
      actions.querySelectorAll('.add-to-cart__wrapper').forEach((el) => el.classList.toggle('hideBtn', !available));
      actions.querySelectorAll('.notify-wrapper').forEach((el) => el.classList.toggle('hideBtn', available));
      actions.querySelectorAll('.QuantityHandler').forEach((el) => el.classList.toggle('hideBtn', !available));
    }

    if (sticky) {
      sticky.querySelectorAll('.add-to-cart__wrapper').forEach((el) => el.classList.toggle('hideBtn', !available));
      sticky.querySelectorAll('.notify-wrapper').forEach((el) => el.classList.toggle('hideBtn', available));
      sticky.querySelectorAll('.QuantityHandler').forEach((el) => el.classList.toggle('hideBtn', !available));
    }

    root.querySelectorAll('.product__atc-button').forEach((btn) => {
      const labelNode = btn.querySelector('.button-txt') || btn.querySelector('.ButtonText');
      if (!labelNode) return;

      if (!btn.dataset.originalAction) {
        btn.dataset.originalAction = btn.getAttribute('data-action') || '';
        btn.dataset.originalType = btn.getAttribute('type') || '';
        btn.dataset.originalAriaControls = btn.getAttribute('aria-controls') || '';
      }

      const context =
        btn.closest('.product-info__actions, .product-module__sticky-atc, .pdp-sticky-product-atc') || root;
      const notifyBtn =
        context.querySelector('.notify-wrapper:not(.hideBtn) .product-module__product-atc-notify') ||
        context.querySelector('.notify-wrapper .product-module__product-atc-notify');
      const notifyLabelNode = notifyBtn?.querySelector('.button-txt, .ButtonText');
      const notifyLabelText = notifyLabelNode?.textContent?.trim();
      const notifyMode = notifyBtn?.dataset?.oosMode || 'notify';
      const notifyIsDisabled = notifyMode === 'sold_out';
      const notifyAction = notifyBtn?.getAttribute('data-action');
      const notifyAriaControls = notifyBtn?.getAttribute('aria-controls');

      Array.from(labelNode.childNodes).forEach((n) => {
        if (n.nodeType === Node.TEXT_NODE) n.remove();
      });

      const inline = labelNode.querySelector('.atc-price-inline');
      const totalInLabel = labelNode.querySelector('.button-total-price');

      if (!available) {
        const outOfStockLabel = notifyLabelText || window.variantStrings?.soldOut || 'SOLD OUT';
        labelNode.insertBefore(document.createTextNode(outOfStockLabel), labelNode.firstChild);

        if (!notifyIsDisabled && notifyAction === 'toggle-popup') {
          btn.setAttribute('data-action', 'toggle-popup');
          btn.setAttribute('type', 'button');
          if (notifyAriaControls) btn.setAttribute('aria-controls', notifyAriaControls);
          btn.removeAttribute('disabled');
          btn.removeAttribute('aria-disabled');
          btn.removeAttribute('tabindex');
        }

        if (notifyIsDisabled) {
          btn.setAttribute('disabled', 'disabled');
          btn.setAttribute('aria-disabled', 'true');
          btn.setAttribute('tabindex', '-1');
          btn.removeAttribute('data-action');
          btn.setAttribute('type', 'button');
          btn.removeAttribute('aria-controls');
        } else {
          btn.removeAttribute('disabled');
          btn.removeAttribute('aria-disabled');
          btn.removeAttribute('tabindex');
        }

        if (inline) inline.remove();
        if (totalInLabel) totalInLabel.textContent = '';
        return;
      }

      labelNode.insertBefore(
        document.createTextNode((window.variantStrings?.addToCart || 'ADD TO CART').toUpperCase()),
        labelNode.firstChild,
      );
      if (btn.dataset.originalAction) btn.setAttribute('data-action', btn.dataset.originalAction);
      else btn.removeAttribute('data-action');
      if (btn.dataset.originalType) btn.setAttribute('type', btn.dataset.originalType);
      else btn.removeAttribute('type');
      if (btn.dataset.originalAriaControls) btn.setAttribute('aria-controls', btn.dataset.originalAriaControls);
      else btn.removeAttribute('aria-controls');
      btn.removeAttribute('disabled');
      btn.removeAttribute('aria-disabled');
      btn.removeAttribute('tabindex');

      if (inline && !labelNode.contains(inline)) labelNode.appendChild(inline);
      if (totalInLabel && !labelNode.contains(totalInLabel)) labelNode.appendChild(totalInLabel);
    });
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }

  updateSelectedTexts() {
    if (!this.currentVariant) return;

    this.querySelectorAll('[data-selected-text]').forEach((el) => {
      const index = parseInt(el.getAttribute('data-option-index'), 10);
      const value = this.currentVariant.options[index];
      if (value) el.textContent = value;
    });
  }
}

customElements.define('variant-selects', VariantSelects);

class ProductUspsSlider extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.transitionSpeedSliding = this.element.getAttribute("data-settings");
    this.enableAnimation = this.element.getAttribute("data-enable-animation") === "true";
    this.animWrapper = this.element.querySelector(
      ".pm__usps-slider--anim-wrapper"
    );
    this.original = this.element.querySelector(
      ".pm__usps-slider--duplicate-wrapper"
    );
    this.hasInitialized = false;
    this.currentAnimation = null;
    this.mobile = null; // Track breakpoint state to prevent unnecessary reinit
    this.isSafari = false;
    this.safariStyleSheet = null;
  }

  connectedCallback() {
    this.bindEvents();

    // clone USP slider into sticky on page load
    requestAnimationFrame(() => {
      this.cloneUspsSliderIntoSticky();
    });

    if (this.enableAnimation && this.transitionSpeedSliding) {
      this.visibilityObserver = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting && !this.hasInitialized) {
            // First time becoming visible - initialize
            this.hasInitialized = true;
            setTimeout(() => {
              this.handleBreakpointChange();
            }, 100);
          } else if (!entry.isIntersecting && this.hasInitialized) {
            // Pause animation when not visible to save performance
            if (this.isSafari && this.animWrapper) {
              this.animWrapper.style.animationPlayState = 'paused';
              this.animWrapper.style.webkitAnimationPlayState = 'paused';
            } else if (this.currentAnimation) {
              this.currentAnimation.pause();
            }
          } else if (entry.isIntersecting && this.hasInitialized) {
            // Resume animation when visible again
            if (this.isSafari && this.animWrapper) {
              this.animWrapper.style.animationPlayState = 'running';
              this.animWrapper.style.webkitAnimationPlayState = 'running';
            } else if (this.currentAnimation) {
              this.currentAnimation.play();
            }
          }
        });
      }, { threshold: 0.01 });

      this.visibilityObserver.observe(this.element);
    }
  }

  disconnectedCallback() {
    // Stop animation and clean up when element is removed
    this.stopAnimation();

    if (this.visibilityObserver) {
      this.visibilityObserver.disconnect();
    }

    // Clean up cart event listeners
    if (this.cartUpdateHandler) {
      document.removeEventListener('cart:updated', this.cartUpdateHandler);
    }
    if (this.cartRenderHandler) {
      document.removeEventListener('cart:render', this.cartRenderHandler);
    }

    // Clean up pause/play handlers
    if (this.pauseHandler) {
      this.element.removeEventListener("mouseenter", this.pauseHandler);
      this.element.removeEventListener("mouseleave", this.playHandler);
    }

    // Clean up Safari CSS animation
    if (this.safariStyleSheet) {
      this.safariStyleSheet.remove();
      this.safariStyleSheet = null;
    }

    // Reset state for fresh initialization
    this.hasInitialized = false;
  }

  bindEvents() {
    if (this.enableAnimation) {
      // Detect Safari/iOS for CSS animation fallback (must be before handlers that use it)
      // iOS forces ALL browsers to use WebKit, so we need to detect iOS devices too
      const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) ||
        (navigator.maxTouchPoints > 1 && /Macintosh/.test(navigator.userAgent));
      this.isSafari = isIOS || /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

      const debouncedFunc = debounce(this.handleBreakpointChange.bind(this), 100);
      responsive.addResizeListener(this, debouncedFunc);
      // Don't call handleBreakpointChange here - let IntersectionObserver handle it
      // this.handleBreakpointChange();

      // Pause animation during cart updates to prevent iOS stuttering
      this.cartUpdateHandler = () => {
        if (this.isSafari && this.animWrapper) {
          this.animWrapper.style.animationPlayState = 'paused';
          this.animWrapper.style.webkitAnimationPlayState = 'paused';
        } else if (this.currentAnimation) {
          this.currentAnimation.pause();
        }
      };

      this.cartRenderHandler = () => {
        // Resume animation after cart render completes
        requestAnimationFrame(() => {
          if (this.element.offsetParent !== null) {
            if (this.isSafari && this.animWrapper) {
              this.animWrapper.style.animationPlayState = 'running';
              this.animWrapper.style.webkitAnimationPlayState = 'running';
            } else if (this.currentAnimation) {
              this.currentAnimation.play();
            } else if (this.hasInitialized && !this.isSafari) {
              // Animation was lost, reinitialize it
              this.startAnimating();
            }
          }
        });
      };

      document.addEventListener('cart:updated', this.cartUpdateHandler);
      document.addEventListener('cart:render', this.cartRenderHandler);
    } else {
      // Static layout without animation
      this.original.style.width = "100%";
    }
  }

  cloneUspsSliderIntoSticky() {
    const original = document.querySelector('product-usps-slider');
    const stickyWrapper = document.querySelector('.Quantity-ATC--wrapper--sticky');

    if (!original || !stickyWrapper) return;

    // Spriječi dupli clone
    if (stickyWrapper.nextElementSibling?.matches('product-usps-slider')) return;

    const clone = original.cloneNode(true);

    // Makni ID da nema duplikata
    clone.removeAttribute('id');

    stickyWrapper.insertAdjacentElement('afterend', clone);
  }

  handleBreakpointChange() {
    const isDesktop = responsive.matchesBreakpoint("lap_and_up");
    const newMobileState = !isDesktop;

    // Only reinitialize if breakpoint actually changed, or if not yet initialized
    const breakpointChanged = this.mobile !== newMobileState;
    const needsInit = !this.hasInitialized || breakpointChanged;

    if (!needsInit) {
      return; // Skip if already initialized and breakpoint hasn't changed
    }

    this.mobile = newMobileState;

    if (isDesktop) {
      if (this.transitionSpeedSliding) {
        this.duplicateBlockWrappers();
      } else {
        Array.from(this.original.children).forEach(
          (block) => (block.style.display = "flex")
        );
      }
    } else {
      if (this.transitionSpeedSliding) {
        this.duplicateBlockWrappers();
      } else {
        this.original.style.justifyContent = "center";
      }
    }
  }

  resetWrapper() {
    // Remove all children except the first one (the original wrapper)
    while (this.animWrapper.children.length > 1) {
      this.animWrapper.removeChild(this.animWrapper.lastChild);
    }
  }

  duplicateBlockWrappers() {
    this.resetWrapper();

    const originalWidth = this.original.offsetWidth;

    // If width is 0, the element is not visible yet - skip initialization
    if (originalWidth === 0) {
      return;
    }

    // Check if there's only one item
    const itemCount = this.original.children.length;

    // If only one item, just center it without duplication or animation
    if (itemCount === 1) {
      this.original.style.width = `100%`;
      this.animWrapper.style.width = `100%`;
      this.animWrapper.style.position = "relative";
      this.original.style.justifyContent = "center";

      // Get computed padding values and add them to the height
      const computedStyle = window.getComputedStyle(this.element);
      const paddingTop = parseFloat(computedStyle.paddingTop) || 0;
      const paddingBottom = parseFloat(computedStyle.paddingBottom) || 0;
      const totalPadding = paddingTop + paddingBottom;

      this.element.style.height = `${this.animWrapper.offsetHeight + totalPadding}px`;
      return;
    }

    // Calculate the gap between slides
    if (this.original.children.length >= 2) {
      this.spaceDivWidth = this.getDistanceBetweenBlocks(this.original.children[0], this.original.children[1]);
    } else {
      this.spaceDivWidth = 0;
    }

    // For 2-3 slides, duplicate more times for smoother animation
    const duplicateCount = itemCount <= 3 ? 5 : 2;
    const wrapperWidth = (duplicateCount + 1) * originalWidth + duplicateCount * this.spaceDivWidth;

    // Set wrapper width and position
    this.animWrapper.style.width = `${wrapperWidth}px`;
    this.animWrapper.style.position = "absolute";

    // Set explicit width for original
    this.original.style.width = `${originalWidth}px`;
    this.original.style.flexShrink = '0';

    // Create duplicates
    for (let i = 0; i < duplicateCount; i++) {
      const spaceDiv = document.createElement('div');
      spaceDiv.style.width = this.spaceDivWidth + 'px';
      spaceDiv.style.flexShrink = '0';
      this.animWrapper.appendChild(spaceDiv);

      const duplicate = this.original.cloneNode(true);
      duplicate.style.width = `${originalWidth}px`;
      duplicate.style.flexShrink = '0';
      this.animWrapper.appendChild(duplicate);
    }

    // Get computed padding values and add them to the height
    const computedStyle = window.getComputedStyle(this.element);
    const paddingTop = parseFloat(computedStyle.paddingTop) || 0;
    const paddingBottom = parseFloat(computedStyle.paddingBottom) || 0;
    const totalPadding = paddingTop + paddingBottom;

    this.element.style.height = `${this.animWrapper.offsetHeight + totalPadding}px`;

    setTimeout(() => {
      this.startAnimating();
    }, 100);
  }

  // Public method to reinitialize the slider
  reinitialize() {
    if (this.enableAnimation && this.transitionSpeedSliding) {
      this.duplicateBlockWrappers();
    }
  }

  startAnimating() {
    // Always clean up previous animations to allow reinitialization
    if (this.currentAnimation) {
      this.currentAnimation.cancel();
      this.currentAnimation = null;
    }

    // Clean up previous Safari CSS animation
    if (this.safariStyleSheet) {
      this.safariStyleSheet.remove();
      this.safariStyleSheet = null;
    }

    // Reset animation styles for Safari
    if (this.isSafari && this.animWrapper) {
      this.animWrapper.style.animation = 'none';
      this.animWrapper.style.webkitAnimation = 'none';
    }

    const originalWidth = this.original.offsetWidth;
    const singleSetWidth = originalWidth + this.spaceDivWidth;

    // Calculate exact translation needed for one complete set
    const translateStart = 0;
    const translateEnd = -(singleSetWidth);
    const duration = parseInt(this.transitionSpeedSliding) * 1000;

    // Force the element into its own compositing layer to prevent scroll interference
    this.animWrapper.style.willChange = 'transform';
    this.animWrapper.style.backfaceVisibility = 'hidden';
    this.animWrapper.style.webkitBackfaceVisibility = 'hidden';

    // Use CSS animations for Safari (more stable during scroll)
    if (this.isSafari) {
      const animationName = `usps-slide-${Date.now()}`;

      // Create a style element with the keyframe animation
      this.safariStyleSheet = document.createElement('style');
      this.safariStyleSheet.textContent = `
        @-webkit-keyframes ${animationName} {
          from { -webkit-transform: translate3d(${translateStart}px, -50%, 0); transform: translate3d(${translateStart}px, -50%, 0); }
          to { -webkit-transform: translate3d(${translateEnd}px, -50%, 0); transform: translate3d(${translateEnd}px, -50%, 0); }
        }
        @keyframes ${animationName} {
          from { transform: translate3d(${translateStart}px, -50%, 0); }
          to { transform: translate3d(${translateEnd}px, -50%, 0); }
        }
      `;
      document.head.appendChild(this.safariStyleSheet);

      // Apply CSS animation
      this.animWrapper.style.animation = `${animationName} ${duration}ms linear infinite`;
      this.animWrapper.style.webkitAnimation = `${animationName} ${duration}ms linear infinite`;

      // Store animation name for pause/play control
      this.safariAnimationName = animationName;

      if (!this.pauseHandler) {
        this.pauseHandler = () => {
          this.animWrapper.style.animationPlayState = 'paused';
          this.animWrapper.style.webkitAnimationPlayState = 'paused';
        };
        this.playHandler = () => {
          this.animWrapper.style.animationPlayState = 'running';
          this.animWrapper.style.webkitAnimationPlayState = 'running';
        };

        this.element.addEventListener("mouseenter", this.pauseHandler);
        this.element.addEventListener("mouseleave", this.playHandler);
      }
    } else {
      // Use Web Animations API for other browsers
      this.animWrapper.style.transform = `translate3d(${translateStart}px, -50%, 0)`;

      this.currentAnimation = this.animWrapper.animate(
        [
          { transform: `translate3d(${translateStart}px, -50%, 0)` },
          { transform: `translate3d(${translateEnd}px, -50%, 0)` },
        ],
        {
          duration: duration,
          iterations: Infinity,
          easing: "linear",
        }
      );

      if (!this.pauseHandler) {
        this.pauseHandler = () => {
          if (this.currentAnimation) this.currentAnimation.pause();
        };
        this.playHandler = () => {
          if (this.currentAnimation) this.currentAnimation.play();
        };

        this.element.addEventListener("mouseenter", this.pauseHandler);
        this.element.addEventListener("mouseleave", this.playHandler);
      }
    }
  }

  stopAnimation() {
    if (this.currentAnimation) {
      this.currentAnimation.cancel();
      this.currentAnimation = null;
    }

    // Stop Safari CSS animation
    if (this.isSafari && this.animWrapper) {
      this.animWrapper.style.animation = 'none';
      this.animWrapper.style.webkitAnimation = 'none';
    }
  }

  getDistanceBetweenBlocks(blockOne, blockTwo) {
    return blockTwo.getBoundingClientRect().left - blockOne.getBoundingClientRect().right;
  }
}
customElements.define("product-usps-slider", ProductUspsSlider);

class NotifyMePopup extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(document.body);

    this._closeTimer = null;
    this._isClosing = false;

    this.validator = null;

    this.bindEvents();
  }

  connectedCallback() {
    this.initFormValidation();
    this.syncSubmitButton();
  }

  bindEvents() {
    this.delegateElement.on('submit', '.notify-me__popup-inputs', (e) => {
      this.submitNotifyMe(e);
    });

    // enable/disable submit while typing
    this.delegateElement.on('input', '.notify-me__popup-inputs .notify-me__input', () => {
      this.syncSubmitButton();
    });

    this.delegateElement.on('blur', '.notify-me__popup-inputs .notify-me__input', () => {
      this.syncSubmitButton();
    });

    // Open (sold out button)
    this.delegateElement.on('click', '[data-action="toggle-popup"][aria-controls="notify-me-popup"]', (e) => {
      e.preventDefault();
      e.stopPropagation();
      if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();
      this.openPopup();
    });

    // CLOSE — overlay + X use the SAME handler
    this.delegateElement.on('click', '.notify-me__overlay', (e) => {
      e.preventDefault();
      this._requestClose(e);
    });

    this.delegateElement.on('click', '.notify-me__close-btn', (e) => {
      e.preventDefault();
      this._requestClose(e);
    });
  }

  initFormValidation() {
    const form = this.element.querySelector('.notify-me__popup-inputs');
    if (!form) return;

    this.validator = new FormValidator(form, {
      errorClass: 'field--error',
      fieldSelector: '.notify-me_input-mail',
      buttonSelector: '.notify-me__popup-submit',
      validateOnBlur: true,
      validateOnInput: true,
      errorOutputSelector: '.notify-me__popup-content .AlertError',
      showErrorsOnSubmitOnly: false,
    });
  }

  syncSubmitButton() {
    const emailEl = this.element.querySelector('.notify-me__popup-inputs .notify-me__input');
    const submitBtns = this.element.querySelectorAll('.notify-me__popup-inputs .notify-me__popup-submit');
    if (!emailEl || !submitBtns.length) return;

    const email = (emailEl.value || '').trim();
    const isValid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

    submitBtns.forEach((submitBtn) => {
      if (isValid) {
        submitBtn.removeAttribute('disabled');
        submitBtn.classList.remove('disabled');
        submitBtn.setAttribute('aria-disabled', 'false');
      } else {
        submitBtn.setAttribute('disabled', '');
        submitBtn.classList.add('disabled');
        submitBtn.setAttribute('aria-disabled', 'true');
      }
    });
  }

  _getPopupEl() {
    return this.element.querySelector('#notify-me-popup') || document.getElementById('notify-me-popup');
  }

  _getOverlayEl() {
    return this.element.querySelector('.notify-me__overlay') || document.querySelector('.notify-me__overlay');
  }

  _clearCloseState(popup) {
    this._isClosing = false;

    if (this._closeTimer) {
      clearTimeout(this._closeTimer);
      this._closeTimer = null;
    }

    if (popup) popup.classList.remove('closing');
  }

  openPopup() {
    const popup = document.getElementById('notify-me-popup');
    const overlay = this.element.querySelector('.notify-me__overlay') || document.querySelector('.notify-me__overlay');
    if (!popup) return;

    if (this._closeTimer) {
      clearTimeout(this._closeTimer);
      this._closeTimer = null;
    }

    if (this._onCloseAnimEnd) {
      popup.removeEventListener('animationend', this._onCloseAnimEnd);
      this._onCloseAnimEnd = null;
    }

    popup.classList.remove('closing');
    this._isClosing = false;

    popup.setAttribute('aria-hidden', 'false');
    popup.setAttribute('aria-visible', 'true');
    overlay?.classList.add('is-visible');

    this.syncSubmitButton();
  }

  _requestClose(e) {
    e?.stopPropagation?.();
    if (typeof e?.stopImmediatePropagation === 'function') e.stopImmediatePropagation();
    this.closePopup({ immediate: true });
  }

  closePopup({ immediate = false } = {}) {
    const popup = document.getElementById('notify-me-popup');
    const overlay = this.element.querySelector('.notify-me__overlay') || document.querySelector('.notify-me__overlay');

    if (!popup) return;

    if (popup.getAttribute('aria-hidden') === 'true') {
      overlay?.classList.remove('is-visible');
      return;
    }

    if (this._closeTimer) {
      clearTimeout(this._closeTimer);
      this._closeTimer = null;
    }

    if (this._onCloseAnimEnd) {
      popup.removeEventListener('animationend', this._onCloseAnimEnd);
      this._onCloseAnimEnd = null;
    }

    overlay?.classList.remove('is-visible');

    if (immediate) {
      popup.classList.remove('closing');
      popup.setAttribute('aria-hidden', 'true');
      popup.setAttribute('aria-visible', 'false');
      this._isClosing = false;
      return;
    }

    this._isClosing = true;
    popup.classList.add('closing');

    this._onCloseAnimEnd = () => {
      if (popup.getAttribute('aria-hidden') === 'false') {
        popup.classList.remove('closing');
        this._isClosing = false;
        return;
      }

      popup.classList.remove('closing');
      popup.setAttribute('aria-hidden', 'true');
      popup.setAttribute('aria-visible', 'false');
      this._isClosing = false;
    };

    popup.addEventListener('animationend', this._onCloseAnimEnd, { once: false });

    this._closeTimer = setTimeout(() => {
      popup.classList.remove('closing');
      popup.setAttribute('aria-hidden', 'true');
      popup.setAttribute('aria-visible', 'false');
      this._isClosing = false;

      if (this._onCloseAnimEnd) {
        popup.removeEventListener('animationend', this._onCloseAnimEnd);
        this._onCloseAnimEnd = null;
      }
      this._closeTimer = null;
    }, 450);
  }

  submitNotifyMe(e) {
    e.preventDefault();

    const form = e.target.closest('.notify-me__popup-inputs');
    if (!form) return;

    const emailInput = form.querySelector('.notify-me__input');
    const emailTxt = (emailInput?.value || '').trim();
    const alertErr = this.element.querySelector('.notify-me__popup-content .AlertError');

    if (this.validator && typeof this.validator.validateForm === 'function') {
      const ok = this.validator.validateForm();

      if (!ok) {
        if (alertErr) {
          requestAnimationFrame(() => {
            const hasMessage = (alertErr.textContent || '').trim().length > 0;
            alertErr.style.display = hasMessage ? 'block' : 'none';
          });
        }
        return;
      }
    } else {
      if (!emailTxt || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(emailTxt)) {
        if (alertErr) {
          alertErr.textContent = "Please enter a valid email address.";
          alertErr.style.display = 'block';
        }
        return;
      }
    }

    if (alertErr) alertErr.style.display = 'none';
    this.handleKlaviyoAPI(emailTxt);
  }

  async handleKlaviyoAPI(myEmail) {
    const elementWithId = this.element.querySelector('.notify-me__popup-wrapper');
    if (!elementWithId) return;

    const variantID = elementWithId.getAttribute('variant-value');

    const data = {
      type: 'back-in-stock-subscription',
      attributes: {
        channels: ['EMAIL'],
        profile: {
          data: {
            type: 'profile',
            attributes: { email: myEmail },
          },
        },
      },
      relationships: {
        variant: {
          data: {
            type: 'catalog-variant',
            id: `$shopify:::$default:::${variantID}`,
          },
        },
      },
    };

    const endpoint = `https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=${this.element.dataset.key}`;

    const res = await fetch(endpoint, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        accept: 'application/json',
        revision: '2024-06-15',
      },
      body: JSON.stringify({ data }),
    });

    if (!res.ok) throw new Error(`Klaviyo request failed: ${res.statusText}`);

    elementWithId.setAttribute('notify-me-success', 'true');
    elementWithId.style.opacity = 0;

    const group = elementWithId.querySelector('.notify-me__popup-group');
    const successContainer = elementWithId.querySelector('.notify-me__success-container');

    if (group) group.style.display = 'none';

    setTimeout(() => {
      elementWithId.style.opacity = 1;
      if (successContainer) successContainer.style.display = 'flex';
    }, 500);
  }
}

customElements.define('notify-me-popup', NotifyMePopup);

class SearchBar extends HTMLElement {
  constructor() {
    super();

    // base refs
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);

    // key elements (guard every lookup)
    this.searchInputElement = this.element.querySelector('[name="q"]');
    this.searchResultsElement = this.element.querySelector('.searchWrapper');
    const overlayClass = this.element.getAttribute('data-overlay') || 'pageOverlay';
    this.pageOverlayElement = document.querySelector('.' + overlayClass);
    this.clearSearchButton = this.element.querySelector('.search-input__clear');
    this.searchInputContainer = this.element.querySelector('.search-header__input-container');
    this.formElement = this.element.querySelector('form.searchForm');

    // options
    const settingsAttr = this.element.getAttribute('data-settings');
    try {
      this.options = settingsAttr ? JSON.parse(settingsAttr) : {};
    } catch {
      this.options = {};
    }
    this.showRecentSearches = !!this.options.recentSearchesEnabled;

    // initial layout snapshot (guard) — will be re-taken after hydration on first open
    this.initialSearchLayout = this.searchResultsElement ? this.searchResultsElement.cloneNode(true) : null;

    this.cacheInitialSuggestionsFromDOM();

    // header sizing (guard)
    const headerEl = this.element.querySelector('.search-header');
    if (headerEl) {
      document.documentElement.style.setProperty('--search-header-height', `${headerEl.offsetHeight + 48}px`);
    }

    // feature flags
    this.headerTransparent = false;
    this.isOpen = false;

    // recent searches on boot if enabled
    if (this.showRecentSearches) {
      this.getRecentSearches();
    }

    this.bindEvents();
  }

  disconnectedCallback() {
    // Remove input listener
    if (this.searchInputElement && this._onInputListener) {
      this.searchInputElement.removeEventListener('input', this._onInputListener);
    }

    // Remove overlay click listener (if any)
    if (this.pageOverlayElement && this.closeListener) {
      this.pageOverlayElement.removeEventListener('click', this.closeListener);
      this.closeListener = null;
    }

    // Remove transitionend listener binder (safety)
    if (this.handleSearchCloseBinder) {
      this.element.removeEventListener('transitionend', this.handleSearchCloseBinder);
      this.handleSearchCloseBinder = null;
    }

    // Clear pending timeout
    if (this._closeTimeout) {
      clearTimeout(this._closeTimeout);
      this._closeTimeout = null;
    }

    // Destroy delegates to prevent duplicate handlers after section reload
    try { this.delegateElement?.destroy?.(); } catch {}
    try { this.delegateBody?.destroy?.(); } catch {}
    try { this.delegateElement?.off?.(); } catch {}
    try { this.delegateBody?.off?.(); } catch {}
  }

  _hydrateDeferred() {
    if (!this.element.hasAttribute("data-deferred")) return;
    const tpl = this.element.querySelector("template.search-deferred");
    if (!tpl) return;
    const target = this.element.querySelector(".predictiveSearch");
    if (target) {
      target.appendChild(document.importNode(tpl.content, true));
    }
    tpl.remove();
    this.element.removeAttribute("data-deferred");
    if (this.searchResultsElement) {
      this.initialSearchLayout = this.searchResultsElement.cloneNode(true);
    }
    this.cacheInitialSuggestionsFromDOM();
    this.element.querySelectorAll(".predictiveSearch .animatedContent").forEach((el) => {
      el.setAttribute("data-loaded", "true");
      requestAnimationFrame(() => el.classList.add("RevolutionAnimation--in"));
    });
  }

  bindEvents() {
    this._onInputListener = debounce(this.onInput.bind(this), 450);

    // Hydrate deferred search content on first open (triggered by GlobalPopup.openPopup)
    this.element.addEventListener('quicksearch:open', () => this._hydrateDeferred(), { once: true });

    this.delegateBody.on('click', '[data-action="open-search"]', this.openSearch.bind(this));
    this.delegateBody.on('click', '.search[aria-expanded=false] .searchInput--Wrapper', this.openSearch.bind(this));
    this.delegateElement.on('click', '[data-action="clear-input"]', this.resetSearch.bind(this));
    this.delegateElement.on('click', '[data-action="close-search"]', this.closeSearch.bind(this));

    if (this.searchInputElement) {
      this.searchInputElement.addEventListener('input', this._onInputListener);
    }

    this.delegateElement.on('click', '[data-action="search-string"]', this.onInput.bind(this));
    this.delegateElement.on('keypress', '[data-action="search-string"]', this.onInput.bind(this));

    this.delegateBody.on('menu:open', this.closeSearch.bind(this));
    this.delegateBody.on('close:search', this.closeSearch.bind(this));
    this.delegateBody.on('drawer:open', this.closeSearch.bind(this));
    this.delegateBody.on('popup:opened', this.closeSearch.bind(this));
    this.delegateBody.on('cart-drawer:open', this.closeSearch.bind(this));
    this.delegateBody.on('account-drawer:open', this.closeSearch.bind(this));

    this.delegateBody.on('mobile-menu:open', this.showSearchInputMobile.bind(this));
    this.delegateBody.on('mobile-menu:close', this.hideSearchInputMobile.bind(this));

    this.delegateElement.on('submit', 'form.searchForm', this.handleFormSubmit.bind(this));
  }

  handleFormSubmit(event) {
    event.preventDefault();

    let url = new URL(this.formElement.action, window.location.origin);
    url.searchParams.set('q', this.searchInputElement.value);

    window.location.href = url.toString();
  }

  initCarousel() {
    if (!this.searchResultsElement) return;
    const carousel = this.searchResultsElement.querySelector('[data-swiper-settings]');
    if (carousel) {
      this.newCarousel = carousel.initSwiper();
    }
  }

  showSearchInputMobile() {
    this.element.style.display = '';
    requestAnimationFrame(() => {
      this.element.setAttribute('aria-hidden', 'false');
      this.searchResultsElement.setAttribute('aria-hidden', true);
      this.searchResultsElement.style.display = 'none';
    });
    document.documentElement.style.setProperty(
      '--search-input-heignt',
      `${this.element.querySelector('.searchInput--Wrapper').offsetHeight}px`,
    );
  }

  hideSearchInputMobile() {
    const handleTransitionEnd = () => {
      const mobileMenuDrawer = document.querySelector('main-menu-dropdown .menu__drawer');
      if (mobileMenuDrawer.getAttribute('aria-hidden') == 'false') {
        this.element.style.display = 'none';
      }

      this.searchInputContainer.removeEventListener('transitionend', handleTransitionEnd);
    };
    this.searchInputContainer.addEventListener('transitionend', handleTransitionEnd);

    this.searchResultsElement.setAttribute('aria-hidden', '');
    this.searchResultsElement.style.display = '';
    this.element.setAttribute('aria-hidden', 'true');
  }

  openSearch(event) {
    if (event?.preventDefault) event.preventDefault();
    if (window.Drawer && Drawer.active) Drawer.active.closeDrawer();
    if (window.globalPopup) window.globalPopup.closeAllPopups?.();

    // Prevent opening if already opening or if currently closing
    if (this.isOpen || this._isOpening || this._isClosing) {
      // If already open, allow it to toggle closed
      if (this.isOpen && !this._isClosing) {
        this.closeSearch();
      }
      return;
    }

    this._isOpening = true;

    // broadcast close events for other UI
    this.element.dispatchEvent(new CustomEvent('menu:close', { bubbles: true }));
    this.element.dispatchEvent(new CustomEvent('drawer:close-other', { bubbles: true }));

    // ensure element exists
    if (!this.element) {
      console.error('Search element not found');
      this._isOpening = false;
      return;
    }

    // show container
    this.element.style.display = 'block';

    // ARIA setup
    requestAnimationFrame(() => {
      const search = document.querySelector('#quickSearch');

      if (search) {
        search.setAttribute('aria-hidden', 'false');
        search.setAttribute('aria-expanded', 'true');
      }
    });

    const headerSearchBar = document.querySelector('.header-search');
    if (headerSearchBar) headerSearchBar.classList.add('hidden');

    // overlay placement
    if (typeof responsive !== 'undefined') {
      this.pageOverlayElement.style.top = 'calc(var(--header-height-fixed) + var(--announcement-dynamic-height))';
      this.pageOverlayElement.classList.add('is-visible');
    }

    // lock scroll (guard external lib)
    const scrollable = this.element.querySelector('[data-scrollable]');
    if (typeof bodyScrollLock !== 'undefined' && scrollable) {
      try {
        bodyScrollLock.disableBodyScroll(scrollable, window.bodyScrollLockOptions || undefined);

        this.element.style.setProperty('--body-scroll-lock-offset', document.body.style.paddingRight || '0px');
      } catch {}
    }
    var scrollbarGap = window.innerWidth - document.documentElement.clientWidth;
    document.body.style.setProperty('--scrollbar-gap', (scrollbarGap > 0 ? scrollbarGap : 0) + 'px');
    document.body.classList.add('scrollLock');

    // focus input
    setTimeout(() => {
      if (this.searchInputElement) this.searchInputElement.focus();
    }, 200);

    const headerElement = document.querySelector('header-component');
    if (headerElement) {
      headerElement.dispatchEvent(new CustomEvent('quicksearch:open', { bubbles: true }));
    }

    // state + overlay click to close
    this.isOpen = true;
    this._isOpening = false;

    if (this.pageOverlayElement) {
      this.closeListener = this.closeSearch.bind(this);
      this.pageOverlayElement.addEventListener('click', this.closeListener);
    }
  }

  closeSearch(event) {
    if (event?.preventDefault) event.preventDefault();
    if (!this.isOpen) return;

    // Prevent multiple close operations
    if (this._isClosing) return;
    this._isClosing = true;

    this.element.setAttribute('aria-hidden', 'true');
    this.element.setAttribute('aria-expanded', 'false');

    // Clean up any existing listener to prevent stacking
    if (this.handleSearchCloseBinder) {
      this.element.removeEventListener('transitionend', this.handleSearchCloseBinder);
    }

    this.handleSearchCloseBinder = this.handleSearchClose.bind(this);
    this.element.addEventListener('transitionend', this.handleSearchCloseBinder, { once: true });

    if (this.pageOverlayElement) {
      this.pageOverlayElement.classList.remove('is-visible');
      // Remove the click listener immediately
      if (this.closeListener) {
        this.pageOverlayElement.removeEventListener('click', this.closeListener);
        this.closeListener = null;
      }
    }

    this.isOpen = false;

    const headerSearchBar = document.querySelector('.header-search');
    if (headerSearchBar) headerSearchBar.classList.remove('hidden');

    // Clear any existing fallback timeout
    if (this._closeTimeout) {
      clearTimeout(this._closeTimeout);
    }

    // Fallback: force cleanup if transition doesn't fire
    this._closeTimeout = setTimeout(() => {
      if (!this.isOpen && this._isClosing) {
        this.handleSearchClose(
          { propertyName: 'opacity' },
          ['menu:open', 'drawer:open', 'popup:opened', 'cart-drawer:open', 'account-drawer:open'].includes(event?.type) ? false : true
        );
      }
    }, 400);
  }

  handleSearchClose(e, removeBodyScollLock = true) {
    // Only run once per close operation
    if (!this._isClosing) return;

    // Only proceed on the opacity transition or forced cleanup
    if (e?.propertyName !== 'opacity') return;

    // Clear the fallback timeout
    if (this._closeTimeout) {
      clearTimeout(this._closeTimeout);
      this._closeTimeout = null;
    }

    const headerElement = document.querySelector('header-component');
    if (headerElement) {
      headerElement.dispatchEvent(new CustomEvent('quicksearch:closed', { bubbles: true }));
    }

    // Unlock scroll
    if (removeBodyScollLock) {
      document.body.classList.remove('scrollLock');
      document.body.style.removeProperty('--scrollbar-gap');
      const scrollable = this.element.querySelector('[data-scrollable]');
      if (typeof bodyScrollLock !== 'undefined' && scrollable) {
        try {
          bodyScrollLock.enableBodyScroll(scrollable, window.bodyScrollLockOptions || undefined);
        } catch {}
      }
    }

    // Hide element
    this.element.style.display = 'none';

    this.resetSearch();

    // Restore announcement bar and header section z-index so CSS applies; avoid inline override persisting after search close
    const announcementSection = document.querySelector('.shopify-section-section-announcement_bar');
    if (announcementSection?.style) announcementSection.style.removeProperty('z-index');
    const headerSection = document.querySelector('header-component')?.closest('.shopify-section');
    if (headerSection?.style) headerSection.style.removeProperty('z-index');

    // Reset overlay
    if (
      typeof responsive !== 'undefined' &&
      responsive.matchesBreakpoint &&
      responsive.matchesBreakpoint('lap_and_up')
    ) {
      if (this.pageOverlayElement) this.pageOverlayElement.removeAttribute('style');
    }

    // Clean up listener
    if (this.handleSearchCloseBinder) {
      this.element.removeEventListener('transitionend', this.handleSearchCloseBinder);
      this.handleSearchCloseBinder = null;
    }

    // Reset closing flag
    this._isClosing = false;
  }

  async onInput(event) {
    // 1) get the value (typing OR clicking a suggestion)
    const source = event?.target;
    let val = source && 'value' in source ? source.value : '';
    if (source?.getAttribute && source.getAttribute('data-value') && !val) {
      val = source.getAttribute('data-value');
      const el = this.element.querySelector('.searchInput');
      if (el) {
        el.value = val;
        el.setAttribute('value', val);
      }
    }
    this.lastInputValue = val;

    // 2) empty input → reset
    if (!val.trim()) {
      if (this.initialSearchLayout && this.searchResultsElement) {
        this.searchResultsElement.innerHTML = this.initialSearchLayout.innerHTML;
        this.searchResultsElement.style.opacity = 1;
      }
      const host = this.element.querySelector('.predictiveSearch--queries');
      if (host) host.innerHTML = '';
      if (this.showRecentSearches) this.getRecentSearches();
      if (this.clearSearchButton) this.clearSearchButton.setAttribute('aria-hidden', 'true');
      return;
    }

    // 3) ensure wrapper exists
    this.searchResultsElement = this.element.querySelector('.searchWrapper');
    if (!this.searchResultsElement) return;
    this.searchResultsElement.style.opacity = 0;
    if (this.clearSearchButton) this.clearSearchButton.setAttribute('aria-hidden', 'false');

    // 4) RACE GUARD: only latest request may update the UI
    const token = (this.currentRequestToken = (this.currentRequestToken || 0) + 1);

    try {
      // 5) build a clean URL (no trailing spaces) + ask for query suggestions
      const sectionId = 'search-predictive';
      const params = new URLSearchParams();
      params.set('q', val);
      params.set('resources[type]', 'query,product,collection,article,page');
      params.set('resources[limit_scope]', 'each');
      params.set('resources[options][fields]', 'title,product_type,variants.title,tag,body,author,vendor,variants.sku');
      params.set('section_id', sectionId);
      params.set('_', String(Date.now()));
      const url = `${routes.predictive_search_url}?${params.toString()}`;

      const response = await fetch(url, { cache: 'no-store' });
      if (!response.ok) throw new Error(response.status);

      // If a newer request started, drop this one
      if (token !== this.currentRequestToken) return;

      // 6) parse the HTML and inject results
      const text = await response.text();
      const parsed = new DOMParser().parseFromString(text, 'text/html');
      const hostEl = parsed.querySelector(`#shopify-section-${sectionId}`) || parsed.body;
      const resultsMarkup = hostEl ? hostEl.innerHTML : '';

      this.searchResultsElement.innerHTML = resultsMarkup;

      // NEW: inject cached suggestions + repopulate slides inside the new DOM
      this.syncPredictiveSuggestions();
      this.getRecentSearches();

      requestAnimationFrame(() => {
        this.initCarousel();
      });

      // 7) finish
      this.searchResultsElement.style.opacity = 1;
      if (this.showRecentSearches) this.recentSearches();
    } catch (error) {
      if (error?.code === 20) return;
      console.error('[SearchBar] predictive search failed:', error);
      if (this.showRecentSearches) this.getRecentSearches();
      if (this.searchResultsElement) this.searchResultsElement.style.opacity = 1;
    }
  }

  resetSearch() {
    if (this.initialSearchLayout && this.searchResultsElement) {
      this.searchResultsElement.innerHTML = this.initialSearchLayout.innerHTML;
    }

    const suggestionsHost = this.element.querySelector('.predictiveSearch--queries');
    if (suggestionsHost) suggestionsHost.remove();

    if (this.searchInputElement) {
      this.searchInputElement.value = '';
      this.searchInputElement.removeAttribute('value');
    }

    this.initCarousel();

    if (this.searchResultsElement) this.searchResultsElement.style.opacity = '';

    setTimeout(() => {
      if (this.searchInputElement) this.searchInputElement.focus();
    }, 200);

    this.cacheInitialSuggestionsFromDOM();

    if (this.showRecentSearches) this.getRecentSearches();

    if (this.clearSearchButton) {
      this.clearSearchButton.setAttribute('aria-hidden', 'true');
    }
  }

  recentSearches() {
    if (!this.showRecentSearches) return;

    if ((this.lastInputValue || '').length > 2) {
      const searchTerm = JSON.parse(localStorage.getItem('searchTerms') || '[]');
      if (!searchTerm.includes(this.lastInputValue)) {
        searchTerm.unshift(this.lastInputValue);
      }
      try {
        localStorage.setItem('searchTerms', JSON.stringify(searchTerm.slice(0, 5)));
      } catch {}
    }
  }

  // Stores current markup from initial suggestions (skeleton or populated)
  cacheInitialSuggestionsFromDOM() {
    if (!this.showRecentSearches) return;

    const initial = this.element.querySelector('#initial-suggestions');
    if (!initial) return;

    this.initialSuggestionsMarkup = initial.innerHTML || '';
  }

  // Inject cached suggestions markup into predictive container
  syncPredictiveSuggestions() {
    if (!this.showRecentSearches) return;

    const target = this.element.querySelector('#predictive-suggestions');
    if (!target) return;

    if (!this.initialSuggestionsMarkup) {
      this.cacheInitialSuggestionsFromDOM();
    }

    target.innerHTML = this.initialSuggestionsMarkup || '';
  }

  getRecentSearches() {
    if (!this.showRecentSearches) return;

    let items = JSON.parse(localStorage.getItem('searchTerms') || '[]');
    items = items.slice(0, 5);

    const predictiveRoot =
      this.element.querySelector('#predictive-suggestions') ||
      this.element.querySelector('#initial-suggestions') ||
      this.element;

    const wrapper = predictiveRoot.querySelector('.search__recent-searches.swiper-wrapper');
    const container = predictiveRoot.querySelector('.predictive-search__recent-searches');

    if (!wrapper || !container) return;

    if (items.length > 0) {
      let appendString = '';

      items.forEach((id) => {
        const safe = String(id).replace(/"/g, '&quot;');

        appendString +=
          "<div class='swiper-slide' style='width:auto'>" +
          "<div role='option' tabIndex='0' class='search__recent-searches--item u-p3' data-action='search-string' data-value=\"" +
          safe +
          '">' +
          id +
          '</div>' +
          '</div>';
      });

      wrapper.innerHTML = appendString;
      container.style.display = '';

      requestAnimationFrame(() => {
        const swiper = predictiveRoot.querySelector('.search__recent-swiper');
        if (swiper?.initSwiper) swiper.initSwiper();

        this.cacheInitialSuggestionsFromDOM();
      });
    } else {
      container.style.display = 'none';
      wrapper.innerHTML = '';

      this.cacheInitialSuggestionsFromDOM();
    }
  }
}

customElements.define('search-bar', SearchBar);

class ContactSection extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.validator = null;
    this.bindEvents();
    this.toggleButton();
  }

  bindEvents() {
    this.delegateElement.on(
      "change",
      "[data-state='required']",
      this.toggleButton.bind(this)
    );

    this.delegateElement.on(
      "input",
      'input[type="email"][name="contact[email]"]',
      this.handleEmailTyping.bind(this)
    );
  }

  connectedCallback() {
    this.initFormValidation();
  }

  initFormValidation() {
    const form = this.element.querySelector("form");
    if (!form) return;

    this.validator = new FormValidator(form, {
      errorClass: "field--error",
      fieldSelector: ".field, .form-checkbox",
      buttonSelector: ".validate-button",
      validateOnBlur: true,
      validateOnInput: false,
      showErrorsOnSubmitOnly: false,
      fieldErrorSelector: ".field__error"
    });
  }

  toggleButton() {
    if (this.validator && this.validator.updateButtonState) {
      this.validator.updateButtonState();
    }
  }

  handleEmailTyping() {
    if (this.validator?.updateButtonState) this.validator.updateButtonState();
  }
}

customElements.define('contact-section', ContactSection);
/**
 * Friend Referral form.
 *
 * Captures TWO emails:
 *   - referrer (existing customer who shares)
 *   - friend   (new prospect who gets the discount)
 *
 * On submit, fires two Klaviyo Client API calls in parallel:
 *   1. `Referral Submitted` event on the REFERRER profile, with the friend's
 *      email merged onto the referrer profile as a custom property
 *      (`referred_friend_email` by default). The backend bridge later uses
 *      this property to match `Placed Order` → `Referral Converted`.
 *   2. `Friend Invited` event on the FRIEND profile. This is the metric a
 *      Klaviyo flow listens to in order to email the friend their discount.
 *
 * Optionally also subscribes the friend to the configured Klaviyo list.
 */
class FriendReferralSection extends HTMLElement {

  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.form = null;
    this.validator = null;
    this.newsletterHandler = null;
    this.klaviyoClient = null;
    this.settings = null;
    this._eventsBound = false;
    this.formContentEl = null;
    this.successWrapper = null;
    this.errorWrapper = null;
    this.errorTextEl = null;

    this.bindEvents();
  }

  bindEvents() {
    this.delegateElement.on(
      "change",
      "[data-state='required']",
      this.toggleButton.bind(this)
    );
  }

  connectedCallback() {
    if (this._eventsBound) return;
    this._eventsBound = true;

    this.form = this.element.querySelector("form");
    if (!this.form) return;

    this.formContentEl = this.element.querySelector("[data-friend-referral-form-content]");
    this.successWrapper = this.element.querySelector("[data-friend-referral-success]");
    this.errorWrapper = this.element.querySelector("[data-friend-referral-error]");
    this.errorTextEl = this.element.querySelector("[data-friend-referral-error-text]");

    this.referrerInput = this.form.querySelector('input[name="referrer[email]"]');
    this.friendInput = this.form.querySelector('input[name="contact[email]"]');

    this.initKlaviyoHandlers();
    this.initFormValidation();
    this.toggleButton();

    // Always prevent native form submission (Enter key / browser default).
    this.form.addEventListener("submit", (e) => {
      e?.preventDefault?.();
      e?.stopPropagation?.();
      return false;
    });

    const submitBtn = this.element.querySelector(".friend-referral__submit");
    if (submitBtn) {
      submitBtn.addEventListener("click", this.onSubmit.bind(this));
    }

    // Hide success / error messages as soon as the user edits any email.
    [this.referrerInput, this.friendInput].forEach((input) => {
      if (!input) return;
      input.addEventListener("input", this.handleEmailTyping.bind(this));
    });
  }

  initKlaviyoHandlers() {
    const settingsEl = this.element.querySelector("[data-klaviyo-settings]");
    if (!settingsEl) return;

    if (this.klaviyoClient) return;

    let settings;
    try {
      settings = JSON.parse(
        settingsEl.dataset.klaviyoSettings ||
          settingsEl.getAttribute("data-klaviyo-settings")
      );
    } catch (e) {
      console.error("Friend referral: Klaviyo settings parse error:", e);
      return;
    }

    if (!settings?.publicApiKey) {
      console.warn("Friend referral: missing Klaviyo public key — form will not submit.");
      return;
    }

    // NewsletterHandler is declared later in this file. Lazy-init prevents
    // "Cannot access before initialization" if connectedCallback runs first.
    const NewsletterHandlerClass = window.NewsletterHandler;
    const KlaviyoClientClass = window.KlaviyoClient;
    if (!NewsletterHandlerClass || !KlaviyoClientClass) {
      setTimeout(() => this.initKlaviyoHandlers(), 0);
      return;
    }

    this.settings = {
      listId: settings.listId,
      publicKey: settings.publicApiKey,
      metricReferralSubmitted: settings.metricReferralSubmitted || "Referral Submitted",
      metricFriendInvited: settings.metricFriendInvited || "Friend Invited",
      friendPropertyName: settings.friendPropertyName || "referred_friend_email",
      subscribeFriendToList: settings.subscribeFriendToList !== false,
    };

    this.klaviyoClient = new KlaviyoClientClass({ publicKey: this.settings.publicKey });

    if (this.settings.listId) {
      this.newsletterHandler = new NewsletterHandlerClass({
        listId: this.settings.listId,
        publicKey: this.settings.publicKey,
        // We aggregate states ourselves below, so swallow handler-level callbacks.
        onSuccess: () => {},
        onError: () => {},
      });
    }
  }

  initFormValidation() {
    if (!this.form) return;

    this.validator = new FormValidator(this.form, {
      errorClass: "field--error",
      fieldSelector: ".field, .form-checkbox",
      buttonSelector: ".friend-referral__submit",
      validateOnBlur: true,
      validateOnInput: false,
      showErrorsOnSubmitOnly: false,
      fieldErrorSelector: ".field__error"
    });

    // Self-referral guard: friend email must differ from referrer email.
    if (this.friendInput && this.referrerInput) {
      const selfMsg =
        window.theme?.translations?.referral_self_error ||
        "You can't refer yourself — enter a friend's email.";
      this.validator.addValidator(
        this.friendInput.id,
        (value) => {
          const referrer = this.referrerInput.value.trim().toLowerCase();
          const friend = (value || "").trim().toLowerCase();
          if (referrer && friend && referrer === friend) {
            return selfMsg;
          }
          return true;
        },
        selfMsg
      );
    }
  }

  toggleButton() {
    if (this.validator && this.validator.updateButtonState) {
      this.validator.updateButtonState();
    }
  }

  async onSubmit(e) {
    e?.preventDefault?.();
    e?.stopPropagation?.();
    if (!this.validator || !this.klaviyoClient) return;

    const isValid = this.validator.showAllErrors();
    if (!isValid) return;

    const referrerEmail = this.referrerInput?.value?.trim();
    const friendEmail = this.friendInput?.value?.trim();
    if (!referrerEmail || !friendEmail) return;

    const submitBtn = this.element.querySelector(".friend-referral__submit");
    this.setSubmitting(submitBtn, true);

    try {
      // Fire both events (and optional list opt-in) in parallel.
      // Note: `Promise.allSettled` so a single failure doesn't black-hole the
      // whole referral — but we still surface errors below.
      const tasks = [
        // 1. Referrer event — atomically stamps `referred_friend_email` on
        //    the referrer profile via the embedded `profile.properties`.
        this.klaviyoClient.trackEvent({
          email: referrerEmail,
          metricName: this.settings.metricReferralSubmitted,
          eventProperties: { friend_email: friendEmail },
          profileProperties: { [this.settings.friendPropertyName]: friendEmail },
        }),
        // 2. Friend event — used by Flow 1 to send the friend their discount.
        this.klaviyoClient.trackEvent({
          email: friendEmail,
          metricName: this.settings.metricFriendInvited,
          eventProperties: { referrer_email: referrerEmail },
        }),
      ];

      if (this.settings.subscribeFriendToList && this.newsletterHandler) {
        tasks.push(
          this.newsletterHandler.subscribe(friendEmail).catch((err) => {
            // 409 = friend is already on the list. That's fine for a referral
            // — the events still fired, so don't fail the whole submission.
            if (err?.message === "DUPLICATE_EMAIL") return null;
            throw err;
          })
        );
      }

      const results = await Promise.allSettled(tasks);
      const eventResults = results.slice(0, 2); // events MUST succeed
      const eventFailure = eventResults.find((r) => r.status === "rejected");

      if (eventFailure) {
        console.error("Friend referral: Klaviyo event failed:", eventFailure.reason);
        this.showErrorState();
        return;
      }

      this.showSuccessState();
    } catch (error) {
      console.error("Friend referral: unexpected error:", error);
      this.showErrorState();
    } finally {
      this.setSubmitting(submitBtn, false);
    }
  }

  setSubmitting(btn, isSubmitting) {
    if (!btn) return;
    if (isSubmitting) {
      btn.setAttribute("disabled", "true");
      btn.classList.add("disabled", "is-loading");
      btn.setAttribute("aria-disabled", "true");
    } else {
      btn.classList.remove("is-loading");
      // Final disabled state is decided by the validator on next button update.
      this.toggleButton();
    }
  }

  showSuccessState() {
    this.hideErrorState();
    if (this.successWrapper) {
      this.successWrapper.style.display = "block";
      this.successWrapper
        .querySelectorAll(".contact-section__success")
        .forEach((el) => (el.style.display = "block"));
    }
    // Clear only the friend input so the referrer can refer another friend
    // without retyping their own email. Do NOT dispatch an "input" event
    // here — it would re-trigger handleEmailTyping() and instantly hide the
    // success message we just rendered. Instead, sync validator state directly.
    if (this.friendInput) {
      this.friendInput.value = "";
      const fieldContainer = this.friendInput.closest(".field");
      if (fieldContainer) fieldContainer.classList.remove("field--error");
      const errorOutput = this.friendInput
        .closest(".field-container")
        ?.querySelector(".field__error");
      if (errorOutput) errorOutput.textContent = "";
    }
    if (this.validator?.updateButtonState) this.validator.updateButtonState();
  }

  showErrorState(message) {
    if (this.successWrapper) this.successWrapper.style.display = "none";
    if (this.errorWrapper) {
      if (message && this.errorTextEl) this.errorTextEl.textContent = message;
      this.errorWrapper.style.display = "block";
      this.errorWrapper
        .querySelectorAll(".contact-section__success")
        .forEach((el) => (el.style.display = "block"));
    }
  }

  hideErrorState() {
    if (this.errorWrapper) {
      this.errorWrapper.style.display = "none";
      this.errorWrapper
        .querySelectorAll(".contact-section__success")
        .forEach((el) => (el.style.display = "none"));
    }
  }

  handleEmailTyping() {
    // Hide success/error so the referrer can submit another friend.
    if (this.successWrapper) {
      this.successWrapper.style.display = "none";
      this.successWrapper
        .querySelectorAll(".contact-section__success")
        .forEach((el) => (el.style.display = "none"));
    }
    this.hideErrorState();

    if (this.validator?.updateButtonState) this.validator.updateButtonState();
  }
}

customElements.define('friend-referral', FriendReferralSection);

class LocalizationForm extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.bindEvents();
  }

  connectedCallback() {
    this.input = this.querySelector(
      'input[name="language_code"], input[name="country_code"]'
    );
    this.form = this.querySelector("form");
  }

  bindEvents() {
    this.delegateElement.on("click", "a", this.onItemClick.bind(this));
  }

  onItemClick(event) {
    event.preventDefault();
    if (!this.input || !this.form) return;
    this.input.value = event.currentTarget.dataset.value;
    this.form.submit();
  }
}

customElements.define('localization-form', LocalizationForm);

class PickupAvailability extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    if (!this.hasAttribute('available')) return;
    this.fetchAvailability(this.dataset.variantId);
  }

fetchAvailability(variantId) {
    const variantSectionUrl = `${window.routes.localeRootUrl}/variants/${variantId}/?section_id=helper-pickup`;

    fetch(variantSectionUrl)
      .then((response) => response.text())
      .then((text) => {
        const sectionInnerHTML = new DOMParser().parseFromString(text, 'text/html').querySelector('.shopify-section');
        this.renderPreview(sectionInnerHTML);
      })
      .catch((e) => {
        this.renderError();
      });
  }

  renderError() {}

  renderPreview(sectionInnerHTML) {
    this.element.innerHTML = '';

    this.element.appendChild(sectionInnerHTML.querySelector('.LocalPickup_--Wrapper'));
    if (sectionInnerHTML.querySelector('#LocalPickup')) {
      this.element.appendChild(sectionInnerHTML.querySelector('#LocalPickup'));
      new Drawer(this.element.querySelector('#LocalPickup'));
    }
  }
}

customElements.define('pickup-availability', PickupAvailability);

class CartNote extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.textarea = this.element.querySelector('textarea');
    this.button = this.element.querySelector('.CartNote--Submit');
    this.noteSucess = this.element.querySelector('.cartNote--Success');
    this.bindEvents();
  }
  bindEvents() {
    this.delegateElement.on('click', "[data-action='update-note']", this.updateNote.bind(this));

    this.delegateElement.on('click', "[data-action='edit-note']", this.editNote.bind(this));
  }
  editNote() {
    this.textarea.removeAttribute('disabled');
    this.button.innerText = window.cartStrings.enter_note;
    this.button.setAttribute('data-action', 'update-note');
    this.textarea.focus();
    this.noteSucess.style.visibility = 'hidden';
    this.noteSucess.style.opacity = '0';
  }

  updateNote() {
    var _this = this;
    this.value = this.textarea.value;

    fetch(window.routes.localeRootUrl + '/cart/update.js', {
      body: JSON.stringify({ note: this.value }),
      credentials: 'same-origin',
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
    }).then(function (response) {
      if (response.ok) {
        if (_this.value == '') {
          return;
        }
        _this.textarea.setAttribute('disabled', 'disabled');
        _this.button.innerText = window.cartStrings.note_change;
        _this.button.setAttribute('data-action', 'edit-note');
        _this.noteSucess.style.visibility = 'visible';
        _this.noteSucess.style.opacity = '1';
      }
    });
  }
}

customElements.define('cart-note', CartNote);

class NewsletterHandler {
  constructor(options = {}) {
    this.listId = options.listId;
    this.publicKey = options.publicKey;
    this.onSuccess = options.onSuccess || (() => {});
    this.onError = options.onError || ((error) => console.error('Newsletter error:', error));
  }

  /**
   * Submit email to Klaviyo
   * @param {string} email - Email address to subscribe
   * @returns {Promise<Response>}
   */
  async subscribe(email) {
    if (!email || !this.listId || !this.publicKey) {
      throw new Error('Missing required parameters: email, listId, or publicKey');
    }

    const payload = {
      data: {
        type: 'subscription',
        attributes: {
          profile: {
            data: {
              type: 'profile',
              attributes: { email: email },
            },
          },
        },
        relationships: {
          list: {
            data: {
              type: 'list',
              id: this.listId,
            },
          },
        },
      },
    };

    const endpoint = `https://a.klaviyo.com/client/subscriptions/?company_id=${encodeURIComponent(this.publicKey)}`;

    try {
      const response = await fetch(endpoint, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/vnd.api+json',
          revision: '2024-06-15',
          'Cache-Control': 'no-cache',
        },
        body: JSON.stringify(payload),
        keepalive: true,
      });

      if (!response.ok) {
        // Handle specific error cases
        if (response.status === 409) {
          // Duplicate subscription
          throw new Error('DUPLICATE_EMAIL');
        }
        throw new Error(`Klaviyo API error: ${response.statusText}`);
      }

      return response;
    } catch (error) {
      this.onError(error);
      throw error;
    }
  }

  /**
   * Validate email format
   * @param {string} email
   * @returns {boolean}
   */
  static isValidEmail(email) {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  }
}

// Expose for components declared earlier in this file.
window.NewsletterHandler = NewsletterHandler;

/**
 * Thin wrapper around Klaviyo's public Client API for tracking events.
 *
 * Uses POST /client/events/ which lets us:
 *   - Track a metric event on a profile (creates the profile if missing).
 *   - Atomically merge custom profile properties onto that profile via the
 *     `profile.attributes.properties` payload — no separate profile upsert needed.
 *
 * Auth = `company_id` query param (the public key). No secret key in browser.
 */
class KlaviyoClient {
  constructor({ publicKey } = {}) {
    this.publicKey = publicKey;
  }

  /**
   * @param {object} args
   * @param {string} args.email - Profile email this event is fired against.
   * @param {string} args.metricName - Klaviyo metric name (must match flow trigger).
   * @param {object} [args.eventProperties] - Arbitrary key/value props on the event.
   * @param {object} [args.profileProperties] - Custom props to merge onto the profile.
   * @returns {Promise<Response>}
   */
  async trackEvent({ email, metricName, eventProperties = {}, profileProperties = {} }) {
    if (!email || !metricName || !this.publicKey) {
      throw new Error('KlaviyoClient.trackEvent: missing email, metricName or publicKey');
    }

    const payload = {
      data: {
        type: 'event',
        attributes: {
          properties: eventProperties,
          metric: {
            data: {
              type: 'metric',
              attributes: { name: metricName },
            },
          },
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email,
                properties: profileProperties,
              },
            },
          },
        },
      },
    };

    const endpoint = `https://a.klaviyo.com/client/events/?company_id=${encodeURIComponent(this.publicKey)}`;

    const response = await fetch(endpoint, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/vnd.api+json',
        revision: '2024-06-15',
        'Cache-Control': 'no-cache',
      },
      body: JSON.stringify(payload),
      keepalive: true,
    });

    if (!response.ok) {
      throw new Error(`Klaviyo trackEvent failed (${response.status}): ${response.statusText}`);
    }

    return response;
  }
}

window.KlaviyoClient = KlaviyoClient;

class NewsletterPopup extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);
    this.pageOverlayElement = document.querySelector('.pageOverlay');
    this.options = JSON.parse(this.element.getAttribute('data-section-settings'));

    // a11y / focus
    this.previouslyFocusedElement = null;
    this.focusableSelectors =
      'a[href], area[href], input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, embed, [contenteditable], [tabindex]:not([tabindex="-1"])';

    this._eventsBound = false;

    // Initialize newsletter handler
    this.initNewsletterHandler();

    if (this.options.edit_mode) {
      this.options.delay = 0;
      this.openNewsletter();
    } else {
      this.checkCookiePopupAndStart();
    }
  }

  initNewsletterHandler() {
    const settings = this.getNewsletterSettings();
    this.newsletterHandler = new NewsletterHandler({
      listId: settings.listId,
      publicKey: settings.publicApiKey,
      onSuccess: () => {
        localStorage.setItem('popup-subscribed', 'true');
        this.showSuccessState();
      },
      onError: (error) => {
        console.error("Klaviyo subscription error:", error);
        if (error.message === "DUPLICATE_EMAIL") {
          this.showDuplicateEmailMessage();
        }
      },
    });
  }

  getNewsletterSettings() {
    const wrapper = this.element.querySelector(".newsletter__wrapper");
    if (wrapper && wrapper.dataset.settings) {
      return JSON.parse(wrapper.dataset.settings);
    }
    // Fallback to options if settings not in wrapper
    return {
      listId: this.options.klaviyo_list_id,
      publicApiKey: this.options.klaviyo_public_key,
    };
  }

  connectedCallback() {
    if (!this._eventsBound) {
      this._eventsBound = true;
      this.bindEvents();
    }
    this.initFormValidation();
  }

  bindEvents() {
    const formEl = this.element.querySelector("#popupForm");
    if (formEl) {
      formEl.addEventListener("submit", this.onSubmit.bind(this));
    }

    this.delegateElement.on("click", '[data-action="close-modal"]', this.closeNewsletter);
  }

  initFormValidation() {
    const form = this.element.querySelector("form");
    if (!form) return;

    this.validator = new FormValidator(form, {
      errorClass: "field--error",
      fieldSelector: ".newsletter__email-input-wrapper",
      buttonSelector: ".newsletter__subscribe-button",
      validateOnBlur: true,
      validateOnInput: true,
      errorOutputSelector: '.newsletter__error-wrapper',
      showErrorsOnSubmitOnly: false,
    });

    // Make sure both (mobile + desktop) subscribe buttons get enabled/disabled
    this.syncSubscribeButtons();
    const emailEl = this.element.querySelector("#klaviyoEmail");
    if (emailEl) {
      emailEl.addEventListener("input", () => this.syncSubscribeButtons());
      emailEl.addEventListener("blur", () => this.syncSubscribeButtons());
    }
  }

  syncSubscribeButtons() {
    const emailEl = this.element.querySelector("#klaviyoEmail");
    if (!emailEl) return;

    const email = emailEl.value.trim();
    const isValid = NewsletterHandler.isValidEmail(email);

    this.element.querySelectorAll(".newsletter__subscribe-button").forEach((btn) => {
      if (isValid) {
        btn.removeAttribute("disabled");
        btn.classList.remove("disabled");
        btn.setAttribute("aria-disabled", "false");
      } else {
        btn.setAttribute("disabled", "");
        btn.classList.add("disabled");
        btn.setAttribute("aria-disabled", "true");
      }
    });
  }

  checkCookiePopupAndStart() {
    const cookiePopup = document.querySelector("#shopify-pc__banner");
    if (cookiePopup) {
      const isVisible =
        cookiePopup.style.display !== "none" &&
        window.getComputedStyle(cookiePopup).display !== "none";

      if (isVisible) {
        this.waitForCookiePopupDismissal(cookiePopup);
      } else {
        this.cookiePopupDismissed = true;
        this.handleOpenOptions();
      }
    } else {
      this.cookiePopupDismissed = true;
      this.handleOpenOptions();
    }
  }

  handleCookieButtonClick(e) {
    setTimeout(() => {
      this.cookiePopupDismissed = true;
      this.handleOpenOptions();
      document.removeEventListener("click", this.handleCookieButtonClick);
    }, 500);
  }

  waitForCookiePopupDismissal() {
    this.delegateBody.on(
      "click",
      "#shopify-pc__banner__btn-decline",
      this.handleCookieButtonClick.bind(this)
    );

    this.delegateBody.on(
      "click",
      "#shopify-pc__banner__btn-accept",
      this.handleCookieButtonClick.bind(this)
    );
  }

  handleOpenOptions() {
    if (!this.cookiePopupDismissed) {
      return;
    }

    const seen = localStorage.getItem('popup-seen') === 'true';
    const subscribed = localStorage.getItem('popup-subscribed') === 'true';

    if ((this.options.show_only_once && seen) || subscribed) {
      return;
    }

    if (this.options.scroll_amount > 0) {
      this._measureDocHeight();
      this._docHeightResizeListener = responsive.addResizeListener(this, this._measureDocHeight);
      this.myScrollListener = scrollListener.addScrollListener(this, this.scrollListener);
    } else {
      this.openNewsletter();
    }
  }

  _measureDocHeight = () => {
    const body = document.body;
    const html = document.documentElement;
    this._newsletterDocHeight = Math.max(
      body.scrollHeight,
      body.offsetHeight,
      html.clientHeight,
      html.scrollHeight,
      html.offsetHeight,
    );
  };

  scrollListener = () => {
    const docHeight = this._newsletterDocHeight || 1;
    const percScrolled = (window.scrollY / docHeight) * 100;

    if (percScrolled >= this.options.scroll_amount) {
      this.openNewsletter();
    }
  };

  getFocusableElements() {
    const nodes = Array.from(this.element.querySelectorAll(this.focusableSelectors));
    return nodes.filter((el) => {
      const isHidden =
        el.closest('[aria-hidden="true"]') ||
        el.hasAttribute("hidden") ||
        el.style.display === "none";
      return !isHidden;
    });
  }

  focusFirstElement() {
    const email = this.element.querySelector("#klaviyoEmail");
    const closeBtn = this.element.querySelector('[data-action="close-modal"]');
    if (email && !email.disabled) {
      email.focus();
      return;
    }
    if (closeBtn) closeBtn.focus();
  }

  onKeyDown = (e) => {
    if (this.element.getAttribute("aria-hidden") !== "false") return;

    if (e.key === "Escape" || e.key === "Esc") {
      e.preventDefault();
      this.closeNewsletter();
      return;
    }

    if (e.key !== "Tab") return;

    // If focus is outside while modal is open, force it back in
    if (!this.element.contains(document.activeElement)) {
      e.preventDefault();
      this.focusFirstElement();
      return;
    }

    const focusable = this.getFocusableElements();
    if (!focusable.length) return;

    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    const active = document.activeElement;

    if (e.shiftKey) {
      if (active === first || active === this.element) {
        e.preventDefault();
        last.focus();
      }
    } else {
      if (active === last) {
        e.preventDefault();
        first.focus();
      }
    }
  };

  addA11yListeners() {
    document.addEventListener("keydown", this.onKeyDown, true);
    this.element.addEventListener("keydown", this.onKeyDown, true);
    this.element.addEventListener("focusin", this.onFocusIn, true);
  }

  removeA11yListeners() {
    document.removeEventListener("keydown", this.onKeyDown, true);
    this.element.removeEventListener("keydown", this.onKeyDown, true);
    this.element.removeEventListener("focusin", this.onFocusIn, true);
  }

  onFocusIn = (e) => {
    if (this.element.getAttribute("aria-hidden") !== "false") return;
    if (this.element.contains(e.target)) return;

    const focusable = this.getFocusableElements();
    if (focusable.length) focusable[0].focus();
  };

  openNewsletter() {
    if (this.myScrollListener) {
      this.myScrollListener.removeScrollListener();
      this.myScrollListener = null;
    }
    if (this._docHeightResizeListener) {
      this._docHeightResizeListener.removeResizeListener();
      this._docHeightResizeListener = null;
    }

    setTimeout(() => {
      this.previouslyFocusedElement = document.activeElement;

      this.element.setAttribute("aria-hidden", false);

      // iOS specific problem of course...
      // This approach ensures the background is truly locked and the user cannot scroll the underlying content.
      const isIOS = /iPhone|iPad|iPod/i.test(window.navigator.userAgent);
      if (isIOS && !this._iosScrollFreeze) {
        const scrollY = window.scrollY || window.pageYOffset || 0;
        this._iosScrollFreeze = {
          scrollY,
          position: document.body.style.position,
          top: document.body.style.top,
          left: document.body.style.left,
          right: document.body.style.right,
          width: document.body.style.width,
        };

        document.body.style.position = "fixed";
        document.body.style.top = `-${scrollY}px`;
        document.body.style.left = "0";
        document.body.style.right = "0";
        document.body.style.width = "100%";
      }

      //Overlay
      // Clean up any pending close operations from any component
      if (this.pageOverlayElement._pendingCloseHandler) {
        this.pageOverlayElement.removeEventListener(
          "transitionend",
          this.pageOverlayElement._pendingCloseHandler
        );
        this.pageOverlayElement._pendingCloseHandler = null;
      }
      if (this.pageOverlayElement._pendingCloseTimeout) {
        clearTimeout(this.pageOverlayElement._pendingCloseTimeout);
        this.pageOverlayElement._pendingCloseTimeout = null;
      }

      this.pageOverlayElement.style.display = 'block';
      requestAnimationFrame(() => {
        this.pageOverlayElement.classList.add("is-visible");
      });
      this.pageOverlayElement.addEventListener("click", this.closeNewsletter);

      bodyScrollLock.disableBodyScroll(this.element, bodyScrollLockOptions);
      document.body.style.setProperty('--scrollbar-gap', (window.innerWidth - document.documentElement.clientWidth > 0 ? window.innerWidth - document.documentElement.clientWidth : 0) + 'px');
      document.body.classList.add("scrollLock");
      IOSScrollLock.lock();

      localStorage.setItem('popup-seen', true);

      this.addA11yListeners();
      requestAnimationFrame(() => this.focusFirstElement());
    }, 1000 * this.options.delay);
  }

  closeNewsletter = () => {
    this.element.setAttribute('aria-hidden', true);

    //Overlay
    this.pageOverlayElement.classList.remove('is-visible');

    const transitionHandler = () => {
      if (this.pageOverlayElement._pendingCloseTimeout) {
        clearTimeout(this.pageOverlayElement._pendingCloseTimeout);
        this.pageOverlayElement._pendingCloseTimeout = null;
      }
      this.pageOverlayElement.style.display = 'none';
      this.pageOverlayElement.removeEventListener('transitionend', transitionHandler);
      this.pageOverlayElement._pendingCloseHandler = null;
    };

    // Store handler on overlay element so other components can clean it up
    this.pageOverlayElement._pendingCloseHandler = transitionHandler;
    this.pageOverlayElement.addEventListener('transitionend', transitionHandler);

    // Fallback in case transitionend doesn't fire
    this.pageOverlayElement._pendingCloseTimeout = setTimeout(() => {
      if (this.pageOverlayElement._pendingCloseHandler) {
        this.pageOverlayElement.removeEventListener(
          "transitionend",
          this.pageOverlayElement._pendingCloseHandler
        );
        this.pageOverlayElement._pendingCloseHandler = null;
      }
      this.pageOverlayElement.style.display = 'none';
      this.pageOverlayElement._pendingCloseTimeout = null;
    }, 850);

    this.pageOverlayElement.removeEventListener('click', this.closeNewsletter);

    bodyScrollLock.clearAllBodyScrollLocks();
    document.body.classList.remove("scrollLock");
    IOSScrollLock.unlock();
    document.body.style.removeProperty('--scrollbar-gap');

    // iOS: vratimo frozen scroll poziciju
    if (this._iosScrollFreeze) {
      const { scrollY, position, top, left, right, width } = this._iosScrollFreeze;
      document.body.style.position = position;
      document.body.style.top = top;
      document.body.style.left = left;
      document.body.style.right = right;
      document.body.style.width = width;

      this._iosScrollFreeze = null;
      window.scrollTo(0, scrollY);
    }

    if (this.myScrollListener) {
      this.myScrollListener.removeScrollListener();
      this.myScrollListener = null;
    }
    if (this._docHeightResizeListener) {
      this._docHeightResizeListener.removeResizeListener();
      this._docHeightResizeListener = null;
    }

    this.removeA11yListeners();

    const toFocus = this.previouslyFocusedElement;
    this.previouslyFocusedElement = null;
    if (toFocus && typeof toFocus.focus === "function") {
      requestAnimationFrame(() => toFocus.focus());
    }
  };

  async onSubmit(e) {
    e.preventDefault();

    const emailEl = this.element.querySelector("#klaviyoEmail");
    const email = emailEl.value.trim();

    if (!email) return;

    try {
      const response = await this.newsletterHandler.subscribe(email);
      if (response.ok) this.showSuccessState();
      // Success handler is called automatically in newsletterHandler
    } catch (error) {
      // Error handler is called automatically in newsletterHandler
    }
  }

  showSuccessState() {
    const popup = this.element;
    const contentWrapper = popup.querySelector(".newsletter-popup__content-wrapper");
    const success = popup.querySelector(".newsletter__success-wrapper");
    const duplicateWrapper = popup.querySelector(".newsletter__duplicate-email-wrapper");

    // Hide duplicate message if it was showing
    if (duplicateWrapper) {
      duplicateWrapper.style.display = "none";
    }

    contentWrapper.style.display = "none";
    success.style.display = "";

    requestAnimationFrame(() => this.focusFirstElement());
  }

  showDuplicateEmailMessage() {
    const popup = this.element;
    const form = popup.querySelector(".newsletter__form");
    const successWrapper = popup.querySelector(".newsletter__success-wrapper");
    const duplicateWrapper = successWrapper.querySelector(".newsletter__duplicate-email-wrapper");

    form.style.display = "none";
    successWrapper.style.display = "";
    duplicateWrapper.style.display = "";

    requestAnimationFrame(() => this.focusFirstElement());
  }
}

customElements.define('newsletter-popup', NewsletterPopup);

class LocalizationSelectors extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);
  }

  connectedCallback() {
    if (this._initialized) return;
    this._initialized = true;

    if (typeof Popup === "function" && !window.globalPopup) {
      window.globalPopup = new Popup();
    }

    this.btn = this.querySelector("#localization-selector-btn");
    this.modal = document.querySelector("#modal-country");
    if (!this.btn || !this.modal) return;

    if (this.modal.getAttribute("aria-hidden") === "true") {
      this.modal.style.display = "none";
    }

    const handleLock = () => {
      const isOpen = this.modal.getAttribute("aria-expanded") === "true";
      if (isOpen) {
        IOSScrollLock.lock();
        document.body.classList.add("localization-open");
      } else {
        IOSScrollLock.unlock();
        document.body.classList.remove("localization-open");
      }
    };

    this.syncState = () => {
      const isOpen = this.modal.getAttribute("aria-hidden") === "false";
      this.btn.classList.toggle("is-open", isOpen);
      handleLock();
    };

    this.syncState();

    this._observer = new MutationObserver(this.syncState);
    this._observer.observe(this.modal, {
      attributes: true,
      attributeFilter: ["aria-hidden", "aria-expanded"]
    });

    this.bindEvents();
  }

  bindEvents() {
    this.delegateElement.on("click", "#localization-selector-btn", () => {
      if (this._clickLocked) return;
      this._clickLocked = true;
      const currentlyOpen = this.modal.getAttribute("aria-hidden") === "false";
      this.btn.classList.toggle("is-open", !currentlyOpen);
      setTimeout(() => (this._clickLocked = false), 350);
    });
    this.delegateBody.on("click", ".pageOverlay", () => {
      this.btn.classList.remove("is-open");
    });
  }

  disconnectedCallback() {
    this._observer?.disconnect();
    this._observerCountryContent?.disconnect();
    this._observerCountryTitle?.disconnect();
    IOSScrollLock.unlock();
  }
}

customElements.define("localization-selectors", LocalizationSelectors);

class LocalizationModal extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
  }

  connectedCallback() {
    if (this._initialized) return;
    this._initialized = true;

    this.querySelectorAll(".RevolutionSelectbox").forEach(
      (box) => new RevolutionSelectbox(box)
    );

    const popup = this.closest(".Popup");
    this.noAnim = popup?.classList.contains("no-localization-anim");

    const killMotion = (root) => {
      if (!root) return;
      root.style.transition = "none";
      root.style.animation = "none";
      root.querySelectorAll("*").forEach((el) => {
        el.style.transition = "none";
        el.style.animation = "none";
      });
    };

    if (this.noAnim) {
      killMotion(popup);
      this.querySelectorAll(".RevolutionSelectbox--Content").forEach(killMotion);
    }

    this.countryBox = this.querySelector(".rs-country__selectbox");
    if (this.countryBox) {
      const title = this.countryBox.querySelector(".RevolutionSelectbox--Button .RevolutionSelectbox--Title");
      const content = this.countryBox.querySelector(".RevolutionSelectbox--Content");
      const showCurrency = this.countryBox.dataset.showCurrency === "true";

      const sync = () => {
        const sel = content?.querySelector(".RevolutionSelectbox--Item[selected='selected']");
        if (!title || !sel) return;
        const name = sel.dataset.name || title.textContent.trim();
        const cur = sel.dataset.currency;
        title.textContent = showCurrency && cur ? `${name} (${cur})` : name;
      };

      sync();
      this._observerCountryContent = new MutationObserver(sync);
      this._observerCountryContent.observe(content, {
        subtree: true,
        attributes: true,
        attributeFilter: ["selected"]
      });
      this._observerCountryTitle = new MutationObserver(sync);
      this._observerCountryTitle.observe(title, { childList: true, subtree: true });
    }

    this.form = this.closest("form#localization-form");
    if (!this.form) return;

    this.countryInput = this.form.querySelector("#country-selector__country-code");
    this.langInput = this.form.querySelector("#language-selector__language-code");
    this.langBox = this.querySelector(".rs-language__selectbox");
    this.langInner = this.langBox?.querySelector(".RevolutionSelectbox--InnerContent");

    this.enableDropdownScrollIOSWorkaround();
    this.bindEvents();
  }

  bindEvents() {
    this.delegateElement.on("click", ".rs-country__selectbox .RevolutionSelectbox--Item[data-value]", this.onCountryItemClick.bind(this));
    this.delegateElement.on("click", ".rs-language__selectbox .RevolutionSelectbox--Item[data-value]", this.onLanguageItemClick.bind(this));
  }

  parseLanguages(attr) {
    try {
      return JSON.parse(attr || "[]");
    } catch {
      return [];
    }
  }

  setLanguageButtonTitle(label) {
    const title = this.langBox?.querySelector(
      ".RevolutionSelectbox--Button .RevolutionSelectbox--Title .u-p4"
    );
    if (title) title.textContent = label;
  }

  renderLanguages(languages, currentIso) {
    if (!this.langInner) return;

    while (this.langInner.firstChild) this.langInner.removeChild(this.langInner.firstChild);

    languages.forEach((l) => {
      const item = document.createElement("div");
      item.className = "RevolutionSelectbox--Item";
      item.tabIndex = 0;
      item.setAttribute("data-value", l.iso);
      item.setAttribute("data-name", l.name);
      item.setAttribute("data-selectboxid", "language-selector__language-code");
      item.setAttribute("data-action", "selectbox-change");
      if (l.iso === currentIso) item.setAttribute("selected", "selected");

      const titleWrap = document.createElement("div");
      titleWrap.className = "RevolutionSelectbox--Title";
      const span = document.createElement("span");
      span.className = "RevolutionSelectbox--Title--language u-p4";
      span.textContent = l.name;
      titleWrap.appendChild(span);
      item.appendChild(titleWrap);
      this.langInner.appendChild(item);
    });

    const selected = languages.find((x) => x.iso === currentIso) || languages[0];
    if (selected) this.setLanguageButtonTitle(selected.name);

    if (this.noAnim) {
      this.langInner.style.transition = "none";
      this.langInner.style.animation = "none";
    }
  }

  onCountryItemClick(e) {
    const item = e.target.closest(".RevolutionSelectbox--Item[data-value]");
    if (!item) return;
    e.preventDefault();
    e.stopPropagation();

    const newCountry = item.getAttribute("data-value");
    const langs = this.parseLanguages(item.getAttribute("data-languages"));
    const currentLang = this.langInput?.value;
    const supported = langs.some((l) => l.iso === currentLang);
    const newLang = supported ? currentLang : (langs[0]?.iso || "en");

    if (this.countryInput) this.countryInput.value = newCountry;
    if (this.langInput) this.langInput.value = newLang;

    this.renderLanguages(langs, newLang);
    this.form.submit();
  }

  onLanguageItemClick(e) {
    const item = e.target.closest(".RevolutionSelectbox--Item[data-value]");
    if (!item) return;
    e.preventDefault();
    e.stopPropagation();

    const newLang = item.getAttribute("data-value");
    if (this.langInput) this.langInput.value = newLang;
    this.form.submit();
  }

  enableDropdownScrollIOSWorkaround() {
    const contents = this.querySelectorAll(".RevolutionSelectbox--Content");
    if (!contents.length) return;

    contents.forEach((content) => {
      const isOpen = () => content.getAttribute("aria-hidden") === "false";
      const startAllow = () => content.setAttribute("data-scrollable", "");
      const endAllow = () => content.removeAttribute("data-scrollable");
      let startY = 0;

      content.addEventListener("touchstart", () => {
        if (!isOpen()) return;
        startAllow();
      }, { passive: true });
      content.addEventListener("touchstart", (e) => {
        if (!isOpen()) return;
        startY = e.touches?.[0]?.clientY ?? 0;
      }, { passive: true });
      content.addEventListener("touchmove", (e) => {
        if (!isOpen()) return;
        startAllow();
        e.stopPropagation();

        // If the dropdown can't scroll, prevent the page/body from scrolling.
        const canScroll = content.scrollHeight > content.clientHeight;
        if (!canScroll) {
          e.preventDefault();
          return;
        }

        // Prevent iOS "scroll chaining" when reaching top/bottom of the dropdown.
        const currentY = e.touches?.[0]?.clientY ?? startY;
        const deltaY = currentY - startY; // >0 = moving down, <0 = moving up
        const atTop = content.scrollTop <= 0;
        const atBottom = content.scrollTop + content.clientHeight >= content.scrollHeight - 1;
        if ((atTop && deltaY > 0) || (atBottom && deltaY < 0)) {
          e.preventDefault();
        }
      }, { passive: false });
      content.addEventListener("touchend", endAllow, { passive: true });
      content.addEventListener("touchcancel", endAllow, { passive: true });
    });
  }

  disconnectedCallback() {
    this._observerCountryContent?.disconnect();
    this._observerCountryTitle?.disconnect();
    this.delegateElement?.off?.();
  }
}

customElements.define("localization-modal", LocalizationModal);


class SwiperInit extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.swiper = null;
    this.initializationMode = this.getInitializationMode();
    this.intersectionObserver = null;
    this.isDynamic = this.element.hasAttribute('data-swiper-dynamic');
    this.isDynamicOnce = this.element.hasAttribute('data-swiper-dynamic-once');
    this.isHorizontalFadeDesktop = this.element.hasAttribute('data-swiper-fade-horizontal-desktop');
    this.isHorizontalFadeMobile = this.element.hasAttribute('data-swiper-fade-horizontal-mobile');
    this.isHorizontalFade = this.element.hasAttribute('data-swiper-fade-horizontal');
    this.hasBeenInitialized = false; // Track if dynamic-once has been initialized

    // Bind methods
    this.handleBreakpointChange = this.handleBreakpointChange.bind(this);
    this.handleIntersection = this.handleIntersection.bind(this);
  }

  getInitializationMode() {
    // Check data attributes to determine mode
    if (this.element.hasAttribute('data-swiper-mobile')) {
      return 'mobile';
    } else if (this.element.hasAttribute('data-swiper-desktop')) {
      return 'desktop';
    } else if (this.element.hasAttribute('data-swiper-tablet')) {
      return 'tablet';
    } else {
      return 'universal';
    }
  }

  connectedCallback() {
    // Listen to responsive system breakpoint changes
    document.addEventListener('breakpoint:changed', this.handleBreakpointChange);

    // Set up intersection observer for dynamic swipers
    if (this.isDynamic || this.isDynamicOnce) {
      this.setupIntersectionObserver();
    } else {
      // Auto-initialize if not dynamic and not disabled
      if (!this.element.hasAttribute('data-swiper-manual')) {
        this.initSwiper();
      }
    }
  }

  disconnectedCallback() {
    document.removeEventListener('breakpoint:changed', this.handleBreakpointChange);
    this.cleanupIntersectionObserver();
    this.destroy();
  }

  setupIntersectionObserver() {
    // Get threshold from attribute or use default
    const threshold = parseFloat(this.element.getAttribute('data-swiper-dynamic-threshold')) || 0.1;

    // Get root margin from attribute or use default
    const rootMargin = this.element.getAttribute('data-swiper-dynamic-margin') || '50px';

    this.intersectionObserver = new IntersectionObserver(this.handleIntersection, {
      threshold: threshold,
      rootMargin: rootMargin,
    });

    this.intersectionObserver.observe(this.element);

    console.log(
      `SwiperInit: ${this.isDynamicOnce ? 'Dynamic-once' : 'Dynamic'} mode enabled with threshold: ${threshold}, margin: ${rootMargin}`,
    );
  }

  cleanupIntersectionObserver() {
    if (this.intersectionObserver) {
      this.intersectionObserver.disconnect();
      this.intersectionObserver = null;
    }
  }

  handleIntersection(entries) {
    entries.forEach((entry) => {
      if (entry.target === this.element) {
        if (entry.isIntersecting) {
          // Element is in view - initialize if should be active
          if (this.shouldInitialize() && !this.swiper) {
            console.log('SwiperInit: Element in view - initializing');
            this.initSwiper();
          }
        } else {
          // Element is out of view
          if (this.isDynamic && this.swiper) {
            // Dynamic mode: destroy when out of view
            console.log('SwiperInit: Element out of view - destroying');
            this.destroy();
          }
          // Dynamic-once mode: keep swiper active once initialized
        }
      }
    });
  }

  handleBreakpointChange(event) {
    const { currentBreakpoint } = event.detail;

    // Check if we should be active on this breakpoint
    const shouldBeActive = this.shouldInitialize(currentBreakpoint);
    const currentlyActive = !!this.swiper;

    // For dynamic swipers, only initialize if also in view
    if (this.isDynamic || this.isDynamicOnce) {
      // Let the intersection observer handle initialization
      // Just destroy if shouldn't be active
      if (!shouldBeActive && currentlyActive) {
        this.destroy();
      }
    } else {
      // Normal behavior for non-dynamic swipers
      if (shouldBeActive && !currentlyActive) {
        this.initSwiper();
      } else if (!shouldBeActive && currentlyActive) {
        this.destroy();
      } else if (shouldBeActive && currentlyActive) {
        this.initSwiper();
      }
    }
  }

  initHorizontalFadeOnSwiper() {
    const swiper = this.element.getSwiper();
    const swiperInstance = swiper.swiperElement;
    if (!swiper) return;

    // Add "content-fade" class here
    this.element.classList.add('content-fade');
    const fadeContainer = this.element;

    const update = () => this.updateHorizontalFadeClasses(swiperInstance, fadeContainer);

    // Initial update
    update();

    // Listen to swiper events
    swiperInstance.on('slideChange', update);
    swiperInstance.on('resize', update);
    swiperInstance.on('progress', update);
    swiperInstance.on('touchMove', update);

    window.addEventListener('resize', update);
  }

  updateHorizontalFadeClasses(swiperInstance, fadeContainer) {
    const c = fadeContainer.classList;
    c.remove('fade-left', 'fade-right', 'fade-both-horizontal');

    const atStart = swiperInstance.isBeginning;
    const atEnd = swiperInstance.isEnd;

    if (!atStart && !atEnd) {
      c.add('fade-both-horizontal');
    } else if (!atStart) {
      c.add('fade-left');
    } else if (!atEnd) {
      c.add('fade-right');
    }
  }

  shouldInitialize(breakpoint = null) {
    const currentBreakpoint = breakpoint || responsive.getCurrentBreakpoint();

    switch (this.initializationMode) {
      case 'mobile':
        return ['phone', 'pocket'].includes(currentBreakpoint);
      case 'desktop':
        return ['desktop', 'lap_and_up', 'desktop_wide'].includes(currentBreakpoint);
      case 'tablet':
        return ['tablet', 'tablet_and_up'].includes(currentBreakpoint);
      case 'universal':
        return true;
      default:
        return true;
    }
  }

  initSwiper() {
    // Don't initialize if we shouldn't be active
    if (!this.shouldInitialize()) {
      return;
    }

    // Destroy existing swiper
    this.destroy();

    try {
      // Get thumb element if specified
      const thumbSelector = this.element.getAttribute('data-swiper-thumb');
      const thumbElement = thumbSelector ? document.querySelector(thumbSelector) : null;

      // Use existing RevolutionSwiper class as-is
      this.swiper = new RevolutionSwiper(this.element, thumbElement);

      // Mark as initialized for dynamic-once mode
      if (this.isDynamicOnce) {
        this.hasBeenInitialized = true;
      }

      if (this.isHorizontalFadeDesktop && responsive.matchesBreakpoint('lap_and_up')) {
        this.initHorizontalFadeOnSwiper(this.element);
      }

      const currentBreakpoint = responsive.getCurrentBreakpoint();
      if (this.isHorizontalFadeMobile && (currentBreakpoint === 'phone' || currentBreakpoint === 'pocket')) {
        this.initHorizontalFadeOnSwiper(this.element);
      }

      if (this.isHorizontalFade) {
        this.initHorizontalFadeOnSwiper(this.element);
      }

      // Dispatch initialization event
      this.element.dispatchEvent(
        new CustomEvent('swiper:initialized', {
          bubbles: true,
          detail: {
            breakpoint: responsive.getCurrentBreakpoint(),
            mode: this.initializationMode,
            isDynamic: this.isDynamic,
            isDynamicOnce: this.isDynamicOnce,
            swiper: this.swiper,
          },
        }),
      );

      console.log(
        `SwiperInit: Initialized for ${responsive.getCurrentBreakpoint()} (${this.initializationMode}${this.isDynamic ? ' - dynamic' : ''}${this.isDynamicOnce ? ' - dynamic-once' : ''})`,
      );
    } catch (error) {
      console.error('SwiperInit: Failed to initialize swiper', error);
    }
  }

  destroy() {
    if (this.swiper && this.swiper.swiperElement) {
      this.swiper.swiperElement.destroy(true, true);
      this.swiper = null;

      this.element.dispatchEvent(
        new CustomEvent('swiper:destroyed', {
          bubbles: true,
          detail: {
            breakpoint: responsive.getCurrentBreakpoint(),
            mode: this.initializationMode,
            isDynamic: this.isDynamic,
            isDynamicOnce: this.isDynamicOnce,
          },
        }),
      );
    }
  }

  // Public API methods
  selectSlide(index) {
    if (this.swiper && this.swiper.selectCell) {
      this.swiper.selectCell(index);
    } else {
      // Wait for swiper to initialize, then select
      this.element.addEventListener(
        'swiper:initialized',
        () => {
          if (this.swiper && this.swiper.selectCell) {
            this.swiper.selectCell(index);
          }
        },
        { once: true },
      );
    }
  }

  resize() {
    if (this.swiper) {
      this.swiper.resize();
    }
  }

  getSwiper() {
    return this.swiper;
  }

  getCurrentBreakpoint() {
    return responsive.getCurrentBreakpoint();
  }

  reinitialize() {
    this.initSwiper();
  }

  isDynamicSwiper() {
    return this.isDynamic || this.isDynamicOnce;
  }

  getDynamicMode() {
    if (this.isDynamic) return 'dynamic';
    if (this.isDynamicOnce) return 'dynamic-once';
    return 'static';
  }

  // Static method to initialize all swipers
  static initializeAll() {
    document.querySelectorAll('swiper-init').forEach((element) => {
      element.initSwiper();
    });
  }
}
customElements.define('swiper-init', SwiperInit);

class AnimatedAnnouncementBar extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.announcementBar = document.querySelector('.announcement-bar');
    this.isSticky = this.element.getAttribute('data-sticky');

    this.updateVisibleHeight();
    this.isElementSticky();

    this.transitionSpeed = this.element.getAttribute('data-settings');
    this.animWrapper = this.element.querySelector('.announcement-bar__anim-wrapper');
    this.original = this.element.querySelector('.announcement-bar__duplicate-wrapper');

    this.itemCount = this.original ? this.original.children.length : 0;
    this.hasSingleItem = this.itemCount === 1;

    if (!this.hasSingleItem) {
      let children = Array.from(this.original.children);
      let index = 0;

      while (children.length < 4 && children.length > 0) {
        this.original.appendChild(children[index].cloneNode(true));
        children = Array.from(this.original.children);
        index++;
      }
    } else {
      this.transitionSpeed = null;
    }

    this.firstLoad = true;

    this._observeIntersection();
    this.bindEvents();
  }

  _observeIntersection() {
    this.intersectionObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const visibleHeight = Math.round(entry.intersectionRect.height);
          document.documentElement.style.setProperty('--announcement-dynamic-height', `${visibleHeight}px`);
        });
      },
      {
        root: null,
        threshold: Array.from({ length: 51 }, (_, i) => i / 50),
      },
    );
    this.intersectionObserver.observe(this);
  }

  connectedCallback() {
    document.documentElement.style.setProperty('--announcement-height-fixed', this.element.clientHeight + 'px');
    this.updateVisibleHeight();
  }

  bindEvents() {
    this.handleBreakpointChange();

    this.element.addEventListener('mouseenter', this.pauseAnimation.bind(this));
    this.element.addEventListener('mouseleave', this.resumeAnimation.bind(this));
  }

  pauseAnimation() {
    ContinuousMarqueeAnimator.pause(this.animation);
  }

  resumeAnimation() {
    ContinuousMarqueeAnimator.play(this.animation);
  }

  stopAnimation() {
    ContinuousMarqueeAnimator.cancel(this.animation);
    this.animation = null;
  }

  isElementSticky() {
    if (this.isSticky == 'true') {
      this.element.closest('.shopify-section').classList.add('announcement--sticky');
    } else {
      this.element.closest('.shopify-section').classList.remove('announcement--sticky');
    }
  }

  updateVisibleHeight() {
    const rect = this.element.getBoundingClientRect();
    const windowHeight = window.innerHeight;

    let visibleHeight = Math.min(rect.bottom, windowHeight) - Math.max(rect.top, 0);
    visibleHeight = Math.max(visibleHeight, 0);

    document.documentElement.style.setProperty('--announcement-dynamic-height', `${visibleHeight}px`);
  }

  handleBreakpointChange() {
    if (this.hasSingleItem) {
      this.stopAnimation();

      Array.from(this.original.children).forEach((block, i) => {
        block.style.display = i === 0 ? 'flex' : 'none';
      });

      this.original.style.justifyContent = 'center';
      this.original.style.width = 'fit-content';
      this.animWrapper.style.position = 'relative';
      this.animWrapper.style.width = '100%';
      this.animWrapper.style.transform = '';

      return;
    }

    if (responsive.matchesBreakpoint('lap_and_up')) {
      this.mobile = false;
      if (this.transitionSpeed) {
        this.duplicateBlockWrappers();
      } else {
        Array.from(this.original.children).forEach((block) => (block.style.display = 'flex'));
        this.original.style.justifyContent = 'space-between';
      }
    } else {
      this.mobile = true;
      if (this.transitionSpeed) {
        this.duplicateBlockWrappers();
      } else {
        Array.from(this.original.children).forEach((block, i) => {
          if (i != 0) block.style.display = 'none';
        });
        this.original.style.justifyContent = 'center';
      }
    }
  }

  resetWrapper() {
    Array.from(this.animWrapper.children).forEach((child, i) => {
      if (i != 0) this.animWrapper.removeChild(this.animWrapper.lastChild);
    });
    this.originalNew = this.element.offsetWidth - parseInt(getComputedStyle(this.element).paddingLeft) * 2;
  }

  duplicateBlockWrappers() {
    this.resetWrapper();
    if (this.original != null) {
      const duplicate = this.original.cloneNode(true),
        spaceDiv = document.createElement('div');
      spaceDiv.style.flexShrink = 0;
      if (this.original.children.length == 1) {
        var duplicate2 = duplicate.cloneNode(true);
        var spaceDiv2 = spaceDiv.cloneNode(true);
      }

      var originalWidth = (originalWidth = this.original.offsetWidth);
      if (this.originalNew) originalWidth = this.originalNew;

      if (this.mobile) {
        if (this.original.children.length >= 2) {
          duplicate.style.width = originalWidth * this.original.children.length - window.innerWidth + 'px';
          this.original.style.width = originalWidth * this.original.children.length - window.innerWidth + 'px';
          this.animWrapper.style.width = 2 * (originalWidth * this.original.children.length - window.innerWidth) + 'px';
        } else {
          duplicate.style.width = 'fit-content';
          if (duplicate2) duplicate2.style.width = 'fit-content';
          this.original.style.width = 'fit-content';
          const originalWidthAfter = this.original.offsetWidth;
          setTimeout(() => {
            this.animWrapper.style.width = 2 * originalWidthAfter + 400 + 'px';
          }, 0);
        }

        if (this.original.children.length >= 2)
          this.spaceDivWidth = this.getDistanceBetweenBlocks(this.original.children[0], this.original.children[1]);
        else this.spaceDivWidth = 200;
      } else {
        if (this.original.children.length >= 2)
          this.spaceDivWidth = this.getDistanceBetweenBlocks(this.original.children[0], this.original.children[1]);
        else this.spaceDivWidth = 0;

        duplicate.style.width = originalWidth + 'px';
        this.original.style.width = originalWidth + 'px';
        this.animWrapper.style.width = 2 * originalWidth + this.spaceDivWidth + 'px';
      }

      spaceDiv.style.width = this.spaceDivWidth + 'px';
      if (spaceDiv2) {
        spaceDiv2.style.width = this.spaceDivWidth + 'px';
      }

      this.animWrapper.style.position = 'absolute';
      if (this.mobile && this.firstLoad) this.animWrapper.style.transform = `translateX(${this.spaceDivWidth / 2}px)`;

      this.element.style.height = this.animWrapper.offsetHeight + 'px';

      this.animWrapper.appendChild(spaceDiv);
      this.animWrapper.appendChild(duplicate);
      if (this.original.children.length == 1 && this.mobile) {
        this.animWrapper.appendChild(spaceDiv2);
        this.animWrapper.appendChild(duplicate2);
      }

      setTimeout(() => {
        this.startAnimating();
      }, 100);
    }
  }

  startAnimating() {
    var translate = 0;
    this.mobile && this.firstLoad ? (translate = this.spaceDivWidth / 2) : (translate = 0);
    var wasFirstLoad = this.firstLoad;
    this.firstLoad = false;

    this.animation = this.animWrapper.animate(
      [
        { transform: `translateX(${translate}px)` },
        { transform: `translateX(calc(-50% - ${this.spaceDivWidth / 2}px))` },
      ],
      {
        duration: parseInt(this.transitionSpeed) * 1000,
        iterations: Infinity,
        fill: 'forwards',
        easing: 'linear',
        // Hold the first announcement visible for 1.5s before scrolling starts
        // so users actually see it instead of catching the animation mid-cycle
        delay: wasFirstLoad ? 1500 : 0,
      },
    );
  }

  getDistanceBetweenBlocks(blockOne, blockTwo) {
    return blockTwo.getBoundingClientRect().left - blockOne.getBoundingClientRect().right;
  }
}
customElements.define('announcement-bar', AnimatedAnnouncementBar);


class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
  }

  connectedCallback() {
    this.loadRecommendations();
  }

  async loadRecommendations() {
    const url = this.dataset?.url;
    if (!url) {
      return;
    }

    try {
      const response = await fetch(url);
      if (!response.ok) throw new Error(`Failed to fetch content: ${response.status} ${response.statusText}`);

      const text = await response.text();
      const html = document.createElement("div");
      html.innerHTML = text;

      const recommendations = html.querySelector(".product-recommendation");
      if (!recommendations || !recommendations.innerHTML.trim()) {
        return;
      }

      this.innerHTML = recommendations.innerHTML;

      const cartMode = document.body.dataset.cartMode || "drawer";
      if (cartMode === "drawer") {
        new AddToCart(this.element);
      }

    } catch (error) {
      // Error loading carousel content
    }
  }
}
customElements.define("product-recommendations", ProductRecommendations);


class UspSection extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.sectionId = this.dataset.sectionId || null;
    this.wrapper = null;
    this._isInitialized = false;
    this.closeItemBound = this.closeItem.bind(this);
    this.gridPagination = null;
    this.gridPaginationResizeListener = null;
    this.descriptionToggleResizeListener = null;
    this.descriptionToggleObservers = [];
    this.descriptionCollapseTimeouts = new Map();
    this.descriptionCollapseDelayMs = 500;
  }

  connectedCallback() {
    if (this._isInitialized) return;
    this.wrapper = this.element.querySelector(".usp-section__wrapper");
    if (!this.wrapper) {
      console.error("UspSection: .usp-section__wrapper not found inside <usp-section>.");
      return;
    }
    this._isInitialized = true;
    this.bindEvents();
    this.initGridPagination();
    this.descriptionToggleResizeListener = responsive.addResizeListener(this, () => {
      this.updateDescriptionToggles();
    });
    this.initDescriptionToggleObservers();
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        this.updateDescriptionToggles();
      });
    });
    const hash = window.location.hash.slice(1);
    if (hash) {
      const target = this.wrapper.querySelector(".usp-item#" + CSS.escape(hash));
      if (target) {
        this.showGridPageForItem(target);
        this.openItem(target);
      }
    }
  }

  disconnectedCallback() {
    this.destroy();
  }

  destroy() {
    if (this.delegateElement) this.delegateElement.off();
    if (this.gridPaginationResizeListener?.removeResizeListener) {
      this.gridPaginationResizeListener.removeResizeListener();
    }
    if (this.descriptionToggleResizeListener?.removeResizeListener) {
      this.descriptionToggleResizeListener.removeResizeListener();
    }
    this.descriptionToggleObservers.forEach((observer) => observer.disconnect());
    this.descriptionToggleObservers = [];
    this.clearAllDescriptionCollapseTimeouts();
    this.resetGridPaginationItems();
    this.gridPaginationResizeListener = null;
    this.descriptionToggleResizeListener = null;
    this.gridPagination = null;
    this.wrapper = null;
    this._isInitialized = false;
  }

  isDesktop() {
    const matchesDesktop = responsive.matchesBreakpoint("lap_and_up");
    const hasFinePointer = window.matchMedia("(hover: hover) and (pointer: fine)").matches;
    return matchesDesktop && hasFinePointer;
  }

  isClickOnlyTrigger() {
    return this.element.dataset.uspTrigger === "click";
  }

  bindEvents() {
    // Mobile: click plus / close
    this.delegateElement.on(
      "click",
      '[data-action="usp-block-toggle"]',
      this.handleToggleClick.bind(this)
    );

    this.delegateElement.on(
      "click",
      '[data-action="usp-info-close"]',
      this.handleCloseClick.bind(this)
    );

    this.delegateElement.on(
      "click",
      '[data-action="usp-description-toggle"]',
      this.handleDescriptionToggle.bind(this)
    );

    this.delegateElement.on(
      "click",
      '[data-action="usp-grid-prev"]',
      this.handleGridPaginationPrev.bind(this)
    );

    this.delegateElement.on(
      "click",
      '[data-action="usp-grid-next"]',
      this.handleGridPaginationNext.bind(this)
    );

    this.delegateElement.on(
      "click",
      '[data-action="usp-grid-page"]',
      this.handleGridPaginationPage.bind(this)
    );

    // Desktop: hover open/close (only when hover is enabled)
    if (!this.isClickOnlyTrigger()) {
      this.delegateElement.on(
        "mouseover",
        ".usp-item",
        this.handleItemMouseOver.bind(this)
      );

      this.delegateElement.on(
        "mouseout",
        ".usp-item",
        this.handleItemMouseOut.bind(this)
      );
    }
  }

  initGridPagination() {
    if (!this.hasAttribute("data-mobile-grid-pagination") || !this.wrapper) return;

    const controls = this.wrapper.querySelector("[data-usp-grid-pagination]");
    const pages = this.wrapper.querySelector("[data-usp-grid-pagination-pages]");
    const items = Array.from(this.wrapper.querySelectorAll(".usp-item"));
    const pageSize = parseInt(this.dataset.mobileGridPageSize, 10) || 6;

    if (!controls || !pages || items.length <= pageSize) return;

    this.gridPagination = {
      controls,
      pages,
      items,
      pageSize,
      currentPage: 0,
      totalPages: Math.ceil(items.length / pageSize),
    };

    this.renderGridPaginationPages();
    this.updateGridPagination();
    this.gridPaginationResizeListener = responsive.addResizeListener(this, this.updateGridPagination);
  }

  isMobileGridPaginationActive() {
    if (!this.gridPagination) return false;
    return ["phone", "pocket"].includes(responsive.getCurrentBreakpoint());
  }

  renderGridPaginationPages() {
    if (!this.gridPagination) return;

    const { pages, currentPage, totalPages } = this.gridPagination;
    const nextWrapper = pages.querySelector("[data-usp-grid-next-wrapper]");
    if (!nextWrapper) return;

    pages.querySelectorAll("[data-usp-grid-page-item]").forEach((item) => item.remove());

    const currentPageNumber = currentPage + 1;
    const windowStart = Math.max(1, currentPageNumber - 1);
    const windowEnd = Math.min(totalPages, currentPageNumber + 1);
    const fragment = document.createDocumentFragment();
    const appendPage = (pageNumber) => {
      const item = document.createElement("li");
      item.className = "Pagination--ItemWrapper";
      item.setAttribute("data-usp-grid-page-item", "");

      const button = document.createElement("button");
      button.type = "button";
      button.className = "Pagination--Item link u-p4";
      button.setAttribute("data-action", "usp-grid-page");
      button.setAttribute("data-page", String(pageNumber - 1));
      button.setAttribute("aria-label", `Page ${pageNumber}`);
      button.textContent = String(pageNumber);

      item.appendChild(button);
      fragment.appendChild(item);
    };
    const appendEllipsis = () => {
      const item = document.createElement("li");
      item.className = "Pagination--ItemWrapper";
      item.setAttribute("data-usp-grid-page-item", "");
      item.innerHTML = '<span class="Pagination--Item">...</span>';
      fragment.appendChild(item);
    };

    if (windowStart > 1) {
      appendPage(1);
      if (windowStart > 2) appendEllipsis();
    }

    for (let pageNumber = windowStart; pageNumber <= windowEnd; pageNumber += 1) {
      appendPage(pageNumber);
    }

    if (windowEnd < totalPages) {
      if (windowEnd < totalPages - 1) appendEllipsis();
      appendPage(totalPages);
    }

    pages.insertBefore(fragment, nextWrapper);
  }

  updateGridPagination() {
    if (!this.gridPagination) return;

    if (!this.isMobileGridPaginationActive()) {
      this.gridPagination.controls.hidden = true;
      this.resetGridPaginationItems();
      return;
    }

    const { controls, items, pageSize, totalPages } = this.gridPagination;
    const currentPage = Math.min(this.gridPagination.currentPage, totalPages - 1);
    this.gridPagination.currentPage = currentPage;
    controls.hidden = totalPages <= 1;

    items.forEach((item, index) => {
      const itemPage = Math.floor(index / pageSize);
      const isVisible = itemPage === currentPage;
      item.classList.add("usp-section__grid-page");
      item.classList.toggle("is-hidden", !isVisible);
      item.setAttribute("aria-hidden", isVisible ? "false" : "true");
      if (!isVisible) this.closeItem(item);
    });

    this.renderGridPaginationPages();
    this.updateGridPaginationControls();
  }

  updateGridPaginationControls() {
    if (!this.gridPagination) return;

    const { controls, currentPage, totalPages } = this.gridPagination;
    const prev = controls.querySelector('[data-action="usp-grid-prev"]');
    const next = controls.querySelector('[data-action="usp-grid-next"]');

    if (prev) prev.disabled = currentPage === 0;
    if (next) next.disabled = currentPage === totalPages - 1;

    controls.querySelectorAll('[data-action="usp-grid-page"]').forEach((button) => {
      const isActive = parseInt(button.dataset.page, 10) === currentPage;
      button.classList.toggle("Pagination--ItemCurrent", isActive);
      button.classList.toggle("link", !isActive);
      if (isActive) {
        button.setAttribute("aria-current", "page");
      } else {
        button.removeAttribute("aria-current");
      }
    });
  }

  resetGridPaginationItems() {
    if (!this.gridPagination) return;

    this.gridPagination.items.forEach((item) => {
      item.classList.remove("usp-section__grid-page", "is-hidden");
      item.removeAttribute("aria-hidden");
    });
  }

  setGridPage(page) {
    if (!this.gridPagination) return;

    const nextPage = Math.max(0, Math.min(page, this.gridPagination.totalPages - 1));
    if (nextPage === this.gridPagination.currentPage && this.isMobileGridPaginationActive()) return;

    const itemsEl = this.wrapper?.querySelector(".usp-section__items");
    const shouldAnimate = this.isMobileGridPaginationActive() && !window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (shouldAnimate && itemsEl) itemsEl.classList.add("is-page-changing");

    this.gridPagination.currentPage = nextPage;
    window.setTimeout(() => {
      this.updateGridPagination();
      if (shouldAnimate && itemsEl) {
        requestAnimationFrame(() => itemsEl.classList.remove("is-page-changing"));
      }
      if (this.isMobileGridPaginationActive()) {
        const firstVisibleItem = this.gridPagination.items[nextPage * this.gridPagination.pageSize];
        if (firstVisibleItem) {
          firstVisibleItem.scrollIntoView({ behavior: shouldAnimate ? "smooth" : "auto", block: "start" });
        }
      }
    }, shouldAnimate ? 160 : 0);
  }

  showGridPageForItem(item) {
    if (!this.gridPagination || !item) return;

    const index = this.gridPagination.items.indexOf(item);
    if (index < 0) return;

    this.gridPagination.currentPage = Math.floor(index / this.gridPagination.pageSize);
    this.updateGridPagination();
  }

  handleGridPaginationPrev(e) {
    e.preventDefault();
    if (!this.gridPagination) return;
    this.setGridPage(this.gridPagination.currentPage - 1);
  }

  handleGridPaginationNext(e) {
    e.preventDefault();
    if (!this.gridPagination) return;
    this.setGridPage(this.gridPagination.currentPage + 1);
  }

  handleGridPaginationPage(e) {
    e.preventDefault();
    const btn = e.target.closest('[data-action="usp-grid-page"]');
    const page = parseInt(btn?.dataset?.page, 10);
    if (!Number.isNaN(page)) this.setGridPage(page);
  }

  openItem(item) {
    if (!item || !item.isConnected || item.classList.contains("is-open")) return;
    item.classList.add("is-open");

    const toggle = item.querySelector('[data-action="usp-block-toggle"]');
    if (toggle) toggle.setAttribute("aria-expanded", "true");

    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        this.updateDescriptionToggles(item);
      });
    });
  }

  clearDescriptionCollapseTimeout(item) {
    const timeoutId = this.descriptionCollapseTimeouts.get(item);
    if (!timeoutId) return;
    clearTimeout(timeoutId);
    this.descriptionCollapseTimeouts.delete(item);
  }

  clearAllDescriptionCollapseTimeouts() {
    this.descriptionCollapseTimeouts.forEach((timeoutId) => clearTimeout(timeoutId));
    this.descriptionCollapseTimeouts.clear();
  }

  scheduleDescriptionCollapse(item) {
    if (!item?.querySelector(".usp-info__description-wrapper.is-expanded")) return;
    this.clearDescriptionCollapseTimeout(item);
    const timeoutId = setTimeout(() => {
      this.descriptionCollapseTimeouts.delete(item);
      this.collapseDescriptions(item);
    }, this.descriptionCollapseDelayMs);
    this.descriptionCollapseTimeouts.set(item, timeoutId);
  }

  collapseDescriptions(item) {
    if (!item) return;
    item.querySelectorAll(".usp-info__description-wrapper").forEach((wrapper) => {
      wrapper.classList.remove("is-expanded");
      const btn = wrapper.querySelector('[data-action="usp-description-toggle"]');
      if (btn) btn.setAttribute("aria-expanded", "false");
    });
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        this.updateDescriptionToggles(item);
      });
    });
  }

  closeItem(item) {
    if (!item || !item.isConnected || !item.classList.contains("is-open")) return;
    const toggle = item.querySelector('[data-action="usp-block-toggle"]');
    item.classList.remove("is-open");
    if (toggle) toggle.setAttribute("aria-expanded", "false");
    if (item.id && item.id.startsWith("ingredient-") && window.location.hash === "#" + item.id) {
      history.replaceState(null, "", window.location.pathname + window.location.search);
    }
  }

  closeAll(exceptItem = null) {
    if (!this.wrapper) return;
    this.wrapper.querySelectorAll(".usp-item.is-open").forEach((item) => {
      if (item === exceptItem) return;
      this.closeItem(item);
      this.scheduleDescriptionCollapse(item);
    });
  }

  closeAllImmediate() {
    this.clearAllDescriptionCollapseTimeouts();
    if (!this.wrapper) return;
    this.wrapper.querySelectorAll(".usp-item.is-open").forEach((item) => {
      this.closeItem(item);
      this.collapseDescriptions(item);
    });
  }

  handleToggleClick(e) {
    // Desktop: plus does nothing when hover is enabled (hover only)
    if (this.isDesktop() && !this.isClickOnlyTrigger()) return;

    const btn = e.delegateTarget || e.target;
    const item = btn.closest(".usp-item");
    if (!item) return;

    this.closeAllImmediate();
    this.openItem(item);
  }

  handleCloseClick(e) {
    const btn = e.delegateTarget || e.target;
    const item = btn.closest(".usp-item");
    if (!item) return;
    this.clearDescriptionCollapseTimeout(item);
    this.closeItem(item);
    this.collapseDescriptions(item);
  }

  handleDescriptionToggle(e) {
    const btn = e.delegateTarget || e.target;
    const wrapper = btn.closest(".usp-info__description-wrapper");
    if (!wrapper) return;

    const isExpanded = wrapper.classList.toggle("is-expanded");
    btn.setAttribute("aria-expanded", isExpanded ? "true" : "false");
    if (isExpanded) wrapper.dataset.truncated = "1";
    if (!isExpanded) this.updateDescriptionToggle(wrapper);
  }

  initDescriptionToggleObservers() {
    if (!this.wrapper || typeof ResizeObserver === "undefined") return;

    this.wrapper.querySelectorAll(".usp-info__description-wrapper").forEach((wrapper) => {
      const observer = new ResizeObserver(() => {
        this.updateDescriptionToggle(wrapper);
      });
      observer.observe(wrapper);
      this.descriptionToggleObservers.push(observer);
    });
  }

  isDescriptionTruncated(wrapper) {
    const content = wrapper.querySelector(".usp-info__description-content");
    const measure = wrapper.querySelector(".usp-info__description-measure");
    if (!content || !measure) return null;

    const width = content.offsetWidth || wrapper.offsetWidth;
    if (width <= 0) return null;

    measure.style.width = `${width}px`;
    const clampedHeight = content.clientHeight;
    const fullHeight = measure.scrollHeight;

    return fullHeight > clampedHeight;
  }

  updateDescriptionToggle(wrapper) {
    const btn = wrapper?.querySelector('[data-action="usp-description-toggle"]');
    if (!btn) return;

    if (wrapper.classList.contains("is-expanded")) {
      btn.hidden = wrapper.dataset.truncated !== "1";
      return;
    }

    const isTruncated = this.isDescriptionTruncated(wrapper);
    if (isTruncated === null) return;

    wrapper.dataset.truncated = isTruncated ? "1" : "0";
    btn.hidden = !isTruncated;

    if (!isTruncated) {
      wrapper.classList.remove("is-expanded");
      btn.setAttribute("aria-expanded", "false");
    }
  }

  updateDescriptionToggles(root = this.wrapper) {
    if (!root) return;
    root.querySelectorAll(".usp-info__description-wrapper").forEach((wrapper) => {
      this.updateDescriptionToggle(wrapper);
    });
  }

  handleItemMouseOver(e) {
    if (!this.isDesktop()) return;

    const item = e.delegateTarget || e.target.closest(".usp-item");
    if (!item || !this.contains(item)) return;

    const from = e.relatedTarget;
    if (from && item.contains(from)) return;

    this.clearDescriptionCollapseTimeout(item);
    this.closeAll(item);
    this.openItem(item);
  }

  handleItemMouseOut(e) {
    if (!this.isDesktop()) return;

    const item = e.delegateTarget || e.target.closest(".usp-item");
    if (!item || !this.contains(item)) return;

    const to = e.relatedTarget;
    if (to && item.contains(to)) return;

    this.closeItem(item);
    this.scheduleDescriptionCollapse(item);
  }
}

if (!customElements.get("usp-section")) {
  customElements.define("usp-section", UspSection);
}

// Input fields that accept only digits (e.g. contact form number type)
(function initNumberOnlyInputs() {
  var delegate = new Delegate(document.body);
  function allowDigitsOnly(el) {
    var start = el.selectionStart;
    var end = el.selectionEnd;
    var val = el.value.replace(/\D/g, "");
    if (val !== el.value) {
      el.value = val;
      var len = val.length;
      el.setSelectionRange(Math.min(start, len), Math.min(end, len));
    }
  }
  delegate.on("input", ".js-input-number-only", function (e) {
    allowDigitsOnly(e.target);
  });
  delegate.on("paste", ".js-input-number-only", function (e) {
    e.preventDefault();
    var pasted = (e.clipboardData || window.clipboardData).getData("text").replace(/\D/g, "");
    var el = e.target;
    var start = el.selectionStart;
    var end = el.selectionEnd;
    el.value = el.value.slice(0, start) + pasted + el.value.slice(end);
    el.setSelectionRange(start + pasted.length, start + pasted.length);
  });
})();

class FAQSection extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.options = JSON.parse(this.element.getAttribute('data-section-settings'));
  }

  connectedCallback() {
    this.searchInput = this.element.querySelector('.faq-search__input');
    this.noResultsTermEl = this.element.querySelector('#faq__no-results-term');

    this.firstTag = this.element.querySelector('.faq-tab');
    if (this.firstTag) this.firstTag.classList.add('is-active');

    this.bindEvents();
    this.disableUnlinkedTabs();
    requestAnimationFrame(() => this.initializeFaqDropdowns());

    this._onSwiperInit = (e) => {
      const swiperEl = e.target;
      if (!swiperEl || swiperEl.tagName?.toLowerCase() !== 'swiper-init') return;
      if (!this.element.contains(swiperEl)) return;
      if (!['phone', 'pocket'].includes(responsive.getCurrentBreakpoint())) return;

      const swiperInstance = swiperEl?.swiper?.swiperElement;
      if (!swiperInstance || typeof swiperInstance.slideTo !== 'function') return;
      if (swiperEl.__faqClickBound) return;
      swiperEl.__faqClickBound = true;

      swiperEl.addEventListener('pointerup', () => {
        const index = swiperInstance.clickedIndex;
        if (typeof index !== 'number' || index < 0) return;
        swiperInstance.slideTo(index, 300);
      });
    };

    document.addEventListener('swiper:initialized', this._onSwiperInit);
  }

  disconnectedCallback() {
    this.delegateElement.off();
    if (this._onSwiperInit) {
      document.removeEventListener('swiper:initialized', this._onSwiperInit);
    }
    if (this._sectionObserver) {
      this._sectionObserver.disconnect();
      this._sectionObserver = null;
    }
    if (this._sectionObserverResize?.removeResizeListener) {
      this._sectionObserverResize.removeResizeListener();
      this._sectionObserverResize = null;
    }
    clearTimeout(this.slideToActiveTabTimeout);
  }

  bindEvents() {
    this.onInputListener = debounce(this.handleSearch.bind(this), 350);
    this.debouncedHandleClick = debounce(this.handleTabClick.bind(this), 200);

    this.delegateElement.on(
      'click',
      '[data-action="handle-tab-click"]',
      (event, target) => this.debouncedHandleClick(event, target)
    );

    this.delegateElement.on('click', '[data-action="clear-search"]', this.clearSearch.bind(this));
    this.delegateElement.on('keyup', '[data-action="search-string"]', this.onInputListener);

    this._setupSectionObserver();
    this._sectionObserverResize = responsive.addResizeListener(this, this._setupSectionObserver.bind(this));
  }

  _setupSectionObserver() {
    if (this._sectionObserver) {
      this._sectionObserver.disconnect();
      this._sectionObserver = null;
    }

    const sections = Array.from(this.element.querySelectorAll('.faq-group'));
    if (!sections.length) return;

    const isMobile = ['phone', 'pocket'].includes(responsive.getCurrentBreakpoint());
    let rootMargin;

    if (isMobile) {
      rootMargin = '-50% 0px -50% 0px';
    } else {
      const rootStyles = getComputedStyle(document.documentElement);
      const annHeight = parseInt(rootStyles.getPropertyValue('--announcement-dynamic-height')) || 0;
      const headerHeight = parseInt(rootStyles.getPropertyValue('--header-dynamic-height')) || 0;
      const tabsWrapper = this.element.querySelector('.faq-tabs');
      const tabsHeight = this.options?.stickyTabs ? tabsWrapper?.offsetHeight || 0 : 0;
      const top = annHeight + headerHeight + tabsHeight;
      const bottom = Math.max(0, (window.innerHeight || 0) - top - 1);
      rootMargin = `-${top}px 0px -${bottom}px 0px`;
    }

    this._sectionObserver = new IntersectionObserver(
      (entries) => {
        if (this.element.dataset.clicked === 'true') return;
        const intersecting = entries.filter((e) => e.isIntersecting);
        if (!intersecting.length) return;
        intersecting.sort((a, b) => a.boundingClientRect.top - b.boundingClientRect.top);
        const activeId = intersecting[0].target.id;
        if (!activeId) return;
        this.setActiveTabById(activeId);
        this.slideToActiveTab();
      },
      { rootMargin, threshold: 0 },
    );

    sections.forEach((s) => this._sectionObserver.observe(s));
  }

  centerTabInSwiper(tabEl) {
    if (!['phone', 'pocket'].includes(responsive.getCurrentBreakpoint())) return;

    const swiperEl = this.element.querySelector('.faq-tabs swiper-init');
    const s = swiperEl?.swiper?.swiperElement;
    if (!s) return;

    const slideEl = tabEl.closest('.swiper-slide');
    if (!slideEl) return;

    const slides = Array.from(s.slides || []);
    const index = slides.indexOf(slideEl);
    if (index < 0) return;

    const targetSlide = slides[index];
    const slideCenter = targetSlide.offsetLeft + targetSlide.offsetWidth / 2;
    let translate = s.width / 2 - slideCenter;

    const min = s.minTranslate ? s.minTranslate() : s.translate;
    const max = s.maxTranslate ? s.maxTranslate() : s.translate;
    
    translate = Math.max(min, Math.min(translate, max));

    s.setTransition?.(300);
    s.setTranslate?.(translate);
    s.updateProgress?.(translate);
    s.updateActiveIndex?.();
    s.updateSlidesClasses?.();
  }

  setActiveTabById(toggleId) {
    if (!toggleId) return;

    const tabs = this.element.querySelectorAll('.faq-tab');
    tabs.forEach((tab) => {
      const isMatch = tab.getAttribute('data-toggle-id') === toggleId;
      tab.setAttribute('aria-expanded', isMatch ? 'true' : 'false');
      tab.classList.toggle('is-active', isMatch);
    });
  }

  getActiveToggleId() {
    const activeBtn = this.element.querySelector('.faq-tab[aria-expanded="true"]');
    if (activeBtn?.dataset?.toggleId) return activeBtn.dataset.toggleId;
    const firstBtn = this.element.querySelector('.faq-tab');
    return firstBtn?.dataset?.toggleId || null;
  }

  showDropdownById(toggleId) {
    const dropdowns = this.element.querySelectorAll('.faq-group');
    dropdowns.forEach((dd) => {
      const match = dd.id === toggleId;
      dd.setAttribute('aria-hidden', String(!match));
    });
  }

  resetFaqToInitialState() {
    const tabsWrapper = this.element.querySelector('.faq-tabs');
    const dropdownList = this.element.querySelectorAll('.faq-group');
    const noResultsElement = this.element.querySelector('.faq__no-results');

    if (tabsWrapper) tabsWrapper.classList.remove('is-hidden');

    // Always show all tabs in the default state
    const tabs = this.element.querySelectorAll('.faq-tab');
    tabs.forEach((tab) => {
      tab.classList.remove('is-hidden');
    });

    dropdownList.forEach((dropdown) => {
      dropdown.classList.remove('is-hidden');
      dropdown.setAttribute('aria-hidden', 'false');

      // Unhide all dropdown wrappers and their items
      const wrappers = dropdown.querySelectorAll('.faq-dropdown-wrap');
      wrappers.forEach((wrap) => {
        wrap.classList.remove('is-hidden');
        const questions = wrap.querySelectorAll('.Dropdown');
        questions.forEach((content) => content.classList.remove('is-hidden'));
      });
    });

    if (noResultsElement) noResultsElement.classList.add('is-hidden');
  }

  toggleClearButton(show) {
    const clearBtn = this.element.querySelector('.faq-search__clear');
    if (clearBtn) clearBtn.classList.toggle('is-hidden', !show);
  }

  disableUnlinkedTabs() {
    const tabs = this.element.querySelectorAll('.faq-tab');
    tabs.forEach((tab) => {
      const toggleId = tab.getAttribute('data-toggle-id');
      const targetDropdown = this.element.querySelector(`.faq-group[id="${toggleId}"]`);
      if (!targetDropdown) tab.style.cursor = 'default';
    });
  }

  toggleNoResults(show) {
    const noResultsElement = this.element.querySelector('.faq__no-results');
    if (noResultsElement) {
      noResultsElement.classList.toggle('is-hidden', !show);
    }
  }

  contentMatches(element, searchTerm) {
    return element?.textContent.toLowerCase().includes(searchTerm) || false;
  }

  handleSearch() {
    const searchTerm = this.searchInput.value.toLowerCase().trim();
    this.toggleClearButton(!!this.searchInput.value);

    const tabsWrapper = this.element.querySelector('.faq-tabs');
    if (tabsWrapper) tabsWrapper.classList.remove('is-hidden');

    if (searchTerm === '') {
      if (this.noResultsTermEl) this.noResultsTermEl.textContent = '';
      this.resetFaqToInitialState();
      this.toggleNoResults(false);
      return;
    }

    let hasGlobalMatch = false;

    this.element.querySelectorAll('.faq-group').forEach((dropdown) => {
      const wrappers = dropdown.querySelectorAll('.faq-dropdown-wrap');
      let hasTabMatch = false;

      wrappers.forEach((wrap) => {
        const questions = wrap.querySelectorAll('.Dropdown');
        let wrapperMatch = false;

        const tabTitle = dropdown.querySelector('.faq-group__heading .u-h3');
        const titleMatch = this.contentMatches(tabTitle, searchTerm);

        // Filter individual dropdown items inside each wrapper
        questions.forEach((questionWrapper) => {
          const questionTitle = questionWrapper.querySelector('.faq-item__question');
          const answerContent = questionWrapper.querySelector('.faq-item__answer');
          const questionMatches = this.contentMatches(questionTitle, searchTerm);
          const answerMatches = this.contentMatches(answerContent, searchTerm);

          if (questionMatches || answerMatches) {
            questionWrapper.classList.remove('is-hidden');
            wrapperMatch = true;
          } else {
            questionWrapper.classList.add('is-hidden');
          }
        });

        // If no item matched but the group title did, treat wrapper as a match
        if (!wrapperMatch && titleMatch) {
          wrapperMatch = true;
        }

        wrap.classList.toggle('is-hidden', !wrapperMatch);

        if (wrapperMatch) hasTabMatch = true;
      });

      // Hide entire group only if all its wrappers are hidden
      dropdown.classList.toggle('is-hidden', !hasTabMatch);
      if (hasTabMatch) hasGlobalMatch = true;
    });

    if (hasGlobalMatch) {
      this.toggleNoResults(false);

      // Sync aria-hidden from is-hidden class — all matching groups must stay visible
      this.element.querySelectorAll('.faq-group').forEach((dd) => {
        dd.setAttribute('aria-hidden', String(dd.classList.contains('is-hidden')));
      });

      // Hide tabs that don't have any visible groups when searching
      const visibleGroupIds = new Set(
        Array.from(this.element.querySelectorAll('.faq-group:not(.is-hidden)'))
          .map((dd) => dd.id)
          .filter(Boolean)
      );

      const tabs = this.element.querySelectorAll('.faq-tab');
      tabs.forEach((tab) => {
        const toggleId = tab.getAttribute('data-toggle-id');
        const shouldShow = !visibleGroupIds.size || visibleGroupIds.has(toggleId);
        tab.classList.toggle('is-hidden', !shouldShow);
      });

      const firstVisibleGroup = this.element.querySelector('.faq-group:not(.is-hidden)');
      if (firstVisibleGroup?.id) {
        const id = firstVisibleGroup.id;
        this.setActiveTabById(id);

        const esc = window.CSS?.escape ? CSS.escape(id) : id;
        const tabEl = this.element.querySelector(`.faq-tab[data-toggle-id="${esc}"]`);
        if (tabEl) this.centerTabInSwiper(tabEl);
      }
    } else {
      if (this.noResultsTermEl) this.noResultsTermEl.textContent = this.searchInput.value.trim();

      const tabsWrapper = this.element.querySelector('.faq-tabs');
      if (tabsWrapper) tabsWrapper.classList.remove('is-hidden');

      const tabs = this.element.querySelectorAll('.faq-tab');
      tabs.forEach((tab) => {
        tab.classList.remove('is-hidden');
      });

      const dropdownList = this.element.querySelectorAll('.faq-group');
      dropdownList.forEach((dropdown) => {
        dropdown.classList.remove('is-hidden');
        dropdown.setAttribute('aria-hidden', 'false');

        dropdown.querySelectorAll('.faq-dropdown-wrap').forEach((wrap) => {
          wrap.classList.remove('is-hidden');
        });

        dropdown.querySelectorAll('.Dropdown').forEach((question) => {
          question.classList.remove('is-hidden');
        });
      });

      this.toggleNoResults(true);
    }
  }

  clearSearch() {
    if (this.searchInput) {
      this.searchInput.value = '';
      this.searchInput.focus();
    }
    if (this.noResultsTermEl) this.noResultsTermEl.textContent = '';
    this.toggleClearButton(false);
    this.resetFaqToInitialState();
  }

  initializeFaqDropdowns() {
    const tabsWrapper = this.element.querySelector('.faq-tabs');
    if (tabsWrapper) tabsWrapper.classList.remove('is-hidden');

    const allGroups = this.element.querySelectorAll('.faq-group');
    allGroups.forEach((dd) => {
      dd.setAttribute('aria-hidden', 'false');
    });

    const allTabs = this.element.querySelectorAll('.faq-tab');
    allTabs.forEach((tab) => {
      tab.setAttribute('aria-expanded', 'false');
      tab.classList.remove('is-active');
    });
  }

  handleTabClick(event, target) {
    event.preventDefault();

    const tabEl = target || event.currentTarget;
    if (!tabEl) return;

    const targetId = tabEl.getAttribute('data-toggle-id');
    if (!targetId) return;

    this.element.dataset.clicked = 'true';

    this.setActiveTabById(targetId);
    this.slideToActiveTab(0);

    const targetDropdown = this.element.querySelector(`.faq-group[id="${targetId}"]`);
    if (targetDropdown) this.scrollToSection(targetDropdown);

    setTimeout(() => {
      this.element.dataset.clicked = 'false';
    }, 800);
  }

  scrollToSection(targetElement) {
    if (!targetElement) return;

    const rootStyles = getComputedStyle(document.documentElement);
    const annHeight =
      parseInt(rootStyles.getPropertyValue('--announcement-dynamic-height')) || 0;
    const headerHeight =
      parseInt(rootStyles.getPropertyValue('--header-dynamic-height')) || 0;

    const tabsWrapper = this.element.querySelector('.faq-tabs');
    const tabsHeight = this.options?.stickyTabs ? tabsWrapper?.offsetHeight || 0 : 0;
    const offset = annHeight + headerHeight + tabsHeight;

    const rect = targetElement.getBoundingClientRect();
    const targetPosition = window.scrollY + rect.top - offset;

    window.scrollTo({ top: targetPosition, behavior: 'smooth' });
  }

  slideToActiveTab(delay = 0) {
    clearTimeout(this.slideToActiveTabTimeout);
    this.slideToActiveTabTimeout = setTimeout(() => {
      const activeTab =
        this.element.querySelector('.faq-tab[aria-expanded="true"]') ||
        this.element.querySelector('.faq-tab.is-active');
      if (!activeTab) return;

      const slideElement = activeTab.closest('.swiper-slide');
      if (!slideElement) return;

      const swiperEl =
        this.element.querySelector('swiper-init.swiper') ||
        this.element.querySelector('.swiper');

      if (!swiperEl || !swiperEl.swiper) return;

      const s = swiperEl.swiper.swiperElement;
      if (!s || typeof s.slideTo !== 'function') return;

      const slides = Array.from(swiperEl.querySelectorAll('.swiper-slide'));
      const activeIndex = slides.indexOf(slideElement);

      if (activeIndex !== -1) {
        s.slideTo(activeIndex, 300);
      }
    }, delay);
  }

}

customElements.define('faq-section', FAQSection);

class TermsSection extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.options = JSON.parse(this.element.getAttribute('data-section-settings'));
  }

  connectedCallback() {
    this.searchInput = this.element.querySelector('.terms-search__input');
    this.noResultsTermEl = this.element.querySelector('#terms__no-results-term');

    this.firstTag = this.element.querySelector('.terms-tab');
    if (this.firstTag) this.firstTag.classList.add('is-active');

    this.bindEvents();
    this.disableUnlinkedTabs();
    requestAnimationFrame(() => this.initializeTermsDropdowns());
  }

  disconnectedCallback() {
    this.delegateElement.off();
    if (this._sectionObserver) {
      this._sectionObserver.disconnect();
      this._sectionObserver = null;
    }
    if (this._sectionObserverResize?.removeResizeListener) {
      this._sectionObserverResize.removeResizeListener();
      this._sectionObserverResize = null;
    }
    clearTimeout(this.slideToActiveTabTimeout);
  }

  bindEvents() {
    this.onInputListener = debounce(this.handleSearch.bind(this), 350);
    this.debouncedHandleClick = debounce(this.handleTabClick.bind(this), 200);

    this.delegateElement.on(
      'click',
      '[data-action="handle-tab-click"]',
      (event, target) => this.debouncedHandleClick(event, target)
    );

    this.delegateElement.on('click', '[data-action="clear-search"]', this.clearSearch.bind(this));
    this.delegateElement.on('keyup', '[data-action="search-string"]', this.onInputListener);

    this._setupSectionObserver();
    this._sectionObserverResize = responsive.addResizeListener(this, this._setupSectionObserver.bind(this));
  }

  _setupSectionObserver() {
    if (this._sectionObserver) {
      this._sectionObserver.disconnect();
      this._sectionObserver = null;
    }

    const sections = Array.from(this.element.querySelectorAll('.terms-group'));
    if (!sections.length) return;

    const isMobile = ['phone', 'pocket'].includes(responsive.getCurrentBreakpoint());
    let rootMargin;

    if (isMobile) {
      rootMargin = '-50% 0px -50% 0px';
    } else {
      const rootStyles = getComputedStyle(document.documentElement);
      const annHeight = parseInt(rootStyles.getPropertyValue('--announcement-dynamic-height')) || 0;
      const headerHeight = parseInt(rootStyles.getPropertyValue('--header-dynamic-height')) || 0;
      const tabsWrapper = this.element.querySelector('.terms-tabs');
      const tabsHeight = tabsWrapper?.offsetHeight || 0;
      const top = annHeight + headerHeight + tabsHeight;
      const bottom = Math.max(0, (window.innerHeight || 0) - top - 1);
      rootMargin = `-${top}px 0px -${bottom}px 0px`;
    }

    this._sectionObserver = new IntersectionObserver(
      (entries) => {
        if (this.element.dataset.clicked === 'true') return;
        const intersecting = entries.filter((e) => e.isIntersecting);
        if (!intersecting.length) return;
        intersecting.sort((a, b) => a.boundingClientRect.top - b.boundingClientRect.top);
        const activeId = intersecting[0].target.id;
        if (!activeId) return;
        this.setActiveTabById(activeId);
        this.slideToActiveTab();
      },
      { rootMargin, threshold: 0 },
    );

    sections.forEach((s) => this._sectionObserver.observe(s));
  }

  centerTabInSwiper(tabEl) {
    if (!['phone', 'pocket'].includes(responsive.getCurrentBreakpoint())) return;

    const swiperEl = this.element.querySelector('.terms-tabs swiper-init');
    const s = swiperEl?.swiper?.swiperElement;
    if (!s) return;

    const slideEl = tabEl.closest('.swiper-slide');
    if (!slideEl) return;

    const slides = Array.from(s.slides || []);
    const index = slides.indexOf(slideEl);
    if (index < 0) return;

    const targetSlide = slides[index];
    const slideCenter = targetSlide.offsetLeft + targetSlide.offsetWidth / 2;
    let translate = s.width / 2 - slideCenter;

    const min = s.minTranslate ? s.minTranslate() : s.translate;
    const max = s.maxTranslate ? s.maxTranslate() : s.translate;
 
    translate = Math.max(min, Math.min(translate, max));

    s.setTransition?.(300);
    s.setTranslate?.(translate);
    s.updateProgress?.(translate);
    s.updateActiveIndex?.();
    s.updateSlidesClasses?.();
  }

  setActiveTabById(toggleId) {
    if (!toggleId) return;

    const tabs = this.element.querySelectorAll('.terms-tab');
    tabs.forEach((tab) => {
      const isMatch = tab.getAttribute('data-toggle-id') === toggleId;
      tab.setAttribute('aria-expanded', isMatch ? 'true' : 'false');
      tab.classList.toggle('is-active', isMatch);
    });
  }

  getActiveToggleId() {
    const activeBtn = this.element.querySelector('.terms-tab[aria-expanded="true"]');
    if (activeBtn?.dataset?.toggleId) return activeBtn.dataset.toggleId;
    const firstBtn = this.element.querySelector('.terms-tab');
    return firstBtn?.dataset?.toggleId || null;
  }

  showDropdownById(toggleId) {
    const dropdowns = this.element.querySelectorAll('.terms-group');
    dropdowns.forEach((dd) => {
      const match = dd.id === toggleId;
      dd.setAttribute('aria-hidden', String(!match));
    });
  }

  resetTermsToInitialState() {
    const tabsWrapper = this.element.querySelector('.terms-tabs');
    const dropdownList = this.element.querySelectorAll('.terms-group');
    const noResultsElement = this.element.querySelector('.terms__no-results');

    if (tabsWrapper) tabsWrapper.classList.remove('is-hidden');

    // Always show all tabs in the default state
    const tabs = this.element.querySelectorAll('.terms-tab');
    tabs.forEach((tab) => {
      tab.classList.remove('is-hidden');
    });

    dropdownList.forEach((dropdown) => {
      dropdown.classList.remove('is-hidden');
      dropdown.setAttribute('aria-hidden', 'false');

      // Unhide all dropdown wrappers and their items
      const wrappers = dropdown.querySelectorAll('.terms-dropdown-wrap');
      wrappers.forEach((wrap) => {
        wrap.classList.remove('is-hidden');
        const questions = wrap.querySelectorAll('.Dropdown');
        questions.forEach((content) => content.classList.remove('is-hidden'));
      });
    });

    if (noResultsElement) noResultsElement.classList.add('is-hidden');
  }

  toggleClearButton(show) {
    const clearBtn = this.element.querySelector('.terms-search__clear');
    if (clearBtn) clearBtn.classList.toggle('is-hidden', !show);
  }

  disableUnlinkedTabs() {
    const tabs = this.element.querySelectorAll('.terms-tab');
    tabs.forEach((tab) => {
      const toggleId = tab.getAttribute('data-toggle-id');
      const targetDropdown = this.element.querySelector(`.terms-group[id="${toggleId}"]`);
      if (!targetDropdown) tab.style.cursor = 'default';
    });
  }

  toggleNoResults(show) {
    const noResultsElement = this.element.querySelector('.terms__no-results');
    if (noResultsElement) {
      noResultsElement.classList.toggle('is-hidden', !show);
    }
  }

  contentMatches(element, searchTerm) {
    return element?.textContent.toLowerCase().includes(searchTerm) || false;
  }

  handleSearch() {
    const searchTerm = this.searchInput.value.toLowerCase().trim();
    this.toggleClearButton(!!this.searchInput.value);

    const tabsWrapper = this.element.querySelector('.terms-tabs');
    if (tabsWrapper) tabsWrapper.classList.remove('is-hidden');

    if (searchTerm === '') {
      if (this.noResultsTermEl) this.noResultsTermEl.textContent = '';
      this.resetTermsToInitialState();
      this.toggleNoResults(false);
      return;
    }

    let hasGlobalMatch = false;

    this.element.querySelectorAll('.terms-group').forEach((dropdown) => {
      const wrappers = dropdown.querySelectorAll('.terms-dropdown-wrap');
      let hasTabMatch = false;

      wrappers.forEach((wrap) => {
        const questions = wrap.querySelectorAll('.Dropdown');
        let wrapperMatch = false;

        const tabTitle = dropdown.querySelector('.terms-group__heading .u-h3');
        const titleMatch = this.contentMatches(tabTitle, searchTerm);

        // Filter individual dropdown items inside each wrapper
        questions.forEach((questionWrapper) => {
          const questionTitle = questionWrapper.querySelector('.terms-item__question');
          const answerContent = questionWrapper.querySelector('.terms-item__answer');
          const questionMatches = this.contentMatches(questionTitle, searchTerm);
          const answerMatches = this.contentMatches(answerContent, searchTerm);

          if (questionMatches || answerMatches) {
            questionWrapper.classList.remove('is-hidden');
            wrapperMatch = true;
          } else {
            questionWrapper.classList.add('is-hidden');
          }
        });

        // If no item matched but the group title did, treat wrapper as a match
        if (!wrapperMatch && titleMatch) {
          wrapperMatch = true;
        }

        wrap.classList.toggle('is-hidden', !wrapperMatch);

        if (wrapperMatch) hasTabMatch = true;
      });

      // Hide entire group only if all its wrappers are hidden
      dropdown.classList.toggle('is-hidden', !hasTabMatch);
      if (hasTabMatch) hasGlobalMatch = true;
    });

    if (hasGlobalMatch) {
      this.toggleNoResults(false);

      // Sync aria-hidden from is-hidden class — all matching groups must stay visible
      this.element.querySelectorAll('.terms-group').forEach((dd) => {
        dd.setAttribute('aria-hidden', String(dd.classList.contains('is-hidden')));
      });

      // Hide tabs that don't have any visible groups when searching
      const visibleGroupIds = new Set(
        Array.from(this.element.querySelectorAll('.terms-group:not(.is-hidden)'))
          .map((dd) => dd.id)
          .filter(Boolean)
      );

      const tabs = this.element.querySelectorAll('.terms-tab');
      tabs.forEach((tab) => {
        const toggleId = tab.getAttribute('data-toggle-id');
        const shouldShow = !visibleGroupIds.size || visibleGroupIds.has(toggleId);
        tab.classList.toggle('is-hidden', !shouldShow);
      });

      const firstVisibleGroup = this.element.querySelector('.terms-group:not(.is-hidden)');
      if (firstVisibleGroup?.id) {
        const id = firstVisibleGroup.id;
        this.setActiveTabById(id);

        const esc = window.CSS?.escape ? CSS.escape(id) : id;
        const tabEl = this.element.querySelector(`.terms-tab[data-toggle-id="${esc}"]`);
        if (tabEl) this.centerTabInSwiper(tabEl);
      }
    } else {
      if (this.noResultsTermEl) this.noResultsTermEl.textContent = this.searchInput.value.trim();
      this.resetTermsToInitialState();
      this.toggleNoResults(true);
    }
  }

  clearSearch() {
    if (this.searchInput) {
      this.searchInput.value = '';
      this.searchInput.focus();
    }
    if (this.noResultsTermEl) this.noResultsTermEl.textContent = '';
    this.toggleClearButton(false);
    this.resetTermsToInitialState();
  }

  initializeTermsDropdowns() {
    const tabsWrapper = this.element.querySelector('.terms-tabs');
    if (tabsWrapper) tabsWrapper.classList.remove('is-hidden');

    const allGroups = this.element.querySelectorAll('.terms-group');
    allGroups.forEach((dd) => {
      dd.setAttribute('aria-hidden', 'false');
    });

    const allTabs = this.element.querySelectorAll('.terms-tab');
    allTabs.forEach((tab) => {
      tab.setAttribute('aria-expanded', 'false');
      tab.classList.remove('is-active');
    });
  }

  handleTabClick(event, target) {
    event.preventDefault();

    const tabEl = target || event.currentTarget;
    if (!tabEl) return;
    const targetId = tabEl.getAttribute('data-toggle-id');
    if (!targetId) return;

    this.element.dataset.clicked = 'true';

    this.setActiveTabById(targetId);

    this.slideToActiveTab(0);

    const targetDropdown = this.element.querySelector(`.terms-group[id="${targetId}"]`);
    if (targetDropdown) this.scrollToSection(targetDropdown);

    setTimeout(() => {
      this.element.dataset.clicked = 'false';
    }, 800);
  }

  scrollToSection(targetElement) {
    if (!targetElement) return;

    const rootStyles = getComputedStyle(document.documentElement);
    const annHeight =
      parseInt(rootStyles.getPropertyValue('--announcement-dynamic-height')) || 0;
    const headerHeight =
      parseInt(rootStyles.getPropertyValue('--header-dynamic-height')) || 0;

    const tabsWrapper = this.element.querySelector('.terms-tabs');
    const tabsHeight = tabsWrapper?.offsetHeight || 0;
    const offset = annHeight + headerHeight + tabsHeight;

    const rect = targetElement.getBoundingClientRect();
    const targetPosition = window.scrollY + rect.top - offset;

    window.scrollTo({ top: targetPosition, behavior: 'smooth' });
  }

  slideToActiveTab(delay = 0) {
    clearTimeout(this.slideToActiveTabTimeout);
    this.slideToActiveTabTimeout = setTimeout(() => {
      const activeTab =
        this.element.querySelector('.terms-tab[aria-expanded="true"]') ||
        this.element.querySelector('.terms-tab.is-active');
      if (!activeTab) return;

      const slideElement = activeTab.closest('.swiper-slide');
      if (!slideElement) return;

      const swiperEl =
        this.element.querySelector('swiper-init.swiper') ||
        this.element.querySelector('.swiper');

      if (!swiperEl || !swiperEl.swiper) return;

      const s = swiperEl.swiper.swiperElement;
      if (!s || typeof s.slideTo !== 'function') return;

      const slides = Array.from(swiperEl.querySelectorAll('.swiper-slide'));
      const activeIndex = slides.indexOf(slideElement);

      if (activeIndex !== -1) {
        s.slideTo(activeIndex, 300);
      }
    }, delay);
  }

}

customElements.define('terms-section', TermsSection);

class IngredientChecker extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);

    // vezane reference za event listenere (da ih možemo maknuti u disconnectedCallback)
    this.handleCheckBound = this.handleCheck.bind(this);
    this.handleResetBound = this.handleReset.bind(this);

    this._isInitialized = false;
  }

  connectedCallback() {
    if (this._isInitialized) return;

    this.textarea = this.querySelector(".ingredient-checker__textarea");
    this.resultsWrapper = this.querySelector(".ingredient-checker-results-wrapper");
    this.resultsSection = this.querySelector(".ingredient-checker_results__section");

    if (!this.resultsWrapper || !this.textarea) {
      return;
    }

    this.safeListEl = this.resultsWrapper.querySelector(".results-card--safe ul");
    this.unsafeListEl = this.resultsWrapper.querySelector(".results-card--unsafe ul");
    this.unsafeCard = this.resultsWrapper.querySelector(".results-card--unsafe");
    this.safeCard = this.resultsWrapper.querySelector(".results-card--safe");
    this.subtitleEl = this.resultsWrapper.querySelector(".ingredient-checker-results-subtitle");
    this.unknownEl = this.resultsWrapper.querySelector(".ingredient-checker-unknown");

    // metaobject podaci iz data atributa
    try {
      this.safeIngredients = JSON.parse(this.resultsWrapper.dataset.safe || "[]");
      this.safeLinks = JSON.parse(this.resultsWrapper.dataset.safeLinks || "[]");
      this.safeHandles = JSON.parse(this.resultsWrapper.dataset.safeHandles || "[]");
      this.unsafeIngredients = JSON.parse(this.resultsWrapper.dataset.unsafe || "[]");
      this.unsafeLinks = JSON.parse(this.resultsWrapper.dataset.unsafeLinks || "[]");
      this.unsafeHandles = JSON.parse(this.resultsWrapper.dataset.unsafeHandles || "[]");
    } catch (e) {
      console.error("IngredientChecker: failed to parse dataset lists", e);
      this.safeIngredients = [];
      this.safeLinks = [];
      this.safeHandles = [];
      this.unsafeIngredients = [];
      this.unsafeLinks = [];
      this.unsafeHandles = [];
    }

    // osiguraj da su liste uvijek nizovi (ne null) i napravi index mape za brzi lookup
    if (!Array.isArray(this.safeIngredients)) this.safeIngredients = [];
    if (!Array.isArray(this.safeLinks)) this.safeLinks = [];
    if (!Array.isArray(this.safeHandles)) this.safeHandles = [];
    if (!Array.isArray(this.unsafeIngredients)) this.unsafeIngredients = [];
    if (!Array.isArray(this.unsafeLinks)) this.unsafeLinks = [];
    if (!Array.isArray(this.unsafeHandles)) this.unsafeHandles = [];

    this.safeIndexByName = new Map(this.safeIngredients.map((n, i) => [String(n).toLowerCase(), i]));
    this.unsafeIndexByName = new Map(this.unsafeIngredients.map((n, i) => [String(n).toLowerCase(), i]));

    this.safeSet = new Set(this.safeIngredients.map((i) => i.toLowerCase()));
    this.unsafeSet = new Set(this.unsafeIngredients.map((i) => i.toLowerCase()));

    this.safeLinkMap = new Map(
      this.safeIngredients.map((name, idx) => {
        const base = this.safeLinks[idx];
        const handle = this.safeHandles[idx];
        const url =
          base && handle && base.indexOf("#") === -1
            ? base.replace(/\/$/, "") + "#ingredient-" + handle
            : base || null;
        return [name.toLowerCase(), url];
      })
    );

    this.unsafeLinkMap = new Map(
      this.unsafeIngredients.map((name, idx) => {
        const base = this.unsafeLinks[idx];
        const handle = this.unsafeHandles[idx];
        const url =
          base && handle && base.indexOf("#") === -1
            ? base.replace(/\/$/, "") + "#ingredient-" + handle
            : base || null;
        return [name.toLowerCase(), url];
      })
    );

    try {
      this.ingredientImageUrls = JSON.parse(
        this.resultsWrapper.dataset.ingredientImageUrls || "{}"
      );
    } catch (e) {
      console.error("IngredientChecker: failed to parse ingredientImageUrls", e);
      this.ingredientImageUrls = {};
    }

    this.delegateElement.on(
      "click",
      ".check_button",
      this.handleCheckBound
    );
    this.delegateElement.on(
      "click",
      ".reset_button",
      this.handleResetBound
    );

    this._isInitialized = true;
  }

  disconnectedCallback() {
    try {
      this.delegateElement?.off?.();
    } catch (e) {}
  }

  handleCheck(event) {
    event.preventDefault();

    const value = this.textarea.value || '';
    // razbij po zarezu, točki-zarezu i novom redu, trim + lower
    const inputIngredients = value
      .split(/[,;\n]+/)
      .map(i => i.trim())
      .filter(i => i.length > 0);

    const safeFound = [];
    const unsafeFound = [];
    const unknownFound = [];

    inputIngredients.forEach(raw => {
      const normalized = raw.toLowerCase();
      if (this.unsafeSet.has(normalized)) {
        unsafeFound.push(raw);
      } else if (this.safeSet.has(normalized)) {
        safeFound.push(raw);
      } else {
        unknownFound.push(raw);
      }
    });

    const noResultsSubtitle = this.resultsWrapper.querySelector('.ingredient-checker-no-results-subtitle');

    // isprazni postojeće liste
    this.safeListEl.innerHTML = '';
    this.unsafeListEl.innerHTML = '';

    // sakrij unknown count i "no results" poruku — više ih ne koristimo
    if (this.unknownEl) {
      this.unknownEl.textContent = '';
      this.unknownEl.classList.remove('is-visible');
    }
    if (noResultsSubtitle) {
      noResultsSubtitle.classList.remove('is-visible');
    }

    // ako nema niti jednog flagged (unsafe) sastojka, pokaži pozitivnu poruku i sakrij kartice
    if (unsafeFound.length === 0) {
      if (this.safeCard) this.safeCard.classList.add('is-hidden');
      if (this.unsafeCard) this.unsafeCard.classList.add('is-hidden');
      if (this.subtitleEl) this.subtitleEl.classList.add('is-visible');
      if (this.resultsSection) this.resultsSection.classList.add('is-visible');
      return;
    }

    // popuni unsafe (ako ih ima) – s linkom i slikom iz USP/ingredient metaobjecta
    unsafeFound.forEach(item => {
      const li = document.createElement('li');
      li.classList.add('u-p3', 'pb-l', 'ingredient-result-item','pl-xl');
      const normalized = item.toLowerCase();
      const idx = this.unsafeIndexByName ? this.unsafeIndexByName.get(normalized) : -1;
      const handle = idx != null && idx !== -1 ? this.unsafeHandles[idx] : null;
      const imgUrl = handle && this.ingredientImageUrls[handle];
      if (imgUrl) {
        const img = document.createElement('img');
        img.src = imgUrl;
        img.alt = '';
        img.classList.add('ingredient-result-item__img');
        img.width = 40;
        img.height = 50;
        li.appendChild(img);
      }
      const wrap = document.createElement('span');
      wrap.classList.add('ingredient-result-item__label');
      const url = this.unsafeLinkMap.get(item.toLowerCase());
      if (url) {
        const a = document.createElement('a');
        a.href = url;
        a.textContent = item;
        a.classList.add('ingredient-link');
        wrap.appendChild(a);
      } else {
        wrap.textContent = item;
      }
      li.appendChild(wrap);
      this.unsafeListEl.appendChild(li);
    });

   
    safeFound.forEach(item => {
      const li = document.createElement('li');
      li.classList.add('u-p3', 'pb-l', 'ingredient-result-item','pl-xl');
      const normalized = item.toLowerCase();
      const idx = this.safeIndexByName ? this.safeIndexByName.get(normalized) : -1;
      const handle = idx != null && idx !== -1 ? this.safeHandles[idx] : null;
      const imgUrl = handle && this.ingredientImageUrls[handle];
      if (imgUrl) {
        const img = document.createElement('img');
        img.src = imgUrl;
        img.alt = '';
        img.classList.add('ingredient-result-item__img');
        img.width = 40;
        img.height = 50;
        li.appendChild(img);
      }
      const wrap = document.createElement('span');
      wrap.classList.add('ingredient-result-item__label');
      const url = this.safeLinkMap.get(item.toLowerCase());
      if (url) {
        const a = document.createElement('a');
        a.href = url;
        a.textContent = item;
        a.classList.add('ingredient-link');
        wrap.appendChild(a);
      } else {
        wrap.textContent = item;
      }
      li.appendChild(wrap);
      this.safeListEl.appendChild(li);
    });

    if (this.unsafeCard) {
      if (unsafeFound.length === 0) {
        this.unsafeCard.classList.add('is-hidden');
        this.unsafeCard.classList.remove('is-single');
      } else {
        this.unsafeCard.classList.remove('is-hidden');
      }
    }

    // sakrij safe karticu ako ima više unsafe nego safe sastojaka
    // i označi unsafe karticu kao "single" kada nema safe rezultata
    const hasSafe = safeFound.length > 0;
    if (this.safeCard) {
      if (unsafeFound.length > safeFound.length) {
        this.safeCard.classList.add('is-hidden');
      } else {
        this.safeCard.classList.remove('is-hidden');
      }
    }
    if (this.unsafeCard) {
      if (!hasSafe && unsafeFound.length > 0) {
        this.unsafeCard.classList.add('is-single');
      } else {
        this.unsafeCard.classList.remove('is-single');
      }
    }

    // prikaži subtitle samo ako ima više safe nego unsafe sastojaka
    if (this.subtitleEl) {
      if (safeFound.length > unsafeFound.length) {
        this.subtitleEl.classList.add('is-visible');
      } else {
        this.subtitleEl.classList.remove('is-visible');
      }
    }

    if (this.resultsSection) {
      this.resultsSection.classList.add('is-visible');
    }
  }

  handleReset(event) {
    event.preventDefault();
    this.textarea.value = '';
    this.safeListEl.innerHTML = '';
    this.unsafeListEl.innerHTML = '';
    if (this.resultsSection) {
      this.resultsSection.classList.remove('is-visible');
    }
    if (this.subtitleEl) {
      this.subtitleEl.classList.remove('is-visible');
    }
  }
}

customElements.define('ingredient-checker', IngredientChecker);

/**
 * Web Animations API helper for continuous horizontal marquees.
 * Uses the same pause/play pattern as AnimatedAnnouncementBar.
 */
class ContinuousMarqueeAnimator {
  static pause(animation) {
    animation?.pause();
  }

  static play(animation) {
    animation?.play();
  }

  static cancel(animation) {
    animation?.cancel();
  }

  constructor() {
    this.animation = null;
    this.element = null;
  }

  start(element, { shiftPx, durationMs, direction = 'rtl' }) {
    this.stop();

    if (!element || !shiftPx) return null;

    this.element = element;
    const shift = shiftPx;
    const isLtr = direction === 'ltr';
    const from = isLtr ? `translate3d(${-shift}px, 0, 0)` : 'translate3d(0, 0, 0)';
    const to = isLtr ? 'translate3d(0, 0, 0)' : `translate3d(${-shift}px, 0, 0)`;

    element.style.willChange = 'transform';

    this.animation = element.animate([{ transform: from }, { transform: to }], {
      duration: durationMs,
      iterations: Infinity,
      easing: 'linear',
      fill: 'both',
    });

    return this.animation;
  }

  pause() {
    ContinuousMarqueeAnimator.pause(this.animation);
  }

  play() {
    ContinuousMarqueeAnimator.play(this.animation);
  }

  stop() {
    ContinuousMarqueeAnimator.cancel(this.animation);
    this.animation = null;

    if (this.element) {
      this.element.style.removeProperty('will-change');
      this.element.style.removeProperty('transform');
      this.element = null;
    }
  }

  get isRunning() {
    return !!this.animation && this.animation.playState !== 'finished';
  }

  get isPaused() {
    return this.animation?.playState === 'paused';
  }
}

/**
 * Infinite horizontal press-logo marquee.
 * Duplicates logo cycles for seamless looping and animates via WAAPI.
 */
class PressLogo extends HTMLElement {
  static REFERENCE_DISTANCE_PX = 1440;
  constructor() {
    super();

    this.element = this;
    this.delegateBody = null;
    this._animator = new ContinuousMarqueeAnimator();

    this._resizeObserver = null;
    this._reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    this._boundResizeHandler = null;
    this._boundTapToggle = null;
    this._boundHoverEnter = null;
    this._boundHoverLeave = null;
    this._isInitialized = false;
    this._isReady = false;
    this._repeatWidth = 0;
    this._cycleSignature = '';
    this._buildTimer = null;
    this._imageLoadHandlers = [];
    this._readyFallbackTimer = null;
    this._suppressResizeUntil = 0;
  }

  connectedCallback() {
    if (this._isInitialized) return;

    this._isInitialized = true;
    this.delegateBody = new Delegate(document.body);

    this._parseSettings();
    this._bindEvents();
    this._bindPauseEvents();
    this._observeCycle();
  }

  disconnectedCallback() {
    this.destroy();
  }

  destroy() {
    this._stopAnimation();
    this._clearBuildTimer();
    this._clearReadyFallbackTimer();
    this._removeImageLoadListeners();

    if (this._boundResizeHandler) {
      window.removeEventListener('resize', this._boundResizeHandler);
      this._boundResizeHandler = null;
    }

    if (this._resizeObserver) {
      this._resizeObserver.disconnect();
      this._resizeObserver = null;
    }

    if (this.delegateBody) {
      this.delegateBody.off();
      this.delegateBody = null;
    }

    this._unbindPauseEvents();

    this._isInitialized = false;
    this._isReady = false;
    this.classList.remove('is-ready');
  }

  _parseSettings() {
    try {
      this.settings = JSON.parse(this.dataset.settings || '{}');
    } catch (error) {
      console.error('PressLogo: failed to parse settings', error);
      this.settings = {};
    }

    this.enabled = this.settings.enabled !== false;
    this.pauseOnHover = this.settings.pauseOnHover === true;
    this.direction = this.settings.direction || 'rtl';
    this.durationMs = this._parseDuration(this.settings.duration || '40s');

    this.classList.toggle('is-pause-hover', this.pauseOnHover);
  }

  _bindPauseEvents() {
    this._unbindPauseEvents();

    if (!this.pauseOnHover) return;

    this._boundTapToggle = this._handleTapToggle.bind(this);
    this.element.addEventListener('click', this._boundTapToggle);

    if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
      this._boundHoverEnter = this._handleHoverEnter.bind(this);
      this._boundHoverLeave = this._handleHoverLeave.bind(this);
      this.element.addEventListener('mouseenter', this._boundHoverEnter);
      this.element.addEventListener('mouseleave', this._boundHoverLeave);
    }
  }

  _unbindPauseEvents() {
    if (this._boundTapToggle) {
      this.element.removeEventListener('click', this._boundTapToggle);
      this._boundTapToggle = null;
    }

    if (this._boundHoverEnter) {
      this.element.removeEventListener('mouseenter', this._boundHoverEnter);
      this.element.removeEventListener('mouseleave', this._boundHoverLeave);
      this._boundHoverEnter = null;
      this._boundHoverLeave = null;
    }

    this._resumeHoverPause();
    this.classList.remove('is-tap-paused', 'is-hover-paused');
  }

  _handleHoverEnter() {
    if (!this.pauseOnHover || responsive.matchesBreakpoint('pocket')) return;
    if (!this._animator.isRunning) return;

    this._animator.pause();
    this.classList.add('is-hover-paused');
  }

  _handleHoverLeave() {
    this.classList.remove('is-hover-paused');

    if (!this.classList.contains('is-tap-paused') && this._animator.isRunning) {
      this._animator.play();
    }
  }

  _resumeHoverPause() {
    this.classList.remove('is-hover-paused');
  }

  _handleTapToggle(event) {
    if (!responsive.matchesBreakpoint('pocket') || !this._animator.isRunning) return;

    const link = event.target.closest('.press-logo-carousel__logo-link');
    const wasPaused = this.classList.contains('is-tap-paused');

    if (link) {
      if (!wasPaused) {
        event.preventDefault();
        this.classList.add('is-tap-paused');
        this._animator.pause();
      }

      return;
    }

    this.classList.toggle('is-tap-paused');

    if (this.classList.contains('is-tap-paused')) {
      this._animator.pause();
      return;
    }

    if (!this.classList.contains('is-hover-paused')) {
      this._animator.play();
    }
  }

  _getCycleSignature(cycle) {
    return `${cycle.children.length}:${Math.round(cycle.scrollWidth)}`;
  }

  _getRepeatWidth(track, cycle) {
    const cycles = track.querySelectorAll('.press-logo__cycle');

    if (cycles.length > 1) {
      const firstRect = cycles[0].getBoundingClientRect();
      const secondRect = cycles[1].getBoundingClientRect();

      return secondRect.left - firstRect.left;
    }

    const width = cycle.getBoundingClientRect().width || cycle.scrollWidth;
    const gap = parseFloat(getComputedStyle(cycle).marginRight) || 0;

    return width + gap;
  }

  _scheduleBuild() {
    this._clearBuildTimer();

    this._buildTimer = setTimeout(() => {
      this._buildTimer = null;
      this.build();
    }, 250);
  }

  _clearBuildTimer() {
    if (!this._buildTimer) return;

    clearTimeout(this._buildTimer);
    this._buildTimer = null;
  }

  _removeImageLoadListeners() {
    this._imageLoadHandlers.forEach(({ img, handler }) => {
      img.removeEventListener('load', handler);
      img.removeEventListener('error', handler);
    });

    this._imageLoadHandlers = [];
  }

  _getVisibleImages(cycle) {
    return [...cycle.querySelectorAll('img')].filter((img) => {
      const style = window.getComputedStyle(img);

      return style.display !== 'none' && style.visibility !== 'hidden';
    });
  }

  _areCycleImagesReady(cycle) {
    const images = this._getVisibleImages(cycle);

    if (!images.length) return true;

    return images.every((img) => img.complete);
  }

  _clearReadyFallbackTimer() {
    if (!this._readyFallbackTimer) return;

    clearTimeout(this._readyFallbackTimer);
    this._readyFallbackTimer = null;
  }

  _scheduleReadyFallback() {
    this._clearReadyFallbackTimer();

    this._readyFallbackTimer = setTimeout(() => {
      this._readyFallbackTimer = null;

      if (this._isReady) return;

      this.build();
    }, 4000);
  }

  async _decodeTrackImages(track) {
    const images = this._getVisibleImages(track);

    if (!images.length) return;

    await Promise.all(
      images.map(async (img) => {
        if (typeof img.decode !== 'function') return;

        try {
          await img.decode();
        } catch (error) {
          // Continue when decode is unavailable or fails.
        }
      })
    );
  }

  _revealNow() {
    requestAnimationFrame(() => {
      if (!this.isConnected || this._isReady) return;

      this._startMarquee();

      requestAnimationFrame(() => {
        if (!this.isConnected || this._isReady) return;
        this._setReady();
      });
    });
  }

  _computeMarqueeDuration(repeatWidth) {
    if (!repeatWidth) return this.durationMs;

    // Duration setting is seconds to scroll REFERENCE_DISTANCE_PX; scale by cycle
    // width so speed is consistent across logo counts and breakpoints.
    return this.durationMs * (repeatWidth / PressLogo.REFERENCE_DISTANCE_PX);
  }

  _startMarquee() {
    const track = this.querySelector('.press-logo__track');

    if (!track || !this._repeatWidth) return;

    const wasPaused = this.classList.contains('is-tap-paused') || this.classList.contains('is-hover-paused');

    this._animator.start(track, {
      shiftPx: this._repeatWidth,
      durationMs: this._computeMarqueeDuration(this._repeatWidth),
      direction: this.direction,
    });

    this.classList.toggle('is-ltr', this.direction === 'ltr');
    this.classList.toggle('is-rtl', this.direction !== 'ltr');
    this.classList.add('is-animating');

    if (wasPaused) {
      this._animator.pause();
    }
  }

  build() {
    const track = this.querySelector('.press-logo__track');
    const cycle = this.querySelector('.press-logo__cycle');

    if (!track || !cycle) return;

    this.classList.toggle('is-disabled', !this.enabled);

    if (!this.enabled || this._reducedMotion) {
      this._stripClones(track);
      this._stopAnimation();
      this._setReady();
      return;
    }

    const minWidth = Math.max(window.innerWidth * 2, 1);

    this._ensureClones(track, cycle);

    if (!this._areCycleImagesReady(cycle)) {
      this._scheduleReadyFallback();
      return;
    }

    if (track.scrollWidth < minWidth) {
      this._scheduleReadyFallback();
      return;
    }

    const repeatWidth = this._getRepeatWidth(track, cycle);

    if (repeatWidth <= 0) {
      this._scheduleReadyFallback();
      return;
    }

    if (
      this._animator.isRunning &&
      this._repeatWidth > 0 &&
      Math.abs(repeatWidth - this._repeatWidth) < 1
    ) {
      if (!this._isReady) this._revealNow();
      return;
    }

    this._repeatWidth = repeatWidth;
    this._stopAnimation();

    if (this._isReady) {
      this._startMarquee();
      return;
    }

    this._decodeTrackImages(track).then(() => {
      if (!this.isConnected) return;
      this._revealNow();
    });
  }

  _setReady() {
    if (this._isReady) return;

    this._clearReadyFallbackTimer();
    this._isReady = true;
    this._suppressResizeUntil = Date.now() + 2000;
    this.classList.add('is-ready');
  }

  _stripClones(track) {
    track.querySelectorAll('.press-logo__cycle').forEach((node, index) => {
      if (index > 0) node.remove();
    });

    const cycle = track.querySelector('.press-logo__cycle');
    if (cycle) cycle.setAttribute('aria-hidden', 'false');
  }

  _ensureClones(track, cycle) {
    const signature = this._getCycleSignature(cycle);
    const needsReset = signature !== this._cycleSignature;

    this._cycleSignature = signature;

    if (needsReset) {
      track.querySelectorAll('.press-logo__cycle').forEach((node, index) => {
        if (index > 0) node.remove();
      });
    }

    const minWidth = Math.max(window.innerWidth * 2, 1);
    const template = track.querySelector('.press-logo__cycle');
    let safety = 0;

    while (safety < 20) {
      const cycleCount = track.querySelectorAll('.press-logo__cycle').length;
      const needsMoreWidth = track.scrollWidth < minWidth;
      const needsDuplicate = cycleCount < 2;

      if (!needsMoreWidth && !needsDuplicate) break;

      track.appendChild(template.cloneNode(true));
      safety += 1;
    }

    track.querySelectorAll('.press-logo__cycle').forEach((node, index) => {
      node.setAttribute('aria-hidden', index === 0 ? 'false' : 'true');
    });
  }

  _stopAnimation() {
    this._resumeHoverPause();
    this.classList.remove('is-tap-paused');
    this._animator.stop();
    this.classList.remove('is-animating', 'is-ltr', 'is-rtl');
  }

  _parseDuration(value) {
    const numeric = parseFloat(value);

    if (Number.isNaN(numeric)) return 40000;

    return value.includes('ms') ? numeric : numeric * 1000;
  }

  async _runInitialBuild(cycle) {
    if (document.readyState !== 'complete') {
      await new Promise((resolve) => {
        window.addEventListener('load', resolve, { once: true });
      });
    }

    if (!this.isConnected) return;

    const images = this._getVisibleImages(cycle);

    if (images.length) {
      await Promise.all(
        images.map(async (img) => {
          if (!img.complete) {
            await new Promise((resolve) => {
              const done = () => resolve();

              img.addEventListener('load', done, { once: true });
              img.addEventListener('error', done, { once: true });
            });
          }

          if (typeof img.decode === 'function') {
            try {
              await img.decode();
            } catch (error) {
              // Continue with the loaded bitmap when decode is unavailable.
            }
          }
        })
      );
    }

    if (!this.isConnected) return;

    this.build();
  }

  _observeCycle() {
    const cycle = this.querySelector('.press-logo__cycle');

    if (!cycle) return;

    if (this._resizeObserver) {
      this._resizeObserver.disconnect();
    }

    this._removeImageLoadListeners();

    let lastObservedWidth = cycle.scrollWidth;

    this._resizeObserver = new ResizeObserver(() => {
      if (this._suppressResizeUntil && Date.now() < this._suppressResizeUntil) return;

      const nextWidth = cycle.scrollWidth;
      const threshold = this._isReady ? 16 : 2;

      if (Math.abs(nextWidth - lastObservedWidth) < threshold) return;

      lastObservedWidth = nextWidth;
      this._scheduleBuild();
    });

    this._resizeObserver.observe(cycle);

    cycle.querySelectorAll('img').forEach((img) => {
      if (img.complete) return;

      const handler = () => {
        if (this._isReady) return;

        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            if (this._isReady) return;
            this._scheduleBuild();
          });
        });
      };

      img.addEventListener('load', handler, { once: true });
      img.addEventListener('error', handler, { once: true });
      this._imageLoadHandlers.push({ img, handler });
    });

    this._runInitialBuild(cycle);
  }

  _bindEvents() {
    let resizeTimer = null;

    this._boundResizeHandler = () => {
      clearTimeout(resizeTimer);

      resizeTimer = setTimeout(() => {
        this.build();
      }, 200);
    };

    window.addEventListener('resize', this._boundResizeHandler);

    this.delegateBody.on('shopify:section:load', (event) => {
      if (!event.target.contains(this)) return;

      this._parseSettings();
      this._cycleSignature = '';
      this._repeatWidth = 0;
      this._isReady = false;
      this._stopAnimation();
      this._clearReadyFallbackTimer();
      this.classList.remove('is-ready');

      this._bindPauseEvents();
      this._observeCycle();
    });
  }
}

customElements.define('press-logo', PressLogo);

class HyphenatedText extends HTMLElement {
  connectedCallback() {
    if (this.dataset.keepHyphenatedWords === 'false') return;
    if (this.closest('[data-disable-hyphenated-text]')) return;

    this.normalizeHyphens();
  }

  normalizeHyphens() {
    const letterHyphenLetter = /([A-Za-zÀ-ÖØ-öø-ÿ])\-([A-Za-zÀ-ÖØ-öø-ÿ])/g;
    const walker = document.createTreeWalker(this, NodeFilter.SHOW_TEXT, {
      acceptNode(node) {
        const parent = node.parentElement;

        if (parent && parent.closest('script, style, svg')) {
          return NodeFilter.FILTER_REJECT;
        }

        return NodeFilter.FILTER_ACCEPT;
      }
    });
    const textNodes = [];

    while (walker.nextNode()) {
      textNodes.push(walker.currentNode);
    }

    textNodes.forEach((node) => {
      node.nodeValue = node.nodeValue.replace(letterHyphenLetter, '$1\u2011$2');
    });
  }
}

if (!customElements.get('hyphenated-text')) {
  customElements.define('hyphenated-text', HyphenatedText);
}
